
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("Cp1xd", function(module, exports) {

$parcel$export(module.exports, "SmartRequestSummary", () => $d70ec7d91f23627f$export$1c304207f6ce0d55);

var $5uXOq = parcelRequire("5uXOq");

var $d6u6P = parcelRequire("d6u6P");

var $iXVV6 = parcelRequire("iXVV6");

var $aQIFj = parcelRequire("aQIFj");
const $d70ec7d91f23627f$export$1c304207f6ce0d55 = ({ props: { isProactiveExperimentConditionMet: isProactiveExperimentConditionMet } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "smartRequestSummary",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6u6P.SummaryStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aQIFj.Summary), {
        isProactiveExperimentConditionMet: isProactiveExperimentConditionMet
    })));

});
parcelRegister("d6u6P", function(module, exports) {

$parcel$export(module.exports, "SummaryStateContainer", () => $5b8f798841dae39b$export$bb07b368817cbd09);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $lGvJS = parcelRequire("lGvJS");
const $5b8f798841dae39b$export$bb07b368817cbd09 = ({ children: children })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const issueId = (0, $2gCtH.useIssueId)();
    if (issueId == null || issueKey == null) // Outside the context of an issue, we can't show anything meaningful
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGvJS.StateContainer), {
        scope: issueKey
    }, children);
};

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("aQIFj", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $e90a1b5f0825965f$export$46453a0401d6cd1a);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $7i3ao = parcelRequire("7i3ao");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $f5oqj = parcelRequire("f5oqj");

var $fNobW = parcelRequire("fNobW");

var $fBaBT = parcelRequire("fBaBT");

var $eNNkf = parcelRequire("eNNkf");


var $37QwF = parcelRequire("37QwF");

var $94cfG = parcelRequire("94cfG");

var $2gCtH = parcelRequire("2gCtH");

var $eF8rD = parcelRequire("eF8rD");

var $lGvJS = parcelRequire("lGvJS");

var $iJl7P = parcelRequire("iJl7P");

var $6a30R = parcelRequire("6a30R");

var $iixvy = parcelRequire("iixvy");

var $5oFIy = parcelRequire("5oFIy");

var $147rB = parcelRequire("147rB");

var $6s1PB = parcelRequire("6s1PB");

var $cSD7y = parcelRequire("cSD7y");

var $kVVL1 = parcelRequire("kVVL1");

var $7XYc4 = parcelRequire("7XYc4");

var $d4MOh = parcelRequire("d4MOh");

var $DVljb = parcelRequire("DVljb");

var $90yGq = parcelRequire("90yGq");

var $6Zc45 = parcelRequire("6Zc45");

var $jTFqj = parcelRequire("jTFqj");

var $kpCa9 = parcelRequire("kpCa9");

var $4Hax6 = parcelRequire("4Hax6");

var $eJfzL = parcelRequire("eJfzL");

var $a7K3Y = parcelRequire("a7K3Y");

var $dzJaD = parcelRequire("dzJaD");

const $e90a1b5f0825965f$export$f82e92dacb45e73e = ()=>{
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const isFeatureEnabled = isPremium && isAiOptInEnabled;
    const [isPanelShown] = (0, $lGvJS.useIsPanelShown)();
    const { closeSummaryPanel: closeSummaryPanel, stopLoading: stopLoading, setIsGenerating: setIsGenerating } = (0, $lGvJS.useActions)();
    const [isGenerating] = (0, $lGvJS.useIsGenerating)();
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const dataProviders = new (0, $dGzaM.default)();
    const profileCardProvider = (0, $147rB.useProfileCardProvider)();
    dataProviders.setProvider('profilecardProvider', profileCardProvider);
    const [{ content: content, responseState: responseState, error: error }] = (0, $iJl7P.useSmartSummaryStreaming)();
    const onContainerRef = (0, $5uXOq.useCallback)((element)=>{
        if (element && typeof element.scrollIntoView === 'function') element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, []);
    const onClosePanel = (0, $5uXOq.useCallback)(()=>{
        closeSummaryPanel();
        /** - isGenerating refers to when we call stream endpoint before any events come back *
		 *  - initialization refers to initial setup of streaming
		 *  - answer part means still streaming response
		 * */ const isStreaming = isGenerating || responseState === (0, $fBaBT.AIAgentResponseState).AnswerPart || responseState === (0, $fBaBT.AIAgentResponseState).Initialization;
        if (isStreaming) {
            stopLoading();
            fireTrack('aiInteraction dismissed', 'cancelJiraSmartSummarizeComments', {
                isGenerating: isStreaming
            });
        }
    }, [
        closeSummaryPanel,
        isGenerating,
        responseState,
        stopLoading,
        fireTrack
    ]);
    const resizingHeightProps = (0, $7i3ao.useResizingHeight)({
        duration: ()=>1500
    });
    const adfNode = (0, $5uXOq.useMemo)(()=>{
        if (!content) return null;
        return (0, $37QwF.encodeAdf)(content, true);
    }, [
        content
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * isGenerating refers to fetch stream call until we get some sort of content
		 * 	that is not initialisation (initialisation is basically no content). This means we actually have content of
		 * 	either streamed responses (answer part), final response (cached summaries)
		 * 	or error.
		 */ if (isGenerating && (responseState === (0, $fBaBT.AIAgentResponseState).AnswerPart || responseState === (0, $fBaBT.AIAgentResponseState).FinalResponse || responseState === (0, $fBaBT.AIAgentResponseState).Error)) setIsGenerating(false);
    }, [
        isGenerating,
        responseState,
        setIsGenerating
    ]);
    if (!isFeatureEnabled || !isPanelShown) return null;
    const renderContent = ()=>{
        if (!adfNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
            eventHandlers: {
                link: {
                    onClick: (0, $6a30R.onLinkClick)
                }
            },
            document: adfNode,
            dataProviders: dataProviders,
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    };
    const renderError = (errorMessageTemplate)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
            eventHandlers: {
                link: {
                    onClick: (0, $6a30R.onLinkClick)
                }
            },
            document: (0, $a7K3Y.mapMessageTemplateErrorToAdfError)(errorMessageTemplate),
            dataProviders: dataProviders,
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    };
    const renderSummary = ()=>{
        switch(responseState){
            case (0, $fBaBT.AIAgentResponseState).Error:
                return renderError(error?.message.message_template);
            case (0, $fBaBT.AIAgentResponseState).AnswerPart:
            case (0, $fBaBT.AIAgentResponseState).FinalResponse:
                return renderContent();
            default:
                return null;
        }
    };
    const renderSummaryComponent = ()=>{
        if (isGenerating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "ai-smart-summaries.ui.first-stream-loading"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $e90a1b5f0825965f$var$containerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kpCa9.GenerationSkeleton), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJfzL.ContentWrapper), {
            ...resizingHeightProps,
            hasContent: true
        }, renderSummary()), responseState === (0, $fBaBT.AIAgentResponseState).Error || responseState === (0, $fBaBT.AIAgentResponseState).FinalResponse ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jTFqj.FooterStreaming), null) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJfzL.Container), {
        ref: onContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        isLoading: isGenerating,
        shouldFitContainer: true,
        spacing: "none",
        testId: "issue-smart-request-summary.ui.ai-container",
        hasNewBorderExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hax6.Header), {
        onClose: onClosePanel
    }), renderSummaryComponent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $e90a1b5f0825965f$export$63362b871a725b7e = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira_smart_summary_convo_ai_migration', 'isEnabled', false), (0, $6Zc45.SummaryNonProactive), $e90a1b5f0825965f$export$f82e92dacb45e73e);
const $e90a1b5f0825965f$export$4fa116da1e7763f6 = ()=>{
    const [hasTriggeredProactive] = (0, $lGvJS.useHasTriggeredProactive)();
    const [hasValidProactiveResponse] = (0, $lGvJS.useHasValidProactiveResponse)();
    const [hasTriggeredNonProactive] = (0, $lGvJS.useHasTriggeredNonProactive)();
    const [isPanelShown] = (0, $lGvJS.useIsPanelShown)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const isFeatureEnabled = isPremium && isAiOptInEnabled;
    if (!isFeatureEnabled) return null;
    // non-proactive experience, this means they have to have pressed the ai button
    // if pressed before our proactive is generated, always show the non-proacitve
    // as we want to count that analytic event as a non-proactive case
    if (isPanelShown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e90a1b5f0825965f$export$63362b871a725b7e, null);
    // if we have not triggered proactive before, or we have already triggered proactive and has a valid response
    // render the proactive component
    // also handles the case where, users haven't scrolled and press the summarise comment
    // from the dropdown menu. This means they have triggered the non proactive experience
    // so dont trigger the proactive case
    if ((!hasTriggeredProactive || hasValidProactiveResponse) && !hasTriggeredNonProactive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzJaD.ProactiveSummary), null);
    return null;
};
const $e90a1b5f0825965f$export$30756591a01a3360 = ()=>{
    const totalComments = (0, $kVVL1.useSelector)((0, $d4MOh.totalCommentsSelector));
    const locale = (0, $DVljb.useLocale)();
    const isEnglishLocale = locale && locale.startsWith('en');
    const [isProactiveExperimentConditionMet, setIsProactiveExperimentConditionMet] = (0, $5uXOq.useState)(false);
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const isFeatureEnabled = isPremium && isAiOptInEnabled;
    const [isPanelShown] = (0, $lGvJS.useIsPanelShown)();
    const accountId = (0, $90yGq.useAccountId)();
    const [hasProactiveFeatureEnabled] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$25f5ee1223725a65));
    /**
	 * Prevent experiment exposure from triggering for experiences like
	 * 4 initial comments, and then add a new comment and then they are part of test group
	 * and an exposure fires and triggers a proactive experiment.
	 */ (0, $5uXOq.useEffect)(()=>{
        if (totalComments >= (0, $e01a05af1d49e23d$export$2cb239d55dc89d35) && isEnglishLocale && hasProactiveFeatureEnabled === 'true') setIsProactiveExperimentConditionMet(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!isFeatureEnabled || !accountId) return null;
    if (isProactiveExperimentConditionMet && (0, $6s1PB.expVal)('jira_proactive_comment_summary_experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e90a1b5f0825965f$export$4fa116da1e7763f6, null);
    if (isPanelShown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e90a1b5f0825965f$export$63362b871a725b7e, null);
    return null;
};
const $e90a1b5f0825965f$export$41fd4d57dc812ed3 = ({ isProactiveExperimentConditionMet: isProactiveExperimentConditionMet = false })=>{
    const [isPanelShown] = (0, $lGvJS.useIsPanelShown)();
    if (isProactiveExperimentConditionMet && (0, $6s1PB.expVal)('jira_proactive_comment_summary_experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e90a1b5f0825965f$export$4fa116da1e7763f6, null);
    if (isPanelShown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e90a1b5f0825965f$export$63362b871a725b7e, null);
    return null;
};
const $e90a1b5f0825965f$export$4189691e60966965 = (0, $cSD7y.componentWithFG)('improve_issue_view_comment_ai', $e90a1b5f0825965f$export$41fd4d57dc812ed3, $e90a1b5f0825965f$export$30756591a01a3360);
const $e90a1b5f0825965f$export$46453a0401d6cd1a = (0, $cSD7y.componentWithFG)('proactive_comment_summary_targeting_gate', $e90a1b5f0825965f$export$4189691e60966965, $e90a1b5f0825965f$export$63362b871a725b7e);
const $e90a1b5f0825965f$var$containerStyle = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.150'
});

});
parcelRegister("dGzaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $586c606cb83743fd$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $586c606cb83743fd$var$isUndefined(x) {
    return x === undefined;
}
class $586c606cb83743fd$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("7i3ao", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $5f7cf4464a63f574$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $5f7cf4464a63f574$export$204d7b6d1491a2d3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");


var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $5Otrq = parcelRequire("5Otrq");
const $5f7cf4464a63f574$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $lObw7.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $eba99f58997c09b3$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $5uXOq.useRef)();
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $bh8Xz.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    (0, $5Otrq.useSnapshotBeforeUpdate)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $fsENI.useLayoutEffect)(()=>{
        if ((0, $dWt6p.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $5f7cf4464a63f574$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $5f7cf4464a63f574$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children(resizing)
    });
};

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eba99f58997c09b3$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("5Otrq", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $80940ec2167ac037$export$9e95200239cd148b);

var $5uXOq = parcelRequire("5uXOq");

var $fsENI = parcelRequire("fsENI");
const $80940ec2167ac037$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $5uXOq.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $fsENI.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("f5oqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de1eca32602d427$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $kOFhM = parcelRequire("kOFhM");

var $dGzaM = parcelRequire("dGzaM");
var $9S8fM = parcelRequire("9S8fM");

var $9Iju4 = parcelRequire("9Iju4");
var $fIJEx = parcelRequire("fIJEx");
var $iiXGq = parcelRequire("iiXGq");
var $4ceoy = parcelRequire("4ceoy");
var $2DpUZ = parcelRequire("2DpUZ");

var $gmhCD = parcelRequire("gmhCD");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gE8f9 = parcelRequire("gE8f9");

var $iN9lO = parcelRequire("iN9lO");

var $ap7h6 = parcelRequire("ap7h6");

var $kFiBa = parcelRequire("kFiBa");

var $4NUlu = parcelRequire("4NUlu");
var $fc6h8 = parcelRequire("fc6h8");

var $VSDnB = parcelRequire("VSDnB");

var $dWAZk = parcelRequire("dWAZk");

var $1PVpv = parcelRequire("1PVpv");

var $gkwXh = parcelRequire("gkwXh");

var $4zXba = parcelRequire("4zXba");

var $bXrHm = parcelRequire("bXrHm");

var $9gOVJ = parcelRequire("9gOVJ");
var $12yAL = parcelRequire("12yAL");

var $TM1uy = parcelRequire("TM1uy");

var $knXBU = parcelRequire("knXBU");

var $1urn6 = parcelRequire("1urn6");

var $3kKuL = parcelRequire("3kKuL");

var $dyURG = parcelRequire("dyURG");

var $K5Jsy = parcelRequire("K5Jsy");

var $fCNtA = parcelRequire("fCNtA");

var $4BsEy = parcelRequire("4BsEy");

var $1pTqN = parcelRequire("1pTqN");

var $4YrGg = parcelRequire("4YrGg");

var $8Eu7T = parcelRequire("8Eu7T");

var $jUVor = parcelRequire("jUVor");

var $TPpI8 = parcelRequire("TPpI8");

var $kgV4b = parcelRequire("kgV4b");


var $3lRy2 = parcelRequire("3lRy2");

var $1SqDw = parcelRequire("1SqDw");

var $glOdv = parcelRequire("glOdv");

var $aagOn = parcelRequire("aagOn");

var $dJPoO = parcelRequire("dJPoO");

var $kjHuf = parcelRequire("kjHuf");

var $8QrLL = parcelRequire("8QrLL");
function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
const $3de1eca32602d427$export$1b622068be977101 = 3000;
const $3de1eca32602d427$var$packageName = "platform-pkg";
const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
const $3de1eca32602d427$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $3de1eca32602d427$var$handleMouseTripleClickInTables = (event)=>{
    if ((0, $gE8f9.browser).ios || (0, $gE8f9.browser).android) return;
    const badBrowser = (0, $gE8f9.browser).chrome || (0, $gE8f9.browser).safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $3de1eca32602d427$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $3de1eca32602d427$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $K5Jsy.findInTree)(targetElement, rendererWrapper, (0, $TPpI8.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $3de1eca32602d427$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $5uXOq.useRef)(undefined);
    const providerFactory = (0, $5uXOq.useMemo)(()=>props.dataProviders || new (0, $dGzaM.default)(), [
        props.dataProviders
    ]);
    const createRendererContext = (0, $5uXOq.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $4zXba.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEventOld = (0, $5uXOq.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $5uXOq.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $gmhCD.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $5uXOq.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    // Abstract out the logic into its own function
    const serializer = (0, $kjHuf.useMemoFromPropsDerivative)((serializerProps)=>{
        // If progressive rendering is enabled, create a new serializer
        if ((0, $VSDnB.fg)('cc_complexit_fe_progressive_adf_rendering')) {
            const newSerializer = props.createSerializer?.(serializerProps);
            if (newSerializer) return newSerializer;
        }
        return new (0, $9gOVJ.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $5uXOq.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $5uXOq.useMemo)(()=>(0, $ap7h6.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $5uXOq.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $iN9lO.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $5uXOq.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $5uXOq.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $kOFhM.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $5uXOq.useEffect)(()=>{
        let rafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).STARTED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB
                },
                eventType: (0, $gkwXh.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $iN9lO.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $fc6h8.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $4NUlu.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).RENDERED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $knXBU.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $kFiBa.getResponseEndTime)(),
                            nodes: (0, $kgV4b.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $5uXOq.useMemo)(()=>createRendererContext(props.featureFlags, props.isTopLevelRenderer), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext
    ]);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $12yAL.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $dJPoO.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dyURG.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1pTqN.ActiveHeaderIdProvider), {
            value: (0, $3kKuL.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $TM1uy.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4BsEy.Provider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9S8fM.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jUVor.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3lRy2.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $3kKuL.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$3de1eca32602d427$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iiXGq.default), null));
    }
};
const $3de1eca32602d427$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($3de1eca32602d427$export$c49fe2316038f3c2);
const $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContext = (props)=>{
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8QrLL.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$c49fe2316038f3c2, propsWithoutPortal));
};
const $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContextMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($3de1eca32602d427$var$RendererFunctionalComponentWithPortalContext);
const $3de1eca32602d427$var$getRendererComponent = (nodeComponents)=>{
    // If nodeComponents are provided, for now we don't want to remove portal from props
    // and use context instead because at this time we cannot guarantee that existing
    // consumers of Atlaskit Renderer will update to use the new portal context.
    if (!Boolean(nodeComponents) && (0, $VSDnB.fg)('cc_complexit_reduce_portal_rerenders')) return $3de1eca32602d427$var$RendererFunctionalComponentWithPortalContextMemoized;
    return $3de1eca32602d427$var$RendererFunctionalComponentMemoized;
};
function $3de1eca32602d427$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $4YrGg.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $5uXOq.useContext)((0, $1SqDw.ValidationContext)) || {};
    const RendererComponent = $3de1eca32602d427$var$getRendererComponent(props.nodeComponents);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(RendererComponent, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: {
            allowNestedTables: allowNestedTables
        }
    });
}
const $3de1eca32602d427$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $4NUlu.getAnalyticsAppearance)(props.appearance),
            packageName: $3de1eca32602d427$var$packageName,
            packageVersion: $3de1eca32602d427$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))()
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2DpUZ.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8Eu7T.ErrorBoundary), {
                component: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fIJEx.IntlErrorBoundary), null, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $3de1eca32602d427$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $19a4579e32968c00$export$74b525449cc7cbd1);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    (0, $5uXOq.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $19a4579e32968c00$export$74b525449cc7cbd1)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $19a4579e32968c00$export$74b525449cc7cbd1)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Iju4.BaseTheme), {
        baseFontSize: (0, $aagOn.getBaseFontSize)(appearance)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1urn6.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $glOdv.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (appearance === 'comment' && isTopLevelRenderer && (0, $VSDnB.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3de1eca32602d427$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3de1eca32602d427$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $3de1eca32602d427$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const rendererRef = (0, $5uXOq.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fCNtA.RendererActionsContext), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4YrGg.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;

});
parcelRegister("9S8fM", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $d1ee541d73df1fcd$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $d1ee541d73df1fcd$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $d1ee541d73df1fcd$export$6fde1d0d81db98e1);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");
const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $dGzaM.default)());
const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $d1ee541d73df1fcd$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("9Iju4", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $b0fd15d81ba0fb5a$export$a1a213d350ca51ca);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $g0wej = parcelRequire("g0wej");

var $iHYdz = parcelRequire("iHYdz");

var $4ceoy = parcelRequire("4ceoy");
function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $iHYdz.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0wej.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("iHYdz", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $01f0a5ace820da37$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $01f0a5ace820da37$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $01f0a5ace820da37$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $01f0a5ace820da37$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $01f0a5ace820da37$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $01f0a5ace820da37$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $01f0a5ace820da37$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $01f0a5ace820da37$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $01f0a5ace820da37$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $01f0a5ace820da37$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $01f0a5ace820da37$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $01f0a5ace820da37$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $01f0a5ace820da37$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $01f0a5ace820da37$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $01f0a5ace820da37$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $01f0a5ace820da37$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $01f0a5ace820da37$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $01f0a5ace820da37$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $01f0a5ace820da37$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $01f0a5ace820da37$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $01f0a5ace820da37$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $01f0a5ace820da37$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $01f0a5ace820da37$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $01f0a5ace820da37$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $01f0a5ace820da37$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $01f0a5ace820da37$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $01f0a5ace820da37$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $01f0a5ace820da37$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $01f0a5ace820da37$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $01f0a5ace820da37$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $01f0a5ace820da37$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $01f0a5ace820da37$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $01f0a5ace820da37$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $01f0a5ace820da37$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $01f0a5ace820da37$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $01f0a5ace820da37$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $01f0a5ace820da37$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $01f0a5ace820da37$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $01f0a5ace820da37$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $01f0a5ace820da37$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $01f0a5ace820da37$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $01f0a5ace820da37$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $01f0a5ace820da37$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $01f0a5ace820da37$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $01f0a5ace820da37$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $01f0a5ace820da37$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $01f0a5ace820da37$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $01f0a5ace820da37$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $01f0a5ace820da37$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $01f0a5ace820da37$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $01f0a5ace820da37$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $01f0a5ace820da37$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $01f0a5ace820da37$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $01f0a5ace820da37$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $01f0a5ace820da37$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $01f0a5ace820da37$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $01f0a5ace820da37$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $01f0a5ace820da37$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $01f0a5ace820da37$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $01f0a5ace820da37$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $01f0a5ace820da37$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $01f0a5ace820da37$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $01f0a5ace820da37$export$59733a9f61449b25);
$parcel$export(module.exports, "VIEWPORT_SIZES", () => $01f0a5ace820da37$export$96b72b7f243fa693);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $01f0a5ace820da37$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $01f0a5ace820da37$export$42608c013398a830);

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$37e178ca41c198ca = `0 0 0 ${$01f0a5ace820da37$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
const $01f0a5ace820da37$export$b46cda584c619451 = 2;
const $01f0a5ace820da37$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
const $01f0a5ace820da37$export$9db045950eedb49f = 760;
const $01f0a5ace820da37$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $VSDnB.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
const $01f0a5ace820da37$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    if ((0, $VSDnB.fg)('live_pages_content_jump_mitigation')) return '2.188rem';
    return "var(--ds-space-500, 40px)";
};
const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $01f0a5ace820da37$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
const $01f0a5ace820da37$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $01f0a5ace820da37$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});
parcelRegister("gmhCD", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $a90e6fd79e0e0cb2$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iEN9D = parcelRequire("iEN9D");

var $hdkTE = parcelRequire("hdkTE");

var $a0Psj = parcelRequire("a0Psj");
function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
    if ((0, $a0Psj._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $a0Psj._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $a0Psj._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $hdkTE.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $a90e6fd79e0e0cb2$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $a0Psj._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("hdkTE", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $7a273b3c03491c92$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7rlXf = parcelRequire("7rlXf");
const $7a273b3c03491c92$export$6cbb856f286b07ef = {
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_controls_performance_fixes: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_performance_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-02
    platform_editor_smart_link_cmd_ctrl_click: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_link_cmd_ctrl_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-13
    editor_text_highlight_orange_to_yellow: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_text_highlight_orange_to_yellow'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-05
    editor_ai_contextual_selection_toolbar_button: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_contextual_selection_toolbar_button'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-08
    editor_ai_converge_free_gen_on_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_converge_free_gen_on_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    editor_ai_cmd_palette_remove_retry: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_cmd_palette_remove_retry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-13
    editor_ai_comment_freegen_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_comment_freegen_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    confluence_p2m_style_recalc_and_expand_joint_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_p2m_style_recalc_and_expand_joint_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-21
    platform_editor_nodevisibility: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nodevisibility'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-30
    platform_editor_exp_disable_lnv: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_disable_lnv'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-22
    editor_ai_in_editor_streaming: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_in_editor_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_hide_floating_toolbar_in_ssr: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_floating_toolbar_in_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_open_overlay_perf: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_card_open_overlay_perf'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_toolbar_rerender_optimization_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_rerender_optimization_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-30
    platform_editor_controls_toolbar_pinning_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_toolbar_pinning_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-30
    platform_editor_ai_iw_full_page_adf_streaming: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_full_page_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("7rlXf", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", () => $641ded07329846f0$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $641ded07329846f0$export$fb89e8a786694d1);

var $9qwvi = parcelRequire("9qwvi");
function $641ded07329846f0$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $641ded07329846f0$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $9qwvi.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("9qwvi", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $41035ee8947774ef$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $41035ee8947774ef$export$a9a18ae5ba42aeab);
function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $41035ee8947774ef$var$IS_TESTING_ENV = false;

});



parcelRegister("a0Psj", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $ae2371e90434836c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $ae2371e90434836c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $ae2371e90434836c$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $ae2371e90434836c$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hdkTE = parcelRequire("hdkTE");
let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
let $ae2371e90434836c$export$4e849416bb5c5b52 = {};
let $ae2371e90434836c$export$cf7305fc65acbf0d;
function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $hdkTE.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $ae2371e90434836c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $ae2371e90434836c$export$4e849416bb5c5b52 = paramOverrides;
}

});



parcelRegister("4ceoy", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $a2904bcfe480568e$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $a2904bcfe480568e$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $a2904bcfe480568e$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $a2904bcfe480568e$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $a2904bcfe480568e$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8QpSo = parcelRequire("8QpSo");

var $7nRxN = parcelRequire("7nRxN");

var $gJlZe = parcelRequire("gJlZe");

var $1v3g5 = parcelRequire("1v3g5");
function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a2904bcfe480568e$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
    };
}
const $a2904bcfe480568e$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, $8QpSo.default)(()=>{
    return (0, $1v3g5.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
    const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
    const widthRef = (0, $5uXOq.useRef)(width);
    const isMountedRef = (0, $5uXOq.useRef)(true);
    const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $5uXOq.useMemo)(()=>{
        return (0, $7nRxN.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a2904bcfe480568e$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gJlZe.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)($a2904bcfe480568e$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("gJlZe", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $f3c667de71b5760d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWz2c = parcelRequire("jWz2c");
const $f3c667de71b5760d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jWz2c.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;

});
parcelRegister("jWz2c", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $76470ef26276f9f4$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1LwQL = parcelRequire("1LwQL");
const $76470ef26276f9f4$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1LwQL.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1LwQL", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $1dfb7d23cdbb03d0$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("1v3g5", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $161da1f5bf80dbfb$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("fIJEx", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $f1eccfecc1c43fb5$export$7df0749115d18d19);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("iiXGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $94120525d10931b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $94120525d10931b9$var$blockNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent, (0, $7R1zM.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $94120525d10931b9$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    })))));
};
var $94120525d10931b9$export$2e2bcd8739ae039 = (0, $8RXs9.default)($94120525d10931b9$var$UnsupportedBlockNode);

});
parcelRegister("gkwXh", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $97c56ca7515fdb59$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $97c56ca7515fdb59$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $97c56ca7515fdb59$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $97c56ca7515fdb59$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $97c56ca7515fdb59$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $97c56ca7515fdb59$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $97c56ca7515fdb59$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
var $97c56ca7515fdb59$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $97c56ca7515fdb59$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $97c56ca7515fdb59$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $97c56ca7515fdb59$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $97c56ca7515fdb59$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $97c56ca7515fdb59$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $97c56ca7515fdb59$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $97c56ca7515fdb59$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("7R1zM", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $757d518931aaa671$export$32ec96484dd3ba39);

var $7VHMR = parcelRequire("7VHMR");
const $757d518931aaa671$export$32ec96484dd3ba39 = (0, $7VHMR.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("d54NZ", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $850930d0b79c2a61$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $850930d0b79c2a61$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $850930d0b79c2a61$export$3a34598135e7219b);

var $gkwXh = parcelRequire("gkwXh");
const $850930d0b79c2a61$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $gkwXh.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, $gkwXh.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("9tFGn", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("2DpUZ", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $10143a74d71d9da7$export$9ac3d19711324187);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");
const $10143a74d71d9da7$export$9ac3d19711324187 = (0, $cb25w.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("gE8f9", function(module, exports) {

$parcel$export(module.exports, "browser", () => $6911d91f679e4e6c$export$3f2684e5d7cb1006);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("iN9lO", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $420059dd531814dc$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $420059dd531814dc$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $420059dd531814dc$export$6f766653554dac02);

var $b7gJe = parcelRequire("b7gJe");
const $420059dd531814dc$var$measureMap = new Map();
function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $420059dd531814dc$var$measureMap.set(measureName, performance.now());
}
function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $420059dd531814dc$export$6f766653554dac02(measureName);
    }
}
function $420059dd531814dc$export$6f766653554dac02(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    $420059dd531814dc$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $420059dd531814dc$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return false;
    return $420059dd531814dc$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("b7gJe", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $da51e67df7144cd5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $da51e67df7144cd5$export$48995af1e77d8643);
let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
    if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
}
function $da51e67df7144cd5$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $da51e67df7144cd5$export$4370ec0f52022f66() {
    return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("ap7h6", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $3e05ce213e57560b$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $3e05ce213e57560b$export$267ed650a5d21ae6);

var $b7gJe = parcelRequire("b7gJe");
const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $3e05ce213e57560b$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("kFiBa", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $9d05c46136d117ff$export$92d097a1155bbe27);

var $b7gJe = parcelRequire("b7gJe");
function $9d05c46136d117ff$export$92d097a1155bbe27() {
    if (!(0, $b7gJe.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("4NUlu", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $d9ce436f8d702318$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $d9ce436f8d702318$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $d9ce436f8d702318$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $d9ce436f8d702318$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $d9ce436f8d702318$export$288273ee3e3b6132);

var $d93fQ = parcelRequire("d93fQ");

var $gZGBX = parcelRequire("gZGBX");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");
const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $d9ce436f8d702318$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $gZGBX.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $hFEwm.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $d9ce436f8d702318$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("gZGBX", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $c5f36586ce432e9f$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $c5f36586ce432e9f$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $c5f36586ce432e9f$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $c5f36586ce432e9f$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $c5f36586ce432e9f$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $c5f36586ce432e9f$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $c5f36586ce432e9f$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $c5f36586ce432e9f$export$1692d8b0e89cecc3);

var $kCV8T = parcelRequire("kCV8T");

var $eS2Dn = parcelRequire("eS2Dn");
const $c5f36586ce432e9f$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $c5f36586ce432e9f$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $kCV8T.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
            if (i == 0) $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $c5f36586ce432e9f$export$c2b25f346d19bcbb($pos) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $c5f36586ce432e9f$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $c5f36586ce432e9f$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $c5f36586ce432e9f$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $c5f36586ce432e9f$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $c5f36586ce432e9f$var$warnedAboutTextSelection = false;
function $c5f36586ce432e9f$var$checkTextSelection($pos) {
    if (!$c5f36586ce432e9f$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $c5f36586ce432e9f$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $c5f36586ce432e9f$export$c2b25f346d19bcbb extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $c5f36586ce432e9f$var$checkTextSelection($anchor);
        $c5f36586ce432e9f$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $c5f36586ce432e9f$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $kCV8T.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $c5f36586ce432e9f$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $c5f36586ce432e9f$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("text", $c5f36586ce432e9f$export$c2b25f346d19bcbb);
class $c5f36586ce432e9f$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $c5f36586ce432e9f$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $c5f36586ce432e9f$export$e2940151ac854c0b extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
        return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $c5f36586ce432e9f$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$c5f36586ce432e9f$export$e2940151ac854c0b.prototype.visible = false;
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("node", $c5f36586ce432e9f$export$e2940151ac854c0b);
class $c5f36586ce432e9f$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $c5f36586ce432e9f$var$TextBookmark(pos, pos) : new $c5f36586ce432e9f$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(node)) return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
        return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $c5f36586ce432e9f$export$c15d9ba76bdbcd95 extends $c5f36586ce432e9f$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        if (content == (0, $kCV8T.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $c5f36586ce432e9f$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $c5f36586ce432e9f$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $c5f36586ce432e9f$var$AllBookmark;
    }
}
$c5f36586ce432e9f$export$52baac22726c72bf.jsonID("all", $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
const $c5f36586ce432e9f$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $c5f36586ce432e9f$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $c5f36586ce432e9f$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $c5f36586ce432e9f$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(child)) return $c5f36586ce432e9f$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $eS2Dn.ReplaceStep) || step instanceof (0, $eS2Dn.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $c5f36586ce432e9f$var$UPDATED_SEL = 1, $c5f36586ce432e9f$var$UPDATED_MARKS = 2, $c5f36586ce432e9f$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $c5f36586ce432e9f$export$febc5573c75cefb0 extends (0, $eS2Dn.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $c5f36586ce432e9f$var$UPDATED_SEL) & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $c5f36586ce432e9f$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $kCV8T.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $kCV8T.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $c5f36586ce432e9f$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $c5f36586ce432e9f$var$UPDATED_SCROLL) > 0;
    }
}
function $c5f36586ce432e9f$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $c5f36586ce432e9f$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $c5f36586ce432e9f$var$bind(desc.init, self);
        this.apply = $c5f36586ce432e9f$var$bind(desc.apply, self);
    }
}
const $c5f36586ce432e9f$var$baseFields = [
    new $c5f36586ce432e9f$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $c5f36586ce432e9f$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $c5f36586ce432e9f$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $c5f36586ce432e9f$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $c5f36586ce432e9f$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $c5f36586ce432e9f$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $c5f36586ce432e9f$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $c5f36586ce432e9f$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $c5f36586ce432e9f$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $c5f36586ce432e9f$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $c5f36586ce432e9f$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $c5f36586ce432e9f$var$Configuration(config.schema, config.plugins);
        let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $kCV8T.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $c5f36586ce432e9f$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $c5f36586ce432e9f$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $c5f36586ce432e9f$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $c5f36586ce432e9f$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $c5f36586ce432e9f$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $c5f36586ce432e9f$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $c5f36586ce432e9f$var$keys = Object.create(null);
function $c5f36586ce432e9f$var$createKey(name) {
    if (name in $c5f36586ce432e9f$var$keys) return name + "$" + ++$c5f36586ce432e9f$var$keys[name];
    $c5f36586ce432e9f$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $c5f36586ce432e9f$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $c5f36586ce432e9f$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("eS2Dn", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $ad3826e817ebec37$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $ad3826e817ebec37$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $ad3826e817ebec37$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $ad3826e817ebec37$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $ad3826e817ebec37$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $ad3826e817ebec37$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $ad3826e817ebec37$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $ad3826e817ebec37$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $ad3826e817ebec37$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $ad3826e817ebec37$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $ad3826e817ebec37$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $ad3826e817ebec37$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $ad3826e817ebec37$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $ad3826e817ebec37$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $ad3826e817ebec37$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $ad3826e817ebec37$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $ad3826e817ebec37$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $ad3826e817ebec37$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $ad3826e817ebec37$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $ad3826e817ebec37$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $ad3826e817ebec37$export$563a914cafbdc389);

var $kCV8T = parcelRequire("kCV8T");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $ad3826e817ebec37$var$lower16 = 0xffff;
const $ad3826e817ebec37$var$factor16 = Math.pow(2, 16);
function $ad3826e817ebec37$var$makeRecover(index, offset) {
    return index + offset * $ad3826e817ebec37$var$factor16;
}
function $ad3826e817ebec37$var$recoverIndex(value) {
    return value & $ad3826e817ebec37$var$lower16;
}
function $ad3826e817ebec37$var$recoverOffset(value) {
    return (value - (value & $ad3826e817ebec37$var$lower16)) / $ad3826e817ebec37$var$factor16;
}
const $ad3826e817ebec37$var$DEL_BEFORE = 1, $ad3826e817ebec37$var$DEL_AFTER = 2, $ad3826e817ebec37$var$DEL_ACROSS = 4, $ad3826e817ebec37$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $ad3826e817ebec37$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $ad3826e817ebec37$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($ad3826e817ebec37$var$DEL_BEFORE | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($ad3826e817ebec37$var$DEL_AFTER | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $ad3826e817ebec37$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $ad3826e817ebec37$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $ad3826e817ebec37$export$c53d01c3ab9721b3.empty) return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $ad3826e817ebec37$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $ad3826e817ebec37$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $ad3826e817ebec37$var$DEL_AFTER : pos == end ? $ad3826e817ebec37$var$DEL_BEFORE : $ad3826e817ebec37$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $ad3826e817ebec37$var$DEL_SIDE;
                return new $ad3826e817ebec37$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $ad3826e817ebec37$export$c53d01c3ab9721b3.empty : new $ad3826e817ebec37$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $ad3826e817ebec37$export$c53d01c3ab9721b3.empty = new $ad3826e817ebec37$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $ad3826e817ebec37$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $ad3826e817ebec37$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $ad3826e817ebec37$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $ad3826e817ebec37$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $ad3826e817ebec37$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $ad3826e817ebec37$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $ad3826e817ebec37$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $ad3826e817ebec37$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $ad3826e817ebec37$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $ad3826e817ebec37$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $ad3826e817ebec37$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $kCV8T.ReplaceError)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $ad3826e817ebec37$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($ad3826e817ebec37$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $kCV8T.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $ad3826e817ebec37$export$d24ba56b0e3464a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ad3826e817ebec37$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ad3826e817ebec37$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("addMark", $ad3826e817ebec37$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $ad3826e817ebec37$export$94150db1311f67a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $ad3826e817ebec37$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $ad3826e817ebec37$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $ad3826e817ebec37$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeMark", $ad3826e817ebec37$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $ad3826e817ebec37$export$adefd16c402fee4e extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $ad3826e817ebec37$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("addNodeMark", $ad3826e817ebec37$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $ad3826e817ebec37$export$fdf7d1dc10724da2 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $ad3826e817ebec37$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeNodeMark", $ad3826e817ebec37$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $ad3826e817ebec37$export$5c860b2e74034756 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $ad3826e817ebec37$var$contentBetween(doc, this.from, this.to)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $ad3826e817ebec37$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $ad3826e817ebec37$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $ad3826e817ebec37$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $ad3826e817ebec37$export$5c860b2e74034756(json.from, json.to, (0, $kCV8T.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("replace", $ad3826e817ebec37$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $ad3826e817ebec37$export$444ba800d6024a98 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($ad3826e817ebec37$var$contentBetween(doc, this.from, this.gapFrom) || $ad3826e817ebec37$var$contentBetween(doc, this.gapTo, this.to))) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $ad3826e817ebec37$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $ad3826e817ebec37$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $ad3826e817ebec37$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $kCV8T.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("replaceAround", $ad3826e817ebec37$export$444ba800d6024a98);
function $ad3826e817ebec37$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $ad3826e817ebec37$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $ad3826e817ebec37$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $ad3826e817ebec37$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $ad3826e817ebec37$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $kCV8T.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $ad3826e817ebec37$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur, end, (0, $kCV8T.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $kCV8T.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $kCV8T.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $ad3826e817ebec37$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $ad3826e817ebec37$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$ad3826e817ebec37$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $ad3826e817ebec37$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $kCV8T.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $kCV8T.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $kCV8T.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $kCV8T.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $kCV8T.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $ad3826e817ebec37$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $ad3826e817ebec37$var$findWrappingOutside(range, nodeType);
    let inner = around && $ad3826e817ebec37$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($ad3826e817ebec37$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($ad3826e817ebec37$var$withAttrs));
}
function $ad3826e817ebec37$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $ad3826e817ebec37$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $ad3826e817ebec37$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $ad3826e817ebec37$var$wrap(tr, range, wrappers) {
    let content = (0, $kCV8T.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $kCV8T.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, start, end, new (0, $kCV8T.Slice)(content, 0, 0), wrappers.length, true));
}
function $ad3826e817ebec37$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ad3826e817ebec37$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $ad3826e817ebec37$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $ad3826e817ebec37$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $ad3826e817ebec37$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $ad3826e817ebec37$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $ad3826e817ebec37$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $kCV8T.Fragment).empty, after = (0, $kCV8T.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $kCV8T.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $kCV8T.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(pos, pos, new (0, $kCV8T.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $ad3826e817ebec37$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $ad3826e817ebec37$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $ad3826e817ebec37$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $ad3826e817ebec37$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $ad3826e817ebec37$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $ad3826e817ebec37$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $ad3826e817ebec37$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $ad3826e817ebec37$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $ad3826e817ebec37$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $ad3826e817ebec37$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $kCV8T.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $ad3826e817ebec37$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $ad3826e817ebec37$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $ad3826e817ebec37$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $ad3826e817ebec37$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $kCV8T.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice);
    return new $ad3826e817ebec37$var$Fitter($from, $to, slice).fit();
}
function $ad3826e817ebec37$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $ad3826e817ebec37$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $kCV8T.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $kCV8T.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $kCV8T.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $ad3826e817ebec37$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $ad3826e817ebec37$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $ad3826e817ebec37$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $kCV8T.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $kCV8T.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($ad3826e817ebec37$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, frontierDepth, (0, $kCV8T.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $kCV8T.Slice).empty : new (0, $kCV8T.Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$ad3826e817ebec37$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $ad3826e817ebec37$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $ad3826e817ebec37$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.depth, (0, $kCV8T.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $kCV8T.Fragment).empty, true);
        if (add.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $ad3826e817ebec37$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($ad3826e817ebec37$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $ad3826e817ebec37$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ad3826e817ebec37$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $ad3826e817ebec37$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $ad3826e817ebec37$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $ad3826e817ebec37$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $kCV8T.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $ad3826e817ebec37$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$ad3826e817ebec37$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $ad3826e817ebec37$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $ad3826e817ebec37$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $ad3826e817ebec37$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $ad3826e817ebec37$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $ad3826e817ebec37$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $kCV8T.Slice)($ad3826e817ebec37$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $ad3826e817ebec37$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($ad3826e817ebec37$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $kCV8T.Fragment).empty, true));
    }
    return fragment;
}
function $ad3826e817ebec37$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $ad3826e817ebec37$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
}
function $ad3826e817ebec37$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $ad3826e817ebec37$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $ad3826e817ebec37$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $ad3826e817ebec37$export$626399c38172f669 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $ad3826e817ebec37$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $ad3826e817ebec37$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("attr", $ad3826e817ebec37$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $ad3826e817ebec37$export$f50707b396300ac9 extends $ad3826e817ebec37$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $ad3826e817ebec37$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $ad3826e817ebec37$export$f50707b396300ac9(json.attr, json.value);
    }
}
$ad3826e817ebec37$export$fd55ce593607084a.jsonID("docAttr", $ad3826e817ebec37$export$f50707b396300ac9);
/**
@internal
*/ let $ad3826e817ebec37$export$88cc3a1dfce48dd3 = class extends Error {
};
$ad3826e817ebec37$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.constructor = $ad3826e817ebec37$export$88cc3a1dfce48dd3;
$ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $ad3826e817ebec37$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $ad3826e817ebec37$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $ad3826e817ebec37$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $kCV8T.Slice).empty) {
        let step = $ad3826e817ebec37$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $kCV8T.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $ad3826e817ebec37$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $ad3826e817ebec37$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $ad3826e817ebec37$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $ad3826e817ebec37$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $ad3826e817ebec37$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $ad3826e817ebec37$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $ad3826e817ebec37$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $ad3826e817ebec37$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $ad3826e817ebec37$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $ad3826e817ebec37$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $ad3826e817ebec37$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $kCV8T.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $ad3826e817ebec37$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $ad3826e817ebec37$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $ad3826e817ebec37$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $ad3826e817ebec37$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("5r0mK", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $3f4fc20879d21ebe$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $3f4fc20879d21ebe$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $3f4fc20879d21ebe$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $3f4fc20879d21ebe$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $3f4fc20879d21ebe$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $3f4fc20879d21ebe$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $3f4fc20879d21ebe$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $3f4fc20879d21ebe$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $3f4fc20879d21ebe$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $3f4fc20879d21ebe$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $3f4fc20879d21ebe$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $3f4fc20879d21ebe$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $3f4fc20879d21ebe$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $3f4fc20879d21ebe$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $3f4fc20879d21ebe$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $3f4fc20879d21ebe$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $3f4fc20879d21ebe$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $3f4fc20879d21ebe$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $3f4fc20879d21ebe$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $3f4fc20879d21ebe$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $3f4fc20879d21ebe$export$2344b14b097df817);
// src/selection.ts

var $gZGBX = parcelRequire("gZGBX");

var $kCV8T = parcelRequire("kCV8T");
var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
    if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $kCV8T.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $kCV8T.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $kCV8T.Node) && node.type && node.type.spec.selectable);
var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
    if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, $gZGBX.NodeSelection)(tr.doc.resolve(pos)));
    return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
};
var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
            }
        }
        if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, $gZGBX.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $gZGBX.NodeSelection);
};
var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $3f4fc20879d21ebe$var$cloneTr(tr);
        }
        return tr;
    };
var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $kCV8T.Fragment) ? content : (0, $kCV8T.Fragment).from(content));
};
var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $kCV8T.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $kCV8T.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
    };
var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
    };
var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
};
var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
    };
var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $gZGBX.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("hFEwm", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $451fe475e5e2c47a$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $kCV8T = parcelRequire("kCV8T");

var $gZGBX = parcelRequire("gZGBX");

var $6MNnJ = parcelRequire("6MNnJ");

var $uOUlv = parcelRequire("uOUlv");

var $6hQQ3 = parcelRequire("6hQQ3");

var $6e6o8 = parcelRequire("6e6o8");

var $aKDxB = parcelRequire("aKDxB");

var $bQFBc = parcelRequire("bQFBc");
class $451fe475e5e2c47a$export$831cc7e2a83afa94 extends (0, $gZGBX.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $aKDxB.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $6hQQ3.pointsAtCell)($anchorCell) && (0, $6hQQ3.pointsAtCell)($headCell) && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $gZGBX.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $6e6o8.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $6e6o8.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $kCV8T.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $kCV8T.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $kCV8T.Slice).empty : content);
        }
        const sel = (0, $gZGBX.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $kCV8T.Slice)((0, $kCV8T.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $uOUlv.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $uOUlv.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $451fe475e5e2c47a$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $uOUlv.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $6MNnJ.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $gZGBX.Selection).jsonID('cell', $451fe475e5e2c47a$export$831cc7e2a83afa94);

});
parcelRegister("6MNnJ", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $7bc56074adb266b5$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $gZGBX = parcelRequire("gZGBX");

var $bQFBc = parcelRequire("bQFBc");
class $7bc56074adb266b5$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $7bc56074adb266b5$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bQFBc.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $gZGBX.Selection).fromJSON(doc, data);
        }
        return (0, $gZGBX.Selection).near($headCell, 1);
    }
}

});
parcelRegister("bQFBc", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $e501ca8feab95168$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $e501ca8feab95168$export$debd62b44eb7e281);
function $e501ca8feab95168$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $e501ca8feab95168$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("uOUlv", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $ca500cf7ecedd822$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $ca500cf7ecedd822$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $ca500cf7ecedd822$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $ca500cf7ecedd822$var$readFromCache, $ca500cf7ecedd822$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $ca500cf7ecedd822$var$readFromCache = (key)=>cache.get(key);
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $ca500cf7ecedd822$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $ca500cf7ecedd822$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $ca500cf7ecedd822$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $ca500cf7ecedd822$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $ca500cf7ecedd822$export$c60fae4049791eae = 140;
class $ca500cf7ecedd822$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $ca500cf7ecedd822$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $ca500cf7ecedd822$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $ca500cf7ecedd822$var$readFromCache(table) || $ca500cf7ecedd822$var$addToCache(table, $ca500cf7ecedd822$var$computeMap(table));
    }
}
// Compute a table map.
function $ca500cf7ecedd822$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $ca500cf7ecedd822$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $ca500cf7ecedd822$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($ca500cf7ecedd822$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $ca500cf7ecedd822$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $ca500cf7ecedd822$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $ca500cf7ecedd822$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $ca500cf7ecedd822$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca500cf7ecedd822$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("6hQQ3", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $6704a47d099ba366$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $6704a47d099ba366$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $6704a47d099ba366$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $6704a47d099ba366$export$172699367bb25225);

var $uOUlv = parcelRequire("uOUlv");
function $6704a47d099ba366$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $6704a47d099ba366$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $6704a47d099ba366$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $6704a47d099ba366$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $uOUlv.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("6e6o8", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $44eb8577da1c519b$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $44eb8577da1c519b$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $44eb8577da1c519b$export$147ee78a1321ac36);
function $44eb8577da1c519b$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $44eb8577da1c519b$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("aKDxB", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $d20b421410b3cfed$export$a60a444208fd5099);

var $gZGBX = parcelRequire("gZGBX");

var $uOUlv = parcelRequire("uOUlv");
function $d20b421410b3cfed$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $uOUlv.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $gZGBX.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("fc6h8", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $d5e5ded83470406e$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("4zXba", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $e819a2725d93345d$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $e819a2725d93345d$export$6d018dd0f6cbebcb);

var $e4eHl = parcelRequire("e4eHl");

var $3T6Xo = parcelRequire("3T6Xo");
const $e819a2725d93345d$var$EMPTY = {};
function $e819a2725d93345d$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $e819a2725d93345d$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($e819a2725d93345d$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("9gOVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a549b54270369c2c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kCV8T = parcelRequire("kCV8T");

var $gmhCD = parcelRequire("gmhCD");

var $3kKuL = parcelRequire("3kKuL");
parcelRequire("gJX6d");
var $5KNWO = parcelRequire("5KNWO");
var $gJX6d = parcelRequire("gJX6d");

var $5BLIh = parcelRequire("5BLIh");

var $cKKwC = parcelRequire("cKKwC");
var $GDkvY = parcelRequire("GDkvY");

var $eQNWQ = parcelRequire("eQNWQ");

var $5or39 = parcelRequire("5or39");

var $K5Jsy = parcelRequire("K5Jsy");

var $5r0mK = parcelRequire("5r0mK");

var $VSDnB = parcelRequire("VSDnB");

var $bzwTW = parcelRequire("bzwTW");

var $bVGKe = parcelRequire("bVGKe");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");
function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $kCV8T.MarkType) && prev && prev.type instanceof (0, $kCV8T.MarkType) && Array.isArray(prev.content) && (0, $eQNWQ.isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $a549b54270369c2c$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $gJX6d.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $GDkvY.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $cKKwC.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $cKKwC.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bVGKe.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $5KNWO.DocWithSelectAllTrap) : (0, $5KNWO.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $gJX6d.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $gJX6d.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $GDkvY.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5BLIh.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $h5tvG.segmentText)(mark.text, this.textHighlighter);
        return (0, $3VpWO.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $2OMIu.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $bzwTW.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $bzwTW.insideTable)(path, node.type.schema);
        // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
        const stickyHeaders = !isInsideOfTable && !(0, $bzwTW.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $5or39.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            isPresentational: (0, $VSDnB.fg)('platform_renderer_isPresentational') ? this.isPresentational : false
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $bzwTW.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $3kKuL.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $K5Jsy.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $gJX6d.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $eQNWQ.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 - Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("3kKuL", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $e845fca6b21fd822$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $e845fca6b21fd822$export$acb253d79d72af92);
function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("gJX6d", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $2b5167c1d6aa176d$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $2b5167c1d6aa176d$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $2b5167c1d6aa176d$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $2b5167c1d6aa176d$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $2b5167c1d6aa176d$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("5KNWO")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5KNWO")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4qBtX = parcelRequire("4qBtX");

var $iiXGq = parcelRequire("iiXGq");
var $9kpKZ = parcelRequire("9kpKZ");

var $VSDnB = parcelRequire("VSDnB");

var $atrOQ = parcelRequire("atrOQ");

var $4dtZR = parcelRequire("4dtZR");

var $2SZph = parcelRequire("2SZph");

var $bQeYo = parcelRequire("bQeYo");

var $cOnYv = parcelRequire("cOnYv");

var $cWRvh = parcelRequire("cWRvh");

var $5KNWO = parcelRequire("5KNWO");

var $i8Zwf = parcelRequire("i8Zwf");

var $lKIDi = parcelRequire("lKIDi");

var $7AttJ = parcelRequire("7AttJ");

var $112O7 = parcelRequire("112O7");

var $ieJGA = parcelRequire("ieJGA");

var $3RqVz = parcelRequire("3RqVz");

var $qjsNK = parcelRequire("qjsNK");

var $jHa9U = parcelRequire("jHa9U");

var $6svWT = parcelRequire("6svWT");

var $9FXQX = parcelRequire("9FXQX");

var $hqBb9 = parcelRequire("hqBb9");

var $ixoQV = parcelRequire("ixoQV");

var $dkc63 = parcelRequire("dkc63");

var $cWojJ = parcelRequire("cWojJ");

var $i4Lgj = parcelRequire("i4Lgj");

var $gfMkN = parcelRequire("gfMkN");

const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8WMBu")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("kHVHQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("1KGZa")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("4OnIJ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("clvfA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("2Fwz0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hQAvz")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("2c01v")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("hSHcF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8ugtC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5WPrU")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("6tHHQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("8m1sA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("jHdEo")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("bokwI")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("dmxb9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("32Gvn")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("XeDOe")).then((mod)=>mod.default),
    loading: ()=>null
});

const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("aVEPl")).then((mod)=>mod.default),
    loading: ()=>null
});
const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
    blockquote: (0, $atrOQ.default),
    bulletList: (0, $cWRvh.default),
    blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
    caption: (0, $jHa9U.default),
    date: $2b5167c1d6aa176d$export$6341f9a885713487,
    decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
    decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
    doc: (0, $5KNWO.default),
    emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
    extension: (0, $i8Zwf.default),
    bodiedExtension: (0, $4dtZR.default),
    multiBodiedExtension: (0, $bQeYo.default),
    extensionFrame: (0, $cOnYv.default),
    hardBreak: (0, $lKIDi.default),
    heading: (0, $7AttJ.default),
    inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
    inlineExtension: (0, $112O7.default),
    layoutSection: (0, $ieJGA.default),
    layoutColumn: (0, $3RqVz.default),
    listItem: (0, $qjsNK.default),
    media: $2b5167c1d6aa176d$export$7fc53215244aec38,
    mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
    mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
    mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
    mention: $2b5167c1d6aa176d$export$e891316fea657d90,
    orderedList: (0, $6svWT.default),
    panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
    paragraph: (0, $9FXQX.default),
    placeholder: (0, $hqBb9.default),
    rule: (0, $ixoQV.default),
    status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
    taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
    taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
    table: (0, $dkc63.default),
    tableCell: (0, $cWojJ.TableCell),
    tableHeader: (0, $cWojJ.TableHeader),
    tableRow: (0, $i4Lgj.default),
    unknownBlock: (0, $gfMkN.default),
    unsupportedBlock: (0, $iiXGq.default),
    unsupportedInline: (0, $9kpKZ.default),
    expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
    embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
};
const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $5KNWO.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
        return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
        ...nodeComponents
    };
    nodes['multiBodiedExtension'] = (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $bQeYo.default) : (0, $2SZph.default);
    return nodes[node.type.name];
};
const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
};
const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("4qBtX", function(module, exports) {
"use strict";
var $3396aa4dae68f4b9$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $3396aa4dae68f4b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3396aa4dae68f4b9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3396aa4dae68f4b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $3396aa4dae68f4b9$var$ALL_INITIALIZERS = [];
var $3396aa4dae68f4b9$var$READY_INITIALIZERS = [];
function $3396aa4dae68f4b9$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $3396aa4dae68f4b9$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $3396aa4dae68f4b9$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $3396aa4dae68f4b9$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $3396aa4dae68f4b9$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $3396aa4dae68f4b9$var$render(loaded, props) {
    return $5uXOq.createElement($3396aa4dae68f4b9$var$resolve(loaded), props);
}
function $3396aa4dae68f4b9$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $3396aa4dae68f4b9$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $3396aa4dae68f4b9$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $3396aa4dae68f4b9$var$READY_INITIALIZERS.push(function() {
        if ($3396aa4dae68f4b9$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $3396aa4dae68f4b9$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $3396aa4dae68f4b9$var$_classCallCheck(this, LoadableComponent);
            var _this = $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $5uXOq.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($5uXOq.Component), _class.contextTypes = {
        loadable: $8rCP3.shape({
            report: $8rCP3.func.isRequired
        })
    }, _temp;
}
function $3396aa4dae68f4b9$var$Loadable(opts) {
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$load, opts);
}
function $3396aa4dae68f4b9$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $3396aa4dae68f4b9$var$createLoadableComponent($3396aa4dae68f4b9$var$loadMap, opts);
}
$3396aa4dae68f4b9$var$Loadable.Map = $3396aa4dae68f4b9$var$LoadableMap;
var $3396aa4dae68f4b9$var$Capture = function(_React$Component2) {
    $3396aa4dae68f4b9$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $3396aa4dae68f4b9$var$_classCallCheck(this, Capture);
        return $3396aa4dae68f4b9$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $5uXOq.Children.only(this.props.children);
    };
    return Capture;
}($5uXOq.Component);
$3396aa4dae68f4b9$var$Capture.propTypes = {
    report: $8rCP3.func.isRequired
};
$3396aa4dae68f4b9$var$Capture.childContextTypes = {
    loadable: $8rCP3.shape({
        report: $8rCP3.func.isRequired
    }).isRequired
};
$3396aa4dae68f4b9$var$Loadable.Capture = $3396aa4dae68f4b9$var$Capture;
function $3396aa4dae68f4b9$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $3396aa4dae68f4b9$var$flushInitializers(initializers);
    });
}
$3396aa4dae68f4b9$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$3396aa4dae68f4b9$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $3396aa4dae68f4b9$var$flushInitializers($3396aa4dae68f4b9$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $3396aa4dae68f4b9$var$Loadable;

});

parcelRegister("9kpKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b743bc5ccb58a13$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $iHYdz = parcelRequire("iHYdz");

var $dg0Fl = parcelRequire("dg0Fl");

var $3bDjY = parcelRequire("3bDjY");

var $gkwXh = parcelRequire("gkwXh");

var $7R1zM = parcelRequire("7R1zM");

var $d54NZ = parcelRequire("d54NZ");

var $9tFGn = parcelRequire("9tFGn");
const $5b743bc5ccb58a13$var$inlineNodeStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $iHYdz.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $9tFGn.getUnsupportedContent)((0, $7R1zM.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $7R1zM.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $5uXOq.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, $d54NZ.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $5b743bc5ccb58a13$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
        label: "?",
        LEGACY_size: "small"
    }))));
};
var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);

});

parcelRegister("atrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d51d57a125840f5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("blockquote", {
        children: props.children
    });
}

});

parcelRegister("4dtZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9e9d2beaec6b895$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $i8Zwf = parcelRequire("i8Zwf");

var $8Eu7T = parcelRequire("8Eu7T");

var $fAZXL = parcelRequire("fAZXL");

var $cWCI0 = parcelRequire("cWCI0");

var $gkwXh = parcelRequire("gkwXh");

var $4YrGg = parcelRequire("4YrGg");

var $1SqDw = parcelRequire("1SqDw");

var $VSDnB = parcelRequire("VSDnB");
const $b9e9d2beaec6b895$var$ValidationContextWrapper = ({ children: children })=>{
    // We override validation of nested tables in nested renderers as invalid ADF (but valid Prosemirror)
    // may have been introduced in the parent renderer's render and subsequent transformations.
    // For example - nested tables which are transformed from an extension node in ADF
    // to native Prosemirror nested table nodes in and this is invalid ADF.
    const validationContextValue = (0, $5uXOq.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    if (!(0, $VSDnB.fg)('platform_editor_nested_table_extension_comment_fix')) return children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1SqDw.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Eu7T.ErrorBoundary), {
        component: (0, $cWCI0.ACTION_SUBJECT).RENDERER,
        componentId: (0, $gkwXh.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4YrGg.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($b9e9d2beaec6b895$var$ValidationContextWrapper, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $i8Zwf.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1
                            }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                        } catch (e) {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $i8Zwf.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                    }
                })
            })
        })
    });
};
var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;

});
parcelRegister("i8Zwf", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $1a97cbb70a611ae8$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $1a97cbb70a611ae8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $l8Gxi = parcelRequire("l8Gxi");
const $1a97cbb70a611ae8$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $1a97cbb70a611ae8$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $1a97cbb70a611ae8$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $1a97cbb70a611ae8$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $1a97cbb70a611ae8$var$macroHeights[viewportSize];
    }
};
const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes)=>{
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    const viewportSize = $1a97cbb70a611ae8$var$getViewportSize(extensionId, extensionViewportSizes);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: options.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%',
                    minHeight: viewportSize
                },
                "data-layout": layout,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: overflowContainerClass,
                    children: content
                })
            })
    });
};
const $1a97cbb70a611ae8$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "extension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                }, undefined, parameters?.extensionId, extensionViewportSizes);
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters?.extensionId, extensionViewportSizes);
        }
    });
};
var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, $ajc8Z.default)($1a97cbb70a611ae8$var$Extension, {
    overflowSelector: `.${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("fAZXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cce7a6859f4709$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9Egzu = parcelRequire("9Egzu");

var $2vGdQ = parcelRequire("2vGdQ");
const $45cce7a6859f4709$var$inlineExtensionStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2vGdQ.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $f8Sb3.jsx)($45cce7a6859f4709$export$f41ccc3bd3324832, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Egzu.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $45cce7a6859f4709$export$f41ccc3bd3324832 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "inline-extension-renderer",
        css: $45cce7a6859f4709$var$inlineExtensionStyle
    }, children);
};

});
parcelRegister("gnH2s", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $36d4284a17bc60a0$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $36d4284a17bc60a0$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $36d4284a17bc60a0$export$67a7d49db68d30a0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $izxHQ = parcelRequire("izxHQ");
function $36d4284a17bc60a0$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $36d4284a17bc60a0$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $izxHQ.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$36d4284a17bc60a0$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $36d4284a17bc60a0$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>{
            if ((0, $VSDnB.fg)('confluence_preload_extension_providers')) {
                const maybePromise = $36d4284a17bc60a0$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
                if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $izxHQ.resolveImport)(node.render()));
                else {
                    const preloaded = maybePromise?.renderSync?.();
                    // Only product implemented preloading will return sync result
                    // However the out-of-box won't handle this. Confluence uses a custom implementation
                    return preloaded ? (0, $izxHQ.resolveImportSync)(preloaded) : (0, $izxHQ.resolveImport)(maybePromise.render());
                }
            } else return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $izxHQ.resolveImport)(node.render()));
        },
        loading: $36d4284a17bc60a0$var$ExtensionLoading
    });
}

});
parcelRegister("izxHQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $23c4e3f9598df846$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $23c4e3f9598df846$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImportSync", () => $23c4e3f9598df846$export$dca2026e63034304);
$parcel$export(module.exports, "resolveImport", () => $23c4e3f9598df846$export$d69c9b451c47653b);
const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
}
const $23c4e3f9598df846$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
    return $23c4e3f9598df846$export$dca2026e63034304(await importPromise);
};
function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("9Egzu", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $76144329c6f313cf$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $5uXOq = parcelRequire("5uXOq");
class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("2vGdQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $f7ce50c6d2d400b7$export$9214452ef07eda7);
function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("ajc8Z", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $0d6cb6e0383d0ba0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bbl9Y = parcelRequire("bbl9Y");
const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $bbl9Y.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("bbl9Y", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $cd027df5593f4e8b$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $cd027df5593f4e8b$export$51a5b28e4fb2dba2);
var $cd027df5593f4e8b$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("eOOFp", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $081c5ce54850cd88$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $081c5ce54850cd88$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $081c5ce54850cd88$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $081c5ce54850cd88$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $081c5ce54850cd88$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $081c5ce54850cd88$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $081c5ce54850cd88$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $081c5ce54850cd88$export$70d1bf7729efff40);

var $iHYdz = parcelRequire("iHYdz");

var $8DYpW = parcelRequire("8DYpW");

var $9Iju4 = parcelRequire("9Iju4");

var $4ceoy = parcelRequire("4ceoy");

var $eQcNy = parcelRequire("eQcNy");
const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
    padding: (0, $iHYdz.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $iHYdz.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $iHYdz.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $iHYdz.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $iHYdz.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $9Iju4.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4ceoy.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                const wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcBreakoutWithCustomWidth: (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            // if below 0 then expect we're rendering in SSR
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(mode, editorContainerWidth);
    },
    calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $iHYdz.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
const $081c5ce54850cd88$export$ccc0a02edddeed39 = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth;
function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $eQcNy.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $iHYdz.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $eQcNy.parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $8DYpW.default).layoutFixedWidth;
        case 'wide':
            return (0, $8DYpW.default).layoutFullWidth;
        default:
            return (0, $8DYpW.default).layoutWide;
    }
};

});
parcelRegister("8DYpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb832a3bfaa1d66d$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7VHMR = parcelRequire("7VHMR");

var $l9HLU = parcelRequire("l9HLU");

var $8cp3a = parcelRequire("8cp3a");

var $1C4XH = parcelRequire("1C4XH");

var $9NKqk = parcelRequire("9NKqk");

var $fJyLQ = parcelRequire("fJyLQ");


var $gSYO9 = parcelRequire("gSYO9");

var $jDuvE = parcelRequire("jDuvE");


var $lQKNV = parcelRequire("lQKNV");

var $2i4K4 = parcelRequire("2i4K4");

var $eX53M = parcelRequire("eX53M");

var $80CM7 = parcelRequire("80CM7");

var $kXnoC = parcelRequire("kXnoC");

var $eDTMN = parcelRequire("eDTMN");

var $2V0EL = parcelRequire("2V0EL");

var $kFJBG = parcelRequire("kFJBG");

var $7S9ZN = parcelRequire("7S9ZN");

var $6OcHr = parcelRequire("6OcHr");

var $dbepQ = parcelRequire("dbepQ");

var $kANLZ = parcelRequire("kANLZ");

var $kmmxF = parcelRequire("kmmxF");

var $80TXs = parcelRequire("80TXs");

var $9QBHe = parcelRequire("9QBHe");

var $1IiUD = parcelRequire("1IiUD");

var $kAM3u = parcelRequire("kAM3u");

var $6lWmZ = parcelRequire("6lWmZ");

var $ixwvf = parcelRequire("ixwvf");

var $fJm1A = parcelRequire("fJm1A");

var $ecAvy = parcelRequire("ecAvy");

var $7ywdr = parcelRequire("7ywdr");

var $1ElKj = parcelRequire("1ElKj");



var $3AEXe = parcelRequire("3AEXe");


var $2y1kv = parcelRequire("2y1kv");
var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'View more options in toolbar'
    }
});

});
parcelRegister("l9HLU", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $c0194801a7a2c28d$export$5229ffea355cfdf6);

var $7VHMR = parcelRequire("7VHMR");
const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, $7VHMR.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("8cp3a", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $0f161f19f888f3d2$export$ff612ca71703201d);

var $7VHMR = parcelRequire("7VHMR");
const $0f161f19f888f3d2$export$ff612ca71703201d = (0, $7VHMR.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    },
    createCommentOnInlineNodeSpotlightBody: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
        defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
        description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
    },
    createCommentOnInlineNodeSpotlightAction: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
        defaultMessage: 'Got it',
        description: 'The content of the action button that closes the spotlight'
    }
});

});

parcelRegister("1C4XH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11841756f48da98b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $11841756f48da98b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Resize current element to wide mode'
    },
    resizeHandle: {
        id: 'fabric.editor.resizeHandle',
        defaultMessage: 'Resize handle',
        description: 'Resize handle'
    }
});

});

parcelRegister("9NKqk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f845f8650b83fa4e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f845f8650b83fa4e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("fJyLQ", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $bc1b61e25b99393f$export$42bb270d1224182);

var $7VHMR = parcelRequire("7VHMR");
const $bc1b61e25b99393f$export$42bb270d1224182 = (0, $7VHMR.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("gSYO9", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $6ccabeb0d4490fe2$export$4ce3884394d6d9);

var $7VHMR = parcelRequire("7VHMR");
const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, $7VHMR.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("jDuvE", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $8ffd20c106600435$export$2d7676d841c8ae9);

var $7VHMR = parcelRequire("7VHMR");
const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, $7VHMR.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'Go to link preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("lQKNV", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $20d0fb06aaa96548$export$74e304339778e94d);

var $7VHMR = parcelRequire("7VHMR");
const $20d0fb06aaa96548$export$74e304339778e94d = (0, $7VHMR.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("2i4K4", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $4423ee10317a70cf$export$70c8a7203d95247);

var $7VHMR = parcelRequire("7VHMR");
const $4423ee10317a70cf$export$70c8a7203d95247 = (0, $7VHMR.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: 'View more elements that can be inserted'
    },
    viewMoreAriaLabel: {
        id: 'fabric.editor.viewMoreAriaLabel',
        defaultMessage: 'View all elements',
        description: 'A more descriptive aria label describing that users can view all the elements to be inserted.'
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("eX53M", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("80CM7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $402c787ddf19f01c$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $402c787ddf19f01c$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("kXnoC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19e3f2f865259995$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19e3f2f865259995$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("eDTMN", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ec9866e02d0168cb$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    },
    askAI: {
        id: 'fabric.editor.navigate.toolbar.askAI',
        defaultMessage: 'Ask AI',
        description: 'Open the AI panel to ask a question or generate content.'
    }
});

});

parcelRegister("2V0EL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bcecf16097bd0035$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bcecf16097bd0035$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kFJBG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a872fd5a03f73724$export$defe85febe8b728c);
// Common Translations will live here

var $7VHMR = parcelRequire("7VHMR");
const $a872fd5a03f73724$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("7S9ZN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9078664297972b18$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9078664297972b18$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("6OcHr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b883afcc2fb8665e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b883afcc2fb8665e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    statusEditorLabel: {
        id: 'fabric.editor.statusEditorLabel',
        defaultMessage: 'Status editor',
        description: 'Label for the status element editor'
    },
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("dbepQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19b9098ff265842b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19b9098ff265842b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    },
    datePickerOpenedAlert: {
        id: 'fabric.editor.datePickerOpenedAlert',
        defaultMessage: 'Date editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the date picker is opened, letting the user know they can press the Tab button to access the date picker'
    }
});

});

parcelRegister("kANLZ", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $2ae4030e88533f57$export$81b075fd34c2f0bb);

var $7VHMR = parcelRequire("7VHMR");
const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, $7VHMR.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 Column layout',
        description: 'Layout with one column of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("kmmxF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e4735e0a5cdca6f9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("80TXs", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $cedd04a0024a64f8$export$8a0e7c3f8f5b8868);

var $7VHMR = parcelRequire("7VHMR");
const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, $7VHMR.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("9QBHe", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $b943fdad34912591$export$b46a930e1a386b2e);

var $7VHMR = parcelRequire("7VHMR");
const $b943fdad34912591$export$b46a930e1a386b2e = (0, $7VHMR.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("1IiUD", function(module, exports) {

$parcel$export(module.exports, "elementInsertSidePanel", () => $97dbccb0b0b981b3$export$276a218f93338b76);

var $7VHMR = parcelRequire("7VHMR");
const $97dbccb0b0b981b3$export$276a218f93338b76 = (0, $7VHMR.defineMessages)({
    title: {
        id: 'fabric.editor.elementInsertSidePanel.title',
        defaultMessage: 'Insert',
        description: 'Title of a panel that opens on the side'
    }
});

});

parcelRegister("kAM3u", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $147c4cd461faf1fe$export$effb4ee8b6f74abe);

var $7VHMR = parcelRequire("7VHMR");
const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, $7VHMR.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("6lWmZ", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $65d46911a2519e83$export$273d864e9e6d0b1f);

var $7VHMR = parcelRequire("7VHMR");
const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, $7VHMR.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    }
});

});

parcelRegister("ixwvf", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $358e275c47040b0e$export$ee8ab8a034b5a8bd);

var $7VHMR = parcelRequire("7VHMR");
const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, $7VHMR.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text for empty nodes'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Long placeholder text for empty nodes'
    }
});

});

parcelRegister("fJm1A", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $b0fedd2e9a93e39a$export$703e803e9cb0cea4);

var $7VHMR = parcelRequire("7VHMR");
const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, $7VHMR.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("ecAvy", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $e955dc2d97d725ff$export$7bb18eb6f9170174);

var $7VHMR = parcelRequire("7VHMR");
const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, $7VHMR.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("7ywdr", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a3d6d16f96d339d5$export$33aafd5ccbbbd00a);

var $7VHMR = parcelRequire("7VHMR");
const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, $7VHMR.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("1ElKj", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $691908dbd48d7aae$export$83c85447c71428ba);

var $7VHMR = parcelRequire("7VHMR");
const $691908dbd48d7aae$export$83c85447c71428ba = (0, $7VHMR.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("3AEXe", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $a755ba82139b4a7d$export$7eb9dc59242bbc45);

var $7VHMR = parcelRequire("7VHMR");
const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, $7VHMR.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});

parcelRegister("2y1kv", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarMessages", () => $14d5a3715e7fc293$export$b0226831bf5c0d3e);

var $7VHMR = parcelRequire("7VHMR");
const $14d5a3715e7fc293$export$b0226831bf5c0d3e = (0, $7VHMR.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for toolbar position options'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpined: {
        id: 'fabric.editor.toolbarPositionUnpined',
        defaultMessage: 'Pin the toolbar at the top',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionPinedAtTop: {
        id: 'fabric.editor.toolbarPositionPinedAtTop',
        defaultMessage: 'Unpin the toolbar',
        description: 'Label for fixed at top toolbar position option'
    }
});

});


parcelRegister("eQcNy", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $ab609be3c0cbf6e9$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $ab609be3c0cbf6e9$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $ab609be3c0cbf6e9$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $ab609be3c0cbf6e9$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
    return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
}
function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
    return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("l8Gxi", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $ca55565f908e8e5d$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
    EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("8Eu7T", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $19f8e43ef61748ed$export$e926676385687eaf);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $1KzE6 = parcelRequire("1KzE6");

var $knXBU = parcelRequire("knXBU");

var $7Jxgt = parcelRequire("7Jxgt");
class $19f8e43ef61748ed$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $dWAZk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $1KzE6.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            children: this.props.children
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("1KzE6", function(module, exports) {

$parcel$export(module.exports, "logException", () => $8cb678cf4830ec10$export$f86b2a1a2ce291b3);

var $8eFcy = parcelRequire("8eFcy");
const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $8cb678cf4830ec10$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("4IfOW"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("5bwDx"));
        const sentryOptions = {
            dsn: (0, $8eFcy.isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
            release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("8eFcy", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $1a8a754a294d51a4$export$64d6499adf9b2e51);
const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("4IfOW", function(module, exports) {

let $36e78b2683548d65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36e78b2683548d65$var$load("5j2yR").then(()=>parcelRequire('hFoxV'));

});

parcelRegister("5bwDx", function(module, exports) {

let $3c674bc9dbc46d1b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c674bc9dbc46d1b$var$load("5ywns").then(()=>parcelRequire('1dEW4'));

});


parcelRegister("knXBU", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $11894d4d5d86b4b1$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $11894d4d5d86b4b1$export$e48589d9e4824227);
var $11894d4d5d86b4b1$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $11894d4d5d86b4b1$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $11894d4d5d86b4b1$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($11894d4d5d86b4b1$var$RESOLVE_METHOD || {});

});


parcelRegister("cWCI0", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $78ed418dcea0e38c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $78ed418dcea0e38c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $78ed418dcea0e38c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $78ed418dcea0e38c$export$9957974f8b4d8f74);
var $78ed418dcea0e38c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $78ed418dcea0e38c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    return ACTION;
}({});
var $78ed418dcea0e38c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    return ACTION_SUBJECT;
}({});
var $78ed418dcea0e38c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("4YrGg", function(module, exports) {

$parcel$export(module.exports, "AnnotationsPositionContext", () => $5dd0541565473935$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $5dd0541565473935$export$cef0157dd42cbb3f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $eka68 = parcelRequire("eka68");

var $8Mz83 = parcelRequire("8Mz83");

var $iYAgE = parcelRequire("iYAgE");

var $joddd = parcelRequire("joddd");

var $1oOiu = parcelRequire("1oOiu");

var $2NMNM = parcelRequire("2NMNM");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");

var $jw62c = parcelRequire("jw62c");
const $5dd0541565473935$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $joddd.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $5dd0541565473935$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    startPos: 1
});
const $5dd0541565473935$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1oOiu.useAnnotationStateByTypeEvent)({
        type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2EsbE.AnnotationRangeProvider), {
            allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kuusl.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8Mz83.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eka68.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider?.annotationManager) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jw62c.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$export$7121915072388536, {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                isNestedRender: isNestedRender,
                onLoadComplete: onLoadComplete,
                children: children
            })
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iYAgE.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($5dd0541565473935$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("eka68", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $38b360e678e45e5a$export$41cd4a02859c2806);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $1oOiu = parcelRequire("1oOiu");

var $fCNtA = parcelRequire("fCNtA");
const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1oOiu.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("iYAgE", function(module, exports) {

$parcel$export(module.exports, "ProvidersContext", () => $1cf3b601714e6f28$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1cf3b601714e6f28$export$aafe46a36ef535ba);

var $5uXOq = parcelRequire("5uXOq");
const $1cf3b601714e6f28$export$6a26b015ac619737 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $1cf3b601714e6f28$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $5uXOq.createContext)({});

});

parcelRegister("1oOiu", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $477334c02b9da473$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $477334c02b9da473$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $477334c02b9da473$export$26cf539704e444c1);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $88i6h = parcelRequire("88i6h");

var $gkwXh = parcelRequire("gkwXh");

var $dWAZk = parcelRequire("dWAZk");

var $jw62c = parcelRequire("jw62c");
const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $5uXOq.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $jw62c.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $5uXOq.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $jw62c.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $jw62c.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $477334c02b9da473$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $jw62c.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $jw62c.useAnnotationManagerState)();
    const selectedAnnotation = (0, $5uXOq.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $477334c02b9da473$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VIEWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("dEtqo", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $916fd31c0363f129$export$c1c4b33b4e7b1c70);

var $6Oghe = parcelRequire("6Oghe");
var $916fd31c0363f129$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $916fd31c0363f129$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6Oghe)))();
    }
}

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("jw62c", function(module, exports) {

$parcel$export(module.exports, "AnnotationManagerProvider", () => $dbab420736de348f$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $dbab420736de348f$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $dbab420736de348f$export$12cbbb89fb7702d0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $dEtqo = parcelRequire("dEtqo");

var $fCNtA = parcelRequire("fCNtA");
const $dbab420736de348f$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $dbab420736de348f$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)($dbab420736de348f$var$initState);
const $dbab420736de348f$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $dbab420736de348f$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$dbab420736de348f$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $88i6h.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $88i6h.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $88i6h.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $88i6h.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $88i6h.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $dbab420736de348f$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)($dbab420736de348f$var$reducer, $dbab420736de348f$var$initState);
    const actionContext = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    (0, $5uXOq.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $5uXOq.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $5uXOq.useRef)(undefined);
    (0, $5uXOq.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $88i6h.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
	 * This is a temporary solution to ensure that the annotation manager state is in sync with the
	 * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
	 * by the annotation manager itself.
	 */ (0, $5uXOq.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $88i6h.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $dEtqo.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($dbab420736de348f$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($dbab420736de348f$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $dbab420736de348f$export$654a1fb45487f838 = ()=>{
    return (0, $5uXOq.useContext)($dbab420736de348f$var$AnnotationManagerStateContext);
};
const $dbab420736de348f$export$12cbbb89fb7702d0 = ()=>{
    return (0, $5uXOq.useContext)($dbab420736de348f$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("fCNtA", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $7e61ed70df2336e9$export$66feffbad722f9d4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2NMNM = parcelRequire("2NMNM");

var $e8KHW = parcelRequire("e8KHW");

var $gkwXh = parcelRequire("gkwXh");

var $6pY1y = parcelRequire("6pY1y");
const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new (0, $6pY1y.default)());
function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const actions = (0, $5uXOq.useMemo)(()=>new (0, $6pY1y.default)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) > 1 && (0, $VSDnB.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $e8KHW.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, $VSDnB.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children) : children
    });
}
const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("6pY1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7850a7dc1aaf7e$export$2e2bcd8739ae039);

var $88i6h = parcelRequire("88i6h");

var $h03xs = parcelRequire("h03xs");

var $hYNZx = parcelRequire("hYNZx");

var $gZGBX = parcelRequire("gZGBX");

var $gkwXh = parcelRequire("gkwXh");

var $eS2Dn = parcelRequire("eS2Dn");

var $VSDnB = parcelRequire("VSDnB");

var $cMPbW = parcelRequire("cMPbW");

var $4apTl = parcelRequire("4apTl");

var $hAPWV = parcelRequire("hAPWV");
class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.debugAnalyticLoggingEnabled = false;
        // TODO: EDITOR-595 - This method is temporary and should be removed once the following issue
        // has been identified and fixed: https://atlassian.slack.com/archives/C08JK0WSCH5/p1745902609966999
        // This is a copy of the original canApplyAnnotationOnRange. If that returns false this is run to figure out exactly why
        // the annotation cannot be applied to the range.
        this._privateWhyCannotApplyAnnotationOnRange = (pos, doc, schema)=>{
            const { from: from, to: to } = pos;
            if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return 'position invalid';
            const reasons = [];
            doc.nodesBetween(from, to, (node, _pos, parent)=>{
                // Special exception for hardBreak nodes
                if (schema.nodes.hardBreak === node.type) return false;
                // For block elements or text nodes, we want to check
                // if annotations are allowed inside this tree
                // or if we're leaf and not text
                if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                    const isAllowedInlineNode = [
                        'emoji',
                        'status',
                        'date',
                        'mention',
                        'inlineCard'
                    ].includes(node.type.name);
                    if (node.isInline && !node.isText && !isAllowedInlineNode) {
                        reasons.push(`Err 1 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isLeaf && !node.isText && !isAllowedInlineNode) {
                        reasons.push(`Err 2 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                        reasons.push(`Err 3 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}, parent: ${parent?.type.name}`);
                        return false;
                    }
                } else {
                    if (node.isInline && !node.isText) {
                        reasons.push(`Err 4 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isLeaf && !node.isText) {
                        reasons.push(`Err 5 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}`);
                        return false;
                    } else if (node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                        reasons.push(`Err 6 - type: ${node.type.name}, isInline: ${node.isInline}, isText: ${node.isText}, isLeaf: ${node.isLeaf}, parent: ${parent?.type.name}`);
                        return false;
                    }
                }
                return true;
            });
            return reasons.join(', ');
        };
        this.initFromContext = initFromContext;
        this.transformer = new (0, $hYNZx.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation failed - Missing doc or schema`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isDocValid: !!this.doc,
                    isSchemaValid: !!this.schema
                }
            });
            return false;
        }
        const currentSelection = (0, $gZGBX.TextSelection).create(this.doc, from, to);
        if ((0, $h03xs.isEmptyTextSelection)(currentSelection, this.schema)) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation - Empty Text Selection`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    from: from,
                    to: to
                }
            });
            return false;
        }
        const result = (0, $h03xs.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        if (this.debugAnalyticLoggingEnabled && !result && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
            // @ts-ignore
            action: 'failed',
            // @ts-ignore
            actionSubject: 'applyAnnotation',
            // @ts-ignore
            actionSubjectId: 'inlineCommentFailureReason',
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // @ts-ignore
                reason: `Annotation canApplyAnnotationOnRange failed`,
                details: this._privateWhyCannotApplyAnnotationOnRange({
                    from: from,
                    to: to
                }, this.doc, this.schema),
                commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                from: from,
                to: to
            }
        });
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $eS2Dn.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $eS2Dn.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $gkwXh.ACTION).DELETED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $eS2Dn.RemoveMarkStep) ? (0, $4apTl.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) {
            if (this.debugAnalyticLoggingEnabled && this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation Position validation failed - Missing doc or position`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isPosValid: !!pos,
                    isDocValid: !!this.doc
                }
            });
            return false;
        }
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $cMPbW.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $cMPbW.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $h03xs.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) {
            if (this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation applyAnnotation failed - Missing doc, position or schema`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes'),
                    isPosValid: !!pos,
                    isDocValid: !!this.doc,
                    isSchemaValid: !!this.schema
                }
            });
            return false;
        }
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $eS2Dn.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $cMPbW.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) {
            if (this.onAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) this.onAnalyticsEvent({
                // @ts-ignore
                action: 'failed',
                // @ts-ignore
                actionSubject: 'applyAnnotation',
                // @ts-ignore
                actionSubjectId: 'inlineCommentFailureReason',
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    // @ts-ignore
                    reason: `Annotation applyAnnotation failed - ${failed}`,
                    commentsOnInlineNodesAllowed: (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')
                }
            });
            return false;
        }
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $4apTl.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $hAPWV.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $h03xs.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
    /**
	 * This is a temporary method used for controlling when extra analytics shoulw be logged.
	 */ _setDebugLogging(enabled) {
        this.debugAnalyticLoggingEnabled = enabled;
    }
}

});
parcelRegister("h03xs", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $ccb20202dc8fa865$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $ccb20202dc8fa865$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $ccb20202dc8fa865$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $ccb20202dc8fa865$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $ccb20202dc8fa865$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $ccb20202dc8fa865$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $ccb20202dc8fa865$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $ccb20202dc8fa865$export$2efbc6d84ea0fbec);

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");
const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("cMPbW", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $c9441534493a403f$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $c9441534493a403f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $c9441534493a403f$export$74899f7e5acb5cd3);

var $VSDnB = parcelRequire("VSDnB");

var $eS2Dn = parcelRequire("eS2Dn");
function $c9441534493a403f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
function $c9441534493a403f$var$isPositionPointer(element) {
    return $c9441534493a403f$var$getStartPos(element) > -1;
}
function $c9441534493a403f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
    return $c9441534493a403f$var$findParent(parentElement);
}
function $c9441534493a403f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $c9441534493a403f$var$findMediaParent(parentElement);
}
function $c9441534493a403f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
    return $c9441534493a403f$var$findParentBeforePointer(parentElement);
}
function $c9441534493a403f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $c9441534493a403f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $c9441534493a403f$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $c9441534493a403f$var$isNodeInlineMark(node) {
    return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $c9441534493a403f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $c9441534493a403f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
    if ($c9441534493a403f$var$isElementNode(node)) {
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $c9441534493a403f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if ((0, $VSDnB.fg)('platform_editor_annotation_position_comment_nodes')) {
            if (prev.nodeType === Node.COMMENT_NODE) {
                // Comment nodes should not result in the position being
                // incremented, so we skip them.
                prev = prev.previousSibling;
                continue;
            }
        }
        if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $c9441534493a403f$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $c9441534493a403f$var$getStartPos(node) + offset;
    }
    const parent = $c9441534493a403f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $eS2Dn.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("4apTl", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $3b0115c3167e4664$export$b0ea72d31617ccea);

var $h03xs = parcelRequire("h03xs");

var $VSDnB = parcelRequire("VSDnB");
function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $h03xs.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("hAPWV", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $8b6d6fb20e026dde$export$fb7dab895a0d310e);
function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});






parcelRegister("8Mz83", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $68c25c02b6872087$export$787af8a111ff3c03);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");

var $6MIvG = parcelRequire("6MIvG");

var $iatcV = parcelRequire("iatcV");
const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6MIvG.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iatcV.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};

});
parcelRegister("6MIvG", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $38d3fe2fadcf735b$export$6d8376a902cb8aa7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7g31n = parcelRequire("7g31n");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");

var $kuusl = parcelRequire("kuusl");
const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $2EsbE.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $kuusl.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7g31n.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$38d3fe2fadcf735b$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("7g31n", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $3da53cae08f8e9e6$export$2109cd350bcf6eda);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $fCNtA = parcelRequire("fCNtA");

var $2EsbE = parcelRequire("2EsbE");
const $3da53cae08f8e9e6$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fVTp8", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $c2a45e53becb69f1$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $c2a45e53becb69f1$export$e14699d956e87e73);
const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
    const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("2EsbE", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $7c7af48337b91c7a$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $7c7af48337b91c7a$export$708fc397e2b6f08d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $7c7af48337b91c7a$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $7c7af48337b91c7a$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $7c7af48337b91c7a$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $7c7af48337b91c7a$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $7c7af48337b91c7a$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $5uXOq.useReducer)($7c7af48337b91c7a$var$reducer, $7c7af48337b91c7a$var$initialState);
    const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $5uXOq.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $5uXOq.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $5uXOq.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $5uXOq.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $5uXOq.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $5uXOq.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
	 * If this is a nested render, we do not provide the context
	 * because it has already been provided higher up the component tree
	 * and we need the original context to create annotations on extensions.
	 */ return isNestedRender ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($7c7af48337b91c7a$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$export$145b9bb655c3d220);
};
const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
    return (0, $5uXOq.useContext)($7c7af48337b91c7a$export$efb0d1c8cbaac647);
};

});


parcelRegister("kuusl", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $b758d405b6d3becf$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $b758d405b6d3becf$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $b758d405b6d3becf$export$c288883964405c82);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $b758d405b6d3becf$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWithinRange: false
});
const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
    const timeoutHandler = (0, $5uXOq.useRef)();
    const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $5uXOq.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $5uXOq.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
};
const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
    return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("iatcV", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d73a3647df6a8131$export$74435b85e23b84d9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jWe7H = parcelRequire("jWe7H");

var $bZQ2Q = parcelRequire("bZQ2Q");

var $fCNtA = parcelRequire("fCNtA");
const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $jWe7H.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bZQ2Q.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$d73a3647df6a8131$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("jWe7H", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $cd0f4805a1ba9aff$export$47201332e612f5a4);

var $5uXOq = parcelRequire("5uXOq");

var $2EsbE = parcelRequire("2EsbE");

var $jqO24 = parcelRequire("jqO24");

var $cMPbW = parcelRequire("cMPbW");

var $VSDnB = parcelRequire("VSDnB");

var $jw62c = parcelRequire("jw62c");
const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $5uXOq.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $2EsbE.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $jw62c.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $5uXOq.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $5uXOq.useCallback)((event)=>{
        if ((0, $VSDnB.fg)('platform_renderer_triple_click_selects_paragraph')) {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                    lastRangeRef.current = null; // Clear last range if selection is invalid
                    if (isAnnotationManagerEnabled) clearSelectionRange();
                    return;
                }
                let _range = sel.getRangeAt(0);
                // Skip if the selection hasn’t changed
                if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer } = _range;
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    if (isTripleClick) {
                        let p = startContainer;
                        while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                        if (p && p.nodeName === 'P' && p instanceof Element) {
                            const range = document.createRange();
                            range.selectNodeContents(p);
                            sel.removeAllRanges();
                            sel.addRange(range);
                            _range = sel.getRangeAt(0);
                        }
                    }
                    setSelectionRange(_range.cloneRange());
                    lastRangeRef.current = _range;
                }
            }, 100);
        } else {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                    if (isAnnotationManagerEnabled) clearSelectionRange();
                    return;
                }
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $jqO24.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                    const parentNode = startContainer.parentNode;
                    // ED-23493
                    // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                    // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                    // Triple clicks are the only case that can cause the endContainer to be a non-text node
                    // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                    // platform/packages/editor/renderer/src/steps/index.ts Line 180
                    // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                    if (isTripleClick && commonAncestorContainer && commonAncestorContainer.nodeType === Node.ELEMENT_NODE && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $cMPbW.isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P' // ignore if the parent node is strong, em, etc.
                    ) {
                        const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                        _range.setEnd(lastChild, lastChild.length || 0);
                    }
                    setSelectionRange(_range.cloneRange());
                }
            }, 250);
        }
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("jqO24", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $8373eb69e5c4287b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bZQ2Q", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $7e4c7bbc0d380e24$export$ca7741472ed8ba00);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bXrHm = parcelRequire("bXrHm");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $fVTp8 = parcelRequire("fVTp8");

var $dWAZk = parcelRequire("dWAZk");

var $gkwXh = parcelRequire("gkwXh");

var $4apTl = parcelRequire("4apTl");

var $fCNtA = parcelRequire("fCNtA");

var $jw62c = parcelRequire("jw62c");

var $2EsbE = parcelRequire("2EsbE");
const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $2EsbE.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $jw62c.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $4apTl.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) {
            // TODO: EDITOR-595 - This analytic event is temporary and should be removed once the following issue
            // has been identified and fixed: https://atlassian.slack.com/archives/C08JK0WSCH5/p1745902609966999
            if (createAnalyticsEvent && (0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) createAnalyticsEvent({
                action: 'failed',
                actionSubject: 'applyAnnotation',
                actionSubjectId: 'inlineCommentFailureReason',
                attributes: {
                    reason: 'Annotation Position invalid',
                    draftDocumentPosition: selectionDraftDocumentPosition,
                    documentPosition: documentPosition,
                    applyAnnotation: !!applyAnnotation,
                    isDraftPositionFixEnabled: true
                },
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        if ((0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) actions._setDebugLogging(true);
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INSERTED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK
        }).fire((0, $dWAZk.FabricChannel).editor);
        if ((0, $VSDnB.fg)('platform_renderer_annotations_create_debug_logging')) {
            const result = applyAnnotation(positionToAnnotate, annotation);
            actions._setDebugLogging(false);
            return result;
        } else return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $gkwXh.ACTION).OPENED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fVTp8.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $VSDnB.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $88i6h.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $gkwXh.ACTION).CLOSED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $dWAZk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $88i6h.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $5uXOq.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("joddd", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $9aa08f3110a2b008$export$39f7c1a861a0d41c);

var $5uXOq = parcelRequire("5uXOq");

var $dEtqo = parcelRequire("dEtqo");

var $VSDnB = parcelRequire("VSDnB");

var $iYAgE = parcelRequire("iYAgE");

var $fCNtA = parcelRequire("fCNtA");

var $jw62c = parcelRequire("jw62c");
const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $5uXOq.useContext)((0, $fCNtA.RendererContext));
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $5uXOq.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender && (0, $VSDnB.fg)('use_comments_data_annotation_updater')) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $dEtqo.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});


parcelRegister("1SqDw", function(module, exports) {

$parcel$export(module.exports, "ValidationContext", () => $a1d6c169ab0ab071$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $a1d6c169ab0ab071$export$5b655fe45447a548);

var $5uXOq = parcelRequire("5uXOq");
const $a1d6c169ab0ab071$export$d452675449e81987 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a1d6c169ab0ab071$export$5b655fe45447a548 = $a1d6c169ab0ab071$export$d452675449e81987.Provider;

});


parcelRegister("2SZph", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb082cddb2d59aba$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $5uXOq = parcelRequire("5uXOq");

var $i8Zwf = parcelRequire("i8Zwf");

var $fAZXL = parcelRequire("fAZXL");

var $edXiX = parcelRequire("edXiX");
var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");
const $fb082cddb2d59aba$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $fb082cddb2d59aba$var$navigationCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $fb082cddb2d59aba$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $fb082cddb2d59aba$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $f8Sb3.css)((0, $edXiX.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $edXiX.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $fb082cddb2d59aba$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fAZXL.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $i8Zwf.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $i8Zwf.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $fb082cddb2d59aba$export$2e2bcd8739ae039 = $fb082cddb2d59aba$var$MultiBodiedExtension;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("edXiX", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $a5dc814f02ba73ab$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $a5dc814f02ba73ab$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $a5dc814f02ba73ab$var$mbeExtensionContainer = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $a5dc814f02ba73ab$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $a5dc814f02ba73ab$var$extensionFrameContent = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
    mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
    extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
};

});


parcelRegister("bQeYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc6f3b113435da$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                                                                   * @jsxRuntime classic
                                                                                                                   * @jsx jsx
                                                                                                                   * @jsxFrag
                                                                                                                   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $4ceoy = parcelRequire("4ceoy");

var $l8Gxi = parcelRequire("l8Gxi");

var $eOOFp = parcelRequire("eOOFp");

var $dkSnq = parcelRequire("dkSnq");

var $e4NNv = parcelRequire("e4NNv");
function $c5dc6f3b113435da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c5dc6f3b113435da$var$containerStyles = {
    name: "utcqjk",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}"
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $c5dc6f3b113435da$var$MultiBodiedExtensionWrapper = ({ width: width, path: path, layout: layout, children: children })=>{
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: isTopLevel ? (0, $eOOFp.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $e4NNv.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $dkSnq.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $f8Sb3.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $f8Sb3.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("section", {
        css: [
            $c5dc6f3b113435da$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($c5dc6f3b113435da$var$MultiBodiedExtensionWrapper, {
            layout: layout,
            width: width,
            path: path
        }, renderContent())));
};
var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;

});
parcelRegister("dkSnq", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $ef5b9c26278248e6$export$3c7139d93ecb4f1f);

var $5uXOq = parcelRequire("5uXOq");
const $ef5b9c26278248e6$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild (_index) {
                return false;
            },
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("e4NNv", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $9b12fab9f9c859c0$export$e55394818db35473);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $gnH2s = parcelRequire("gnH2s");

var $9S8fM = parcelRequire("9S8fM");
const $9b12fab9f9c859c0$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>(0, $8QpSo.default)((0, $gnH2s.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState();
    const providerPromise = (0, $9S8fM.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $gnH2s.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("cOnYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $adf8f8318644b4cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $adf8f8318644b4cb$var$containerCSSOld = {
    name: "1e1nv5z",
    styles: "min-height:100px;flex-basis:100%"
};
const $adf8f8318644b4cb$var$containerCSSNew = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            (0, $VSDnB.fg)('platform_editor_multi_body_extension_extensibility') ? $adf8f8318644b4cb$var$containerCSSNew : $adf8f8318644b4cb$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;

});

parcelRegister("cWRvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4346c39a86c4f3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kjhhp = parcelRequire("kjhhp");

var $503mU = parcelRequire("503mU");
function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $kjhhp.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("503mU", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $95f5719763d590de$export$75aa84e85754623e);
function $95f5719763d590de$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("5KNWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e507ebac88967e63$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $e507ebac88967e63$export$41121a410ca2f650);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $l8Gxi = parcelRequire("l8Gxi");

var $bGnBY = parcelRequire("bGnBY");
function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $e507ebac88967e63$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (0, $bGnBY.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $l8Gxi.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("bGnBY", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $08249876083d1eac$export$98871b245ee25215);

var $gkwXh = parcelRequire("gkwXh");

var $5uXOq = parcelRequire("5uXOq");

var $TM1uy = parcelRequire("TM1uy");

var $lb6Ua = parcelRequire("lb6Ua");
const $08249876083d1eac$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $TM1uy.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $lb6Ua.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                action: (0, $gkwXh.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("TM1uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e1e4f8cfab5159$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $64e1e4f8cfab5159$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;

});

parcelRegister("lb6Ua", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $854590065f4073c9$export$6e6724d89f27411);
class $854590065f4073c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("lKIDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a311e98fd838fb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("br", {});
};
var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;

});

parcelRegister("7AttJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20de8dc9c3ed0b1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");

var $bFU4G = parcelRequire("bFU4G");

var $gkwXh = parcelRequire("gkwXh");

var $TM1uy = parcelRequire("TM1uy");

var $jSk6P = parcelRequire("jSk6P");

var $3rouw = parcelRequire("3rouw");
const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $TM1uy.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3rouw.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $gkwXh.ACTION).CLICKED,
                        actionSubject: (0, $gkwXh.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $gkwXh.EVENT_TYPE).UI
                    });
                    return (0, $jSk6P.copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $e20de8dc9c3ed0b1$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $bFU4G.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(HX, {
                id: headingIdToUse,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                onMouseEnter: mouseEnterHandler,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $2OMIu.jsx)($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    headingId: headingId
                })
            })
        ]
    });
}
var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;

});
parcelRegister("jSk6P", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2ff51d830678d63e$export$f980440e1ab4537d);
const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("3rouw", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b36f5408031b5508$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b36f5408031b5508$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $jOyH3 = parcelRequire("jOyH3");

var $3bDjY = parcelRequire("3bDjY");

var $1Bd5P = parcelRequire("1Bd5P");
function $b36f5408031b5508$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b36f5408031b5508$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b36f5408031b5508$var$copyAnchorButtonStyles = {
    name: "vhh4ux",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #44546F);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b36f5408031b5508$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $1Bd5P.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $1Bd5P.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $1Bd5P.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : headingId,
                type: "button"
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
                label: this.getCopyAriaLabel(),
                LEGACY_size: this.props.level > 3 ? 'small' : 'medium',
                color: this.state.isClicked ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
            }));
        };
    }
}
var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b36f5408031b5508$var$HeadingAnchor);

});
parcelRegister("1Bd5P", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $bb2bb569629ca076$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $bb2bb569629ca076$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $bb2bb569629ca076$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7VHMR = parcelRequire("7VHMR");
const $bb2bb569629ca076$export$74bada844422036d = (0, $7VHMR.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, $7VHMR.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, $7VHMR.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("112O7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bc2ade6d275922$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fAZXL = parcelRequire("fAZXL");
const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fAZXL.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(result)) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;

});

parcelRegister("ieJGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fd1bc0570bfa35$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gmhCD = parcelRequire("gmhCD");
function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
    return (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "layout-section-container",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-layout-section": true,
        children: props.children
    });
}

});

parcelRegister("3RqVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $93f45378df34617d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");
function $93f45378df34617d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $93f45378df34617d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthProvider), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $93f45378df34617d$var$clearNextSiblingMarginTopStyle,
            $93f45378df34617d$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("qjsNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd334ef870d278c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("jHa9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce9f67e250185e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8hSwr = parcelRequire("8hSwr");
const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hSwr.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;

});
parcelRegister("8hSwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb2c70aa755b661$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2AEnW = parcelRequire("2AEnW");
function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5bb2c70aa755b661$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $5bb2c70aa755b661$var$placeholderStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $5bb2c70aa755b661$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $5bb2c70aa755b661$var$placeholderStyle
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), null, formatMessage((0, $2AEnW.messages).placeholder))) : null, children);
    }
}
var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, $8RXs9.default)($5bb2c70aa755b661$export$f7feb87190a94c76);

});
parcelRegister("2AEnW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa314c48a072d691$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $aa314c48a072d691$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("6svWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6654d29b704d772$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dwptW = parcelRequire("dwptW");

var $jlYLw = parcelRequire("jlYLw");

var $uTDrM = parcelRequire("uTDrM");

var $503mU = parcelRequire("503mU");
function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $uTDrM.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $jlYLw.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $uTDrM.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $dwptW.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $503mU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("jlYLw", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $6a64108c33d9274c$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $6a64108c33d9274c$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $6a64108c33d9274c$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $gE8f9 = parcelRequire("gE8f9");
const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
var $6a64108c33d9274c$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($6a64108c33d9274c$var$CSS_VAR_NAMES || {});
const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
    return style;
}
const $6a64108c33d9274c$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $f8Sb3.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $gE8f9.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $dwptW.orderedListSelector), ",", (0, $kjhhp.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("uTDrM", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $ebe278356715a8a4$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $ebe278356715a8a4$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $ebe278356715a8a4$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $ebe278356715a8a4$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $ebe278356715a8a4$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $ebe278356715a8a4$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
};
const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
    const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $ebe278356715a8a4$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("9FXQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d2961aa3d14cef$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $EGPjg = parcelRequire("EGPjg");
function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        ...dataAttributes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $EGPjg.default), {
            children: children
        })
    }));
}

});
parcelRegister("EGPjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $372a7010ecff9ba7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("hqBb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $add04eab04996fda$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $add04eab04996fda$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
}

});

parcelRegister("ixoQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bb5022786e53a6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("dkc63", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $7478efdfea2a60bf$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $7478efdfea2a60bf$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $7478efdfea2a60bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $ajc8Z = parcelRequire("ajc8Z");
var $4ceoy = parcelRequire("4ceoy");

var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $fKLIs = parcelRequire("fKLIs");

var $gmhCD = parcelRequire("gmhCD");


var $cWojJ = parcelRequire("cWojJ");

var $4BsEy = parcelRequire("4BsEy");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");

var $cInAA = parcelRequire("cInAA");
const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $7478efdfea2a60bf$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $7478efdfea2a60bf$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $7478efdfea2a60bf$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $7478efdfea2a60bf$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $7478efdfea2a60bf$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $7478efdfea2a60bf$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $7478efdfea2a60bf$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $7478efdfea2a60bf$export$940095e914312886 = (node, children)=>{
    return $7478efdfea2a60bf$export$28daf78feed5098c(children) && node && node.firstChild && !$7478efdfea2a60bf$export$42f5658c8e0092da(node.firstChild);
};
class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $19a4579e32968c00$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth),
                `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $iHYdz.akEditorFullWidthLayoutWidth), renderWidth) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $fKLIs.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $7478efdfea2a60bf$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aXGN.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4mor.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $7478efdfea2a60bf$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $7478efdfea2a60bf$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $7478efdfea2a60bf$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $7478efdfea2a60bf$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $7478efdfea2a60bf$export$100baa0f10804e6e($7478efdfea2a60bf$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $7478efdfea2a60bf$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7478efdfea2a60bf$var$TableWithShadowsAndContainerStyles = (0, $ajc8Z.default)((0, $cInAA.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7478efdfea2a60bf$var$TableWithShadows = (0, $ajc8Z.default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cInAA.TableProcessorWithContainerStyles), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ceoy.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $19a4579e32968c00$export$12fd658e5eef0d79) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $2OMIu.jsx)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, $4BsEy.withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);

});
parcelRegister("6gEe5", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $356bd8bd1d42bb7c$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $356bd8bd1d42bb7c$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $356bd8bd1d42bb7c$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $356bd8bd1d42bb7c$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $356bd8bd1d42bb7c$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $356bd8bd1d42bb7c$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $356bd8bd1d42bb7c$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $356bd8bd1d42bb7c$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");

var $gE8f9 = parcelRequire("gE8f9");

var $cYeQP = parcelRequire("cYeQP");

var $hgR8Y = parcelRequire("hgR8Y");
function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
const $356bd8bd1d42bb7c$export$e5ff276883773ffd = 8;
const $356bd8bd1d42bb7c$export$880976487022eb5 = $356bd8bd1d42bb7c$export$808015ab1dd6897a + $356bd8bd1d42bb7c$export$e5ff276883773ffd - $356bd8bd1d42bb7c$export$72aad729077aa0fb;
const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $9UDEr.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $9UDEr.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $9UDEr.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $9UDEr.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $9UDEr.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $9UDEr.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $9UDEr.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $9UDEr.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $9UDEr.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $356bd8bd1d42bb7c$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $356bd8bd1d42bb7c$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $hgR8Y.tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $iHYdz.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $VSDnB.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"};
		}` : '', ".", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}", (0, $VSDnB.fg)('platform_editor_renderer_table_header_styles') ? `> tbody > tr > th, > tbody > tr > td` : 'th, td', "{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", (0, $gE8f9.browser).gecko || (0, $gE8f9.browser).ie || (0, $gE8f9.browser).mac && (0, $gE8f9.browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $iHYdz.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $iHYdz.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $iHYdz.akEditorBreakoutPadding) : 0), (0, $iHYdz.akEditorWideLayoutWidth));
            return 0, $iHYdz.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("eluMF", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $b41fea6975363b1e$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)();
};

});

parcelRegister("cYeQP", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $dca73d3fed5e4b1b$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $VSDnB = parcelRequire("VSDnB");
function $dca73d3fed5e4b1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
var $dca73d3fed5e4b1b$var$_ref = {
    name: "tagqr6",
    styles: "--ds--code--bg-color:transparent"
};
const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $f8Sb3.css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $iHYdz.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $iHYdz.akEditorCodeFontFamily), ";min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;white-space:normal;", (0, $VSDnB.fg)('platform_editor_fix_code_block_bg_color_in_macro') ? /*#__PURE__*/ (0, $f8Sb3.css)() : $dca73d3fed5e4b1b$var$_ref, " .code-block-gutter-pseudo-element::before{content:attr(data-label);}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "::before{content:'1';visibility:hidden;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $iHYdz.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $f8Sb3.css)("::before{content:' ';line-height:", (0, $iHYdz.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $iHYdz.akEditorLineHeight), "em!important;}");

});

parcelRegister("hgR8Y", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9UDEr = parcelRequire("9UDEr");

var $hAs1r = parcelRequire("hAs1r");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $9UDEr.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $hAs1r.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $f8Sb3.css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());

});
parcelRegister("hAs1r", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $3966f91ec47ca318$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $3966f91ec47ca318$export$a270511a0e7fd61a);
// This import will be stripped on build

var $kTHGn = parcelRequire("kTHGn");
function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $3966f91ec47ca318$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $kTHGn.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $kTHGn.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("5vnE9", function(module, exports) {

$parcel$export(module.exports, "compose", () => $8cb395a24b5942e2$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("5or39", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $a59f56ae192d20af$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $a59f56ae192d20af$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $a59f56ae192d20af$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $a59f56ae192d20af$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $a59f56ae192d20af$export$889a8e446452be16);
function $a59f56ae192d20af$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("5J0oM", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $c09b1d49576acabb$export$49215374a8bec29c);

var $9BYlQ = parcelRequire("9BYlQ");
var $c09b1d49576acabb$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $c09b1d49576acabb$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $c09b1d49576acabb$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, $9BYlQ.SortOrder).ASC)=>{
    const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $9BYlQ.SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("9BYlQ", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $42ab1316856d1585$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dEtqo = parcelRequire("dEtqo");

var $kXC89 = parcelRequire("kXC89");
var $42ab1316856d1585$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("kXC89", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $fa36a5395f686390$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $fa36a5395f686390$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $fa36a5395f686390$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $fa36a5395f686390$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $fa36a5395f686390$export$501a79d885598191);
var $fa36a5395f686390$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $fa36a5395f686390$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $fa36a5395f686390$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $fa36a5395f686390$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $fa36a5395f686390$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("fKLIs", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $78b5f00ff26d55fc$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $78b5f00ff26d55fc$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $78b5f00ff26d55fc$export$3930799be057b305);

var $5r0mK = parcelRequire("5r0mK");

var $iHYdz = parcelRequire("iHYdz");

var $bQr2R = parcelRequire("bQr2R");

var $ejmVg = parcelRequire("ejmVg");

var $6gEe5 = parcelRequire("6gEe5");

var $eOOFp = parcelRequire("eOOFp");
const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $iHYdz.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $iHYdz.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $iHYdz.akEditorFullWidthLayoutWidth)
};
const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth += (0, $iHYdz.akLayoutGutterOffset) * 2; // extra width that gets added to layout
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $iHYdz.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, $ejmVg.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
                const $pos = state.doc.resolve(pos);
                const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $ejmVg.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $bQr2R.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
            // padding left
            parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $6gEe5.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $iHYdz.akEditorFullWidthLayoutWidth)) : (0, $eOOFp.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, $iHYdz.akEditorDefaultLayoutWidth);
};
const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
    return $78b5f00ff26d55fc$export$3930799be057b305(node);
};

});
parcelRegister("bQr2R", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $6a203c68476205e6$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $6a203c68476205e6$export$91624ec52c59c24c);
const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
const $6a203c68476205e6$export$91624ec52c59c24c = 12;

});

parcelRegister("ejmVg", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $16b49a7404f3316f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $16b49a7404f3316f$export$a1bb91aa2d5fcce8);
const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;

});


const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

parcelRegister("cWojJ", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $decaf4f5703baa00$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $decaf4f5703baa00$export$1e4baea7053fc0e3);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");
var $9UDEr = parcelRequire("9UDEr");

var $hxoiH = parcelRequire("hxoiH");

var $9BYlQ = parcelRequire("9BYlQ");

var $hAs1r = parcelRequire("hAs1r");

var $hrpWq = parcelRequire("hrpWq");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $l8Gxi = parcelRequire("l8Gxi");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");
const $decaf4f5703baa00$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return (0, $9BYlQ.SortOrder).ASC;
        case (0, $9BYlQ.SortOrder).ASC:
            return (0, $9BYlQ.SortOrder).DESC;
        case (0, $9BYlQ.SortOrder).DESC:
            return (0, $9BYlQ.SortOrder).NO_ORDER;
    }
    return (0, $9BYlQ.SortOrder).NO_ORDER;
};
const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $1Bd5P.tableCellMessages);
    switch(currentSortOrder){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $hAs1r.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $87j2U.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $hxoiH.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $9UDEr.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $decaf4f5703baa00$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $koVbs.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $9BYlQ.SortOrder).NO_ORDER ? (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                className: (0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $2OMIu.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrpWq.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $gkwXh.ACTION).SORT_COLUMN,
                    actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $knXBU.PLATFORM).WEB,
                        mode: (0, $knXBU.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $gkwXh.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                },
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK
            });
        }
    };
};
const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;

});
parcelRegister("hrpWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d33846969f29997f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8RXs9 = parcelRequire("8RXs9");

var $3bDjY = parcelRequire("3bDjY");

var $9BYlQ = parcelRequire("9BYlQ");


var $3hakN = parcelRequire("3hakN");
function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d33846969f29997f$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$buttonStyles = /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $d33846969f29997f$var$iconWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $d33846969f29997f$var$iconStyles = {
    name: "14n17e4",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);user-select:none;&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $9BYlQ.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $3hakN.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $3hakN.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $9BYlQ.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $9BYlQ.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $9BYlQ.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $9BYlQ.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d33846969f29997f$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $d33846969f29997f$var$iconStyles
        ]
    }))));
};
var $d33846969f29997f$export$2e2bcd8739ae039 = (0, $8RXs9.default)($d33846969f29997f$var$SortingIcon);

});
const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

parcelRegister("3hakN", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $c1f584a2cfc01515$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $c1f584a2cfc01515$export$f142573f51a67577);

var $7VHMR = parcelRequire("7VHMR");
const $c1f584a2cfc01515$export$458c50917513cd1a = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $c1f584a2cfc01515$export$f142573f51a67577 = (0, $7VHMR.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("4BsEy", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $3b927b61a8274f19$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $3b927b61a8274f19$export$65e2d5a272a382b0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $3b927b61a8274f19$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(new Map());
const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("2aXGN", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $9b3e020198447653$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $9b3e020198447653$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $9b3e020198447653$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");


var $VSDnB = parcelRequire("VSDnB");

var $a4mor = parcelRequire("a4mor");

var $6cOrl = parcelRequire("6cOrl");
function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b3e020198447653$export$3de6413b528017ca = 8;
const $9b3e020198447653$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $9b3e020198447653$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, white)"
        }
    },
    borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
    background: "var(--ds-surface-overlay, white)",
    boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $9b3e020198447653$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $iHYdz.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $9b3e020198447653$var$fixedTableDivStaticStyles,
            $9b3e020198447653$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: (0, $VSDnB.fg)('sticky_header_in_embedded_confluence_fix') ? typeof top === 'number' ? `${top}px` : undefined : top ? `${top}px` : undefined
        }
    }, props.children);
};
const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($9b3e020198447653$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4mor.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $6cOrl.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $9b3e020198447653$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("a4mor", function(module, exports) {

$parcel$export(module.exports, "Table", () => $40c6d2c88bc98a0d$export$54ec01a60f47d33d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3nHPA = parcelRequire("3nHPA");

var $fKLIs = parcelRequire("fKLIs");

var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");
const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let tableWidth = tableNode ? (0, $fKLIs.getTableContainerWidth)(tableNode) : (0, $iHYdz.akEditorDefaultLayoutWidth);
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $VSDnB.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("table", {
        ...(0, $VSDnB.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3nHPA.Colgroup), {
                columnWidths: columnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("3nHPA", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $ae0cfecd7422435f$export$89efc2d0ceeaa030);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $fKLIs = parcelRequire("fKLIs");

var $9JDnL = parcelRequire("9JDnL");

var $dyURG = parcelRequire("dyURG");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $6gEe5.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $6gEe5.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : (0, $6gEe5.tableCellMinWidth));
};
const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $iHYdz.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, $fKLIs.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $iHYdz.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $6gEe5.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $6gEe5.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $iHYdz.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $iHYdz.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $iHYdz.akEditorTableLegacyCellMinWidth) ? (0, $iHYdz.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $dyURG.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $9JDnL.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $iHYdz.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});
parcelRegister("9JDnL", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $7cc75954bd6ebac0$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dyURG = parcelRequire("dyURG");
const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, $dyURG.useRendererContext)()?.featureFlags;

});
parcelRegister("dyURG", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $6d8aa882825f4203$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $6d8aa882825f4203$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $5uXOq = parcelRequire("5uXOq");
const $6d8aa882825f4203$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;

});




parcelRegister("6cOrl", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $7a2ba32d880ccda8$export$40e12ce8e0a76b0c);

var $5uXOq = parcelRequire("5uXOq");
function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("kjIja", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $b5d34963b73650ed$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $b5d34963b73650ed$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $b5d34963b73650ed$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $b5d34963b73650ed$export$33331a99fac775a1);
const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);

});

parcelRegister("eIscD", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $ea0307076d72d83e$export$8c072780619cfc83);

var $6gEe5 = parcelRequire("6gEe5");

var $VSDnB = parcelRequire("VSDnB");
class $ea0307076d72d83e$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.stickyScrollbarContainerElement = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        this.sentinels.bottom = (0, $VSDnB.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels?.item(bottomSentinels.length - 1) : this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});

parcelRegister("cInAA", function(module, exports) {

$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => $ef3de7a711c9e97e$export$827f89182557f335);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6gEe5 = parcelRequire("6gEe5");

var $fKLIs = parcelRequire("fKLIs");


var $VSDnB = parcelRequire("VSDnB");

var $5vnE9 = parcelRequire("5vnE9");
var $5or39 = parcelRequire("5or39");
var $5J0oM = parcelRequire("5J0oM");

var $9BYlQ = parcelRequire("9BYlQ");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");

var $cWojJ = parcelRequire("cWojJ");

var $2aXGN = parcelRequire("2aXGN");

var $a4mor = parcelRequire("a4mor");

var $kjIja = parcelRequire("kjIja");

var $eIscD = parcelRequire("eIscD");
const $ef3de7a711c9e97e$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $ef3de7a711c9e97e$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $ef3de7a711c9e97e$export$eec82c0a93aa66d9 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) || (0, $kjIja.isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $ef3de7a711c9e97e$export$bdb2dadcb04aad50 = (appearance)=>(0, $kjIja.isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $ef3de7a711c9e97e$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $9BYlQ.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $5J0oM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5or39.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $ef3de7a711c9e97e$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $ef3de7a711c9e97e$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $ef3de7a711c9e97e$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $ef3de7a711c9e97e$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $ef3de7a711c9e97e$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $ef3de7a711c9e97e$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cWojJ.TableHeader);
    return children.every((node)=>node.type === (0, $cWojJ.TableHeader));
};
const $ef3de7a711c9e97e$export$940095e914312886 = (node, children)=>{
    return $ef3de7a711c9e97e$export$28daf78feed5098c(children) && node && node.firstChild && !$ef3de7a711c9e97e$export$42f5658c8e0092da(node.firstChild);
};
class $ef3de7a711c9e97e$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $eIscD.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $2aXGN.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $6gEe5.tableMarginTop) - (0, $2aXGN.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $iHYdz.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $19a4579e32968c00$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $iHYdz.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $fKLIs.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $kjIja.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $kjIja.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $fKLIs.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $kjIja.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $kjIja.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $kjIja.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $iHYdz.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $ef3de7a711c9e97e$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aXGN.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode?.attrs.layout,
                        "data-autosize": tableNode?.attrs.__autoSize,
                        "data-table-local-id": tableNode?.attrs.localId,
                        "data-table-width": tableNode?.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a4mor.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $VSDnB.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: (0, $VSDnB.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                            ...$ef3de7a711c9e97e$var$stickyContainerBaseStyles,
                            ...$ef3de7a711c9e97e$var$stickyContainerAdditionalStyles
                        } : $ef3de7a711c9e97e$var$stickyContainerBaseStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            style: {
                                width: (0, $VSDnB.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $ef3de7a711c9e97e$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.updatedLayout = 'custom', this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $2aXGN.tableStickyPadding);
            const tableTop = $ef3de7a711c9e97e$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $ef3de7a711c9e97e$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $ef3de7a711c9e97e$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $ef3de7a711c9e97e$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        const orderedChildren = (0, $5vnE9.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $2OMIu.jsx)($ef3de7a711c9e97e$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $ef3de7a711c9e97e$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $5or39.hasMergedCell)(tableNode)) return $ef3de7a711c9e97e$export$100baa0f10804e6e($ef3de7a711c9e97e$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $ef3de7a711c9e97e$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}

});


parcelRegister("i4Lgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6cf54c99dd1cb3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5vnE9 = parcelRequire("5vnE9");

var $9BYlQ = parcelRequire("9BYlQ");

var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");
class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $2OMIu.jsx)("td", {
                    className: (0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $5vnE9.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && (!(0, $VSDnB.fg)('cc_complexit_fe_improve_table_sorting') || isHeaderRow)) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $9BYlQ.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $9BYlQ.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if ((0, $VSDnB.fg)('platform_editor_table_column_group_width_check_3') ? this.state.colGroupWidths?.length : this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("gfMkN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5be854e6b8cbd84$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("8WMBu", function(module, exports) {

let $01ae58891255b6e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01ae58891255b6e8$var$load("7uAi5").then(()=>parcelRequire('fyj1u'));

});

parcelRegister("kHVHQ", function(module, exports) {

let $f134960741cca6cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f134960741cca6cd$var$load("9JEXq").then(()=>parcelRequire('bO8HO'));

});

parcelRegister("1KGZa", function(module, exports) {

let $146b6e5faaa248eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $146b6e5faaa248eb$var$load("af9eo").then(()=>parcelRequire('iLXzZ'));

});

parcelRegister("4OnIJ", function(module, exports) {

let $380e3b5a085ebc97$var$load = (parcelRequire("28QjX"))(4);
module.exports = $380e3b5a085ebc97$var$load("eiJrL").then(()=>parcelRequire('5Y7e4'));

});

parcelRegister("clvfA", function(module, exports) {

let $8fcfafdd49347737$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fcfafdd49347737$var$load("bF2Yj").then(()=>parcelRequire('h2Mqp'));

});

parcelRegister("2Fwz0", function(module, exports) {

let $1f18ab91da841361$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f18ab91da841361$var$load("7vMvR").then(()=>parcelRequire('sFJC1'));

});

parcelRegister("hQAvz", function(module, exports) {

let $cfe39cbeca7c95a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cfe39cbeca7c95a6$var$load("7qbwG").then(()=>parcelRequire('4hMem'));

});

parcelRegister("2c01v", function(module, exports) {

let $198cb86922264390$var$load = (parcelRequire("28QjX"))(4);
module.exports = $198cb86922264390$var$load("hNOP2").then(()=>parcelRequire('c3ssB'));

});

parcelRegister("hSHcF", function(module, exports) {

let $d048fe1c0cc67525$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d048fe1c0cc67525$var$load("76n7a"),
    $d048fe1c0cc67525$var$load("l253H"),
    $d048fe1c0cc67525$var$load("ffQaD"),
    $d048fe1c0cc67525$var$load("kvRbA"),
    $d048fe1c0cc67525$var$load("aPoGi")
]).then(()=>parcelRequire('hibqv'));

});

parcelRegister("8ugtC", function(module, exports) {

let $62dde7fb2c16a4f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $62dde7fb2c16a4f8$var$load("76n7a"),
    $62dde7fb2c16a4f8$var$load("l253H"),
    $62dde7fb2c16a4f8$var$load("ffQaD"),
    $62dde7fb2c16a4f8$var$load("kvRbA"),
    $62dde7fb2c16a4f8$var$load("93KAt")
]).then(()=>parcelRequire('1lkep'));

});

parcelRegister("5WPrU", function(module, exports) {

let $454a4740a2b767cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $454a4740a2b767cb$var$load("fliVL"),
    $454a4740a2b767cb$var$load("76n7a"),
    $454a4740a2b767cb$var$load("l253H"),
    $454a4740a2b767cb$var$load("ffQaD"),
    $454a4740a2b767cb$var$load("kvRbA"),
    $454a4740a2b767cb$var$load("kNFvF"),
    $454a4740a2b767cb$var$load("dhTaM")
]).then(()=>parcelRequire('fz1ZD'));

});

parcelRegister("6tHHQ", function(module, exports) {

let $4b775aa4acac24a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $4b775aa4acac24a1$var$load("fliVL"),
    $4b775aa4acac24a1$var$load("76n7a"),
    $4b775aa4acac24a1$var$load("l253H"),
    $4b775aa4acac24a1$var$load("ffQaD"),
    $4b775aa4acac24a1$var$load("kvRbA"),
    $4b775aa4acac24a1$var$load("kNFvF"),
    $4b775aa4acac24a1$var$load("gNqLi")
]).then(()=>parcelRequire('lD0Zb'));

});

parcelRegister("8m1sA", function(module, exports) {

let $615182c0cb4d0375$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $615182c0cb4d0375$var$load("fliVL"),
    $615182c0cb4d0375$var$load("76n7a"),
    $615182c0cb4d0375$var$load("l253H"),
    $615182c0cb4d0375$var$load("ffQaD"),
    $615182c0cb4d0375$var$load("kvRbA"),
    $615182c0cb4d0375$var$load("kNFvF"),
    $615182c0cb4d0375$var$load("fig2F")
]).then(()=>parcelRequire('gQwn3'));

});

parcelRegister("jHdEo", function(module, exports) {

let $e56c9f2f2e5028d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e56c9f2f2e5028d1$var$load("76n7a"),
    $e56c9f2f2e5028d1$var$load("l253H"),
    $e56c9f2f2e5028d1$var$load("gguur")
]).then(()=>parcelRequire('aPwmB'));

});

parcelRegister("bokwI", function(module, exports) {

let $84b1dbc8c386e490$var$load = (parcelRequire("28QjX"))(4);
module.exports = $84b1dbc8c386e490$var$load("d0X7J").then(()=>parcelRequire('ebIkR'));

});

parcelRegister("dmxb9", function(module, exports) {

let $9ba7110bdfeaeeb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9ba7110bdfeaeeb3$var$load("76n7a"),
    $9ba7110bdfeaeeb3$var$load("l253H"),
    $9ba7110bdfeaeeb3$var$load("lNsfv")
]).then(()=>parcelRequire('74PfD'));

});

parcelRegister("32Gvn", function(module, exports) {

let $237287a63ccdc68d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $237287a63ccdc68d$var$load("1VmC7").then(()=>parcelRequire('9jt2S'));

});

parcelRegister("XeDOe", function(module, exports) {

let $0b20de37847b85c1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0b20de37847b85c1$var$load("ffQaD"),
    $0b20de37847b85c1$var$load("kvRbA"),
    $0b20de37847b85c1$var$load("76n7a"),
    $0b20de37847b85c1$var$load("l253H"),
    $0b20de37847b85c1$var$load("kRYcQ")
]).then(()=>parcelRequire('V5Yjo'));

});

parcelRegister("aVEPl", function(module, exports) {

let $7f4ee5b0867c0347$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7f4ee5b0867c0347$var$load("ffQaD"),
    $7f4ee5b0867c0347$var$load("kvRbA"),
    $7f4ee5b0867c0347$var$load("eIR2q")
]).then(()=>parcelRequire('hA9EZ'));

});


parcelRegister("5BLIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1269296b575a9fc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4dDLS = parcelRequire("4dDLS");
const $e1269296b575a9fc$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4dDLS.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;

});
parcelRegister("4dDLS", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dLpur = parcelRequire("dLpur");

var $i9Z2i = parcelRequire("i9Z2i");

var $b60W1 = parcelRequire("b60W1");

var $fVTp8 = parcelRequire("fVTp8");

var $h5tvG = parcelRequire("h5tvG");

var $3VpWO = parcelRequire("3VpWO");

var $jw62c = parcelRequire("jw62c");

var $2EsbE = parcelRequire("2EsbE");
function $3c5c154ced085d7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $3c5c154ced085d7f$var$markStyles = {
    name: "ko40kj",
    styles: "color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;border-bottom:2px solid transparent;cursor:pointer;padding:1px 0 2px;&:has(.card), &:has([data-inline-card]){padding:5px 0 3px 0;}&:has(.date-lozenger-container){padding-top:var(--ds-space-025, 2px);}background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const markRef = (0, $5uXOq.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fVTp8.dataAttributes)(draftPosition),
        css: $3c5c154ced085d7f$var$markStyles,
        ref: markRef
    }, children);
};
const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dLpur.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $h5tvG.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $2EsbE.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $b60W1.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $i9Z2i.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dLpur.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $i9Z2i.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $i9Z2i.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $h5tvG.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, (0, $3VpWO.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $3c5c154ced085d7f$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, components);
};

});
parcelRegister("dLpur", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $0808a380eaa6574c$export$c1bd4813440b4505);
var $0808a380eaa6574c$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("i9Z2i", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $b2e5f988c70f5313$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $b2e5f988c70f5313$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $b2e5f988c70f5313$export$1059bfc467f4f55d);

var $5uXOq = parcelRequire("5uXOq");
const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $b2e5f988c70f5313$var$isReactElement(child) {
    return !!child.type;
}
const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("b60W1", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $cc6d6765c9b34830$export$b1baddbd5f289877);

var $dLpur = parcelRequire("dLpur");
const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dLpur.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dLpur.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dLpur.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dLpur.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("h5tvG", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("3VpWO", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $eefbbe172cfc7a10$export$8a20fd0614851c5f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            }, `${segment.text}_${startPos}_${idx}`)
        });
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});



parcelRegister("cKKwC", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $d006a5118aec07b0$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $d006a5118aec07b0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $5uoEK = parcelRequire("5uoEK");
const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $88i6h.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uoEK.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;

});
parcelRegister("5uoEK", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $97291021c9f24158$export$f3069f755c1eba0b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $88i6h = parcelRequire("88i6h");

var $dEtqo = parcelRequire("dEtqo");

var $8u8ms = parcelRequire("8u8ms");

var $6Oe8V = parcelRequire("6Oe8V");

var $3N1TD = parcelRequire("3N1TD");

var $1oOiu = parcelRequire("1oOiu");

var $iYAgE = parcelRequire("iYAgE");

var $jw62c = parcelRequire("jw62c");
const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $3N1TD.useInlineCommentSubscriberContext)();
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1oOiu.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $jw62c.useAnnotationManagerDispatch)();
    const onClick = (0, $5uXOq.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $dEtqo.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $6Oe8V.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $88i6h.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8u8ms.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};

});
parcelRegister("8u8ms", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $c95b45af50ffb058$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $88i6h = parcelRequire("88i6h");

var $VSDnB = parcelRequire("VSDnB");

var $koVbs = parcelRequire("koVbs");

var $1Bd5P = parcelRequire("1Bd5P");

var $jw62c = parcelRequire("jw62c");
const $c95b45af50ffb058$var$markStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }
    }
});
const $c95b45af50ffb058$var$markStylesLayeringFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $88i6h.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $c95b45af50ffb058$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $c95b45af50ffb058$var$accessibilityStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $koVbs.default)();
    const annotationIds = (0, $5uXOq.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jw62c.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $jw62c.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $5uXOq.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $88i6h.AnnotationMarkStates).ACTIVE) return;
        if ((0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $c95b45af50ffb058$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $88i6h.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $f8Sb3.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $c95b45af50ffb058$var$markStyles,
                (0, $VSDnB.fg)('platform_renderer_nested_annotation_styling') && $c95b45af50ffb058$var$markStylesLayeringFix,
                (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $c95b45af50ffb058$var$markStylesWithInlineComments,
                (0, $VSDnB.fg)('confluence-frontend-comments-panel') && $c95b45af50ffb058$var$markStylesWithCommentsPanel,
                !$c95b45af50ffb058$var$isMobile() && $c95b45af50ffb058$var$accessibilityStyles,
                $c95b45af50ffb058$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $1Bd5P.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};

});

parcelRegister("6Oe8V", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $588f60613625d184$export$8e7d47f9e38ad4f1);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $5uXOq.useContext)((0, $iYAgE.InlineCommentsStateContext));
    return (0, $5uXOq.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("3N1TD", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $861d152b5ce122b2$export$b46737175cffd396);

var $5uXOq = parcelRequire("5uXOq");

var $iYAgE = parcelRequire("iYAgE");
const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
    const providers = (0, $5uXOq.useContext)((0, $iYAgE.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("GDkvY", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $d1627eb50b8d1823$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $bVGKe = parcelRequire("bVGKe");

var $lqKi3 = parcelRequire("lqKi3");

var $kgK5w = parcelRequire("kgK5w");

var $f14yv = parcelRequire("f14yv");

var $eVxaj = parcelRequire("eVxaj");

var $gUlHA = parcelRequire("gUlHA");

var $c15YI = parcelRequire("c15YI");

var $koUAb = parcelRequire("koUAb");

var $eESZY = parcelRequire("eESZY");

var $95Yll = parcelRequire("95Yll");

var $lbdLJ = parcelRequire("lbdLJ");

var $9xZ5X = parcelRequire("9xZ5X");

var $g5EjF = parcelRequire("g5EjF");

var $acz8Q = parcelRequire("acz8Q");

var $8DQfy = parcelRequire("8DQfy");

var $g9yqu = parcelRequire("g9yqu");

var $cKKwC = parcelRequire("cKKwC");

var $itF0z = parcelRequire("itF0z");

var $6EeUE = parcelRequire("6EeUE");
const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
    code: (0, $bVGKe.default),
    em: (0, $lqKi3.default),
    link: (0, $kgK5w.default),
    strike: (0, $f14yv.default),
    strong: (0, $eVxaj.default),
    subsup: (0, $gUlHA.default),
    textColor: (0, $c15YI.default),
    backgroundColor: (0, $koUAb.default),
    underline: (0, $eESZY.default),
    annotation: (0, $cKKwC.default),
    border: (0, $itF0z.default),
    // Stage0
    confluenceInlineComment: (0, $6EeUE.default),
    breakout: (0, $95Yll.default),
    alignment: (0, $lbdLJ.default),
    indentation: (0, $9xZ5X.default),
    unsupportedMark: (0, $g5EjF.default),
    unsupportedNodeAttribute: (0, $acz8Q.default),
    dataConsumer: (0, $8DQfy.default),
    fragment: (0, $g9yqu.default)
};
const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
    return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bVGKe", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $caa083dc61fd842d$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $caa083dc61fd842d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $O2UjQ = parcelRequire("O2UjQ");

var $fJyLQ = parcelRequire("fJyLQ");
const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $O2UjQ.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, $8RXs9.default)($caa083dc61fd842d$export$7cea6ffa7022e85f);

});
parcelRegister("O2UjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9c981a54265bdd$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");
const $4c9c981a54265bdd$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rko1sit _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $4c9c981a54265bdd$var$Code = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $bwpsq.default)([
            $4c9c981a54265bdd$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $31cgS.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: replacedChildren
    });
}
function $4c9c981a54265bdd$var$isReactElement(child) {
    return !!child.type;
}
$4c9c981a54265bdd$var$Code.displayName = 'Code';
var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $59fdc1b7b0ae96c9$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



parcelRegister("lqKi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd21faba719ebab1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kgK5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9900830cb94354be$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $K5Jsy = parcelRequire("K5Jsy");

var $knXBU = parcelRequire("knXBU");

var $gkwXh = parcelRequire("gkwXh");

var $VSDnB = parcelRequire("VSDnB");

var $iHvAB = parcelRequire("iHvAB");

var $daJ0i = parcelRequire("daJ0i");
const $9900830cb94354be$var$anchorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    }
});
function $9900830cb94354be$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $K5Jsy.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $daJ0i.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iHvAB.default), {
        css: $9900830cb94354be$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $gkwXh.ACTION).VISITED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).LINK,
                eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $knXBU.PLATFORM).WEB,
                    mode: (0, $knXBU.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        ...(0, $VSDnB.fg)('platform_editor_hyperlink_underline') && {
            isLinkComponent: true
        }
    }, props.children));
}

});
parcelRegister("K5Jsy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $75b48ee07210971a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $75b48ee07210971a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $75b48ee07210971a$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $75b48ee07210971a$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $hYNZx = parcelRequire("hYNZx");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $75b48ee07210971a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $75b48ee07210971a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $kOFhM.defaultSchema));
        this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, $hYNZx.JSONTransformer)());
    }
}
const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("iHvAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65e7a399613e0863$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $994MI = parcelRequire("994MI");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $g2eZ6 = parcelRequire("g2eZ6");

var $66xOO = parcelRequire("66xOO");

var $hTTxJ = parcelRequire("hTTxJ");

var $cI2hq = parcelRequire("cI2hq");
const $65e7a399613e0863$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $65e7a399613e0863$var$Anchor = (0, $g2eZ6.withLinkClickedEvent)('a');
const $65e7a399613e0863$export$8c0773eab230d49e = (0, $g2eZ6.withLinkClickedEvent)((0, $e4yMr.default));
const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, ...props })=>{
    (0, $gKZoD.di)($65e7a399613e0863$export$8c0773eab230d49e, (0, $cI2hq.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $cI2hq.useLinkWarningModal)();
    const Link = isLinkComponent && (0, $VSDnB.fg)('platform_editor_hyperlink_underline') ? $65e7a399613e0863$export$8c0773eab230d49e : $65e7a399613e0863$var$Anchor;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $66xOO.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
                    "data-testid": testId,
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hTTxJ.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, $994MI.default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});

parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});

parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});


parcelRegister("66xOO", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $a51765c35bf0b052$export$9458cdec663b9ff1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("hTTxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ef61591d3052acd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");
const $6ef61591d3052acd$var$breakWordsCss = null;
const $6ef61591d3052acd$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7zaVw.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>(0, $VSDnB.fg)('platform-linking-fix-a11y-in-smart-card') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                                    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...(0, $7zaVw.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: content
    });
};
var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, $8RXs9.default)($6ef61591d3052acd$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    /**
	 * @deprecated remove when cleaning up FG platform_bandicoots-smart-card-disable-aria
	 */ more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});


parcelRegister("cI2hq", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $afd5dc953340b04b$export$32b76c003683c2ec);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $57Lhk = parcelRequire("57Lhk");

var $VSDnB = parcelRequire("VSDnB");

var $fzJZi = parcelRequire("fzJZi");
const $afd5dc953340b04b$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
    const [url, setUrl] = (0, $5uXOq.useState)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $57Lhk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
        const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        if ((0, $VSDnB.fg)('do-not-show-link-mismatch-warning-for-same-origin')) {
            const currentAtlassianProductOrigin = window.location.origin;
            const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
            if (isSafeToIgnoreNonOriginDifferences) return true;
        }
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("57Lhk", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $8f5c48f3a9939b0b$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $e2gHg = parcelRequire("e2gHg");
const $8f5c48f3a9939b0b$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
$8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
$8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
$8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
    const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
    if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("e2gHg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a37e3434b26d3f31$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a37e3434b26d3f31$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a37e3434b26d3f31$var$isString(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
}
function $a37e3434b26d3f31$var$isObject(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
}
function $a37e3434b26d3f31$var$isRegExp(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
}
function $a37e3434b26d3f31$var$isFunction(obj) {
    return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
}
function $a37e3434b26d3f31$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a37e3434b26d3f31$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a37e3434b26d3f31$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a37e3434b26d3f31$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a37e3434b26d3f31$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a37e3434b26d3f31$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a37e3434b26d3f31$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a37e3434b26d3f31$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a37e3434b26d3f31$var$isObject(val)) {
            if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
            else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a37e3434b26d3f31$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a37e3434b26d3f31$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a37e3434b26d3f31$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a37e3434b26d3f31$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a37e3434b26d3f31$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a37e3434b26d3f31$var$createMatch(self, shift) {
    var match = new $a37e3434b26d3f31$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a37e3434b26d3f31$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a37e3434b26d3f31$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a37e3434b26d3f31$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a37e3434b26d3f31$var$LinkifyIt;

});
parcelRegister("d5qnw", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("f14yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e31acef3336a9ea7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("eVxaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356ea5acdd73a43$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("gUlHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c264e87eca3a3d05$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $c264e87eca3a3d05$var$isSub = (type)=>{
    return type === 'sub';
};
function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
    if ($c264e87eca3a3d05$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("c15YI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8904856eee164f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $lKA8N = parcelRequire("lKA8N");

var $hxoiH = parcelRequire("hxoiH");
function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $lKA8N.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("lKA8N", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $965e3166a7c18c5e$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $965e3166a7c18c5e$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("koUAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d139f843714a421$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $87j2U = parcelRequire("87j2U");

var $7dikW = parcelRequire("7dikW");

var $hxoiH = parcelRequire("hxoiH");
function $7d139f843714a421$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $7dikW.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $87j2U.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $5uXOq.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("7dikW", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);

var $gmhCD = parcelRequire("gmhCD");
const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $gmhCD.editorExperiment)('editor_text_highlight_orange_to_yellow', 'test', {
        exposure: true
    })) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $b5a4f7ad3e4ae03c$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("eESZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8016b636a69d58$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("95Yll", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f1f5242a99941b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $4ceoy = parcelRequire("4ceoy");

var $eOOFp = parcelRequire("eOOFp");

var $iHYdz = parcelRequire("iHYdz");

var $gmhCD = parcelRequire("gmhCD");
const $56f1f5242a99941b$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4ceoy.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $56f1f5242a99941b$var$wrapperStyles,
            "data-mode": props.mode,
            ...(0, $gmhCD.editorExperiment)('advanced_layouts', true) && {
                'data-has-width': !!props.width,
                'data-width': props.width
            },
            style: {
                width: (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $eOOFp.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("lbdLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b7090399d1e727$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $aeGrH = parcelRequire("aeGrH");
const $d1b7090399d1e727$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $aeGrH.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($d1b7090399d1e727$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("9xZ5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef073b46e3c6008$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("g5EjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1398622ac205fad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("acz8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $04eeed03d14d0e78$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("8DQfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $009dff5e97619965$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $009dff5e97619965$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("g9yqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ac6eff929f5b91e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("itF0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f200b42408cc462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6EeUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $efbb661461ca3406$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});


parcelRegister("eQNWQ", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $7bbfc2d34b0938dd$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $7bbfc2d34b0938dd$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $7bbfc2d34b0938dd$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $7bbfc2d34b0938dd$export$81b20b6c83a56bd);

var $9IGaJ = parcelRequire("9IGaJ");
var $kc0v7 = parcelRequire("kc0v7");
var $iZOJ9 = parcelRequire("iZOJ9");
var $bFtEE = parcelRequire("bFtEE");

var $kOFhM = parcelRequire("kOFhM");

var $VSDnB = parcelRequire("VSDnB");
const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $kc0v7.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iZOJ9.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
    };
};
const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, $kOFhM.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iZOJ9.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iZOJ9.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $bFtEE.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $9IGaJ.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $9IGaJ.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
};
const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iZOJ9.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("kc0v7", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $eb355120b38723aa$export$b1f729c6af6f2a6e);

var $ctVrM = parcelRequire("ctVrM");
const $eb355120b38723aa$var$typedNodes = $ctVrM;
const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));

});
parcelRegister("ctVrM", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("7kC9H")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("7kC9H")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("7kC9H")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("6bbHe")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("5y0tR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("bd7A9")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("xjCuM")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aXBFx")).blockquote);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("aXBFx")).extendedBlockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("aXBFx")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => (parcelRequire("aXBFx")).blockquoteWithoutNonBodiedMacros);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("kjhhp")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("kjhhp")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("8vlrc")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("8vlrc")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("jnMM2")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("lRTZM")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("M4hHz")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("dwptW")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("dwptW")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("dwptW")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("abme3")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("7DoMR")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("7lRBh")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("g7Cky")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("g7Cky")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("2FIVU")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("2FIVU")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("2FIVU")).listItemWithDecisionStage0);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => (parcelRequire("2FIVU")).listItemWithoutNonBodiedMacros);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("bFtEE")).extendedPanel);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => (parcelRequire("bFtEE")).panelWithoutNestedNonBodiedMacros);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("bFtEE")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("3DR6L")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("9X587")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("5JeV5")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("7agO8")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("7agO8")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("7agO8")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("92lix")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("7Xgp3")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("bIGZ7")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("bIGZ7")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("bIGZ7")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("bIGZ7")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("bIGZ7")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("bIGZ7")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("9UDEr")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("9UDEr")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("9UDEr")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("9UDEr")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("9UDEr")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("9UDEr")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("9UDEr")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("9UDEr")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("9UDEr")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("9UDEr")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("9UDEr")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("9UDEr")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("9UDEr")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("9UDEr")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("9UDEr")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("9UDEr")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("9UDEr")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("9UDEr")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("9UDEr")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("9UDEr")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("9UDEr")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("9UDEr")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("9UDEr")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("8gSD8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("8gSD8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("Khvpb")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("43mJF")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("43mJF")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iThOL")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("b2VmY")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dgJoa")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("gZoER")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("gZoER")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("4EbxI")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("cCBEe")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("21PS7")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("d1d6m")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("6kr5W")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("18bvk")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dx5eC")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => (parcelRequire("dx5eC")).nestedExpandWithoutNonBodiedMacros);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("kshOv")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("hhN5g")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5BOuQ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5AxYU")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("47jug")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("47jug")).multiBodiedExtension);

var $7kC9H = parcelRequire("7kC9H");

var $6bbHe = parcelRequire("6bbHe");

var $5y0tR = parcelRequire("5y0tR");

var $bd7A9 = parcelRequire("bd7A9");

var $xjCuM = parcelRequire("xjCuM");

var $aXBFx = parcelRequire("aXBFx");

var $kjhhp = parcelRequire("kjhhp");

var $8vlrc = parcelRequire("8vlrc");

var $jnMM2 = parcelRequire("jnMM2");

var $lRTZM = parcelRequire("lRTZM");

var $M4hHz = parcelRequire("M4hHz");

var $dwptW = parcelRequire("dwptW");

var $abme3 = parcelRequire("abme3");

var $7DoMR = parcelRequire("7DoMR");

var $7lRBh = parcelRequire("7lRBh");

var $g7Cky = parcelRequire("g7Cky");

var $2FIVU = parcelRequire("2FIVU");

var $bFtEE = parcelRequire("bFtEE");

var $3DR6L = parcelRequire("3DR6L");

var $9X587 = parcelRequire("9X587");

var $5JeV5 = parcelRequire("5JeV5");

var $7agO8 = parcelRequire("7agO8");

var $92lix = parcelRequire("92lix");

var $7Xgp3 = parcelRequire("7Xgp3");

var $bIGZ7 = parcelRequire("bIGZ7");

var $9UDEr = parcelRequire("9UDEr");

var $8gSD8 = parcelRequire("8gSD8");

var $Khvpb = parcelRequire("Khvpb");

var $43mJF = parcelRequire("43mJF");

var $iThOL = parcelRequire("iThOL");

var $b2VmY = parcelRequire("b2VmY");

var $dgJoa = parcelRequire("dgJoa");

var $gZoER = parcelRequire("gZoER");

var $4EbxI = parcelRequire("4EbxI");

var $cCBEe = parcelRequire("cCBEe");

var $21PS7 = parcelRequire("21PS7");

var $d1d6m = parcelRequire("d1d6m");

var $6kr5W = parcelRequire("6kr5W");

var $18bvk = parcelRequire("18bvk");

var $dx5eC = parcelRequire("dx5eC");

var $kshOv = parcelRequire("kshOv");

var $hhN5g = parcelRequire("hhN5g");

var $5BOuQ = parcelRequire("5BOuQ");

var $5AxYU = parcelRequire("5AxYU");

var $47jug = parcelRequire("47jug");

});



parcelRegister("bzwTW", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $99a90b85f857f7e6$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $99a90b85f857f7e6$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $99a90b85f857f7e6$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $99a90b85f857f7e6$export$244bf4b32387ef62);
const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $99a90b85f857f7e6$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});


parcelRegister("12yAL", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $af6d4930d9141440$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kOFhM = parcelRequire("kOFhM");

var $4FBRr = parcelRequire("4FBRr");
var $aSk3Q = parcelRequire("aSk3Q");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
var $4IuOY = parcelRequire("4IuOY");

var $eQNWQ = parcelRequire("eQNWQ");

var $VSDnB = parcelRequire("VSDnB");

var $8QpSo = parcelRequire("8QpSo");

var $knXBU = parcelRequire("knXBU");

var $1cjf7 = parcelRequire("1cjf7");

var $kgV4b = parcelRequire("kgV4b");
const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $af6d4930d9141440$var$withStopwatch = (cb)=>{
    const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $af6d4930d9141440$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4FBRr.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $4IuOY.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $eQNWQ.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    if ((0, $VSDnB.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $aSk3Q.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer',
            disableNestedRendererTreatment: (0, $VSDnB.fg)('platform_editor_nested_table_extension_comment_fix')
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $gkwXh.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
                eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $af6d4930d9141440$var$memoValidation = (0, $8QpSo.default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
    let result = false;
    if ((0, $VSDnB.fg)('cc_complexit_fe_memoValidation_redundant_calls')) {
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        newSkipValidation, newValidationOverrides] = newArgs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    } else {
        // This path has a bug and it will wrongfully assign dispatchAnalyticsEvent to skipValidation/oldSkipValidation
        // instead of ignoring it as it does not skip it when unpacking the array.
        // This results the function returning false when it should return true
        // and causing extra re-renders. see https://hello.jira.atlassian.cloud/browse/COMPLEXIT-161.
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , skipValidation, newValidationOverrides] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    }
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $af6d4930d9141440$var$memoSerializeFragment = (0, $8QpSo.default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, $8QpSo.default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
});
const $af6d4930d9141440$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $kOFhM.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
        return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $d54NZ.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $1cjf7.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kgV4b.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("4FBRr", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $75bd921bb3a8c47e$export$6528700f3fa2fe2a);

var $l1C1k = parcelRequire("l1C1k");
const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $l1C1k.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("4IuOY", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $2c0bbb60cfee2804$export$884cfad20dece33e);

var $905ey = parcelRequire("905ey");

var $gkwXh = parcelRequire("gkwXh");

var $d54NZ = parcelRequire("d54NZ");
const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $2c0bbb60cfee2804$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $d54NZ.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $gkwXh.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $905ey.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("905ey", function(module, exports) {

$parcel$export(module.exports, "validator", () => $e861220f24467804$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $gsiq1 = parcelRequire("gsiq1");

var $iiazc = parcelRequire("iiazc");

var $1H4Aw = parcelRequire("1H4Aw");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $e861220f24467804$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($gsiq1).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$gsiq1[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $iiazc.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $gsiq1[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $iiazc.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($gsiq1[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $gsiq1[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($gsiq1[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $gsiq1[subItem] : (0, $iiazc.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $e861220f24467804$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e861220f24467804$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $e861220f24467804$export$66c739158ef99a42(spec, value) {
    if (!(0, $iiazc.isDefined)(value)) return !!spec.optional;
    if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $iiazc.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $iiazc.isBoolean)(value);
        case 'number':
            return (0, $iiazc.isNumber)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $iiazc.isInteger)(value) && ((0, $iiazc.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $iiazc.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $iiazc.isDefined)((0, $1H4Aw.validatorFnMap)[rule]) && (0, $1H4Aw.validatorFnMap)[rule](value);
            return (0, $iiazc.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $iiazc.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $iiazc.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $iiazc.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $iiazc.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
};
const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $e861220f24467804$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $iiazc.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $iiazc.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $iiazc.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $iiazc.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $iiazc.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $iiazc.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $iiazc.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $iiazc.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $iiazc.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $iiazc.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("gsiq1", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("5fjVx")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("5fjVx")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("5fjVx")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5fjVx")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("5fjVx")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("5fjVx")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("5fjVx")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("5fjVx")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("5fjVx")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("5fjVx")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("5fjVx")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("5fjVx")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("5fjVx")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("5fjVx")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("5fjVx")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("5fjVx")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("5fjVx")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("5fjVx")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("5fjVx")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("5fjVx")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("5fjVx")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("5fjVx")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("5fjVx")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("5fjVx")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("5fjVx")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fjVx")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("5fjVx")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("5fjVx")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("5fjVx")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("5fjVx")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("5fjVx")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("5fjVx")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("5fjVx")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("5fjVx")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("5fjVx")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("5fjVx")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("5fjVx")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("5fjVx")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("5fjVx")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5fjVx")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("5fjVx")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("5fjVx")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("5fjVx")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("5fjVx")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("5fjVx")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("5fjVx")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("5fjVx")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("5fjVx")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("5fjVx")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("5fjVx")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5fjVx")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("5fjVx")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("5fjVx")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("5fjVx")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("5fjVx")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("5fjVx")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("5fjVx")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("5fjVx")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("5fjVx")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("5fjVx")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("5fjVx")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("5fjVx")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5fjVx")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("5fjVx")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("5fjVx")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("5fjVx")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("5fjVx")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("5fjVx")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("5fjVx")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("5fjVx")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("5fjVx")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("5fjVx")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("5fjVx")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("5fjVx")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("5fjVx")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("5fjVx")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5fjVx")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("5fjVx")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("5fjVx")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("5fjVx")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("5fjVx")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("5fjVx")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("5fjVx")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("5fjVx")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5fjVx = parcelRequire("5fjVx");

});
parcelRegister("5fjVx", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $3d1dcf8b9eccd1a7$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $3d1dcf8b9eccd1a7$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $3d1dcf8b9eccd1a7$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $3d1dcf8b9eccd1a7$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $3d1dcf8b9eccd1a7$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $3d1dcf8b9eccd1a7$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $3d1dcf8b9eccd1a7$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $3d1dcf8b9eccd1a7$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $3d1dcf8b9eccd1a7$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $3d1dcf8b9eccd1a7$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $3d1dcf8b9eccd1a7$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $3d1dcf8b9eccd1a7$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $3d1dcf8b9eccd1a7$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $3d1dcf8b9eccd1a7$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $3d1dcf8b9eccd1a7$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $3d1dcf8b9eccd1a7$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $3d1dcf8b9eccd1a7$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $3d1dcf8b9eccd1a7$export$425327af25286e5e);
const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("iiazc", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $2c8456da404b8e3f$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $2c8456da404b8e3f$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $2c8456da404b8e3f$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $2c8456da404b8e3f$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $2c8456da404b8e3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $2c8456da404b8e3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $2c8456da404b8e3f$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $2c8456da404b8e3f$export$7b85fd78dd236198);
const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $2c8456da404b8e3f$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("1H4Aw", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $608e35270d0ca1e8$export$d1b377ca77ac267d);

var $iZOJ9 = parcelRequire("iZOJ9");
const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iZOJ9.isSafeUrl)
};

});



parcelRegister("1cjf7", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $dad344c5873159ce$export$a43de96edd8d0a0);

var $4NUlu = parcelRequire("4NUlu");
var $2KwKW = parcelRequire("2KwKW");

var $gkwXh = parcelRequire("gkwXh");

var $knXBU = parcelRequire("knXBU");
const $dad344c5873159ce$var$rendersMap = {};
const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $2KwKW.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $4NUlu.getAnalyticsAppearance)(item.appearance),
                platform: (0, $knXBU.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $gkwXh.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $gkwXh.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $knXBU.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $gkwXh.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $dad344c5873159ce$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("2KwKW", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $4210b4deee40727f$export$484b83e0462998d);

var $l1C1k = parcelRequire("l1C1k");
var $4210b4deee40727f$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $4210b4deee40727f$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
    };
};
const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $l1C1k.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $l1C1k.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("kgV4b", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $7ac8dee2b321f8fd$export$1daf15cbaf649dad);

var $3Y1bF = parcelRequire("3Y1bF");
function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
    return (0, $3Y1bF.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("3Y1bF", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $de5bae64a9d3f36e$export$533b26079ad0b4b);

var $l1C1k = parcelRequire("l1C1k");
function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1urn6", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $d9518b7b87f036fd$export$77218b6ff680865f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
var $cEHh7 = parcelRequire("cEHh7");

var $9S8fM = parcelRequire("9S8fM");
const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
    const mediaProvider = (0, $9S8fM.useProviderLayout)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $5uXOq.useContext)((0, $cEHh7.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, $85xkt.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});
parcelRegister("85xkt", function(module, exports) {

$parcel$export(module.exports, "getMediaClient", () => $8520c78a499e57c4$export$c9ecbc1b719fd417);

var $9z04W = parcelRequire("9z04W");
const $8520c78a499e57c4$export$f92e83e86b03c398 = new Map();
const $8520c78a499e57c4$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $9z04W.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $8520c78a499e57c4$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $9z04W.MediaClient)(mediaClientConfig);
        $8520c78a499e57c4$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("9z04W", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $a9f77c891230da5c$export$fba8b4ca6d386aec);

var $7n9mn = parcelRequire("7n9mn");
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");

var $1FyHg = parcelRequire("1FyHg");

var $iKPaV = parcelRequire("iKPaV");

var $5eAc2 = parcelRequire("5eAc2");
parcelRequire("8HaZs");
var $fN64m = parcelRequire("fN64m");

class $a9f77c891230da5c$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $fN64m.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $1FyHg.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $gPrGh.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iKPaV.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
        this.stargate = new (0, $5eAc2.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("8y2QC"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("LmkUS", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("6a8j4")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("hQvj4")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("hQvj4")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("gPrGh")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $6a8j4 = parcelRequire("6a8j4");

var $hQvj4 = parcelRequire("hQvj4");

var $gPrGh = parcelRequire("gPrGh");

});
parcelRegister("6a8j4", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $dc598dfdde7cc536$export$8cef61637918b288);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $dc598dfdde7cc536$export$8cef61637918b288 = {
    streams: new (0, $iwKVT.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $7n9mn.EventEmitter2)()
};

});
parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("hQvj4", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $449c85d7d5bc4f1f$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $449c85d7d5bc4f1f$export$17f6055767a8d96a);
function $449c85d7d5bc4f1f$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $449c85d7d5bc4f1f$export$17f6055767a8d96a = (auth)=>{
    if ($449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("gPrGh", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $506f1dfda055692a$export$d3e73a50cc549c2e);
var $506f1dfda055692a$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("1FyHg", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $5d0b8a2b8f8558c8$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $5d0b8a2b8f8558c8$export$20f9315304dd6726);
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");
var $hQvj4 = parcelRequire("hQvj4");

var $7E56q = parcelRequire("7E56q");

var $7LFAu = parcelRequire("7LFAu");

var $1As4I = parcelRequire("1As4I");
var $hzvnk = parcelRequire("hzvnk");

var $ale1y = parcelRequire("ale1y");

var $eeVEv = parcelRequire("eeVEv");

var $5cMkQ = parcelRequire("5cMkQ");

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $5d0b8a2b8f8558c8$var$MEDIA_API_REGION = 'media-api-region';
const $5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $5d0b8a2b8f8558c8$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $7E56q.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $7E56q.MAX_RESOLUTION),
            height: (0, $7E56q.MAX_RESOLUTION)
        } : {}
    };
};
const $5d0b8a2b8f8558c8$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $5d0b8a2b8f8558c8$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $h2NC7.isCommercial)() && (0, $VSDnB.fg)('platform_media_cdn_delivery')) result += '/cdn';
    return result;
};
class $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $ale1y.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $hzvnk.request)(artifactUrl, options, abortController).then((0, $ale1y.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
        };
        this.resolveAuth = (authContext)=>(0, $5cMkQ.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $5cMkQ.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $gPrGh.ChunkHashAlgorithm).Sha256;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
        return (0, $eeVEv.mapToMediaCdnUrl)((0, $ale1y.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $7E56q.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
			const cdnUrl = artifacts[artifactName]?.cdnUrl;
			if (cdnUrl) {
				return cdnUrl;
			}
		} */ const artifactUrl = (0, $7LFAu.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        return (0, $ale1y.createUrl)((0, $eeVEv.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $5d0b8a2b8f8558c8$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $ale1y.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $ale1y.defaultShouldRetryError)(err) || (0, $1As4I.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $ale1y.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $hQvj4.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $ale1y.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $eeVEv.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $hzvnk.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $hzvnk.request)(url, {
            method: 'HEAD',
            traceContext: (0, $ale1y.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $5d0b8a2b8f8558c8$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $5d0b8a2b8f8558c8$export$c8b741e18397852a = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT);
};
const $5d0b8a2b8f8558c8$export$20f9315304dd6726 = ()=>{
    return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION);
};

});
parcelRegister("7E56q", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $7a454a77a18dd963$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $7a454a77a18dd963$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $7a454a77a18dd963$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $7a454a77a18dd963$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $7a454a77a18dd963$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $7a454a77a18dd963$export$f14f521f3d306044);

var $749LC = parcelRequire("749LC");
const $7a454a77a18dd963$export$860a16125e30000b = 'recents';
const $7a454a77a18dd963$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $7a454a77a18dd963$export$6e70f30e392bc53f = 4096;
const $7a454a77a18dd963$export$c1abb8bab1e615cd = 5 * (0, $749LC.DATA_UNIT).MB;
const $7a454a77a18dd963$export$3d5157f0def70e54 = 1000;
const $7a454a77a18dd963$export$f14f521f3d306044 = 2 * (0, $749LC.DATA_UNIT).TB;

});
parcelRegister("749LC", function(module, exports) {

$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $330ebd66cbfb5bbe$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $330ebd66cbfb5bbe$export$76cfea4c354af843);
const $330ebd66cbfb5bbe$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $330ebd66cbfb5bbe$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $330ebd66cbfb5bbe$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("7LFAu", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $cc56e843db2c0cea$export$1cc24defa44e7f84);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $cc56e843db2c0cea$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $h2NC7.isCommercial)() && (0, $VSDnB.fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("h2NC7", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $bc3c8a168b66c7db$export$df69ff6733e73e50);
function $bc3c8a168b66c7db$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});


parcelRegister("1As4I", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $a9b96946563d0d09$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $a9b96946563d0d09$export$3717b1ffef4428ea);

var $gFZHi = parcelRequire("gFZHi");
class $a9b96946563d0d09$export$43ee7d0e4f429743 extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $a9b96946563d0d09$export$3717b1ffef4428ea(err) {
    return err instanceof $a9b96946563d0d09$export$43ee7d0e4f429743;
}

});
parcelRegister("gFZHi", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $fd6342ef86e499fe$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $fd6342ef86e499fe$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $fd6342ef86e499fe$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $fd6342ef86e499fe$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $fd6342ef86e499fe$export$c2b89b9a32286816);

var $loYHr = parcelRequire("loYHr");
class $fd6342ef86e499fe$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fd6342ef86e499fe$export$e574d1724215079f extends $fd6342ef86e499fe$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $fd6342ef86e499fe$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $fd6342ef86e499fe$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $fd6342ef86e499fe$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $fd6342ef86e499fe$export$e574d1724215079f(error?.reason || 'unknown-reason', error.metadata, error.innerError);
};
const $fd6342ef86e499fe$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("loYHr", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $8608a1f56c9594c2$export$c15d72765ee2baa4);
function $8608a1f56c9594c2$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $8608a1f56c9594c2$export$c15d72765ee2baa4(err) {
    return $8608a1f56c9594c2$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("hzvnk", function(module, exports) {

$parcel$export(module.exports, "request", () => $ac16e0b7f5d65450$export$b5fe3f66a567bec0);

var $1As4I = parcelRequire("1As4I");

var $ale1y = parcelRequire("ale1y");
async function $ac16e0b7f5d65450$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $ale1y.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $ale1y.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $ale1y.createProcessFetchResponse)(metadata));
    return (0, $ale1y.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("ale1y", function(module, exports) {

$parcel$export(module.exports, "extendTraceContext", () => $96f7b73b7943f312$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $96f7b73b7943f312$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $96f7b73b7943f312$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $96f7b73b7943f312$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $96f7b73b7943f312$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $96f7b73b7943f312$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $96f7b73b7943f312$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $96f7b73b7943f312$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $96f7b73b7943f312$export$6e2e477edb7d6032);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");

var $27T0s = parcelRequire("27T0s");

var $3JV6R = parcelRequire("3JV6R");

var $1As4I = parcelRequire("1As4I");
const $96f7b73b7943f312$var$getStatusCode = (error)=>(0, $1As4I.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $96f7b73b7943f312$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $96f7b73b7943f312$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $96f7b73b7943f312$export$bc96a6a479480590(error) {
    const statusCode = error && $96f7b73b7943f312$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $96f7b73b7943f312$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $27T0s.getRandomHex)(8)
    } : undefined;
const $96f7b73b7943f312$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $96f7b73b7943f312$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$96f7b73b7943f312$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$96f7b73b7943f312$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $96f7b73b7943f312$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $96f7b73b7943f312$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $3JV6R.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $96f7b73b7943f312$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$96f7b73b7943f312$export$eaf4479116d2f925(auth),
        ...$96f7b73b7943f312$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $96f7b73b7943f312$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $96f7b73b7943f312$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $1As4I.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $96f7b73b7943f312$export$fee2242cbb339663 = (err)=>{
    const statusCode = $96f7b73b7943f312$var$getStatusCode(err);
    return $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $96f7b73b7943f312$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $96f7b73b7943f312$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $96f7b73b7943f312$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$96f7b73b7943f312$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $96f7b73b7943f312$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $96f7b73b7943f312$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($96f7b73b7943f312$export$de0b576cf7ce4a53(err)) throw new (0, $1As4I.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $1As4I.isRequestError)(lastError)) throw $96f7b73b7943f312$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $1As4I.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $96f7b73b7943f312$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $96f7b73b7943f312$export$6397609af718d008(statusCode);
    return new (0, $1As4I.RequestError)(reason, {
        ...metadata,
        ...$96f7b73b7943f312$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $96f7b73b7943f312$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $96f7b73b7943f312$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("27T0s", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $5713248736bc73bb$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $5713248736bc73bb$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $5713248736bc73bb$export$456b25e3a9b4a843);
const $5713248736bc73bb$export$fce6876652108ab = (value)=>value === undefined;
const $5713248736bc73bb$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $5713248736bc73bb$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $5713248736bc73bb$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $5713248736bc73bb$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $5713248736bc73bb$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $5713248736bc73bb$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    }
    else randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("3JV6R", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $30be3f63a223d0a0$export$6833b130611df767);
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");
function $30be3f63a223d0a0$export$6833b130611df767(auth) {
    if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("eeVEv", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $ac061c5da59ee1d7$export$fb88a576cf28364d);

var $VSDnB = parcelRequire("VSDnB");

var $h2NC7 = parcelRequire("h2NC7");
const $ac061c5da59ee1d7$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $ac061c5da59ee1d7$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!(0, $h2NC7.isCommercial)() || tokenLength > $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $VSDnB.fg)('platform_media_cdn_delivery') && (0, $VSDnB.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $ac061c5da59ee1d7$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("5cMkQ", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $c6441b149d7d138c$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $c6441b149d7d138c$export$5211e1371264aec3);

var $ciNTb = parcelRequire("ciNTb");

var $irn0C = parcelRequire("irn0C");
const $c6441b149d7d138c$export$560085fe411c0660 = 10000;
const $c6441b149d7d138c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $c6441b149d7d138c$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $irn0C.rejectTimeout)(authProviderTimeout, new (0, $ciNTb.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $ciNTb.MediaStoreError)) throw err;
        throw new (0, $ciNTb.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $c6441b149d7d138c$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $ciNTb.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("ciNTb", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $63300db0f534a20c$export$b78480bd311630bc);

var $gFZHi = parcelRequire("gFZHi");
class $63300db0f534a20c$export$b78480bd311630bc extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $63300db0f534a20c$export$8d2a9b675b2ce37a(err) {
    return err instanceof $63300db0f534a20c$export$b78480bd311630bc;
}

});

parcelRegister("irn0C", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $974e005d07aa0732$export$cf2d2a1124beacb2);
const $974e005d07aa0732$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $974e005d07aa0732$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iKPaV", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $acdec836078e8c40$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("gpU3c")).FileFetcherError);

var $aZdZn = parcelRequire("aZdZn");

var $cVFxd = parcelRequire("cVFxd");

var $bXrHm = parcelRequire("bXrHm");
parcelRequire("LmkUS");
var $hQvj4 = parcelRequire("hQvj4");

var $txcJN = parcelRequire("txcJN");

var $1FyHg = parcelRequire("1FyHg");

var $1Pp1U = parcelRequire("1Pp1U");

var $749LC = parcelRequire("749LC");

var $gpU3c = parcelRequire("gpU3c");

var $i57HF = parcelRequire("i57HF");

var $hkwMq = parcelRequire("hkwMq");

var $bfb59 = parcelRequire("bfb59");

var $7E56q = parcelRequire("7E56q");

var $6CZ6k = parcelRequire("6CZ6k");

var $7p3Ot = parcelRequire("7p3Ot");

var $lVahM = parcelRequire("lVahM");

var $dhdZw = parcelRequire("dhdZw");

var $gayAy = parcelRequire("gayAy");

var $j1BIJ = parcelRequire("j1BIJ");
var $lYDAe = parcelRequire("lYDAe");

var $29M1K = parcelRequire("29M1K");

var $2Mh8o = parcelRequire("2Mh8o");

var $jzW7G = parcelRequire("jzW7G");

var $gR4o6 = parcelRequire("gR4o6");

var $dJ905 = parcelRequire("dJ905");

var $9KWg9 = parcelRequire("9KWg9");
parcelRequire("8HaZs");
var $fN64m = parcelRequire("fN64m");

var $kFeQ4 = parcelRequire("kFeQ4");

var $ale1y = parcelRequire("ale1y");

var $gFZHi = parcelRequire("gFZHi");
const $acdec836078e8c40$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $acdec836078e8c40$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $acdec836078e8c40$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $fN64m.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $gFZHi.isCommonMediaClientError)(error)) return (0, $gFZHi.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $gFZHi.CommonMediaClientError)(error);
                return (0, $gFZHi.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $gFZHi.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $gFZHi.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $2Mh8o.createMediaSubject)();
            const poll = new (0, $dJ905.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $749LC.isNotFoundMediaItemDetails)(response)) throw new (0, $gpU3c.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $9KWg9.isEmptyFile)(response)) throw new (0, $gpU3c.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $1Pp1U.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $gayAy.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $lVahM.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $1Pp1U.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4');
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch (_err) {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $7p3Ot.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $kFeQ4.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(id)) {
            const subject = (0, $2Mh8o.createMediaSubject)();
            const err = new (0, $gpU3c.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $j1BIJ.fromObservable)(subject);
        }
        if (forceRefresh) (0, $hkwMq.getFileStreamsCache)().remove(id);
        return (0, $j1BIJ.fromObservable)((0, $hkwMq.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $lYDAe.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($bXrHm)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $2Mh8o.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $hkwMq.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $29M1K.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $2Mh8o.createMediaSubject)();
        (0, $hkwMq.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $aZdZn.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $dhdZw.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $i57HF.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $j1BIJ.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $txcJN.downloadUrl)(url, {
            name: name
        });
        (0, $bfb59.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $7E56q.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $ale1y.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $1FyHg.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $hQvj4.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $hkwMq.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($acdec836078e8c40$var$isCopySourceFileWithToken(source) && $acdec836078e8c40$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $jzW7G.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $1Pp1U.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $2Mh8o.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $1Pp1U.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $1Pp1U.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $gR4o6.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $dhdZw.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $dhdZw.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $1Pp1U.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $1Pp1U.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $1Pp1U.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $hkwMq.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $2Mh8o.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("txcJN", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $4c4bd5defea17306$export$8a96edb1c96563f4);
const $4c4bd5defea17306$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("1Pp1U", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $8f64b07ac8c4c4df$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $8f64b07ac8c4c4df$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $8f64b07ac8c4c4df$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $8f64b07ac8c4c4df$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $8f64b07ac8c4c4df$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $8f64b07ac8c4c4df$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $8f64b07ac8c4c4df$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $8f64b07ac8c4c4df$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $8f64b07ac8c4c4df$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $8f64b07ac8c4c4df$export$ea3730792e8bebfb);
const $8f64b07ac8c4c4df$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $8f64b07ac8c4c4df$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $8f64b07ac8c4c4df$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $8f64b07ac8c4c4df$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $8f64b07ac8c4c4df$export$92dd692b31e42e64 = (fileState)=>!$8f64b07ac8c4c4df$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $8f64b07ac8c4c4df$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $8f64b07ac8c4c4df$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $8f64b07ac8c4c4df$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $8f64b07ac8c4c4df$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $8f64b07ac8c4c4df$export$ea3730792e8bebfb = (id, item)=>{
    return $8f64b07ac8c4c4df$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("gpU3c", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $5a4b48edf9ec6627$export$e3e60f0dab8641de);

var $gFZHi = parcelRequire("gFZHi");
class $5a4b48edf9ec6627$export$e3e60f0dab8641de extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $5a4b48edf9ec6627$export$5c3435f75ce0ce70(err) {
    return err instanceof $5a4b48edf9ec6627$export$e3e60f0dab8641de;
}

});

parcelRegister("i57HF", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $8cd2ca9b1610ac88$export$a5575dbeeffdad98);

var $fEpeZ = parcelRequire("fEpeZ");

var $gI62y = parcelRequire("gI62y");

var $ib0Rz = parcelRequire("ib0Rz");

var $f6rzU = parcelRequire("f6rzU");

var $20Dmg = parcelRequire("20Dmg");

var $7E56q = parcelRequire("7E56q");

var $empHz = parcelRequire("empHz");
const $8cd2ca9b1610ac88$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $f6rzU.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $8cd2ca9b1610ac88$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $8cd2ca9b1610ac88$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $8cd2ca9b1610ac88$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $8cd2ca9b1610ac88$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $8cd2ca9b1610ac88$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $7E56q.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $empHz.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $empHz.fileSizeError)) callbacks?.onUploadFinish(new (0, $20Dmg.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $fEpeZ.chunkinator)(content, {
        hashingFunction: (blob)=>$8cd2ca9b1610ac88$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $8cd2ca9b1610ac88$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $7E56q.PROCESSING_BATCH_SIZE),
        processingFunction: $8cd2ca9b1610ac88$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($8cd2ca9b1610ac88$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $8cd2ca9b1610ac88$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("fEpeZ", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $2c9b70a291565367$export$9ab6bef3838698f8);

var $j7Dz8 = parcelRequire("j7Dz8");

var $ib0Rz = parcelRequire("ib0Rz");

var $9RLLl = parcelRequire("9RLLl");

var $bXPjr = parcelRequire("bXPjr");

var $dglPr = parcelRequire("dglPr");

var $kDczJ = parcelRequire("kDczJ");

var $4Vmg1 = parcelRequire("4Vmg1");

var $6SPPN = parcelRequire("6SPPN");

var $RsgFX = parcelRequire("RsgFX");

var $gI62y = parcelRequire("gI62y");
const $2c9b70a291565367$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, $RsgFX.fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $dglPr.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $kDczJ.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $4Vmg1.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $6SPPN.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
            return (0, $gI62y.from)(batchedChunks);
        }), (0, $9RLLl.bufferCount)(totalChunks));
    }));
const $2c9b70a291565367$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $2c9b70a291565367$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("dglPr", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $f0508944ab60c7e6$export$5b92d769f2f57509);

var $eTa7E = parcelRequire("eTa7E");

var $cVFxd = parcelRequire("cVFxd");
const $f0508944ab60c7e6$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("kDczJ", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $3a9c605917062ecc$export$d5f5a550a38ec367);

var $RsgFX = parcelRequire("RsgFX");
const $3a9c605917062ecc$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $3a9c605917062ecc$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $RsgFX.asyncMap)($3a9c605917062ecc$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("RsgFX", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $32ba0ece4537a1a3$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $32ba0ece4537a1a3$export$707ee4c4c95d39e3);

var $kVLXA = parcelRequire("kVLXA");

var $80gxR = parcelRequire("80gxR");
async function $32ba0ece4537a1a3$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $32ba0ece4537a1a3$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $32ba0ece4537a1a3$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $kVLXA.Observable)((sub)=>{
            notifiers.push($32ba0ece4537a1a3$var$notify(project(value), sub, onReady));
        });
};
const $32ba0ece4537a1a3$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($32ba0ece4537a1a3$var$mapper(project), concurrent);

});


parcelRegister("4Vmg1", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $a4f565ebdd47f0f4$export$94ce0f3fcf999415);

var $RsgFX = parcelRequire("RsgFX");
const $a4f565ebdd47f0f4$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $RsgFX.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("6SPPN", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $389997e3e47b2450$export$2f21790600302ed);

var $9RLLl = parcelRequire("9RLLl");

var $ib0Rz = parcelRequire("ib0Rz");
const $389997e3e47b2450$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
};

});


parcelRegister("f6rzU", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $8249c54a4574cd31$export$14b114effbc08b6b);
parcelRequire("LmkUS");
var $gPrGh = parcelRequire("gPrGh");
let $8249c54a4574cd31$var$hasher = null;
let $8249c54a4574cd31$var$sha256Hasher = null;
const $8249c54a4574cd31$export$d9c9d11cd648a505 = ()=>{
    $8249c54a4574cd31$var$hasher = null;
    $8249c54a4574cd31$var$sha256Hasher = null;
};


const $8249c54a4574cd31$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $gPrGh.ChunkHashAlgorithm).Sha256) {
            if (!$8249c54a4574cd31$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("9n8Zs"));
                $8249c54a4574cd31$var$sha256Hasher = new SimpleHasher();
            }
            return $8249c54a4574cd31$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("lHYA1"));
    $8249c54a4574cd31$var$hasher = new SimpleHasher();
    return $8249c54a4574cd31$var$hasher;
};

});
parcelRegister("9n8Zs", function(module, exports) {

let $6d2d3c5275bb77ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d2d3c5275bb77ec$var$load("ioXLv").then(()=>parcelRequire('kXp7T'));

});

parcelRegister("lHYA1", function(module, exports) {

let $fcdc9b0aba31e6d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fcdc9b0aba31e6d8$var$load("76n7a"),
    $fcdc9b0aba31e6d8$var$load("l253H"),
    $fcdc9b0aba31e6d8$var$load("7ykIY")
]).then(()=>parcelRequire('e4mxx'));

});


parcelRegister("20Dmg", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $5ee433d2b5ace7bb$export$515240c3f059c807);

var $gFZHi = parcelRequire("gFZHi");
class $5ee433d2b5ace7bb$export$515240c3f059c807 extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $5ee433d2b5ace7bb$export$80ee180172bc336(err) {
    return err instanceof $5ee433d2b5ace7bb$export$515240c3f059c807;
}

});

parcelRegister("empHz", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $247cdc788c0fb235$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $247cdc788c0fb235$export$71f452e02035c1e2);

var $749LC = parcelRequire("749LC");

var $7E56q = parcelRequire("7E56q");
const $247cdc788c0fb235$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $247cdc788c0fb235$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $7E56q.MAX_UPLOAD_FILE_SIZE)) throw new Error($247cdc788c0fb235$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $749LC.DATA_UNIT).GB) return 5 * (0, $749LC.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $749LC.DATA_UNIT).GB && fileSize <= 50 * (0, $749LC.DATA_UNIT).GB) return 50 * (0, $749LC.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $749LC.DATA_UNIT).GB && fileSize <= 0.95 * (0, $749LC.DATA_UNIT).TB) return 100 * (0, $749LC.DATA_UNIT).MB;
    return 210 * (0, $749LC.DATA_UNIT).MB;
};

});


parcelRegister("hkwMq", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $451397184147c26f$export$f2f061938c1e6810);
class $451397184147c26f$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $451397184147c26f$var$streamCache;

const $451397184147c26f$export$f2f061938c1e6810 = ()=>{
    if (!$451397184147c26f$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("6a8j4")).mediaState;
        $451397184147c26f$var$streamCache = new $451397184147c26f$export$4293896e79732236(mediaState.streams);
    }
    return $451397184147c26f$var$streamCache;
};

});

parcelRegister("bfb59", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $22065e01bf236cb8$export$68d003d3105952ad);
parcelRequire("LmkUS");
var $6a8j4 = parcelRequire("6a8j4");
const $22065e01bf236cb8$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $6a8j4.mediaState).eventEmitter) return (0, $6a8j4.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("6CZ6k", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5k7LC = parcelRequire("5k7LC");
var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $4d35b0145f276bfe$var$_byteToHex = [];
for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
function $4d35b0145f276bfe$var$unparse(buf, offset) {
    var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
    else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("7p3Ot", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $40dc831f91888cf8$export$ae188fee39529b82);

var $hhZW9 = parcelRequire("hhZW9");

var $27T0s = parcelRequire("27T0s");
const $40dc831f91888cf8$export$b79d95ee17a87a = 100;
const $40dc831f91888cf8$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $40dc831f91888cf8$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $40dc831f91888cf8$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $40dc831f91888cf8$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $40dc831f91888cf8$var$makeCacheKey(id, collection);
        if ($40dc831f91888cf8$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($40dc831f91888cf8$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $40dc831f91888cf8$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $27T0s.getRandomHex)(8),
                spanId: (0, $27T0s.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $40dc831f91888cf8$export$71cd2e8f8162d47b(keys, items);
    };
}
function $40dc831f91888cf8$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))($40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $40dc831f91888cf8$export$b79d95ee17a87a
    });
}

});
parcelRegister("hhZW9", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $c964119340a5ebe3$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
        this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $c964119340a5ebe3$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
    if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
    $c964119340a5ebe3$var$resolvedPromise.then(function() {
        $6cAn5.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $c964119340a5ebe3$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $c964119340a5ebe3$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $c964119340a5ebe3$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $c964119340a5ebe3$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $c964119340a5ebe3$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $c964119340a5ebe3$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $c964119340a5ebe3$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $c964119340a5ebe3$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $c964119340a5ebe3$var$DataLoader;

});


parcelRegister("lVahM", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $748ba0ab0f854341$export$ac3214931ffd82af);

var $jzW7G = parcelRequire("jzW7G");
const $748ba0ab0f854341$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $jzW7G.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("jzW7G", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $08d056d70136c4e2$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser);

var $92ewp = parcelRequire("92ewp");

var $8GKRF = parcelRequire("8GKRF");

var $lF4MN = parcelRequire("lF4MN");
const $08d056d70136c4e2$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $92ewp.isArchive)(mimeType)) return 'archive';
    if ((0, $8GKRF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $8GKRF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $8GKRF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $8GKRF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $lF4MN.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("92ewp", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $addf45fda6198a62$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $addf45fda6198a62$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("8GKRF", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $3af4ecf7d6cb882c$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $3af4ecf7d6cb882c$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $3af4ecf7d6cb882c$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $3af4ecf7d6cb882c$export$55ca6cdaf6093034 = (mimeType)=>$3af4ecf7d6cb882c$export$74325e3c843a9555(mimeType) || $3af4ecf7d6cb882c$export$c021f2623a75015f(mimeType) || $3af4ecf7d6cb882c$export$ff36075ea755a717(mimeType) || $3af4ecf7d6cb882c$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("lF4MN", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $8b8147e427110cee$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $8b8147e427110cee$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $8b8147e427110cee$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $8b8147e427110cee$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $8b8147e427110cee$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $8b8147e427110cee$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $8b8147e427110cee$export$548d9148a80556a3 = (mimeType)=>$8b8147e427110cee$export$e9a065a80f76311e(mimeType) || $8b8147e427110cee$export$86baad7a89d908e9(mimeType) || $8b8147e427110cee$export$8cba23825d020bbb(mimeType) || $8b8147e427110cee$export$9c2b4de5fdca2ce3(mimeType) || $8b8147e427110cee$export$94e1479e01d2af53(mimeType);

});



parcelRegister("dhdZw", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $c0fce003746ff4f7$export$89097c0ec1e0dee1);

var $1Pp1U = parcelRequire("1Pp1U");
const $c0fce003746ff4f7$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $1Pp1U.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("gayAy", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $0fff1104576a2bb3$export$ed17558b11b88056);
const $0fff1104576a2bb3$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("j1BIJ", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $6582fd60bc4bbd36$export$4b2432e2d8723823);

var $2Mh8o = parcelRequire("2Mh8o");
function $6582fd60bc4bbd36$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $6582fd60bc4bbd36$export$8659d1f07d151381(item) {
    return $6582fd60bc4bbd36$export$4b2432e2d8723823((0, $2Mh8o.createMediaSubject)(item));
}

});
parcelRegister("2Mh8o", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $c9b8fad0d34272f1$export$bc76d51553fa5e35);

var $dZ0DN = parcelRequire("dZ0DN");
function $c9b8fad0d34272f1$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $dZ0DN.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("lYDAe", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $44429e0ad2a9ded6$export$4dbaaf6c79705e6c);

var $aZdZn = parcelRequire("aZdZn");
const $44429e0ad2a9ded6$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("29M1K", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $c92d9e8096a99b5b$export$71797c284d89a3e1);

var $8IWWt = parcelRequire("8IWWt");

var $5CbXO = parcelRequire("5CbXO");
const $c92d9e8096a99b5b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $8IWWt.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $5CbXO.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("8IWWt", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $094f7e5912c5e863$export$a1c3205f28a20414);
const $094f7e5912c5e863$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("5CbXO", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $3629651e482443d2$export$62aabd5ff85d0451);
const $3629651e482443d2$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("gR4o6", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $81fca2ad541e7785$export$2ccdd6f9a9eba6a);

var $8GKRF = parcelRequire("8GKRF");
var $lF4MN = parcelRequire("lF4MN");

var $5CbXO = parcelRequire("5CbXO");
async function $81fca2ad541e7785$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $lF4MN.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $5CbXO.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("dJ905", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $a9b60fcbc1595cd8$export$4c54d536f8e37dc2);

var $j8kdR = parcelRequire("j8kdR");
const $a9b60fcbc1595cd8$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $a9b60fcbc1595cd8$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$a9b60fcbc1595cd8$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $j8kdR.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $j8kdR.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("j8kdR", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $ba72cde1b79a6066$export$c3748c310e92340a);

var $gFZHi = parcelRequire("gFZHi");
class $ba72cde1b79a6066$export$c3748c310e92340a extends (0, $gFZHi.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $ba72cde1b79a6066$export$541e3e52eea6fece(err) {
    return err instanceof $ba72cde1b79a6066$export$c3748c310e92340a;
}

});


parcelRegister("9KWg9", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $6625df65da5f0486$export$728192ce8dd94659);
const $6625df65da5f0486$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $6625df65da5f0486$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $6625df65da5f0486$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("8HaZs", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("fN64m")).mediaStore);

var $fN64m = parcelRequire("fN64m");

});
parcelRegister("fN64m", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $df71566ec1e8fa2a$export$5785580dea19518d);

var $bIv98 = parcelRequire("bIv98");

var $70n8Q = parcelRequire("70n8Q");

var $ee7sp = parcelRequire("ee7sp");
const $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools = (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    }))));
const $df71566ec1e8fa2a$var$mediaStoreWithDevtools = (0, $ee7sp.createStore)()((0, $bIv98.devtools)((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
        files: {}
    })))));
const $df71566ec1e8fa2a$export$5785580dea19518d = $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools;
const $df71566ec1e8fa2a$export$503459913a0dc356 = (initialStore)=>{
    return (0, $ee7sp.createStore)()((0, $bIv98.subscribeWithSelector)((0, $70n8Q.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("bIv98", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $887bf6c78f4461c3$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $887bf6c78f4461c3$export$5c593627aef9f076);
var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
const $887bf6c78f4461c3$var$trackedConnections = /* @__PURE__ */ new Map();
const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
    const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
    }
    return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
};
const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;

});

parcelRegister("70n8Q", function(module, exports) {

$parcel$export(module.exports, "immer", () => $519a7bf2c276fd5a$export$428de7ec69ac95c);

var $86xFr = parcelRequire("86xFr");
const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $86xFr.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;

});
parcelRegister("86xFr", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;

});


parcelRegister("ee7sp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $a5b82856cfbd137f$export$f51a9068ac82ea43);
var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
    if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("kFeQ4", function(module, exports) {

$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $22ef2bf89bf2366d$export$57945b6819e39246);

var $hhZW9 = parcelRequire("hhZW9");

var $27T0s = parcelRequire("27T0s");
const $22ef2bf89bf2366d$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $22ef2bf89bf2366d$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $27T0s.getRandomHex)(8),
                spanId: (0, $27T0s.getRandomHex)(8)
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $22ef2bf89bf2366d$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))($22ef2bf89bf2366d$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $22ef2bf89bf2366d$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("5eAc2", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $0084b28d1d44d0da$export$c66ca190f89caaac);
class $0084b28d1d44d0da$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("8y2QC", function(module, exports) {

let $6393b5381640274a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6393b5381640274a$var$load("drI9i").then(()=>parcelRequire('piTsY'));

});



parcelRegister("cEHh7", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $2a03c62fd3cc05ea$export$5bff351c86f56d97);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $85xkt.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("1pTqN", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $ae2d04c26b960a03$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $ae2d04c26b960a03$export$cddc3c6ebe2d2cec);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ae2d04c26b960a03$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("jUVor", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $5224f7c9e411dec4$export$cfc1361be0de4203);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eOOFp = parcelRequire("eOOFp");

var $VSDnB = parcelRequire("VSDnB");

function $5224f7c9e411dec4$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, $VSDnB.fg)('platform-ssr-table-resize') ? $5224f7c9e411dec4$export$92859d13f30c883e(id, true) : $5224f7c9e411dec4$export$92859d13f30c883e(id)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $5224f7c9e411dec4$export$92859d13f30c883e(id, optionalFlagArg) {
    return `
	 (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${optionalFlagArg ?? false});
  })(window);
`;
}
const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $eOOFp.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $eOOFp.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $eOOFp.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcBreakoutWithCustomWidth = ${(0, $eOOFp.breakoutConsts).calcBreakoutWithCustomWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $eOOFp.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $eOOFp.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $19a4579e32968c00$export$12fd658e5eef0d79).toString()};
`;
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const resizedBreakout = node.dataset.hasWidth === 'true';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript && node.classList.contains('pm-table-container')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else if (resizedBreakout) width = breakoutConsts.calcBreakoutWithCustomWidth(mode, node.dataset.width || null, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                renderer.offsetWidth);
                else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, $eOOFp.breakoutConsts).calcLineLength;

});

parcelRegister("TPpI8", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $2d523c4d7c031fc5$export$3dee5e4542c672d9);


function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("3lRy2", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $de95a93fc343bd51$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");
const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $de95a93fc343bd51$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles
    }, children);
};
class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)($de95a93fc343bd51$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("glOdv", function(module, exports) {

$parcel$export(module.exports, "RendererStyleContainer", () => $db1d99891a2fef87$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
                                                                                                                                                                                                                                                                           * @jsxRuntime classic
                                                                                                                                                                                                                                                                           * @jsx jsx
                                                                                                                                                                                                                                                                           */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");



var $VSDnB = parcelRequire("VSDnB");

var $l8Gxi = parcelRequire("l8Gxi");

var $iHYdz = parcelRequire("iHYdz");

var $9R9Rb = parcelRequire("9R9Rb");

var $3rouw = parcelRequire("3rouw");

var $cYeQP = parcelRequire("cYeQP");
var $4E5wI = parcelRequire("4E5wI");
var $jlYLw = parcelRequire("jlYLw");
var $ceYEW = parcelRequire("ceYEW");
var $iJOES = parcelRequire("iJOES");
var $6gEe5 = parcelRequire("6gEe5");
var $1bQ0V = parcelRequire("1bQ0V");

var $kjhhp = parcelRequire("kjhhp");
var $dwptW = parcelRequire("dwptW");

var $ajc8Z = parcelRequire("ajc8Z");
var $bbl9Y = parcelRequire("bbl9Y");

var $gE8f9 = parcelRequire("gE8f9");

var $gmhCD = parcelRequire("gmhCD");

var $dkc63 = parcelRequire("dkc63");


var $2o2hu = parcelRequire("2o2hu");

var $04VvC = parcelRequire("04VvC");

var $aagOn = parcelRequire("aagOn");
function $db1d99891a2fef87$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db1d99891a2fef87$var$wrappedMediaBreakoutPoint = 410;
const $db1d99891a2fef87$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $db1d99891a2fef87$var$tableShadowWidth = 32;
const $db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $db1d99891a2fef87$var$tableRowHeight = 44;
const $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded = ()=>(0, $gE8f9.browser).isGecko || (0, $gE8f9.browser).isIE || (0, $gE8f9.browser).isMac && (0, $gE8f9.browser).isChrome;
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $db1d99891a2fef87$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $9R9Rb.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    },
    [`& span.akActionMark`]: {
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        }
    },
    '& span[data-placeholder]': {
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    }
});
const $db1d99891a2fef87$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererFullPageStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $19a4579e32968c00$export$12fd658e5eef0d79)}px`
});
const $db1d99891a2fef87$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $iHYdz.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $db1d99891a2fef87$var$telepointerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`#${$db1d99891a2fef87$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '25px',
        backgroundColor: "var(--ds-background-brand-bold, #0C66E4)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '"AI"',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            fontWeight: "var(--ds-font-weight-bold, 700)",
            width: '12.5px',
            height: '13px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingLeft: '1.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            borderRadius: '0px 2px 2px 0px',
            color: "var(--ds-text-inverse, white)",
            backgroundColor: "var(--ds-background-brand-bold, #0C66E4)"
        }
    }
});
const $db1d99891a2fef87$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $db1d99891a2fef87$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $iHYdz.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $db1d99891a2fef87$var$headingsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${24 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.01em`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${20 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.008em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${16 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.006em`,
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${1}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.003em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${11 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #626F86)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
const $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
const $db1d99891a2fef87$var$headingWithAlignmentStyles = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $db1d99891a2fef87$var$ruleSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $iHYdz.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: '1px'
    }
});
const $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $db1d99891a2fef87$var$paragraphSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $iHYdz.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $iHYdz.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $db1d99891a2fef87$var$listsSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $jlYLw.listItemCounterPadding)}px)`
    },
    [`${0, $dwptW.orderedListSelector}, ${0, $kjhhp.bulletListSelector}`]: {
        /*
     Ensures list item content adheres to the list's margin instead
     of filling the entire block row. This is important to allow
     clicking interactive elements which are floated next to a list.
      For some history and context on this block, see PRs related to tickets.:
     @see ED-6551 - original issue.
     @see ED-7015 - follow up issue.
     @see ED-7447 - flow-root change.
      used to have display: 'table' in tag template style but not supported in object styles
     removed display: 'table' as 'flow-root' is supported in latest browsers
      @see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $db1d99891a2fef87$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
const $db1d99891a2fef87$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $db1d99891a2fef87$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $iHYdz.blockNodesVerticalMargin)
        }
    }
});
const $db1d99891a2fef87$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`})`,
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $db1d99891a2fef87$var$shadowSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $iHYdz.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}, .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $db1d99891a2fef87$var$dateSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $4E5wI.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $db1d99891a2fef87$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $db1d99891a2fef87$var$backgroundColorStyles = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $db1d99891a2fef87$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $iHYdz.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $1bQ0V.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $iHYdz.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $iHYdz.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $db1d99891a2fef87$var$smartCardStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $db1d99891a2fef87$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $db1d99891a2fef87$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $db1d99891a2fef87$var$baseOtherStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        background: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: `${"var(--ds-space-300, 24px)"} 0`
    },
    [`.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .${0, $ceYEW.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $ceYEW.richMediaClassName}.image-align-start,
		.${0, $ceYEW.richMediaClassName}.image-center,
		.${0, $ceYEW.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $l8Gxi.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $l8Gxi.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`
        },
        [`.${(0, $l8Gxi.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $bbl9Y.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $db1d99891a2fef87$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
            margin: `0 ${"var(--ds-space-075, 6px)"} 0 0`,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3rouw.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $db1d99891a2fef87$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $ceYEW.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $ceYEW.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-right, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-left + .${0, $ceYEW.richMediaClassName}.image-wrap-left, .${0, $ceYEW.richMediaClassName}.image-wrap-right + .${0, $ceYEW.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$db1d99891a2fef87$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
// was shared between editor-core and renderer
const $db1d99891a2fef87$var$tableSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E6FCFF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #E3FCEF)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FFFAE6)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFEBE6)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #EAE6FF)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #B3D4FF)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #B3F5FF)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #ABF5D1)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #FFF0B3)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFBDAD)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #C0B6F2)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #B3BAC5)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #4C9AFF)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #79E2F2)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #57D9A3)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FFC400)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #FF8F73)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #998DD9)"} !important`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        margin: `0 auto ${"var(--ds-space-200, 16px)"}`,
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $iHYdz.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} 0 0 0`
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0`
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $6gEe5.tableCellBorderWidth)}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, white)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $iHYdz.akEditorTableToolbar)})`,
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))",
                    [`&:not(.${0, $iHYdz.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, transparent)"}`
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
                    },
                    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
                    }
                }
            }
        }
    }
});
const $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // platform_editor_renderer_table_header_styles has already been launched, so assume it's on
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $6gEe5.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $db1d99891a2fef87$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"}`
    }
});
const $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $ajc8Z.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $6gEe5.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`,
            zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
            width: `${$db1d99891a2fef87$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $ajc8Z.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $bbl9Y.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $6gEe5.tableMarginTop)}px)`
        }
    }
});
const $db1d99891a2fef87$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$db1d99891a2fef87$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $db1d99891a2fef87$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $6gEe5.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`}`
                        }
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// TODO: ED-27229 - Cleanup with `platform_editor_tables_numbered_column_correction`
const $db1d99891a2fef87$var$rendererTableColumnStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${`var(--ds-background-neutral, ${(0, $iHYdz.akEditorTableToolbar)})`}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
                width: `${(0, $iHYdz.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $l8Gxi.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT} .${(0, $6gEe5.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $6gEe5.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $6gEe5.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $l8Gxi.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3rouw.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $db1d99891a2fef87$var$stickyHeaderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        borderBottom: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $iHYdz.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableBorder)})`},
			inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`},
			0px -1px ${`var(--ds-background-accent-gray-subtler, ${(0, $iHYdz.akEditorTableToolbar)})`}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $db1d99891a2fef87$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $iHYdz.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $l8Gxi.RendererCssClassName).DOCUMENT}
		> .${(0, $2o2hu.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $iHYdz.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $iHYdz.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $iHYdz.blockNodesVerticalMargin)
        }
    }
});
const $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $db1d99891a2fef87$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $db1d99891a2fef87$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $iJOES.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $iHYdz.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $iHYdz.akEditorLineHeight)}em !important`
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $iHYdz.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$db1d99891a2fef87$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    }
});
const $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $db1d99891a2fef87$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    const isAdvancedLayoutsOn = (0, $gmhCD.editorExperiment)('advanced_layouts', true);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${(0, $aagOn.getBaseFontSize)(appearance)}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $04VvC.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $04VvC.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $04VvC.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $04VvC.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $04VvC.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $04VvC.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $04VvC.default)('editor.font.body')}`
        },
        css: [
            $db1d99891a2fef87$var$baseStyles,
            $db1d99891a2fef87$var$hideHeadingCopyLinkWrapperStyles,
            appearance === 'full-page' && $db1d99891a2fef87$var$rendererFullPageStyles,
            appearance === 'full-width' && $db1d99891a2fef87$var$rendererFullWidthStyles,
            appearance === 'full-width' && !(0, $dkc63.isTableResizingEnabled)(appearance) && $db1d99891a2fef87$var$rendererFullWidthStylesForTableResizing,
            $db1d99891a2fef87$var$telepointerStyles,
            $db1d99891a2fef87$var$whitespaceSharedStyles,
            $db1d99891a2fef87$var$blockquoteSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$headingsSharedStylesWithEditorUGC : $db1d99891a2fef87$var$headingsSharedStyles,
            $db1d99891a2fef87$var$headingWithAlignmentStyles,
            $db1d99891a2fef87$var$ruleSharedStyles,
            (0, $VSDnB.fg)('platform_editor_typography_ugc') ? $db1d99891a2fef87$var$paragraphSharedStylesWithEditorUGC : $db1d99891a2fef87$var$paragraphSharedStyles,
            $db1d99891a2fef87$var$listsSharedStyles,
            (0, $gE8f9.browser).gecko && $db1d99891a2fef87$var$listsSharedStylesForGekko,
            $db1d99891a2fef87$var$indentationSharedStyles,
            (0, $VSDnB.fg)('platform_editor__renderer_indentation_text_margin') && $db1d99891a2fef87$var$indentationSharedStylesWithMarginFix,
            $db1d99891a2fef87$var$blockMarksSharedStyles,
            $db1d99891a2fef87$var$codeMarkSharedStyles,
            $db1d99891a2fef87$var$shadowSharedStyle,
            $db1d99891a2fef87$var$dateSharedStyle,
            $db1d99891a2fef87$var$textColorStyles,
            $db1d99891a2fef87$var$backgroundColorStyles,
            $db1d99891a2fef87$var$tasksAndDecisionsStyles,
            $db1d99891a2fef87$var$smartCardStyles,
            (0, $VSDnB.fg)('platform-linking-visual-refresh-v1') && $db1d99891a2fef87$var$smartCardStylesAvatarFix,
            (0, $VSDnB.fg)('smartcard_avatar_margin_fix') && $db1d99891a2fef87$var$smartCardStylesAvatarMarginFix,
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && $db1d99891a2fef87$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('editor_inline_comments_on_inline_nodes') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('annotations_align_editor_and_renderer_styles') && $db1d99891a2fef87$var$rendererAnnotationStylesCommentHeightFix,
            $db1d99891a2fef87$var$baseOtherStyles,
            allowNestedHeaderLinks && $db1d99891a2fef87$var$alignedHeadingAnchorStyle,
            $db1d99891a2fef87$var$mediaSingleSharedStyle,
            $db1d99891a2fef87$var$tableSharedStyle,
            $db1d99891a2fef87$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $VSDnB.fg)('platform_editor_bordered_panel_nested_in_table') && $db1d99891a2fef87$var$tableRendererNestedPanelStyles,
            $db1d99891a2fef87$var$isBackgroundClipBrowserFixNeeded() && $db1d99891a2fef87$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $VSDnB.fg)('platform_editor_nested_dnd_styles_changes') ? $db1d99891a2fef87$var$firstNodeWithNotMarginTopWithNestedDnD : $db1d99891a2fef87$var$firstNodeWithNotMarginTop,
            $db1d99891a2fef87$var$rendererTableStyles,
            (0, $dkc63.isStickyScrollbarEnabled)(appearance) && $db1d99891a2fef87$var$stickyScrollbarStyles,
            $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $db1d99891a2fef87$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $db1d99891a2fef87$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            (0, $VSDnB.fg)('platform_editor_tables_numbered_column_correction') ? $db1d99891a2fef87$var$rendererTableColumnStyles : $db1d99891a2fef87$var$rendererTableColumnStylesOld,
            $db1d99891a2fef87$var$stickyHeaderStyles,
            $db1d99891a2fef87$var$codeBlockAndLayoutStyles,
            $db1d99891a2fef87$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $db1d99891a2fef87$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $db1d99891a2fef87$var$gridRenderForCodeBlockStyles,
            (0, $gE8f9.browser).safari && $db1d99891a2fef87$var$codeBlockInListSafariFixStyles
        ],
        "data-testid": testId
    }, children));
};

});
parcelRegister("9R9Rb", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $c55873fb36219b19$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $c55873fb36219b19$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $c55873fb36219b19$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $c55873fb36219b19$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $c55873fb36219b19$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $c55873fb36219b19$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $c55873fb36219b19$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $c55873fb36219b19$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $dR3f5 = parcelRequire("dR3f5");
const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $f8Sb3.css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $c55873fb36219b19$export$dee15762144889b7 = /*#__PURE__*/ (0, $f8Sb3.css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, $dR3f5.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, $dR3f5.referenceHeights)['h6'], -2), ";}");
const $c55873fb36219b19$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $c55873fb36219b19$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $c55873fb36219b19$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, $dR3f5.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("dR3f5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $c9848698b53f0c39$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $c9848698b53f0c39$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $c9848698b53f0c39$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $c9848698b53f0c39$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $c9848698b53f0c39$export$c1317a9224e4d798);
const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
const $c9848698b53f0c39$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("4E5wI", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $174371b9df7208d5$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $174371b9df7208d5$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $174371b9df7208d5$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("ceYEW", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $5c06afce66d8efef$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyleNew", () => $5c06afce66d8efef$export$b51dea84d928a378);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
const $5c06afce66d8efef$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $5c06afce66d8efef$export$b51dea84d928a378 = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $iHYdz.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("iJOES", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $bc13534612fcd0a2$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $bc13534612fcd0a2$export$83e107f0a431e184);
$parcel$export(module.exports, "getSmartCardSharedStyles", () => $bc13534612fcd0a2$export$fbd9b588230965e4);

var $iHYdz = parcelRequire("iHYdz");
const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $iHYdz.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
const $bc13534612fcd0a2$export$fbd9b588230965e4 = ()=>`
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${0, $iHYdz.blockNodesVerticalMargin} 0 0;
    max-width: ${760}px;
  }

  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */
    ul, ol {
      padding-left: inherit;
    }
    /* EDM-11991: Fix list plugin add padding to ADS AvatarGroup end */
  }
`;

});

parcelRegister("1bQ0V", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $2398d5ed497032ce$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $2398d5ed497032ce$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $2398d5ed497032ce$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $f8Sb3.css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $iHYdz.akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $iHYdz.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $iHYdz.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $iHYdz.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("2o2hu", function(module, exports) {

$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $67d1fb0f1c6fc210$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $67d1fb0f1c6fc210$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iHYdz = parcelRequire("iHYdz");
var $eluMF = parcelRequire("eluMF");

var $cYeQP = parcelRequire("cYeQP");

var $23OJc = parcelRequire("23OJc");

var $l8Gxi = parcelRequire("l8Gxi");
const $67d1fb0f1c6fc210$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${(0, $iHYdz.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $iHYdz.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            display: 'flex',
            borderRadius: "var(--ds-border-radius, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #172B4D)",
                borderRadius: "var(--ds-border-radius, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #505F79)",
            boxSizing: 'content-box'
        }
    }
});
const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    [`.${(0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)(".", (0, $l8Gxi.RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $iHYdz.blockNodesVerticalMargin), ";}");
};
const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $23OJc.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $eluMF.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $67d1fb0f1c6fc210$var$codeBlockSharedStyles,
            $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        className: (0, $cYeQP.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("code", null, renderBidiWarnings(text))))));
});
var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;

});
parcelRegister("23OJc", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $807954ab13bca9b8$export$9fb9fe546a188c7b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lrHA4 = parcelRequire("lrHA4");

var $fJyLQ = parcelRequire("fJyLQ");

var $31cgS = parcelRequire("31cgS");
const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $koVbs.default)();
    const warningLabel = intl.formatMessage((0, $fJyLQ.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $31cgS.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("04VvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $53f731000984869b$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $kqZva = parcelRequire("kqZva");
function $53f731000984869b$var$editorUGCToken(path) {
    let tokens;
    if ((0, $VSDnB.fg)('platform_editor_typography_ugc')) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-dst-jira-web-fonts') || (0, $VSDnB.fg)('confluence_typography_refreshed') || (0, $VSDnB.fg)('atlas_editor_typography_refreshed')) tokens = (0, $kqZva.editorUGCTokensRefreshed);
        else tokens = (0, $kqZva.editorUGCTokensModernized);
    } else tokens = (0, $kqZva.editorUGCTokens);
    return tokens[path];
}
var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;

});
parcelRegister("kqZva", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokens", () => $5558cddd9c1ce385$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensModernized", () => $5558cddd9c1ce385$export$95588e746468319e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $5558cddd9c1ce385$export$63adc0ebe3278d31);
const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});


parcelRegister("aagOn", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $1723ca6d969fec09$export$8e2864079bc476bd);

var $iHYdz = parcelRequire("iHYdz");
const $1723ca6d969fec09$export$8e2864079bc476bd = (appearance)=>{
    return appearance && appearance !== 'comment' ? (0, $iHYdz.akEditorFullPageDefaultFontSize) : 14;
};

});


parcelRegister("dJPoO", function(module, exports) {

$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $364a1dd5fa66cb46$export$c94cfc0c675062a1);
const $364a1dd5fa66cb46$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("kjHuf", function(module, exports) {

$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $d3a3005b3046eec9$export$80ffe7e3c6bf25c3);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
function $d3a3005b3046eec9$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $5uXOq.useRef)(props);
    const prevFactory = (0, $5uXOq.useRef)(null);
    return (0, $5uXOq.useMemo)(()=>{
        if ((0, $VSDnB.fg)('cc_complexit_fe_reduce_fragment_serialization')) {
            // check if the serializer is already created
            let shouldCreate = !prevFactory.current;
            // check each prop to see if value has changed and also check if the number of props has changed
            if (prev.current !== props) {
                const propsEntries = Object.entries(props);
                shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
            }
            prev.current = props;
            // If first time or any prop value has changed, create a new serializer
            if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
            return prevFactory.current;
        }
        return factory(propsDerivator(props));
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});

parcelRegister("8QrLL", function(module, exports) {

$parcel$export(module.exports, "PortalContext", () => $d2ca68ebf215abf7$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $d2ca68ebf215abf7$export$b1072f43c67b540c);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $d2ca68ebf215abf7$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $d2ca68ebf215abf7$export$b1072f43c67b540c = ({ portal: portalFromProps } = {})=>{
    const portalFromContext = (0, $5uXOq.useContext)($d2ca68ebf215abf7$export$60d741e20e0aa309);
    if (portalFromProps) return portalFromProps;
    if ((0, $VSDnB.fg)('cc_complexit_reduce_portal_rerenders')) return portalFromContext;
    return undefined;
};

});


parcelRegister("fBaBT", function(module, exports) {

$parcel$export(module.exports, "AIAgentResponseState", () => $ca6cacd78b6b85dc$export$8dac07e05677d855);
$parcel$export(module.exports, "getDefaultAIAgentStreamingState", () => $ca6cacd78b6b85dc$export$25aa85b7d3899cd7);
var $ca6cacd78b6b85dc$export$8dac07e05677d855 = /*#__PURE__*/ function(AIAgentResponseState) {
    AIAgentResponseState["Initialization"] = "Initialization";
    AIAgentResponseState["AnswerPart"] = "AnswerPart";
    AIAgentResponseState["FinalResponse"] = "FinalResponse";
    AIAgentResponseState["FollowUp"] = "FollowUp";
    AIAgentResponseState["Error"] = "Error";
    return AIAgentResponseState;
}({});
function $ca6cacd78b6b85dc$export$25aa85b7d3899cd7() {
    return {
        content: null,
        responseState: "Initialization"
    };
}

});

const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';
const $31848aa9a0db89de$export$51359835e284d90 = 'jira.user.issue.details.layout-setting';
const $31848aa9a0db89de$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $31848aa9a0db89de$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $31848aa9a0db89de$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("37QwF", function(module, exports) {

$parcel$export(module.exports, "isAdfContent", () => $0e5f1c394260ab83$export$d801201dc544181);
$parcel$export(module.exports, "appendContent", () => $0e5f1c394260ab83$export$a236f395afded7e0);
$parcel$export(module.exports, "encodeAdf", () => $0e5f1c394260ab83$export$53ded0b846f45216);

var $dPSMN = parcelRequire("dPSMN");

var $K5Jsy = parcelRequire("K5Jsy");

var $kaMno = parcelRequire("kaMno");
const $0e5f1c394260ab83$export$d801201dc544181 = (content)=>{
    /*
	This try-catch is a necessary guard rail against broken content to prevent higher level
	error boundaries from displaying the error and breaking the experience.
	*/ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $0e5f1c394260ab83$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($0e5f1c394260ab83$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $0e5f1c394260ab83$var$pluginConfig = {
    linkify: {
        findFilepaths: $dPSMN.findFilepaths,
        isLinkInMatches: $dPSMN.isLinkInMatches
    },
    smartLinks: {
        regexStorage: $parcel$global.localStorage
    }
};
const $0e5f1c394260ab83$export$3374c63d7715b4ce = new (0, $K5Jsy.ADFEncoder)((schema)=>new (0, $kaMno.AiMateMarkdownTransformer)(schema, $0e5f1c394260ab83$var$pluginConfig, false));
const $0e5f1c394260ab83$var$streamingAdfEncoder = new (0, $K5Jsy.ADFEncoder)((schema)=>new (0, $kaMno.AiMateMarkdownTransformer)(schema, $0e5f1c394260ab83$var$pluginConfig, true));
const $0e5f1c394260ab83$export$53ded0b846f45216 = (content, streaming = false)=>{
    if ($0e5f1c394260ab83$export$d801201dc544181(content)) return content;
    return streaming ? $0e5f1c394260ab83$var$streamingAdfEncoder.encode(content) : $0e5f1c394260ab83$export$3374c63d7715b4ce.encode(content);
};

});
parcelRegister("dPSMN", function(module, exports) {

$parcel$export(module.exports, "LinkMatcher", () => $c71efdd24f85e7a0$export$4490385c12bf3d4);
$parcel$export(module.exports, "normalizeUrl", () => $c71efdd24f85e7a0$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "linkifyContent", () => $c71efdd24f85e7a0$export$5a511fa58fab15e6);
$parcel$export(module.exports, "findFilepaths", () => $c71efdd24f85e7a0$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $c71efdd24f85e7a0$export$5e652e74655163e5);
$parcel$export(module.exports, "getLinkDomain", () => $c71efdd24f85e7a0$export$238a6141b3685c21);
$parcel$export(module.exports, "isFromCurrentDomain", () => $c71efdd24f85e7a0$export$336c6a47b1dfa1bc);
$parcel$export(module.exports, "getLinkCreationAnalyticsEvent", () => $c71efdd24f85e7a0$export$56039faad4eda709);
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $c71efdd24f85e7a0$export$b7392a423e62dc8c);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $iZOJ9 = parcelRequire("iZOJ9");

var $VSDnB = parcelRequire("VSDnB");

var $gkwXh = parcelRequire("gkwXh");

var $gOwky = parcelRequire("gOwky");

var $7vpuQ = parcelRequire("7vpuQ");
const $c71efdd24f85e7a0$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c71efdd24f85e7a0$export$dabcc234035f6703 = /^(\$|{)/;
class $c71efdd24f85e7a0$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c71efdd24f85e7a0$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $iZOJ9.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c71efdd24f85e7a0$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $iZOJ9.isSafeUrl)(url)) return url;
    return (0, $iZOJ9.normalizeUrl)(url);
}
function $c71efdd24f85e7a0$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c71efdd24f85e7a0$var$findLinkMatches(text).filter((0, $gOwky.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c71efdd24f85e7a0$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c71efdd24f85e7a0$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c71efdd24f85e7a0$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c71efdd24f85e7a0$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c71efdd24f85e7a0$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c71efdd24f85e7a0$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $iZOJ9.linkify).match(text) || [];
}
const $c71efdd24f85e7a0$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($c71efdd24f85e7a0$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c71efdd24f85e7a0$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c71efdd24f85e7a0$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c71efdd24f85e7a0$export$238a6141b3685c21(url)
        }
    };
}
const $c71efdd24f85e7a0$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard && (0, $VSDnB.fg)('platform_editor_controls_patch_11');
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});
parcelRegister("gOwky", function(module, exports) {

$parcel$export(module.exports, "shouldAutoLinkifyMatch", () => $a8453eeff8b41d2c$export$e19a09e301eaa6bb);
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $a8453eeff8b41d2c$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $a8453eeff8b41d2c$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$a8453eeff8b41d2c$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $a8453eeff8b41d2c$export$e19a09e301eaa6bb(match) {
    return $a8453eeff8b41d2c$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("7vpuQ", function(module, exports) {

$parcel$export(module.exports, "getFragmentBackingArray", () => $cd200aea723473fd$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $cd200aea723473fd$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $cd200aea723473fd$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $cd200aea723473fd$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $cd200aea723473fd$export$e0baa27f47733a4a);

var $kCV8T = parcelRequire("kCV8T");
function $cd200aea723473fd$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $cd200aea723473fd$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($cd200aea723473fd$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $kCV8T.Fragment)) children.push(...$cd200aea723473fd$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $kCV8T.Fragment).fromArray(children);
}
function $cd200aea723473fd$export$d8264570c5933bbf(slice, callback) {
    const fragment = $cd200aea723473fd$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $kCV8T.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $cd200aea723473fd$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $kCV8T.Fragment).fromArray(fragmentContent);
}
function $cd200aea723473fd$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $kCV8T.Fragment) ? node : node.content));
    return array;
}
const $cd200aea723473fd$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $cd200aea723473fd$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$cd200aea723473fd$var$findNode(predicate)(slice);
    };

});


parcelRegister("kaMno", function(module, exports) {

$parcel$export(module.exports, "AiMateMarkdownTransformer", () => $0757ea382637289c$export$614853bf2169db97);

var $ivSSX = parcelRequire("ivSSX");

var $4iMad = parcelRequire("4iMad");

var $38KaN = parcelRequire("38KaN");

var $6fRr3 = parcelRequire("6fRr3");

var $kCV8T = parcelRequire("kCV8T");

var $VSDnB = parcelRequire("VSDnB");

var $kboGB = parcelRequire("kboGB");

var $lKkRz = parcelRequire("lKkRz");

var $3p5rU = parcelRequire("3p5rU");

var $htzpC = parcelRequire("htzpC");

var $8ZEpI = parcelRequire("8ZEpI");

var $muDJ0 = parcelRequire("muDJ0");

var $7zJFX = parcelRequire("7zJFX");

var $btItw = parcelRequire("btItw");

var $4bKco = parcelRequire("4bKco");
class $0757ea382637289c$export$614853bf2169db97 extends (0, $38KaN.MarkdownTransformer) {
    constructor(schema, pluginConfig, streaming){
        super();
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $4bKco.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $3p5rU.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $kboGB.default));
        if ((0, $VSDnB.fg)('rovo_enable_data_sculptor')) md.use((0, $lKkRz.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) md.use((0, $muDJ0.createSmartLinksPlugin)(pluginConfig.smartLinks));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $8ZEpI.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $4iMad.markdownItTable));
            if ((0, $VSDnB.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $7zJFX.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $htzpC.default));
        const filter = (0, $4bKco.filterSchemaMapping)(schema, (0, $btItw.mdToPmSchema));
        this.parser = new (0, $6fRr3.MarkdownParser)(schema, md, filter);
    }
    parse(content) {
        const node = this.parser.parse(content);
        if (!node) return new (0, $kCV8T.Node)();
        return node;
    }
}

});
parcelRegister("ivSSX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7fjdG"));

});
parcelRegister("7fjdG", function(module, exports) {
// Main parser class
'use strict';

var $lKlAe = parcelRequire("lKlAe");

var $1mGdb = parcelRequire("1mGdb");

var $keGIi = parcelRequire("keGIi");

var $aVlnc = parcelRequire("aVlnc");

var $81Ci5 = parcelRequire("81Ci5");

var $58y21 = parcelRequire("58y21");

var $43kHv = parcelRequire("43kHv");

var $aK6mt = parcelRequire("aK6mt");

var $k7qPZ = parcelRequire("k7qPZ");



var $5468d7bb65d238e2$var$config = {
    default: (parcelRequire("gcpUf")),
    zero: (parcelRequire("hbvGf")),
    commonmark: (parcelRequire("8Ubo6"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $5468d7bb65d238e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $5468d7bb65d238e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $5468d7bb65d238e2$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $5468d7bb65d238e2$var$BAD_PROTO_RE.test(str) ? $5468d7bb65d238e2$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $5468d7bb65d238e2$var$normalizeLink(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $aK6mt.encode($aK6mt.format(parsed));
}
function $5468d7bb65d238e2$var$normalizeLinkText(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $aK6mt.decode($aK6mt.format(parsed), $aK6mt.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $5468d7bb65d238e2$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $5468d7bb65d238e2$var$MarkdownIt)) return new $5468d7bb65d238e2$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$lKlAe.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $58y21();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $81Ci5();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $aVlnc();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $keGIi();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $43kHv();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $5468d7bb65d238e2$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $5468d7bb65d238e2$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $5468d7bb65d238e2$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $lKlAe;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $lKlAe.assign({}, $1mGdb);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.set = function(options) {
    $lKlAe.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($lKlAe.isString(presets)) {
        presetName = presets;
        presets = $5468d7bb65d238e2$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $5468d7bb65d238e2$var$MarkdownIt;

});
parcelRegister("lKlAe", function(module, exports) {

$parcel$export(module.exports, "lib", () => $fd4ea2dc11e83b2a$export$16c08b91f883959a, (v) => $fd4ea2dc11e83b2a$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227, (v) => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $fd4ea2dc11e83b2a$export$844ec244b1367d54, (v) => $fd4ea2dc11e83b2a$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5, (v) => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03, (v) => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c, (v) => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d, (v) => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $fd4ea2dc11e83b2a$export$73bfc63873071f74, (v) => $fd4ea2dc11e83b2a$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8, (v) => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $fd4ea2dc11e83b2a$export$f78478f71955b6bc, (v) => $fd4ea2dc11e83b2a$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926, (v) => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c, (v) => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $fd4ea2dc11e83b2a$export$829a0d33ae4e744, (v) => $fd4ea2dc11e83b2a$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $fd4ea2dc11e83b2a$export$4888a643af800fc1, (v) => $fd4ea2dc11e83b2a$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d, (v) => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $fd4ea2dc11e83b2a$export$20ef46802c8744b, (v) => $fd4ea2dc11e83b2a$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $fd4ea2dc11e83b2a$export$16c08b91f883959a;
var $fd4ea2dc11e83b2a$export$e6e34fd1f2686227;
var $fd4ea2dc11e83b2a$export$844ec244b1367d54;
var $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5;
var $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03;
var $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c;
var $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d;
var $fd4ea2dc11e83b2a$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8;
var $fd4ea2dc11e83b2a$export$f78478f71955b6bc;
var $fd4ea2dc11e83b2a$export$1d5ccafae59b4926;
var $fd4ea2dc11e83b2a$export$3c52dd84024ae72c;
var $fd4ea2dc11e83b2a$export$829a0d33ae4e744;
var $fd4ea2dc11e83b2a$export$4888a643af800fc1;
var $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d;
var $fd4ea2dc11e83b2a$export$20ef46802c8744b;
'use strict';
function $fd4ea2dc11e83b2a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $fd4ea2dc11e83b2a$var$isString(obj) {
    return $fd4ea2dc11e83b2a$var$_class(obj) === '[object String]';
}
var $fd4ea2dc11e83b2a$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $fd4ea2dc11e83b2a$var$has(object, key) {
    return $fd4ea2dc11e83b2a$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $fd4ea2dc11e83b2a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $fd4ea2dc11e83b2a$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $fd4ea2dc11e83b2a$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $fd4ea2dc11e83b2a$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE = new RegExp($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE.source + '|' + $fd4ea2dc11e83b2a$var$ENTITY_RE.source, 'gi');
var $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $7MxGI = parcelRequire("7MxGI");
function $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, name) {
    var code;
    if ($fd4ea2dc11e83b2a$var$has($7MxGI, name)) return $7MxGI[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($fd4ea2dc11e83b2a$var$isValidEntityCode(code)) return $fd4ea2dc11e83b2a$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $fd4ea2dc11e83b2a$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE, '$1');
}
function $fd4ea2dc11e83b2a$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $fd4ea2dc11e83b2a$var$replaceUnsafeChar(ch) {
    return $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS[ch];
}
function $fd4ea2dc11e83b2a$var$escapeHtml(str) {
    if ($fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE, $fd4ea2dc11e83b2a$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $fd4ea2dc11e83b2a$var$escapeRE(str) {
    return str.replace($fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $fd4ea2dc11e83b2a$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $9bBmm = parcelRequire("9bBmm");
// Currently without astral characters support.
function $fd4ea2dc11e83b2a$var$isPunctChar(ch) {
    return $9bBmm.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $fd4ea2dc11e83b2a$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $fd4ea2dc11e83b2a$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$fd4ea2dc11e83b2a$export$16c08b91f883959a = {};

$fd4ea2dc11e83b2a$export$16c08b91f883959a.mdurl = (parcelRequire("aK6mt"));

$fd4ea2dc11e83b2a$export$16c08b91f883959a.ucmicro = (parcelRequire("7G9dc"));
$fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = $fd4ea2dc11e83b2a$var$assign;
$fd4ea2dc11e83b2a$export$844ec244b1367d54 = $fd4ea2dc11e83b2a$var$isString;
$fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = $fd4ea2dc11e83b2a$var$has;
$fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = $fd4ea2dc11e83b2a$var$unescapeMd;
$fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = $fd4ea2dc11e83b2a$var$unescapeAll;
$fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = $fd4ea2dc11e83b2a$var$isValidEntityCode;
$fd4ea2dc11e83b2a$export$73bfc63873071f74 = $fd4ea2dc11e83b2a$var$fromCodePoint;
$fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = $fd4ea2dc11e83b2a$var$escapeHtml;
$fd4ea2dc11e83b2a$export$f78478f71955b6bc = $fd4ea2dc11e83b2a$var$arrayReplaceAt;
$fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = $fd4ea2dc11e83b2a$var$isSpace;
$fd4ea2dc11e83b2a$export$3c52dd84024ae72c = $fd4ea2dc11e83b2a$var$isWhiteSpace;
$fd4ea2dc11e83b2a$export$829a0d33ae4e744 = $fd4ea2dc11e83b2a$var$isMdAsciiPunct;
$fd4ea2dc11e83b2a$export$4888a643af800fc1 = $fd4ea2dc11e83b2a$var$isPunctChar;
$fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = $fd4ea2dc11e83b2a$var$escapeRE;
$fd4ea2dc11e83b2a$export$20ef46802c8744b = $fd4ea2dc11e83b2a$var$normalizeReference;

});
parcelRegister("7MxGI", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("5mepl"));

});
parcelRegister("5mepl", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"\\/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("aK6mt", function(module, exports) {

$parcel$export(module.exports, "encode", () => $7d2322841b1ac049$export$c564cdbbe6da493, (v) => $7d2322841b1ac049$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $7d2322841b1ac049$export$2f872c0f2117be69, (v) => $7d2322841b1ac049$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $7d2322841b1ac049$export$d9468344d3651243, (v) => $7d2322841b1ac049$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $7d2322841b1ac049$export$98e6a39c04603d36, (v) => $7d2322841b1ac049$export$98e6a39c04603d36 = v);
var $7d2322841b1ac049$export$c564cdbbe6da493;
var $7d2322841b1ac049$export$2f872c0f2117be69;
var $7d2322841b1ac049$export$d9468344d3651243;
var $7d2322841b1ac049$export$98e6a39c04603d36;
'use strict';

$7d2322841b1ac049$export$c564cdbbe6da493 = (parcelRequire("6jTHo"));

$7d2322841b1ac049$export$2f872c0f2117be69 = (parcelRequire("qpEB3"));

$7d2322841b1ac049$export$d9468344d3651243 = (parcelRequire("3yKUv"));

$7d2322841b1ac049$export$98e6a39c04603d36 = (parcelRequire("bQztL"));

});
parcelRegister("6jTHo", function(module, exports) {
'use strict';
var $499fb90cb213ebc3$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $499fb90cb213ebc3$var$getEncodeCache(exclude) {
    var i, ch, cache = $499fb90cb213ebc3$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $499fb90cb213ebc3$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $499fb90cb213ebc3$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $499fb90cb213ebc3$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $499fb90cb213ebc3$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$499fb90cb213ebc3$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$499fb90cb213ebc3$var$encode.componentChars = "-_.!~*'()";
module.exports = $499fb90cb213ebc3$var$encode;

});

parcelRegister("qpEB3", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $04f654215177967d$var$decodeCache = {};
function $04f654215177967d$var$getDecodeCache(exclude) {
    var i, ch, cache = $04f654215177967d$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $04f654215177967d$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $04f654215177967d$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $04f654215177967d$var$decode.defaultChars;
    cache = $04f654215177967d$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$04f654215177967d$var$decode.defaultChars = ';/?:@&=+$,#';
$04f654215177967d$var$decode.componentChars = '';
module.exports = $04f654215177967d$var$decode;

});

parcelRegister("3yKUv", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("bQztL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $8a0012734669979b$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $8a0012734669979b$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $8a0012734669979b$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$8a0012734669979b$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$8a0012734669979b$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$8a0012734669979b$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($8a0012734669979b$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$8a0012734669979b$var$autoEscape = [
    '\''
].concat($8a0012734669979b$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$8a0012734669979b$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($8a0012734669979b$var$autoEscape), $8a0012734669979b$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $8a0012734669979b$var$hostnameMaxLen = 255, $8a0012734669979b$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $8a0012734669979b$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$8a0012734669979b$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$8a0012734669979b$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $8a0012734669979b$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $8a0012734669979b$var$Url) return url;
    var u = new $8a0012734669979b$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$8a0012734669979b$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $8a0012734669979b$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $8a0012734669979b$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $8a0012734669979b$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$8a0012734669979b$var$hostlessProtocol[proto] && (slashes || proto && !$8a0012734669979b$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$hostEndingChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$nonHostChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($8a0012734669979b$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($8a0012734669979b$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($8a0012734669979b$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $8a0012734669979b$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($8a0012734669979b$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$8a0012734669979b$var$Url.prototype.parseHost = function(host) {
    var port = $8a0012734669979b$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $8a0012734669979b$var$urlParse;

});


parcelRegister("7G9dc", function(module, exports) {

$parcel$export(module.exports, "Any", () => $597399ee2a9a2974$export$b24b633b1364b94b, (v) => $597399ee2a9a2974$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $597399ee2a9a2974$export$15dafbac7aec8a57, (v) => $597399ee2a9a2974$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $597399ee2a9a2974$export$239cff0cce87eb56, (v) => $597399ee2a9a2974$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $597399ee2a9a2974$export$56c0d5a1e737357d, (v) => $597399ee2a9a2974$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $597399ee2a9a2974$export$dc98b0b04f4c7758, (v) => $597399ee2a9a2974$export$dc98b0b04f4c7758 = v);
var $597399ee2a9a2974$export$b24b633b1364b94b;
var $597399ee2a9a2974$export$15dafbac7aec8a57;
var $597399ee2a9a2974$export$239cff0cce87eb56;
var $597399ee2a9a2974$export$56c0d5a1e737357d;
var $597399ee2a9a2974$export$dc98b0b04f4c7758;
'use strict';

$597399ee2a9a2974$export$b24b633b1364b94b = (parcelRequire("b9ep3"));

$597399ee2a9a2974$export$15dafbac7aec8a57 = (parcelRequire("23ErL"));

$597399ee2a9a2974$export$239cff0cce87eb56 = (parcelRequire("i4n2C"));

$597399ee2a9a2974$export$56c0d5a1e737357d = (parcelRequire("9bBmm"));

$597399ee2a9a2974$export$dc98b0b04f4c7758 = (parcelRequire("oRY4m"));

});
parcelRegister("i4n2C", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("1mGdb", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $0fe896e38fc1beac$export$2a2c8612930e58d0, (v) => $0fe896e38fc1beac$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $0fe896e38fc1beac$export$22bd24080f95f2b3, (v) => $0fe896e38fc1beac$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $0fe896e38fc1beac$export$89650c5477a69db9, (v) => $0fe896e38fc1beac$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $0fe896e38fc1beac$export$2a2c8612930e58d0;
var $0fe896e38fc1beac$export$22bd24080f95f2b3;
var $0fe896e38fc1beac$export$89650c5477a69db9;
'use strict';

$0fe896e38fc1beac$export$2a2c8612930e58d0 = (parcelRequire("8y5kB"));

$0fe896e38fc1beac$export$22bd24080f95f2b3 = (parcelRequire("guwA0"));

$0fe896e38fc1beac$export$89650c5477a69db9 = (parcelRequire("9bSCV"));

});
parcelRegister("8y5kB", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("guwA0", function(module, exports) {
// Parse link destination
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c018b854bcc71549$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("9bSCV", function(module, exports) {
// Parse link title
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $6b0f83e20702a9d5$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $6b0f83e20702a9d5$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("keGIi", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$assign = $lKlAe.assign;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$unescapeAll = $lKlAe.unescapeAll;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$escapeHtml = $lKlAe.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $ebb63f71260e6c54$var$default_rules = {};
$ebb63f71260e6c54$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $ebb63f71260e6c54$require$escapeHtml(token.content) + '</code>';
};
$ebb63f71260e6c54$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $ebb63f71260e6c54$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $ebb63f71260e6c54$require$escapeHtml(token.content);
    else highlighted = $ebb63f71260e6c54$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$ebb63f71260e6c54$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$ebb63f71260e6c54$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$ebb63f71260e6c54$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content);
};
$ebb63f71260e6c54$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$ebb63f71260e6c54$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $ebb63f71260e6c54$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $ebb63f71260e6c54$require$assign({}, $ebb63f71260e6c54$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][0]) + '="' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $ebb63f71260e6c54$var$Renderer;

});

parcelRegister("aVlnc", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");







var $7f3fce7f6016210f$var$_rules = [
    [
        'normalize',
        (parcelRequire("iWx6a"))
    ],
    [
        'block',
        (parcelRequire("iY2Wj"))
    ],
    [
        'inline',
        (parcelRequire("16b9L"))
    ],
    [
        'linkify',
        (parcelRequire("lOz8R"))
    ],
    [
        'replacements',
        (parcelRequire("45Efy"))
    ],
    [
        'smartquotes',
        (parcelRequire("6sbf2"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("jEa7S"))
    ]
];
/**
 * new Core()
 **/ function $7f3fce7f6016210f$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $7f3fce7f6016210f$var$_rules.length; i++)this.ruler.push($7f3fce7f6016210f$var$_rules[i][0], $7f3fce7f6016210f$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $7f3fce7f6016210f$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$7f3fce7f6016210f$var$Core.prototype.State = (parcelRequire("dRBf6"));
module.exports = $7f3fce7f6016210f$var$Core;

});
parcelRegister("3sin6", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $28423cd2f7c52093$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$28423cd2f7c52093$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$28423cd2f7c52093$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $28423cd2f7c52093$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $28423cd2f7c52093$var$Ruler;

});

parcelRegister("iWx6a", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $dca7516ecd2cb0cd$var$NEWLINES_RE = /\r\n?|\n/g;
var $dca7516ecd2cb0cd$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($dca7516ecd2cb0cd$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($dca7516ecd2cb0cd$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("iY2Wj", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("16b9L", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("lOz8R", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $fe1986eb06b8c500$require$arrayReplaceAt = $lKlAe.arrayReplaceAt;
function $fe1986eb06b8c500$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $fe1986eb06b8c500$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($fe1986eb06b8c500$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($fe1986eb06b8c500$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $fe1986eb06b8c500$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("45Efy", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $2fa6d9dae6dddfa0$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $2fa6d9dae6dddfa0$var$replaceFn(match, name) {
    return $2fa6d9dae6dddfa0$var$SCOPED_ABBR[name.toLowerCase()];
}
function $2fa6d9dae6dddfa0$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE, $2fa6d9dae6dddfa0$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $2fa6d9dae6dddfa0$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($2fa6d9dae6dddfa0$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_scoped(state.tokens[blkIdx].children);
        if ($2fa6d9dae6dddfa0$var$RARE_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("6sbf2", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
var $4b2e13ec30356b37$var$QUOTE_TEST_RE = /['"]/;
var $4b2e13ec30356b37$var$QUOTE_RE = /['"]/g;
var $4b2e13ec30356b37$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $4b2e13ec30356b37$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $4b2e13ec30356b37$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $4b2e13ec30356b37$var$QUOTE_RE.lastIndex = pos;
            t = $4b2e13ec30356b37$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(lastChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(nextChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $4b2e13ec30356b37$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$4b2e13ec30356b37$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $4b2e13ec30356b37$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("jEa7S", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("dRBf6", function(module, exports) {
// Core state object
//
'use strict';

var $jwpQf = parcelRequire("jwpQf");
function $a17d1d317b1d68ad$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$a17d1d317b1d68ad$var$StateCore.prototype.Token = $jwpQf;
module.exports = $a17d1d317b1d68ad$var$StateCore;

});
parcelRegister("jwpQf", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $e3650d20fdc1ba98$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $e3650d20fdc1ba98$var$Token;

});



parcelRegister("81Ci5", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");











var $5d7c1e72b0aff81a$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("gSwCe")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("dHrHm"))
    ],
    [
        'fence',
        (parcelRequire("1KHgS")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("79uLo")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("a0gIO")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("bFPxW")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("6Cm2K"))
    ],
    [
        'html_block',
        (parcelRequire("3IX6c")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("5VRwl")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("2v0Kv"))
    ],
    [
        'paragraph',
        (parcelRequire("d0isB"))
    ]
];
/**
 * new ParserBlock()
 **/ function $5d7c1e72b0aff81a$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $5d7c1e72b0aff81a$var$_rules.length; i++)this.ruler.push($5d7c1e72b0aff81a$var$_rules[i][0], $5d7c1e72b0aff81a$var$_rules[i][1], {
        alt: ($5d7c1e72b0aff81a$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$5d7c1e72b0aff81a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $5d7c1e72b0aff81a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$5d7c1e72b0aff81a$var$ParserBlock.prototype.State = (parcelRequire("l865e"));
module.exports = $5d7c1e72b0aff81a$var$ParserBlock;

});
parcelRegister("gSwCe", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c49afd4af32a69df$require$isSpace = $lKlAe.isSpace;
function $c49afd4af32a69df$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $c49afd4af32a69df$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $c49afd4af32a69df$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c49afd4af32a69df$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $c49afd4af32a69df$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c49afd4af32a69df$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("dHrHm", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("1KHgS", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("79uLo", function(module, exports) {
// Block quotes
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $53513ca36aaad8c7$require$isSpace = $lKlAe.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($53513ca36aaad8c7$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("a0gIO", function(module, exports) {
// Horizontal rule
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $7486e013b11c48f5$require$isSpace = $lKlAe.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$7486e013b11c48f5$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("bFPxW", function(module, exports) {
// Lists
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $87fb82138ea80db7$require$isSpace = $lKlAe.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $87fb82138ea80db7$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $87fb82138ea80db7$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("6Cm2K", function(module, exports) {
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$isSpace = $lKlAe.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$4d1764068d639a24$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$4d1764068d639a24$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $4d1764068d639a24$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("3IX6c", function(module, exports) {
// HTML block
'use strict';

var $9Jgti = parcelRequire("9Jgti");

var $1RRsU = parcelRequire("1RRsU");
var $2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE = $1RRsU.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $2b6352f7d75b50f9$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $9Jgti.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $2b6352f7d75b50f9$var$HTML_SEQUENCES.length; i++){
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $2b6352f7d75b50f9$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $2b6352f7d75b50f9$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("9Jgti", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("1RRsU", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $15c436cb9ae50f13$export$6db61d2c3a16e419, (v) => $15c436cb9ae50f13$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $15c436cb9ae50f13$export$cd48660d06f74639, (v) => $15c436cb9ae50f13$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $15c436cb9ae50f13$export$6db61d2c3a16e419;
var $15c436cb9ae50f13$export$cd48660d06f74639;
'use strict';
var $15c436cb9ae50f13$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $15c436cb9ae50f13$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $15c436cb9ae50f13$var$single_quoted = "'[^']*'";
var $15c436cb9ae50f13$var$double_quoted = '"[^"]*"';
var $15c436cb9ae50f13$var$attr_value = '(?:' + $15c436cb9ae50f13$var$unquoted + '|' + $15c436cb9ae50f13$var$single_quoted + '|' + $15c436cb9ae50f13$var$double_quoted + ')';
var $15c436cb9ae50f13$var$attribute = '(?:\\s+' + $15c436cb9ae50f13$var$attr_name + '(?:\\s*=\\s*' + $15c436cb9ae50f13$var$attr_value + ')?)';
var $15c436cb9ae50f13$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $15c436cb9ae50f13$var$attribute + '*\\s*\\/?>';
var $15c436cb9ae50f13$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $15c436cb9ae50f13$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $15c436cb9ae50f13$var$processing = '<[?][\\s\\S]*?[?]>';
var $15c436cb9ae50f13$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $15c436cb9ae50f13$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $15c436cb9ae50f13$var$HTML_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + '|' + $15c436cb9ae50f13$var$comment + '|' + $15c436cb9ae50f13$var$processing + '|' + $15c436cb9ae50f13$var$declaration + '|' + $15c436cb9ae50f13$var$cdata + ')');
var $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + ')');
$15c436cb9ae50f13$export$6db61d2c3a16e419 = $15c436cb9ae50f13$var$HTML_TAG_RE;
$15c436cb9ae50f13$export$cd48660d06f74639 = $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("5VRwl", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $451bcab957a0998a$require$isSpace = $lKlAe.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$451bcab957a0998a$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $451bcab957a0998a$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("2v0Kv", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("d0isB", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("l865e", function(module, exports) {
// Parser state class
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $f61f10562433da3b$require$isSpace = $lKlAe.isSpace;
function $f61f10562433da3b$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($f61f10562433da3b$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$f61f10562433da3b$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $jwpQf(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$f61f10562433da3b$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$f61f10562433da3b$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$f61f10562433da3b$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$f61f10562433da3b$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$f61f10562433da3b$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$f61f10562433da3b$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$f61f10562433da3b$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$f61f10562433da3b$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$f61f10562433da3b$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($f61f10562433da3b$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$f61f10562433da3b$var$StateBlock.prototype.Token = $jwpQf;
module.exports = $f61f10562433da3b$var$StateBlock;

});


parcelRegister("58y21", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $3bd81911677b8252$var$_rules = [
    [
        'text',
        (parcelRequire("gc14M"))
    ],
    [
        'linkify',
        (parcelRequire("2aNBd"))
    ],
    [
        'newline',
        (parcelRequire("a490I"))
    ],
    [
        'escape',
        (parcelRequire("027TI"))
    ],
    [
        'backticks',
        (parcelRequire("27paT"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).tokenize
    ],
    [
        'link',
        (parcelRequire("frx2x"))
    ],
    [
        'image',
        (parcelRequire("iUeRh"))
    ],
    [
        'autolink',
        (parcelRequire("ktOwv"))
    ],
    [
        'html_inline',
        (parcelRequire("1jFGt"))
    ],
    [
        'entity',
        (parcelRequire("jd9ks"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $3bd81911677b8252$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("ey6sy"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("hrHpd"))
    ]
];
/**
 * new ParserInline()
 **/ function $3bd81911677b8252$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules.length; i++)this.ruler.push($3bd81911677b8252$var$_rules[i][0], $3bd81911677b8252$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules2.length; i++)this.ruler2.push($3bd81911677b8252$var$_rules2[i][0], $3bd81911677b8252$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$3bd81911677b8252$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$3bd81911677b8252$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $3bd81911677b8252$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$3bd81911677b8252$var$ParserInline.prototype.State = (parcelRequire("82i7L"));
module.exports = $3bd81911677b8252$var$ParserInline;

});
parcelRegister("gc14M", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $bc9e9a00ea13b29d$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$bc9e9a00ea13b29d$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("2aNBd", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $1952fd4ef50e3f47$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($1952fd4ef50e3f47$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("a490I", function(module, exports) {
// Proceess '\n'
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $754144646e41a199$require$isSpace = $lKlAe.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $754144646e41a199$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("027TI", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $006650534e77ff18$require$isSpace = $lKlAe.isSpace;
var $006650534e77ff18$var$ESCAPED = [];
for(var $006650534e77ff18$var$i = 0; $006650534e77ff18$var$i < 256; $006650534e77ff18$var$i++)$006650534e77ff18$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $006650534e77ff18$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$006650534e77ff18$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $006650534e77ff18$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("27paT", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("lBrF9", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $fba282ec8c4eab24$export$660b2ee2d4fb4eff, (v) => $fba282ec8c4eab24$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $fba282ec8c4eab24$export$7b804a0e0ce836d9, (v) => $fba282ec8c4eab24$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $fba282ec8c4eab24$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $fba282ec8c4eab24$export$7b804a0e0ce836d9;
'use strict';
$fba282ec8c4eab24$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $fba282ec8c4eab24$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$fba282ec8c4eab24$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $fba282ec8c4eab24$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $fba282ec8c4eab24$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("2MLmq", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $2074cd535103ea35$export$660b2ee2d4fb4eff, (v) => $2074cd535103ea35$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $2074cd535103ea35$export$7b804a0e0ce836d9, (v) => $2074cd535103ea35$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $2074cd535103ea35$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $2074cd535103ea35$export$7b804a0e0ce836d9;
'use strict';
$2074cd535103ea35$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $2074cd535103ea35$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$2074cd535103ea35$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $2074cd535103ea35$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2074cd535103ea35$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("frx2x", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$isSpace = $lKlAe.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$b3e301ae0b1788b5$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("iUeRh", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$isSpace = $lKlAe.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$dc38fb80f8b4f166$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("ktOwv", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $ee8db4fa9cfd6224$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $ee8db4fa9cfd6224$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($ee8db4fa9cfd6224$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($ee8db4fa9cfd6224$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("1jFGt", function(module, exports) {
// Process html tags
'use strict';

var $1RRsU = parcelRequire("1RRsU");
var $0f57e66455279f49$require$HTML_TAG_RE = $1RRsU.HTML_TAG_RE;
function $0f57e66455279f49$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $0f57e66455279f49$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $0f57e66455279f49$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$0f57e66455279f49$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($0f57e66455279f49$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($0f57e66455279f49$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($0f57e66455279f49$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("jd9ks", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $7MxGI = parcelRequire("7MxGI");

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$has = $lKlAe.has;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$isValidEntityCode = $lKlAe.isValidEntityCode;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$fromCodePoint = $lKlAe.fromCodePoint;
var $dfc677c78d4d441f$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $dfc677c78d4d441f$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $dfc677c78d4d441f$require$isValidEntityCode(code) ? $dfc677c78d4d441f$require$fromCodePoint(code) : $dfc677c78d4d441f$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$NAMED_RE);
        if (match) {
            if ($dfc677c78d4d441f$require$has($7MxGI, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $7MxGI[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("ey6sy", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $a979406325d16795$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a979406325d16795$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a979406325d16795$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("hrHpd", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("82i7L", function(module, exports) {
// Inline parser state
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
function $5d9c91befccde6a7$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$5d9c91befccde6a7$var$StateInline.prototype.pushPending = function() {
    var token = new $jwpQf('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$5d9c91befccde6a7$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $jwpQf(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$5d9c91befccde6a7$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(lastChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(nextChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$5d9c91befccde6a7$var$StateInline.prototype.Token = $jwpQf;
module.exports = $5d9c91befccde6a7$var$StateInline;

});


parcelRegister("43kHv", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $2f377ffd6e81380f$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $2f377ffd6e81380f$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $2f377ffd6e81380f$var$isString(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object String]';
}
function $2f377ffd6e81380f$var$isObject(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Object]';
}
function $2f377ffd6e81380f$var$isRegExp(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object RegExp]';
}
function $2f377ffd6e81380f$var$isFunction(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Function]';
}
function $2f377ffd6e81380f$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $2f377ffd6e81380f$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $2f377ffd6e81380f$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $2f377ffd6e81380f$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $2f377ffd6e81380f$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $2f377ffd6e81380f$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $2f377ffd6e81380f$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $2f377ffd6e81380f$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $2f377ffd6e81380f$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $2f377ffd6e81380f$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $2f377ffd6e81380f$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("5GUip"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($2f377ffd6e81380f$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($2f377ffd6e81380f$var$isObject(val)) {
            if ($2f377ffd6e81380f$var$isRegExp(val.validate)) compiled.validate = $2f377ffd6e81380f$var$createValidator(val.validate);
            else if ($2f377ffd6e81380f$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($2f377ffd6e81380f$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $2f377ffd6e81380f$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($2f377ffd6e81380f$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $2f377ffd6e81380f$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($2f377ffd6e81380f$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $2f377ffd6e81380f$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $2f377ffd6e81380f$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $2f377ffd6e81380f$var$createMatch(self, shift) {
    var match = new $2f377ffd6e81380f$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $2f377ffd6e81380f$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $2f377ffd6e81380f$var$LinkifyIt)) return new $2f377ffd6e81380f$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($2f377ffd6e81380f$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $2f377ffd6e81380f$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $2f377ffd6e81380f$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $2f377ffd6e81380f$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $2f377ffd6e81380f$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $2f377ffd6e81380f$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $2f377ffd6e81380f$var$LinkifyIt;

});
parcelRegister("5GUip", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("k7qPZ", function(module, exports) {
'use strict';
/** Highest positive signed 32-bit float value */ const $ea59477c15f361c2$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $ea59477c15f361c2$var$base = 36;
const $ea59477c15f361c2$var$tMin = 1;
const $ea59477c15f361c2$var$tMax = 26;
const $ea59477c15f361c2$var$skew = 38;
const $ea59477c15f361c2$var$damp = 700;
const $ea59477c15f361c2$var$initialBias = 72;
const $ea59477c15f361c2$var$initialN = 128; // 0x80
const $ea59477c15f361c2$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $ea59477c15f361c2$var$regexPunycode = /^xn--/;
const $ea59477c15f361c2$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $ea59477c15f361c2$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $ea59477c15f361c2$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $ea59477c15f361c2$var$baseMinusTMin = $ea59477c15f361c2$var$base - $ea59477c15f361c2$var$tMin;
const $ea59477c15f361c2$var$floor = Math.floor;
const $ea59477c15f361c2$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $ea59477c15f361c2$var$error(type) {
    throw new RangeError($ea59477c15f361c2$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $ea59477c15f361c2$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $ea59477c15f361c2$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($ea59477c15f361c2$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $ea59477c15f361c2$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $ea59477c15f361c2$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $ea59477c15f361c2$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $ea59477c15f361c2$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $ea59477c15f361c2$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $ea59477c15f361c2$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $ea59477c15f361c2$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$damp) : delta >> 1;
    delta += $ea59477c15f361c2$var$floor(delta / numPoints);
    for(; delta > $ea59477c15f361c2$var$baseMinusTMin * $ea59477c15f361c2$var$tMax >> 1; k += $ea59477c15f361c2$var$base)delta = $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$baseMinusTMin);
    return $ea59477c15f361c2$var$floor(k + ($ea59477c15f361c2$var$baseMinusTMin + 1) * delta / (delta + $ea59477c15f361c2$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $ea59477c15f361c2$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $ea59477c15f361c2$var$initialN;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($ea59477c15f361c2$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $ea59477c15f361c2$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
            if (index >= inputLength) $ea59477c15f361c2$var$error('invalid-input');
            const digit = $ea59477c15f361c2$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $ea59477c15f361c2$var$base) $ea59477c15f361c2$var$error('invalid-input');
            if (digit > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - i) / w)) $ea59477c15f361c2$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $ea59477c15f361c2$var$base - t;
            if (w > $ea59477c15f361c2$var$floor($ea59477c15f361c2$var$maxInt / baseMinusT)) $ea59477c15f361c2$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $ea59477c15f361c2$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($ea59477c15f361c2$var$floor(i / out) > $ea59477c15f361c2$var$maxInt - n) $ea59477c15f361c2$var$error('overflow');
        n += $ea59477c15f361c2$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $ea59477c15f361c2$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $ea59477c15f361c2$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $ea59477c15f361c2$var$initialN;
    let delta = 0;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($ea59477c15f361c2$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($ea59477c15f361c2$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $ea59477c15f361c2$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - delta) / handledCPCountPlusOne)) $ea59477c15f361c2$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $ea59477c15f361c2$var$maxInt) $ea59477c15f361c2$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
                    const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $ea59477c15f361c2$var$base - t;
                    output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $ea59477c15f361c2$var$floor(qMinusT / baseMinusT);
                }
                output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(q, 0)));
                bias = $ea59477c15f361c2$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $ea59477c15f361c2$var$toUnicode = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexPunycode.test(string) ? $ea59477c15f361c2$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $ea59477c15f361c2$var$toASCII = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexNonASCII.test(string) ? 'xn--' + $ea59477c15f361c2$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $ea59477c15f361c2$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $ea59477c15f361c2$var$ucs2decode,
        'encode': $ea59477c15f361c2$var$ucs2encode
    },
    'decode': $ea59477c15f361c2$var$decode,
    'encode': $ea59477c15f361c2$var$encode,
    'toASCII': $ea59477c15f361c2$var$toASCII,
    'toUnicode': $ea59477c15f361c2$var$toUnicode
};
module.exports = $ea59477c15f361c2$var$punycode;

});

parcelRegister("gcpUf", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("hbvGf", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("8Ubo6", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("4iMad", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", () => $321e3433bbbbd43e$export$26a6b72a65821214);

var $ew5rH = parcelRequire("ew5rH");
var $321e3433bbbbd43e$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($ew5rH))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("ew5rH", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $a9184747dc810078$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $a9184747dc810078$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $a9184747dc810078$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$a9184747dc810078$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $a9184747dc810078$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("38KaN", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", () => $ca5b579471d13098$export$267fd7ead7cc4561);

var $kOFhM = parcelRequire("kOFhM");

var $ivSSX = parcelRequire("ivSSX");

var $4iMad = parcelRequire("4iMad");

var $6fRr3 = parcelRequire("6fRr3");

var $39HCX = parcelRequire("39HCX");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $ca5b579471d13098$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $ca5b579471d13098$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $ca5b579471d13098$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
    html: false
});
$ca5b579471d13098$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $ca5b579471d13098$export$267fd7ead7cc4561 {
    constructor(schema = (0, $kOFhM.defaultSchema), tokenizer = $ca5b579471d13098$var$md){
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $ca5b579471d13098$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($ca5b579471d13098$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $4iMad.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $39HCX.markdownItMedia));
        this.markdownParser = new (0, $6fRr3.MarkdownParser)(schema, tokenizer, $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, $ca5b579471d13098$var$mdToPmMapping));
    }
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
}

});
parcelRegister("6fRr3", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", () => $48dd97f13fd6d562$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $48dd97f13fd6d562$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $48dd97f13fd6d562$export$61055fa707e69319);

var $kCV8T = parcelRequire("kCV8T");

var $ivSSX = parcelRequire("ivSSX");
/**
Document schema for the data model used by CommonMark.
*/ const $48dd97f13fd6d562$export$4902baddc787debb = new (0, $kCV8T.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $48dd97f13fd6d562$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $kCV8T.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $48dd97f13fd6d562$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $kCV8T.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $48dd97f13fd6d562$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $kCV8T.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $48dd97f13fd6d562$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $48dd97f13fd6d562$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $48dd97f13fd6d562$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $48dd97f13fd6d562$var$noOp() {}
function $48dd97f13fd6d562$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = $48dd97f13fd6d562$var$noOp;
            else {
                handlers[type + "_open"] = $48dd97f13fd6d562$var$noOp;
                handlers[type + "_close"] = $48dd97f13fd6d562$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $48dd97f13fd6d562$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $48dd97f13fd6d562$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $48dd97f13fd6d562$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $48dd97f13fd6d562$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $48dd97f13fd6d562$export$7517583227ad0cb8 = new $48dd97f13fd6d562$export$a64f782182dea128($48dd97f13fd6d562$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $48dd97f13fd6d562$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $48dd97f13fd6d562$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $48dd97f13fd6d562$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $48dd97f13fd6d562$export$f996452ca6e9a0ae = new $48dd97f13fd6d562$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $48dd97f13fd6d562$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $48dd97f13fd6d562$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $48dd97f13fd6d562$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $48dd97f13fd6d562$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $48dd97f13fd6d562$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("39HCX", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $288ff3bbed487814$export$c8dcbd316b71f8cf);
function $288ff3bbed487814$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match, j)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $288ff3bbed487814$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $288ff3bbed487814$var$createRule());
};

});


parcelRegister("kboGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d26c02fbcba604$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");
const $d9d26c02fbcba604$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $d9d26c02fbcba604$var$citation = (state)=>{
    const tokens = [];
    // TODO: Remove the next two lines when rovo_chat_simplify_citation_logic enabled and cleaned up
    const citationIndexMap = {};
    let currentIndex = 1;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $d9d26c02fbcba604$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($d9d26c02fbcba604$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        if (!(0, $VSDnB.fg)('rovo_chat_simplify_citation_logic')) {
                            citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                        }
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $d9d26c02fbcba604$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $d9d26c02fbcba604$var$citation);

});

parcelRegister("lKkRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e1f3f064434b868$export$2e2bcd8739ae039);
const $8e1f3f064434b868$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $8e1f3f064434b868$var$dataSculptor = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $8e1f3f064434b868$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                citationToken.attrs = [
                    [
                        'localId',
                        'data-sculptor'
                    ],
                    [
                        'text',
                        'data-sculptor'
                    ],
                    [
                        'color',
                        'blue'
                    ]
                ];
                const parts = childToken.content.split($8e1f3f064434b868$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else tokenChildren.push(citationToken);
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $8e1f3f064434b868$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $8e1f3f064434b868$var$dataSculptor);

});

parcelRegister("3p5rU", function(module, exports) {

$parcel$export(module.exports, "createLinkifyPlugin", () => $c1d7fcb3e69c8564$export$763ac077c9998026);

var $e2gHg = parcelRequire("e2gHg");

var $iZOJ9 = parcelRequire("iZOJ9");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $c1d7fcb3e69c8564$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $c1d7fcb3e69c8564$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $c1d7fcb3e69c8564$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $c1d7fcb3e69c8564$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($c1d7fcb3e69c8564$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($c1d7fcb3e69c8564$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $iZOJ9.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $c1d7fcb3e69c8564$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
const $c1d7fcb3e69c8564$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', $c1d7fcb3e69c8564$export$8cd7d1ec2e6808da(params));

});

parcelRegister("htzpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae4aa9255782dd$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $b9ae4aa9255782dd$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = /(?<!`)!\[[^\]]*\]\([^\)]+\)(?!`)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $b9ae4aa9255782dd$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $b9ae4aa9255782dd$var$createRule());
};

});

parcelRegister("8ZEpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58bb75d4d8b9c5c$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $b58bb75d4d8b9c5c$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $b58bb75d4d8b9c5c$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $b58bb75d4d8b9c5c$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $b58bb75d4d8b9c5c$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$b58bb75d4d8b9c5c$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $b58bb75d4d8b9c5c$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $b58bb75d4d8b9c5c$var$mentionLinks);

});

parcelRegister("muDJ0", function(module, exports) {

$parcel$export(module.exports, "createSmartLinksPlugin", () => $8d336fe6df406911$export$9625a798761643ac);

var $bq23d = parcelRequire("bq23d");
const $8d336fe6df406911$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $8d336fe6df406911$var$linkPatternEnd = '[^\\s\\]\\)]*';
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
const $8d336fe6df406911$var$linkRegex = {
    youtube: `${$8d336fe6df406911$var$linkPatternStart}youtube\\.com${$8d336fe6df406911$var$linkPatternEnd}`,
    youtubeShortUrl: `${$8d336fe6df406911$var$linkPatternStart}youtu\\.be${$8d336fe6df406911$var$linkPatternEnd}`,
    loomVideo: `${$8d336fe6df406911$var$linkPatternStart}loom\\.com\\/share\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    figmaFile: `${$8d336fe6df406911$var$linkPatternStart}figma\\.com\\/file\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$8d336fe6df406911$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$8d336fe6df406911$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    googleDoc: `${$8d336fe6df406911$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/edit${$8d336fe6df406911$var$linkPatternEnd}`,
    googleForm: `${$8d336fe6df406911$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    microsoftForm: `${$8d336fe6df406911$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$8d336fe6df406911$var$linkPatternEnd}`,
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$8d336fe6df406911$var$linkPatternEnd}`
};
const $8d336fe6df406911$var$supportedEmbedProviders = Object.values($8d336fe6df406911$var$linkRegex).join('|');
const $8d336fe6df406911$var$embedRegex = new RegExp($8d336fe6df406911$var$supportedEmbedProviders, 'g');
const $8d336fe6df406911$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$8d336fe6df406911$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$8d336fe6df406911$var$linkPatternEnd}`
];
const $8d336fe6df406911$var$createSmartLinks = ({ regexStorage: regexStorage })=>(state)=>{
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        for (const token of state.tokens){
            let processedTokenChildren = [];
            embedMatches = [
                ...embedMatches,
                ...new Set(token.content?.trim().match($8d336fe6df406911$var$embedRegex))
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $bq23d.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        if (token.level <= 1 && $8d336fe6df406911$var$embedInlineRegex.some((r)=>url.match(r))) {
                            outputToken.children = processedTokenChildren;
                            tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                            processedTokenChildren = [];
                            let embedToken = new state.Token('embedCard', '', 0);
                            embedToken.content = '';
                            embedToken.block = true;
                            embedToken.attrSet('url', url);
                            embedToken.attrSet('layout', 'center');
                            tokensToAppend.push(embedToken);
                            tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                            outputToken = new state.Token('inline', '', 0);
                            tokensToAppend.push(outputToken);
                            return;
                        }
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    processedTokenChildren.push(childToken);
                });
            }
            outputToken.children = processedTokenChildren;
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        if (embedMatches?.length) [
            ...new Set(embedMatches)
        ].forEach((match)=>{
            let embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $8d336fe6df406911$export$9625a798761643ac = (params)=>(md)=>md.core.ruler.push('inlineCard', $8d336fe6df406911$var$createSmartLinks(params));

});
parcelRegister("bq23d", function(module, exports) {

$parcel$export(module.exports, "isSupportedByLinkingPlatform", () => $e8d3bfaeca12d687$export$4b1056d02426889c);
$parcel$export(module.exports, "hydrateLinkingPlatformCache", () => $e8d3bfaeca12d687$export$d08c351b3b4e4934);

var $8QpSo = parcelRequire("8QpSo");

const $e8d3bfaeca12d687$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $e8d3bfaeca12d687$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    const regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
const $e8d3bfaeca12d687$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $b1a9f1323a849c20$export$56bec2f197c16818))) return JSON.parse(`${regexStorage.getItem((0, $b1a9f1323a849c20$export$56bec2f197c16818))}`);
    return '';
};
const $e8d3bfaeca12d687$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $b1a9f1323a849c20$export$56bec2f197c16818), JSON.stringify(providerRegex));
};
const $e8d3bfaeca12d687$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerRegex = await $e8d3bfaeca12d687$export$ab8eaff0f2d596bd(baseUrl);
    $e8d3bfaeca12d687$export$5af966b3aa3b1d83(regexStorage, providerRegex);
};
const $e8d3bfaeca12d687$export$b7ac97ae80c7eb5a = (data)=>{
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns.map((pattern)=>pattern.source);
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $e8d3bfaeca12d687$export$ab8eaff0f2d596bd = (0, $8QpSo.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $b1a9f1323a849c20$export$57ad190cdc563df3), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return !data ? '' : $e8d3bfaeca12d687$export$b7ac97ae80c7eb5a(data);
    } catch (error) {
        return '';
    }
});

});
const $b1a9f1323a849c20$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $b1a9f1323a849c20$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';



parcelRegister("7zJFX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2c4e4990535216$export$2e2bcd8739ae039);
const $2d2c4e4990535216$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $2d2c4e4990535216$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $2d2c4e4990535216$var$tableBreakTags);

});

parcelRegister("btItw", function(module, exports) {

$parcel$export(module.exports, "pmToMd", () => $360bd652c179d65a$export$cd54a56af01ba875);
$parcel$export(module.exports, "mdToPmSchema", () => $360bd652c179d65a$export$eb83d753215c78a2);
const $360bd652c179d65a$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $360bd652c179d65a$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};

});

parcelRegister("4bKco", function(module, exports) {

$parcel$export(module.exports, "filterSchemaMapping", () => $ba60debb72d7c40c$export$155749302793c60c);
$parcel$export(module.exports, "enableSchemaPlugins", () => $ba60debb72d7c40c$export$a1cf9d9b96e16789);

var $btItw = parcelRequire("btItw");
const $ba60debb72d7c40c$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $ba60debb72d7c40c$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $btItw.pmToMd){
        const key = k;
        for(const i in (0, $btItw.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $btItw.pmToMd)[key][idx]);
        }
    }
};

});



parcelRegister("94cfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1249caed30269ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $6s1PB = parcelRequire("6s1PB");
let $d1249caed30269ff$var$namespaceUUID = 0;
const $d1249caed30269ff$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $d1249caed30269ff$var$AFTER_LOAD_DURATION = 3000;
const $d1249caed30269ff$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const svgRef = (0, $5uXOq.useRef)(null);
    const namespaceId = (0, $5uXOq.useRef)();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $5uXOq.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $d1249caed30269ff$var$newPalette.dark : $d1249caed30269ff$var$newPalette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $d1249caed30269ff$var$namespaceUUID;
        $d1249caed30269ff$var$namespaceUUID += 1;
    }
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $d1249caed30269ff$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$SvgContainer, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $d1249caed30269ff$var$AIContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $d1249caed30269ff$var$Container, ContentComponent: ContentComponent = $d1249caed30269ff$var$Content } = {}, hasNewBorderExperience: hasNewBorderExperience = false }, ref)=>{
    /**
   * We need to ensure the experiment is not sending an exposure here, since it isn't where the experience diverges
   */ // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('proactive-jira-ai-similar-issues');
    const isEnabled = expConfig.get('isEnabled', false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContainerComponent, {
        ref: isEnabled ? undefined : ref,
        "data-testid": testId,
        shouldFitContainer: shouldFitContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContentComponent, {
        ref: isEnabled ? ref : undefined,
        spacing: spacing
    }, children));
});
var $d1249caed30269ff$export$2e2bcd8739ae039 = $d1249caed30269ff$var$AIContainer;
$d1249caed30269ff$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbyb4wl",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _bfhkvuon _16jlkb7n _1pbyb4wl _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $d1249caed30269ff$export$71abc632aa29e6fe = {
    ContainerComponent: $d1249caed30269ff$var$Container,
    ContentComponent: $d1249caed30269ff$var$Content
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$SvgContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _kqswstnw",
            __cmplp.isShadow ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eF8rD", function(module, exports) {

$parcel$export(module.exports, "useSmartSummarizeCommentsAnalytics", () => $401580de2d604199$export$f17e90d73fe08af4);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lGvJS = parcelRequire("lGvJS");
const $401580de2d604199$export$ce053e1c7f865fd7 = {
    aiFeatureName: 'jiraSmartSummarizeComments',
    proactiveAIGenerated: 0,
    userGeneratedAI: 1,
    isAIFeature: 1,
    proactiveGeneratedAI: 0,
    isProactiveGenerated: false
};
const $401580de2d604199$var$getIsProactiveAttributes = (isProactivePanelShown)=>{
    if (isProactivePanelShown) return {
        proactiveAIGenerated: 1,
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        isProactiveGenerated: true
    };
    return {};
};
const $401580de2d604199$export$f17e90d73fe08af4 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isProactivePanelShown] = (0, $lGvJS.useIsProactivePanelShown)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const event = createAnalyticsEvent({});
        return {
            fireTrack: (name, id, attrs)=>(0, $8zOmE.fireTrackAnalytics)(event, name, id, {
                    ...$401580de2d604199$export$ce053e1c7f865fd7,
                    ...attrs,
                    ...$401580de2d604199$var$getIsProactiveAttributes(isProactivePanelShown)
                })
        };
    }, [
        createAnalyticsEvent,
        isProactivePanelShown
    ]);
    return actions;
};

});

parcelRegister("iJl7P", function(module, exports) {

$parcel$export(module.exports, "useSmartSummaryStreaming", () => $a9e37bb9d3380f45$export$f23f371023d30e1b);

var $5uXOq = parcelRequire("5uXOq");

var $fBaBT = parcelRequire("fBaBT");
var $2Kk17 = parcelRequire("2Kk17");
var $4VFMz = parcelRequire("4VFMz");

var $2gCtH = parcelRequire("2gCtH");

var $gXz4p = parcelRequire("gXz4p");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $DVljb = parcelRequire("DVljb");

var $j8DrX = parcelRequire("j8DrX");

var $eF8rD = parcelRequire("eF8rD");
const $a9e37bb9d3380f45$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $a9e37bb9d3380f45$var$SMART_SUMMARY_REQUEST_HEADERS = {
    'x-experience-id': 'jira-smart-summary',
    'x-product': 'jira',
    'x-issynthetic-traffic': $a9e37bb9d3380f45$var$isSynthetic().toString()
};
// The status code belongs to this list won't be sent as taskFail
const $a9e37bb9d3380f45$var$STATUS_CODE_RELIABILITY_WHITE_LIST = [
    400,
    401,
    403,
    429
];
const $a9e37bb9d3380f45$var$sendSloMetrics = (wasExperienceSuccesful, errorMessage, statusCode)=>{
    const experience = 'jiraSmartSummarizeComments';
    const analyticsSource = 'requestSummaryQuery';
    const additionalAttributes = {
        ...errorMessage && {
            error: errorMessage
        },
        ...statusCode && {
            statusCode: statusCode
        }
    };
    (0, $gXz4p.sendExperienceAnalytics)({
        experience: experience,
        wasExperienceSuccesful: wasExperienceSuccesful,
        analyticsSource: analyticsSource,
        application: (0, $efvDm.JIRA_SOFTWARE),
        edition: (0, $ldyPw.PREMIUM_EDITION),
        additionalAttributes: additionalAttributes
    });
};
const $a9e37bb9d3380f45$export$f23f371023d30e1b = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const locale = (0, $DVljb.useNativeLocale)();
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const agentPayload = (0, $5uXOq.useMemo)(()=>({
            recipient_agent_named_id: 'summary_agent',
            agent_input_prompt: 'Summarise the description and comments in this ticket, focus on the essential context points, key decisions made, and specified action items',
            agent_input_context: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                content_url: `${window.location.origin}/browse/${issueKey}`,
                summary_style: 'medium',
                summary_output_mimetype: 'text/markdown',
                prompt_id: 'jira-smart-summary',
                locale: locale
            }
        }), [
        issueKey,
        locale
    ]);
    const onStateChange = (0, $5uXOq.useCallback)((state)=>{
        // TODO: add potential analytics/peformance markers and potential state changes for ui?
        switch(state.responseState){
            case (0, $fBaBT.AIAgentResponseState).Initialization:
                break;
            case (0, $fBaBT.AIAgentResponseState).AnswerPart:
                break;
            case (0, $fBaBT.AIAgentResponseState).FinalResponse:
                fireTrack('aiResult viewed', 'jiraSmartSummarizeComments', {
                    metadata: state.metadata.tokenData
                });
                $a9e37bb9d3380f45$var$sendSloMetrics(true);
                break;
            case (0, $fBaBT.AIAgentResponseState).Error:
                {
                    const errorMessage = state.error?.message.content;
                    const errorStatusCode = state.error?.message.status_code || 500;
                    const errorMessageTemplate = state.error?.message.message_template;
                    // this is user content, we do not classify this as an error for both SLO and unified error analytics
                    if (errorMessageTemplate === (0, $2Kk17.ErrorMessage).ACCEPTABLE_USE_VIOLATIONS) break;
                    /**
					 * Do not trigger SLO failures if they are part of these status code white lists
					 */ if (!$a9e37bb9d3380f45$var$STATUS_CODE_RELIABILITY_WHITE_LIST.includes(errorStatusCode)) $a9e37bb9d3380f45$var$sendSloMetrics(false, errorMessage, errorStatusCode);
                    fireTrack('aiResult error', 'jiraSmartSummarizeCommentsError', {
                        error: errorMessage,
                        statusCode: errorStatusCode
                    });
                    break;
                }
            default:
                break;
        }
    }, [
        fireTrack
    ]);
    const [state, fetch] = (0, $4VFMz.useAIAgentStreaming)(agentPayload, {
        headers: $a9e37bb9d3380f45$var$SMART_SUMMARY_REQUEST_HEADERS
    }, onStateChange);
    return [
        state,
        fetch
    ];
};

});
parcelRegister("2Kk17", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $7f6850ccb555d1d6$export$915e9e7bd4f0f96d);
/**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-29941 Internal documentation for deprecation (no external access)}. Please use `ConvoAIStreamingHeaders` instead.
 * more info: https://hello.atlassian.net/wiki/spaces/CONVAI/pages/4886462722/Sunsetting+assistance-service+timeline
 */ var $7f6850ccb555d1d6$export$915e9e7bd4f0f96d = /*#__PURE__*/ function(ErrorMessage) {
    ErrorMessage["NETWORK_ERROR"] = "NETWORK_ERROR";
    ErrorMessage["NO_ANSWER"] = "NO_ANSWER";
    ErrorMessage["RATE_LIMIT"] = "RATE_LIMIT";
    // typo comes from the backend
    // https://bitbucket.org/atlassian/assistance-service/src/02087c3b6569f042ec338e08e8e0e152c4563dad/src/schema/message_publisher.py#lines-74
    ErrorMessage["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "ASWER_UNAVAILABLE_FOR_CONTENT";
    ErrorMessage["NO_AGENT"] = "NO_AGENT";
    ErrorMessage["PLUGIN_ERRORED"] = "PLUGIN_ERRORED";
    ErrorMessage["OPENAI_RATE_LIMIT_USER_ABUSE"] = "OPENAI_RATE_LIMIT";
    ErrorMessage["ACCEPTABLE_USE_VIOLATIONS"] = "ACCEPTABLE_USE_VIOLATIONS";
    ErrorMessage["AI_DISABLED"] = "AI_DISABLED";
    ErrorMessage["UNEXPECTED"] = "UNEXPECTED";
    ErrorMessage["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    return ErrorMessage;
}({});

});

parcelRegister("4VFMz", function(module, exports) {

$parcel$export(module.exports, "useAIAgentStreaming", () => $9f7224bf4cd98c27$export$3983045c2bc05499);

var $5uXOq = parcelRequire("5uXOq");

var $6riHe = parcelRequire("6riHe");

var $4ca1t = parcelRequire("4ca1t");

var $fBaBT = parcelRequire("fBaBT");
function $9f7224bf4cd98c27$export$3983045c2bc05499(request, config, onStateChange) {
    const refetchId = (0, $5uXOq.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6riHe.useStatefulObservableEffect)((0, $4ca1t.aiAgentStreamingEffect), (0, $fBaBT.getDefaultAIAgentStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onStateChange?.(state);
    }, [
        state,
        onStateChange
    ]);
    const refetch = (0, $5uXOq.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $fBaBT.getDefaultAIAgentStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}

});
parcelRegister("6riHe", function(module, exports) {

$parcel$export(module.exports, "useStatefulObservableEffect", () => $18a0badb3a7f39e4$export$916f6bbdfa1987d0);

var $5uXOq = parcelRequire("5uXOq");

var $8BlFn = parcelRequire("8BlFn");
function $18a0badb3a7f39e4$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $8BlFn.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $5uXOq.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}

});
parcelRegister("8BlFn", function(module, exports) {

$parcel$export(module.exports, "useStatefulObservableLazyEffect", () => $806f98281dc97544$export$7e63706be514842f);

var $5uXOq = parcelRequire("5uXOq");

var $1SBaA = parcelRequire("1SBaA");

var $cab1K = parcelRequire("cab1K");
function $806f98281dc97544$export$7e63706be514842f(onObservableInit, initialState) {
    const [inputSubject$] = (0, $5uXOq.useState)(()=>new (0, $cab1K.Subject)());
    const [observable$] = (0, $5uXOq.useState)(()=>onObservableInit(inputSubject$));
    const stateSnapshot = (0, $5uXOq.useRef)(initialState);
    const subscribe = (0, $5uXOq.useCallback)((handleStoreChange)=>{
        const subscription = observable$.subscribe({
            next: (nextState)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(nextState, stateSnapshot.current)) {
                    stateSnapshot.current = nextState;
                    handleStoreChange();
                }
            },
            // eslint-disable-next-line no-console
            error: (err)=>console.error(err),
            complete: ()=>inputSubject$.complete()
        });
        return ()=>subscription.unsubscribe();
    }, [
        inputSubject$,
        observable$
    ]);
    const getSnapshot = (0, $5uXOq.useCallback)(()=>{
        return stateSnapshot.current;
    }, [
        stateSnapshot
    ]);
    const callback = (0, $5uXOq.useCallback)((nextState)=>{
        inputSubject$.next(nextState);
    }, [
        inputSubject$
    ]);
    const state = (0, $5uXOq.useSyncExternalStore)(subscribe, getSnapshot);
    return [
        state,
        callback
    ];
}

});


parcelRegister("4ca1t", function(module, exports) {

$parcel$export(module.exports, "aiAgentStreamingEffect", () => $33f08f37bd8ea1fd$export$127df341c69343cc);

var $1SBaA = parcelRequire("1SBaA");

var $aq199 = parcelRequire("aq199");

var $ib0Rz = parcelRequire("ib0Rz");

var $8EnuM = parcelRequire("8EnuM");

var $gIcfQ = parcelRequire("gIcfQ");

var $4cJXk = parcelRequire("4cJXk");

var $cVFxd = parcelRequire("cVFxd");

var $bLNAF = parcelRequire("bLNAF");

var $jEfnV = parcelRequire("jEfnV");

var $cvLsC = parcelRequire("cvLsC");

var $4qU0n = parcelRequire("4qU0n");

var $8WVt8 = parcelRequire("8WVt8");

var $jdpvf = parcelRequire("jdpvf");

var $6uKUw = parcelRequire("6uKUw");

var $6iKPk = parcelRequire("6iKPk");

var $fBaBT = parcelRequire("fBaBT");
function $33f08f37bd8ea1fd$export$127df341c69343cc(input$) {
    return input$.pipe((0, $bLNAF.skipWhile)(({ inputs: [_, { skip: skip }] })=>!!skip), (0, $gIcfQ.distinctUntilChanged)(({ inputs: [prevRequest, prevConfig, prevRefetchId] }, { inputs: [nextRequest, nextConfig, nextRefetchId] })=>(0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevRequest, nextRequest) && (0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevConfig, nextConfig) && prevRefetchId === nextRefetchId), (0, $cVFxd.map)(({ inputs: [request, config] })=>({
            config: (0, $8WVt8.getDefaultConfigWithUserSettings)(config),
            request: request
        })), (0, $cVFxd.map)(({ request: request, config: config })=>({
            requestConfig: (0, $4qU0n.createAIAgentRequestConfig)(request, config),
            config: config
        })), (0, $jEfnV.switchMap)(({ requestConfig: requestConfig, config: config })=>{
        (0, $6iKPk.logInfo)('pre request data', config, requestConfig);
        return (0, $jdpvf.makeAIAgentStreamRequest)(requestConfig).pipe((0, $cVFxd.map)((state)=>({
                config: config,
                state: state
            })));
    }), (0, $4cJXk.filter)(({ config: config, state: state })=>{
        if (!config.enableFollowUp && state.responseState === (0, $fBaBT.AIAgentResponseState).FollowUp) return false;
        return true;
    }), (0, $cVFxd.map)(({ config: config, state: state })=>{
        (0, $6iKPk.logInfo)('response data', config, state);
        const nextState = (0, $6uKUw.parsePartialJsonIfNeeded)(state, config);
        (0, $6iKPk.logInfo)('post json parsing content', config, state);
        return {
            state: nextState,
            config: config
        };
    }), (0, $cvLsC.timeInterval)(), (0, $ib0Rz.concatMap)(({ value: { state: state, config: config }, interval: interval })=>{
        if (!config.delayChunkUpdate) return (0, $aq199.of)(state);
        const { time: time, gap: gap } = config.delayChunkUpdate;
        if (interval < gap) return (0, $aq199.of)(state).pipe((0, $8EnuM.delay)(time));
        return (0, $aq199.of)(state);
    }));
}

});
parcelRegister("bLNAF", function(module, exports) {
"use strict";
var $891a8d1da4eedcb9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $891a8d1da4eedcb9$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $891a8d1da4eedcb9$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $891a8d1da4eedcb9$var$skipWhile;
var $891a8d1da4eedcb9$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $891a8d1da4eedcb9$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $891a8d1da4eedcb9$var$SkipWhileSubscriber = function(_super) {
    $891a8d1da4eedcb9$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("cvLsC", function(module, exports) {
"use strict";
var $91bd31fba290f269$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $hSQIY = parcelRequire("hSQIY");
function $91bd31fba290f269$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return function(source) {
        return source.lift(new $91bd31fba290f269$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $91bd31fba290f269$var$timeInterval;
var $91bd31fba290f269$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $91bd31fba290f269$var$TimeInterval;
var $91bd31fba290f269$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $91bd31fba290f269$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $91bd31fba290f269$var$TimeIntervalSubscriber = function(_super) {
    $91bd31fba290f269$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $91bd31fba290f269$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("4qU0n", function(module, exports) {

$parcel$export(module.exports, "createAIAgentRequestConfig", () => $af02c1141cba96f2$export$7e0f2b55f5aef001);
const $af02c1141cba96f2$export$7e0f2b55f5aef001 = (request, config)=>{
    const requestInitParams = {
        method: 'POST',
        headers: new Headers({
            ...config.headers
        }),
        body: JSON.stringify(request)
    };
    return {
        requestInitParams: requestInitParams,
        url: `${config.baseUrl}/${config.chatPath}`
    };
};

});

parcelRegister("8WVt8", function(module, exports) {

$parcel$export(module.exports, "getDefaultConfigWithUserSettings", () => $93d5090f10b97cde$export$f6c7760a1a99679e);

var $2Hqfz = parcelRequire("2Hqfz");

const $93d5090f10b97cde$var$baseUrl = (0, $2Hqfz.Lens).fromNullableProp()('baseUrl', (0, $5bab64b7a676e01c$export$7c03f5942efb8a41));
const $93d5090f10b97cde$var$chatPath = (0, $2Hqfz.Lens).fromNullableProp()('chatPath', (0, $5bab64b7a676e01c$export$82796cc300bdfa9d));
const $93d5090f10b97cde$var$enablePartialJson = (0, $2Hqfz.Lens).fromNullableProp()('enablePartialJson', false);
const $93d5090f10b97cde$var$enableFollowUp = (0, $2Hqfz.Lens).fromNullableProp()('enableFollowUp', false);
const $93d5090f10b97cde$var$enableLocalVerboseLogs = (0, $2Hqfz.Lens).fromNullableProp()('enableLocalVerboseLogs', false);
const $93d5090f10b97cde$var$skip = (0, $2Hqfz.Lens).fromNullableProp()('skip', false);
const $93d5090f10b97cde$var$contentType = (0, $2Hqfz.Lens).fromNullableProp()('content-type', 'application/json;charset=UTF-8');
const $93d5090f10b97cde$export$f6c7760a1a99679e = (config)=>({
        baseUrl: $93d5090f10b97cde$var$baseUrl.get(config),
        chatPath: $93d5090f10b97cde$var$chatPath.get(config),
        enablePartialJson: $93d5090f10b97cde$var$enablePartialJson.get(config),
        enableFollowUp: $93d5090f10b97cde$var$enableFollowUp.get(config),
        enableLocalVerboseLogs: $93d5090f10b97cde$var$enableLocalVerboseLogs.get(config),
        skip: $93d5090f10b97cde$var$skip.get(config),
        headers: {
            'content-type': $93d5090f10b97cde$var$contentType.get(config.headers),
            'x-product': config.headers['x-product'],
            'x-experience-id': config.headers['x-experience-id'],
            'x-issynthetic-traffic': config.headers['x-issynthetic-traffic'] ?? 'false'
        }
    });

});
parcelRegister("2Hqfz", function(module, exports) {

$parcel$export(module.exports, "Lens", () => Lens);
/**
 * @since 1.0.0
 */ 
var $7fups = parcelRequire("7fups");

var $8oqh6 = parcelRequire("8oqh6");

var $6owmV = parcelRequire("6owmV");

var $c9yO0 = parcelRequire("c9yO0");

var $1sIL7 = parcelRequire("1sIL7");

var $crypz = parcelRequire("crypz");

var $Z9TCE = parcelRequire("Z9TCE");

var $kCQUZ = parcelRequire("kCQUZ");

var $4IHNc = parcelRequire("4IHNc");

var $hW8VF = parcelRequire("hW8VF");

var $lB86R = parcelRequire("lB86R");

var $ehgq4 = parcelRequire("ehgq4");

var $ccdkU = parcelRequire("ccdkU");
//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($kCQUZ.reverse(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $kCQUZ.modify(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($kCQUZ.asLens(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($kCQUZ.asPrism(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($kCQUZ.asOptional(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($kCQUZ.asTraversal(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($kCQUZ.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $crypz.pipe)(this, $kCQUZ.asLens, $hW8VF.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $crypz.pipe)(this, $kCQUZ.asPrism, $ehgq4.compose(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $crypz.pipe)(this, $kCQUZ.asOptional, $lB86R.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $crypz.pipe)(this, $kCQUZ.asTraversal, $ccdkU.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $crypz.pipe)($hW8VF.id(), $hW8VF.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $crypz.pipe)($hW8VF.id(), $hW8VF.props.apply($hW8VF, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $1sIL7.fromNullable)(s[k]);
                if ((0, $1sIL7.isNone)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $hW8VF.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($hW8VF.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($hW8VF.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($hW8VF.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $crypz.pipe)(this, $hW8VF.asOptional, $lB86R.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $crypz.pipe)(this, $hW8VF.asTraversal, $ccdkU.compose(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $crypz.pipe)(this, $hW8VF.compose((0, $crypz.pipe)(ab, $kCQUZ.asLens))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($hW8VF.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($ehgq4.fromPredicate(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $1sIL7.isNone)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $1sIL7.option).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($ehgq4.asOptional(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($ehgq4.asTraversal(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $1sIL7.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($ehgq4.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $crypz.pipe)(this, $ehgq4.asOptional, $lB86R.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $crypz.pipe)(this, $ehgq4.asTraversal, $ccdkU.compose(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $crypz.pipe)(this, $ehgq4.compose((0, $crypz.pipe)(ab, $kCQUZ.asPrism))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($ehgq4.composeLens(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $6owmV.identity), (0, $1sIL7.some));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $1sIL7.fromNullable)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $lB86R.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $lB86R.modifyOption(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($lB86R.asTraversal(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $1sIL7.isNone)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($lB86R.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $crypz.pipe)(this, $lB86R.asTraversal, $ccdkU.compose(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $crypz.pipe)(this, $lB86R.compose((0, $crypz.pipe)(ab, $hW8VF.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $crypz.pipe)(this, $lB86R.compose((0, $crypz.pipe)(ab, $ehgq4.asOptional))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $crypz.pipe)(this, $lB86R.compose((0, $crypz.pipe)(ab, $kCQUZ.asOptional))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $ccdkU.modify(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $ccdkU.set(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($ccdkU.filter(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $8oqh6.getApplicative)(M))(function(a) {
                    return (0, $8oqh6.make)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($ccdkU.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $crypz.pipe)(this, $ccdkU.compose((0, $crypz.pipe)(ab, $hW8VF.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $crypz.pipe)(this, $ccdkU.compose((0, $crypz.pipe)(ab, $ehgq4.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $crypz.pipe)(this, $ccdkU.compose((0, $crypz.pipe)(ab, $kCQUZ.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($Z9TCE.fromIso(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($4IHNc.fromAt(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($4IHNc.fromIso(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($7fups.getMonoid())($7fups.of);
        this.exist = foldMap((0, $c9yO0.monoidAny));
        this.all = foldMap((0, $c9yO0.monoidAll));
        this.foldMapFirst = foldMap((0, $1sIL7.getFirstMonoid)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $1sIL7.fromPredicate)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $6owmV.constant)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $ccdkU.fromTraversable(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});
parcelRegister("7fups", function(module, exports) {

$parcel$export(module.exports, "of", () => $547185d5747eecdc$export$ba255e9e49e00608);
$parcel$export(module.exports, "getMonoid", () => $547185d5747eecdc$export$c2a7ef2cc9b32b31);

var $kf9cS = parcelRequire("kf9cS");

var $fl2uO = parcelRequire("fl2uO");

var $5tUZ7 = parcelRequire("5tUZ7");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $4mCaV = parcelRequire("4mCaV");

var $8D8qW = parcelRequire("8D8qW");

var $iCI6U = parcelRequire("iCI6U");

var $ciQV6 = parcelRequire("ciQV6");

var $bLjkL = parcelRequire("bLjkL");
var $547185d5747eecdc$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $547185d5747eecdc$export$a978c53b4062a525 = $4mCaV.isNonEmpty;
var $547185d5747eecdc$export$68159836694e22c1 = $4mCaV.prepend;
var $547185d5747eecdc$export$c4c4d41eab625797 = $4mCaV.prependW;
var $547185d5747eecdc$export$10d8903dec122b9d = $4mCaV.append;
var $547185d5747eecdc$export$19903a1bf1942f6 = $4mCaV.appendW;
var $547185d5747eecdc$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $4mCaV.makeBy(f)(n);
};
var $547185d5747eecdc$export$606959e7ccb797f0 = function(n, a) {
    return $547185d5747eecdc$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $547185d5747eecdc$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $547185d5747eecdc$export$172ec0a6ebfeb6fa = function(ma) {
    return $jc2nG.isNone(ma) ? [] : [
        ma.value
    ];
};
var $547185d5747eecdc$export$80c878c9b1d77917 = function(e) {
    return $jc2nG.isLeft(e) ? [] : [
        e.right
    ];
};
var $547185d5747eecdc$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $547185d5747eecdc$export$4659b591c19bdf3d = $547185d5747eecdc$export$2d55ea551c238330;
var $547185d5747eecdc$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? onNonEmpty($4mCaV.head(as), $4mCaV.tail(as)) : onEmpty();
    };
};
var $547185d5747eecdc$export$6280271dfaec4919 = $547185d5747eecdc$export$ebbe93aa91e3abdc;
var $547185d5747eecdc$export$f3163a37d0ef5927 = $547185d5747eecdc$export$6280271dfaec4919;
var $547185d5747eecdc$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? onNonEmpty($4mCaV.init(as), $4mCaV.last(as)) : onEmpty();
    };
};
var $547185d5747eecdc$export$b1cacb83a5c6bd02 = $547185d5747eecdc$export$364f7f2cc8473008;
var $547185d5747eecdc$export$77fa89c00b331c4c = $547185d5747eecdc$export$b1cacb83a5c6bd02;
var $547185d5747eecdc$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $547185d5747eecdc$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $547185d5747eecdc$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $547185d5747eecdc$export$346677f925de839c = function(as) {
    return as.length;
};
var $547185d5747eecdc$export$2fde0b1c54fc39b9 = $4mCaV.isOutOfBound;
var $547185d5747eecdc$export$dfc7155ac0343b8 = $8D8qW.lookup;
var $547185d5747eecdc$export$5fd5031fecdacec3 = $8D8qW.head;
var $547185d5747eecdc$export$4c7897fafd92b108 = $8D8qW.last;
var $547185d5747eecdc$export$c01875f616615628 = function(as) {
    return $547185d5747eecdc$export$a978c53b4062a525(as) ? $jc2nG.some($4mCaV.tail(as)) : $jc2nG.none;
};
var $547185d5747eecdc$export$2cd8252107eb640b = function(as) {
    return $547185d5747eecdc$export$a978c53b4062a525(as) ? $jc2nG.some($4mCaV.init(as)) : $jc2nG.none;
};
var $547185d5747eecdc$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $547185d5747eecdc$export$2fde0b1c54fc39b9(n, as) ? $547185d5747eecdc$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $547185d5747eecdc$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $547185d5747eecdc$export$2fde0b1c54fc39b9(n, as) ? $547185d5747eecdc$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $547185d5747eecdc$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $547185d5747eecdc$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $547185d5747eecdc$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $547185d5747eecdc$export$b0d75975ac0be0e1($547185d5747eecdc$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $547185d5747eecdc$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $547185d5747eecdc$export$dd1bc94b04021eeb(as) ? $547185d5747eecdc$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $547185d5747eecdc$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $547185d5747eecdc$export$dd1bc94b04021eeb(as) ? $547185d5747eecdc$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $547185d5747eecdc$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($547185d5747eecdc$var$spanLeftIndex(as, predicate));
    };
}
var $547185d5747eecdc$export$de3a4d4a0d731119 = $8D8qW.findIndex;
function $547185d5747eecdc$export$9a2f228bed5035c2(predicate) {
    return $8D8qW.findFirst(predicate);
}
var $547185d5747eecdc$export$a86c11c94d794a95 = $8D8qW.findFirstMap;
function $547185d5747eecdc$export$296de88ccac4bedb(predicate) {
    return $8D8qW.findLast(predicate);
}
var $547185d5747eecdc$export$8b5e6d6ad82284fa = $8D8qW.findLastMap;
var $547185d5747eecdc$export$8855a8be7bd3e9f8 = $8D8qW.findLastIndex;
var $547185d5747eecdc$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $547185d5747eecdc$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $jc2nG.none : $jc2nG.some($547185d5747eecdc$export$f4863e1822a1860c(i, a, as));
    };
};
var $547185d5747eecdc$export$b6d8713d53419d4c = function(i, a) {
    return $547185d5747eecdc$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $547185d5747eecdc$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $547185d5747eecdc$export$2fde0b1c54fc39b9(i, as) ? $jc2nG.none : $jc2nG.some($547185d5747eecdc$export$4937fde8dfc38dbd(i, as));
    };
};
var $547185d5747eecdc$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $547185d5747eecdc$export$2fde0b1c54fc39b9(i, as) ? $jc2nG.none : $jc2nG.some($547185d5747eecdc$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $547185d5747eecdc$export$66c1ae025e96b4bc = function(as) {
    return $547185d5747eecdc$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $547185d5747eecdc$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $547185d5747eecdc$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $547185d5747eecdc$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $547185d5747eecdc$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $547185d5747eecdc$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $547185d5747eecdc$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $547185d5747eecdc$export$8901015135f2fb22(bs, as);
    };
    return $547185d5747eecdc$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $547185d5747eecdc$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $547185d5747eecdc$export$849c7567cbd62acc = function(middle) {
    var f = $4mCaV.prependAll(middle);
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $547185d5747eecdc$export$af200dcf8b7cb5de = function(middle) {
    var f = $4mCaV.intersperse(middle);
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? f(as) : $547185d5747eecdc$export$784d13d8ee351f07(as);
    };
};
var $547185d5747eecdc$export$bb628a54ab399bc9 = function(n) {
    var f = $4mCaV.rotate(n);
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? f(as) : $547185d5747eecdc$export$784d13d8ee351f07(as);
    };
};
var $547185d5747eecdc$export$5bf96401662340b7 = $8D8qW.elem;
var $547185d5747eecdc$export$f70730c3d1fc524e = function(E) {
    var f = $4mCaV.uniq(E);
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? f(as) : $547185d5747eecdc$export$784d13d8ee351f07(as);
    };
};
var $547185d5747eecdc$export$b035e44d7bb4278f = function(ords) {
    var f = $4mCaV.sortBy(ords);
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? f(as) : $547185d5747eecdc$export$784d13d8ee351f07(as);
    };
};
var $547185d5747eecdc$export$433fe05b12ba833f = function(f) {
    var g = $4mCaV.chop(f);
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $547185d5747eecdc$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $547185d5747eecdc$export$a978c53b4062a525(as) ? $4mCaV.splitAt(n)(as) : $547185d5747eecdc$export$dd1bc94b04021eeb(as) ? [
            $547185d5747eecdc$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $547185d5747eecdc$export$784d13d8ee351f07(as)
        ];
    };
};
var $547185d5747eecdc$export$2f0184d5df52135f = function(n) {
    var f = $4mCaV.chunksOf(n);
    return function(as) {
        return $547185d5747eecdc$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $547185d5747eecdc$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $547185d5747eecdc$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $547185d5747eecdc$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $547185d5747eecdc$export$a978c53b4062a525(input) ? $547185d5747eecdc$export$5b8affa63fc6df16($4mCaV.head(input), function(a) {
            return go((0, $6owmV.pipe)(scope, $547185d5747eecdc$export$10d8903dec122b9d(a)), $4mCaV.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $547185d5747eecdc$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $547185d5747eecdc$export$dd1bc94b04021eeb(first) ? $547185d5747eecdc$export$784d13d8ee351f07(second) : $547185d5747eecdc$export$dd1bc94b04021eeb(second) ? $547185d5747eecdc$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $547185d5747eecdc$export$ee1b3e54f0441b22 = $547185d5747eecdc$export$c8c959650bbe80e2;
function $547185d5747eecdc$export$971dd5b0dfd021b6(E) {
    var unionE = $4mCaV.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $547185d5747eecdc$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $547185d5747eecdc$export$a978c53b4062a525(first) && $547185d5747eecdc$export$a978c53b4062a525(second) ? unionE(second)(first) : $547185d5747eecdc$export$a978c53b4062a525(first) ? $547185d5747eecdc$export$784d13d8ee351f07(first) : $547185d5747eecdc$export$784d13d8ee351f07(second);
    };
}
function $547185d5747eecdc$export$bc86dfbf7795668c(E) {
    var elemE = $547185d5747eecdc$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $547185d5747eecdc$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $547185d5747eecdc$export$acaf96a27438246b(E) {
    var elemE = $547185d5747eecdc$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $547185d5747eecdc$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $547185d5747eecdc$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_mapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$8f07ddce13659f50(f));
};
var $547185d5747eecdc$var$_ap = function(fab, fa) {
    return (0, $6owmV.pipe)(fab, $547185d5747eecdc$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_filter = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_filterMap = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_partition = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_partitionMap = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_alt = function(fa, that) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$228be17d80722ab(that));
};
var $547185d5747eecdc$var$_reduce = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_foldMap = function(M) {
    var foldMapM = $547185d5747eecdc$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_reduceRight = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $547185d5747eecdc$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_filterMapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_extend = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_traverse = function(F) {
    var traverseF = $547185d5747eecdc$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $547185d5747eecdc$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $547185d5747eecdc$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseWithIndexF(f));
    };
};
var $547185d5747eecdc$var$_chainRecDepthFirst = $8D8qW._chainRecDepthFirst;
var $547185d5747eecdc$var$_chainRecBreadthFirst = $8D8qW._chainRecBreadthFirst;
var $547185d5747eecdc$export$ba255e9e49e00608 = $4mCaV.of;
var $547185d5747eecdc$export$7f9972325ebfd559 = function() {
    return [];
};
var $547185d5747eecdc$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $547185d5747eecdc$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $547185d5747eecdc$export$5b8affa63fc6df16(function(f) {
        return (0, $6owmV.pipe)(fa, $547185d5747eecdc$export$871de8747c9eaa88(f));
    });
};
var $547185d5747eecdc$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $6owmV.dual)(2, function(ma, f) {
    return (0, $6owmV.pipe)(ma, $547185d5747eecdc$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $547185d5747eecdc$export$bffa455ba8c619a6 = /*#__PURE__*/ $547185d5747eecdc$export$5b8affa63fc6df16((0, $6owmV.identity));
var $547185d5747eecdc$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $547185d5747eecdc$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($jc2nG.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $547185d5747eecdc$export$a04c6c6965dd4709 = function(f) {
    return $547185d5747eecdc$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $547185d5747eecdc$export$8e16b83750b44988 = /*#__PURE__*/ $547185d5747eecdc$export$a04c6c6965dd4709((0, $6owmV.identity));
var $547185d5747eecdc$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $iCI6U.separated)(left, right);
};
var $547185d5747eecdc$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $547185d5747eecdc$export$b29f828819edca8d = function(predicate) {
    return $547185d5747eecdc$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $547185d5747eecdc$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $iCI6U.separated)(left, right);
    };
};
var $547185d5747eecdc$export$3117e3f9ececb6bc = function(f) {
    return $547185d5747eecdc$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $547185d5747eecdc$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $iCI6U.separated)(left, right);
    };
};
var $547185d5747eecdc$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $547185d5747eecdc$export$228be17d80722ab = $547185d5747eecdc$export$1517cca7889d6aaa;
var $547185d5747eecdc$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $547185d5747eecdc$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $547185d5747eecdc$export$ecd5e8ace626722c = /*#__PURE__*/ $547185d5747eecdc$export$8b58be045bf06082((0, $6owmV.identity));
var $547185d5747eecdc$export$b66cdc0497d8a99a = $8D8qW.foldMap;
var $547185d5747eecdc$export$18153bb1181268e5 = $8D8qW.foldMapWithIndex;
var $547185d5747eecdc$export$533b26079ad0b4b = $8D8qW.reduce;
var $547185d5747eecdc$export$bbd3ef8720e22369 = $8D8qW.reduceWithIndex;
var $547185d5747eecdc$export$7fef8bcdbb34f435 = $8D8qW.reduceRight;
var $547185d5747eecdc$export$ce2b2fe0b88ccd0a = $8D8qW.reduceRightWithIndex;
var $547185d5747eecdc$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $547185d5747eecdc$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $547185d5747eecdc$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $547185d5747eecdc$var$_reduce(ta, F.of($547185d5747eecdc$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $6owmV.pipe)(as, $547185d5747eecdc$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $547185d5747eecdc$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $547185d5747eecdc$export$bbd3ef8720e22369(F.of($547185d5747eecdc$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $6owmV.pipe)(bs, $547185d5747eecdc$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $547185d5747eecdc$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $547185d5747eecdc$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $547185d5747eecdc$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $547185d5747eecdc$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $547185d5747eecdc$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($jc2nG.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $547185d5747eecdc$export$9156e739aa33e19f = 'Array';
var $547185d5747eecdc$export$3cb5cd7f7776c81 = $8D8qW.getShow;
var $547185d5747eecdc$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $547185d5747eecdc$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $547185d5747eecdc$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $547185d5747eecdc$export$804fed467fde44e4 = $8D8qW.getEq;
var $547185d5747eecdc$export$1af51209b1b91d07 = $8D8qW.getOrd;
var $547185d5747eecdc$export$baca17b4aff42f82 = function(E) {
    var unionE = $547185d5747eecdc$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $547185d5747eecdc$export$c487aac9f4157837 = function(E) {
    return {
        concat: $547185d5747eecdc$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $547185d5747eecdc$export$d379a869a72e4055 = function(E) {
    var intersectionE = $547185d5747eecdc$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $547185d5747eecdc$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $547185d5747eecdc$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $547185d5747eecdc$export$bd5b6bfc5fa2ee61 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map
};
var $547185d5747eecdc$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($547185d5747eecdc$export$bd5b6bfc5fa2ee61);
var $547185d5747eecdc$export$59a71046037e6c20 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    of: $547185d5747eecdc$export$ba255e9e49e00608
};
var $547185d5747eecdc$export$9fdffe0fe1e91cad = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    mapWithIndex: $547185d5747eecdc$var$_mapWithIndex
};
var $547185d5747eecdc$export$efc21ddc6aeb363d = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap
};
var $547185d5747eecdc$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $kf9cS.apFirst)($547185d5747eecdc$export$efc21ddc6aeb363d);
var $547185d5747eecdc$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $kf9cS.apSecond)($547185d5747eecdc$export$efc21ddc6aeb363d);
var $547185d5747eecdc$export$1279d2b7807629fd = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap,
    of: $547185d5747eecdc$export$ba255e9e49e00608
};
var $547185d5747eecdc$export$f18d5acc27d70423 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap,
    chain: $547185d5747eecdc$export$5b8affa63fc6df16
};
var $547185d5747eecdc$export$e3821ef4970c339c = /*#__PURE__*/ (0, $fl2uO.chainFirst)($547185d5747eecdc$export$f18d5acc27d70423);
var $547185d5747eecdc$export$fb641926d034ac7d = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap,
    of: $547185d5747eecdc$export$ba255e9e49e00608,
    chain: $547185d5747eecdc$export$5b8affa63fc6df16
};
var $547185d5747eecdc$export$8fa953f00d3b093 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    unfold: $547185d5747eecdc$export$c48e357c1a89b78d
};
var $547185d5747eecdc$export$25ba4469a069167 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    alt: $547185d5747eecdc$var$_alt
};
var $547185d5747eecdc$export$aaef8a3eae948f03 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    zero: $547185d5747eecdc$export$7f9972325ebfd559
};
var $547185d5747eecdc$export$864d727b48066337 = /*#__PURE__*/ (0, $bLjkL.guard)($547185d5747eecdc$export$aaef8a3eae948f03, $547185d5747eecdc$export$59a71046037e6c20);
var $547185d5747eecdc$export$4acb47accde578d2 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap,
    of: $547185d5747eecdc$export$ba255e9e49e00608,
    alt: $547185d5747eecdc$var$_alt,
    zero: $547185d5747eecdc$export$7f9972325ebfd559
};
var $547185d5747eecdc$export$5b5dd0e212d2a5bc = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    extend: $547185d5747eecdc$var$_extend
};
var $547185d5747eecdc$export$4a21ac48141ac3c9 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    compact: $547185d5747eecdc$export$8e16b83750b44988,
    separate: $547185d5747eecdc$export$709f6946f4e97408
};
var $547185d5747eecdc$export$d00e1c48fb621173 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    compact: $547185d5747eecdc$export$8e16b83750b44988,
    separate: $547185d5747eecdc$export$709f6946f4e97408,
    filter: $547185d5747eecdc$var$_filter,
    filterMap: $547185d5747eecdc$var$_filterMap,
    partition: $547185d5747eecdc$var$_partition,
    partitionMap: $547185d5747eecdc$var$_partitionMap
};
var $547185d5747eecdc$export$c29a647071e542ec = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    mapWithIndex: $547185d5747eecdc$var$_mapWithIndex,
    compact: $547185d5747eecdc$export$8e16b83750b44988,
    separate: $547185d5747eecdc$export$709f6946f4e97408,
    filter: $547185d5747eecdc$var$_filter,
    filterMap: $547185d5747eecdc$var$_filterMap,
    partition: $547185d5747eecdc$var$_partition,
    partitionMap: $547185d5747eecdc$var$_partitionMap,
    partitionMapWithIndex: $547185d5747eecdc$var$_partitionMapWithIndex,
    partitionWithIndex: $547185d5747eecdc$var$_partitionWithIndex,
    filterMapWithIndex: $547185d5747eecdc$var$_filterMapWithIndex,
    filterWithIndex: $547185d5747eecdc$var$_filterWithIndex
};
var $547185d5747eecdc$export$41404b31838667c9 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    reduce: $547185d5747eecdc$var$_reduce,
    foldMap: $547185d5747eecdc$var$_foldMap,
    reduceRight: $547185d5747eecdc$var$_reduceRight
};
var $547185d5747eecdc$export$e8f7d17aaff345cb = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    reduce: $547185d5747eecdc$var$_reduce,
    foldMap: $547185d5747eecdc$var$_foldMap,
    reduceRight: $547185d5747eecdc$var$_reduceRight,
    reduceWithIndex: $547185d5747eecdc$var$_reduceWithIndex,
    foldMapWithIndex: $547185d5747eecdc$var$_foldMapWithIndex,
    reduceRightWithIndex: $547185d5747eecdc$var$_reduceRightWithIndex
};
var $547185d5747eecdc$export$a0202666c3bda011 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    reduce: $547185d5747eecdc$var$_reduce,
    foldMap: $547185d5747eecdc$var$_foldMap,
    reduceRight: $547185d5747eecdc$var$_reduceRight,
    traverse: $547185d5747eecdc$var$_traverse,
    sequence: $547185d5747eecdc$export$49bb65c2ea163039
};
var $547185d5747eecdc$export$bd7b528d8c36ec41 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    mapWithIndex: $547185d5747eecdc$var$_mapWithIndex,
    reduce: $547185d5747eecdc$var$_reduce,
    foldMap: $547185d5747eecdc$var$_foldMap,
    reduceRight: $547185d5747eecdc$var$_reduceRight,
    reduceWithIndex: $547185d5747eecdc$var$_reduceWithIndex,
    foldMapWithIndex: $547185d5747eecdc$var$_foldMapWithIndex,
    reduceRightWithIndex: $547185d5747eecdc$var$_reduceRightWithIndex,
    traverse: $547185d5747eecdc$var$_traverse,
    sequence: $547185d5747eecdc$export$49bb65c2ea163039,
    traverseWithIndex: $547185d5747eecdc$var$_traverseWithIndex
};
var $547185d5747eecdc$var$_wither = /*#__PURE__*/ (0, $ciQV6.witherDefault)($547185d5747eecdc$export$a0202666c3bda011, $547185d5747eecdc$export$4a21ac48141ac3c9);
var $547185d5747eecdc$var$_wilt = /*#__PURE__*/ (0, $ciQV6.wiltDefault)($547185d5747eecdc$export$a0202666c3bda011, $547185d5747eecdc$export$4a21ac48141ac3c9);
var $547185d5747eecdc$export$748d317b4c426f96 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    compact: $547185d5747eecdc$export$8e16b83750b44988,
    separate: $547185d5747eecdc$export$709f6946f4e97408,
    filter: $547185d5747eecdc$var$_filter,
    filterMap: $547185d5747eecdc$var$_filterMap,
    partition: $547185d5747eecdc$var$_partition,
    partitionMap: $547185d5747eecdc$var$_partitionMap,
    reduce: $547185d5747eecdc$var$_reduce,
    foldMap: $547185d5747eecdc$var$_foldMap,
    reduceRight: $547185d5747eecdc$var$_reduceRight,
    traverse: $547185d5747eecdc$var$_traverse,
    sequence: $547185d5747eecdc$export$49bb65c2ea163039,
    wither: $547185d5747eecdc$var$_wither,
    wilt: $547185d5747eecdc$var$_wilt
};
var $547185d5747eecdc$export$f855115a79f70c1a = $8D8qW.chainRecDepthFirst;
var $547185d5747eecdc$export$7d808dfaa6d54634 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap,
    chain: $547185d5747eecdc$export$5b8affa63fc6df16,
    chainRec: $547185d5747eecdc$var$_chainRecDepthFirst
};
var $547185d5747eecdc$export$bffee57bb00a6859 = $8D8qW.chainRecBreadthFirst;
var $547185d5747eecdc$export$57f3a385c7e59628 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap,
    chain: $547185d5747eecdc$export$5b8affa63fc6df16,
    chainRec: $547185d5747eecdc$var$_chainRecBreadthFirst
};
var $547185d5747eecdc$export$c40604f35db61519 = /*#__PURE__*/ (0, $ciQV6.filterE)($547185d5747eecdc$export$748d317b4c426f96);
var $547185d5747eecdc$export$825ea6cb6fc48d49 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    fromEither: $547185d5747eecdc$export$80c878c9b1d77917
};
var $547185d5747eecdc$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $5tUZ7.fromEitherK)($547185d5747eecdc$export$825ea6cb6fc48d49);
var $547185d5747eecdc$export$f4863e1822a1860c = $4mCaV.unsafeInsertAt;
var $547185d5747eecdc$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $547185d5747eecdc$export$a978c53b4062a525(as) ? $4mCaV.unsafeUpdateAt(i, a, as) : [];
};
var $547185d5747eecdc$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $547185d5747eecdc$export$7ecc1a3b11b57dab = $8D8qW.every;
var $547185d5747eecdc$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $547185d5747eecdc$export$f7e9f41ea797a17 = $547185d5747eecdc$export$ad14ef4001db2bcd;
var $547185d5747eecdc$export$739ec22334c44788 = $8D8qW.intercalate;
var $547185d5747eecdc$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $547185d5747eecdc$export$ba255e9e49e00608($jc2nG.emptyRecord);
var $547185d5747eecdc$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $aFZgk.bindTo)($547185d5747eecdc$export$bd5b6bfc5fa2ee61);
var $547185d5747eecdc$export$5d537b797c421217 = /*#__PURE__*/ (0, $aFZgk.let)($547185d5747eecdc$export$bd5b6bfc5fa2ee61);
var $547185d5747eecdc$export$2385a24977818dd0 = /*#__PURE__*/ (0, $fl2uO.bind)($547185d5747eecdc$export$f18d5acc27d70423);
var $547185d5747eecdc$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $kf9cS.apS)($547185d5747eecdc$export$efc21ddc6aeb363d);
var $547185d5747eecdc$export$e08e3b67e392101e = $547185d5747eecdc$export$5b8affa63fc6df16;
var $547185d5747eecdc$export$d02631cccf789723 = $4mCaV.range;
var $547185d5747eecdc$export$6e22c362a0406a2c = [];
var $547185d5747eecdc$export$8327ebbef2a0ba76 = $4mCaV.cons;
var $547185d5747eecdc$export$c40cf5aab899f397 = $4mCaV.snoc;
var $547185d5747eecdc$export$baeb00bf1e27e233 = $547185d5747eecdc$export$849c7567cbd62acc;
var $547185d5747eecdc$export$2f23118c22fb2630 = {
    URI: $547185d5747eecdc$export$9156e739aa33e19f,
    compact: $547185d5747eecdc$export$8e16b83750b44988,
    separate: $547185d5747eecdc$export$709f6946f4e97408,
    map: $547185d5747eecdc$var$_map,
    ap: $547185d5747eecdc$var$_ap,
    of: $547185d5747eecdc$export$ba255e9e49e00608,
    chain: $547185d5747eecdc$export$5b8affa63fc6df16,
    filter: $547185d5747eecdc$var$_filter,
    filterMap: $547185d5747eecdc$var$_filterMap,
    partition: $547185d5747eecdc$var$_partition,
    partitionMap: $547185d5747eecdc$var$_partitionMap,
    mapWithIndex: $547185d5747eecdc$var$_mapWithIndex,
    partitionMapWithIndex: $547185d5747eecdc$var$_partitionMapWithIndex,
    partitionWithIndex: $547185d5747eecdc$var$_partitionWithIndex,
    filterMapWithIndex: $547185d5747eecdc$var$_filterMapWithIndex,
    filterWithIndex: $547185d5747eecdc$var$_filterWithIndex,
    alt: $547185d5747eecdc$var$_alt,
    zero: $547185d5747eecdc$export$7f9972325ebfd559,
    unfold: $547185d5747eecdc$export$c48e357c1a89b78d,
    reduce: $547185d5747eecdc$var$_reduce,
    foldMap: $547185d5747eecdc$var$_foldMap,
    reduceRight: $547185d5747eecdc$var$_reduceRight,
    traverse: $547185d5747eecdc$var$_traverse,
    sequence: $547185d5747eecdc$export$49bb65c2ea163039,
    reduceWithIndex: $547185d5747eecdc$var$_reduceWithIndex,
    foldMapWithIndex: $547185d5747eecdc$var$_foldMapWithIndex,
    reduceRightWithIndex: $547185d5747eecdc$var$_reduceRightWithIndex,
    traverseWithIndex: $547185d5747eecdc$var$_traverseWithIndex,
    extend: $547185d5747eecdc$var$_extend,
    wither: $547185d5747eecdc$var$_wither,
    wilt: $547185d5747eecdc$var$_wilt
};

});
parcelRegister("kf9cS", function(module, exports) {

$parcel$export(module.exports, "ap", () => $ebcc5999ec7a22e5$export$2f6ca3d3b1f80bf5);
$parcel$export(module.exports, "apFirst", () => $ebcc5999ec7a22e5$export$5f28d9feedcfd46e);
$parcel$export(module.exports, "apSecond", () => $ebcc5999ec7a22e5$export$ed01bc59c3d06bf3);
$parcel$export(module.exports, "apS", () => $ebcc5999ec7a22e5$export$8cbfc0239f42bb49);
$parcel$export(module.exports, "getApplySemigroup", () => $ebcc5999ec7a22e5$export$18979a515d2a828e);
/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ 
var $6owmV = parcelRequire("6owmV");

var $jc2nG = parcelRequire("jc2nG");
function $ebcc5999ec7a22e5$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $ebcc5999ec7a22e5$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $ebcc5999ec7a22e5$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $ebcc5999ec7a22e5$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $ebcc5999ec7a22e5$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $ebcc5999ec7a22e5$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $ebcc5999ec7a22e5$var$curried(f, n - 1, combined);
    };
}
var $ebcc5999ec7a22e5$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $ebcc5999ec7a22e5$var$getTupleConstructor(len) {
    if (!$jc2nG.has.call($ebcc5999ec7a22e5$var$tupleConstructors, len)) $ebcc5999ec7a22e5$var$tupleConstructors[len] = $ebcc5999ec7a22e5$var$curried((0, $6owmV.tuple), len - 1, []);
    return $ebcc5999ec7a22e5$var$tupleConstructors[len];
}
function $ebcc5999ec7a22e5$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $ebcc5999ec7a22e5$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $ebcc5999ec7a22e5$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $ebcc5999ec7a22e5$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $ebcc5999ec7a22e5$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $ebcc5999ec7a22e5$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

});
parcelRegister("6owmV", function(module, exports) {

$parcel$export(module.exports, "getSemigroup", () => $4a7e17c11bbaabc6$export$e759a9a7f8d04692);
$parcel$export(module.exports, "getMonoid", () => $4a7e17c11bbaabc6$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "identity", () => $4a7e17c11bbaabc6$export$f0954fd7d5368655);
$parcel$export(module.exports, "unsafeCoerce", () => $4a7e17c11bbaabc6$export$401372c57776dc);
$parcel$export(module.exports, "constant", () => $4a7e17c11bbaabc6$export$c983f826f44ff86);
$parcel$export(module.exports, "constTrue", () => $4a7e17c11bbaabc6$export$a68382d9631f6c53);
$parcel$export(module.exports, "constFalse", () => $4a7e17c11bbaabc6$export$7349232f2648ca80);
$parcel$export(module.exports, "constNull", () => $4a7e17c11bbaabc6$export$243c2ee5e7d8b05c);
$parcel$export(module.exports, "constUndefined", () => $4a7e17c11bbaabc6$export$3d16a43570087548);
$parcel$export(module.exports, "flow", () => $4a7e17c11bbaabc6$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "tuple", () => $4a7e17c11bbaabc6$export$65e3907585753458);
$parcel$export(module.exports, "pipe", () => $4a7e17c11bbaabc6$export$a4627e546088548d);
$parcel$export(module.exports, "SK", () => $4a7e17c11bbaabc6$export$5f584391ee0d99b4);
$parcel$export(module.exports, "dual", () => $4a7e17c11bbaabc6$export$d1699a1bbdf17835);
var $4a7e17c11bbaabc6$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4a7e17c11bbaabc6$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $4a7e17c11bbaabc6$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $4a7e17c11bbaabc6$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $4a7e17c11bbaabc6$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $4a7e17c11bbaabc6$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $4a7e17c11bbaabc6$export$575097c1c561f76f = function(R) {
    var S = $4a7e17c11bbaabc6$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $4a7e17c11bbaabc6$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $4a7e17c11bbaabc6$export$f0954fd7d5368655(a) {
    return a;
}
var $4a7e17c11bbaabc6$export$401372c57776dc = $4a7e17c11bbaabc6$export$f0954fd7d5368655;
function $4a7e17c11bbaabc6$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $4a7e17c11bbaabc6$export$a68382d9631f6c53 = /*#__PURE__*/ $4a7e17c11bbaabc6$export$c983f826f44ff86(true);
var $4a7e17c11bbaabc6$export$7349232f2648ca80 = /*#__PURE__*/ $4a7e17c11bbaabc6$export$c983f826f44ff86(false);
var $4a7e17c11bbaabc6$export$243c2ee5e7d8b05c = /*#__PURE__*/ $4a7e17c11bbaabc6$export$c983f826f44ff86(null);
var $4a7e17c11bbaabc6$export$3d16a43570087548 = /*#__PURE__*/ $4a7e17c11bbaabc6$export$c983f826f44ff86(undefined);
var $4a7e17c11bbaabc6$export$fe2a8306a887c223 = $4a7e17c11bbaabc6$export$3d16a43570087548;
function $4a7e17c11bbaabc6$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $4a7e17c11bbaabc6$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $4a7e17c11bbaabc6$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $4a7e17c11bbaabc6$export$a2647aa13413c947(n) {
    return n + 1;
}
function $4a7e17c11bbaabc6$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $4a7e17c11bbaabc6$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $4a7e17c11bbaabc6$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $4a7e17c11bbaabc6$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $4a7e17c11bbaabc6$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $4a7e17c11bbaabc6$export$5cc5fd8bb7edf254 = $4a7e17c11bbaabc6$export$f172309911142386;
var $4a7e17c11bbaabc6$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $4a7e17c11bbaabc6$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $4a7e17c11bbaabc6$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $4a7e17c11bbaabc6$export$ccc7b0636abaffc3(first, second);
        },
        empty: $4a7e17c11bbaabc6$export$f0954fd7d5368655
    };
};
var $4a7e17c11bbaabc6$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $4a7e17c11bbaabc6$var$__spreadArray([
                self
            ], args, false));
        };
    };
};

});

parcelRegister("jc2nG", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $df90fc1a491b6d8c$export$e56af863d5645d5f);
$parcel$export(module.exports, "isSome", () => $df90fc1a491b6d8c$export$5d7e502287836e58);
$parcel$export(module.exports, "none", () => $df90fc1a491b6d8c$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $df90fc1a491b6d8c$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "isLeft", () => $df90fc1a491b6d8c$export$d649b6842e09f2b);
$parcel$export(module.exports, "isRight", () => $df90fc1a491b6d8c$export$a9d71693f0c1a85d);
$parcel$export(module.exports, "left", () => $df90fc1a491b6d8c$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $df90fc1a491b6d8c$export$79ffe56a765070d2);
$parcel$export(module.exports, "singleton", () => $df90fc1a491b6d8c$export$439306a4dcaafbb9);
$parcel$export(module.exports, "isNonEmpty", () => $df90fc1a491b6d8c$export$a978c53b4062a525);
$parcel$export(module.exports, "head", () => $df90fc1a491b6d8c$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $df90fc1a491b6d8c$export$c01875f616615628);
$parcel$export(module.exports, "emptyReadonlyArray", () => $df90fc1a491b6d8c$export$6ca726a2417e0f3f);
$parcel$export(module.exports, "emptyRecord", () => $df90fc1a491b6d8c$export$4de80339753b012b);
$parcel$export(module.exports, "has", () => $df90fc1a491b6d8c$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "fromReadonlyNonEmptyArray", () => $df90fc1a491b6d8c$export$7e77326b0f0e268c);
$parcel$export(module.exports, "liftNullable", () => $df90fc1a491b6d8c$export$cd139e14432f317b);
$parcel$export(module.exports, "liftOption", () => $df90fc1a491b6d8c$export$ea4a22f93200df79);
$parcel$export(module.exports, "flatMapNullable", () => $df90fc1a491b6d8c$export$1a0515933c5c84fe);
$parcel$export(module.exports, "flatMapOption", () => $df90fc1a491b6d8c$export$b5f02b7beb8ed7d8);

var $6owmV = parcelRequire("6owmV");
var $df90fc1a491b6d8c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $df90fc1a491b6d8c$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $df90fc1a491b6d8c$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $df90fc1a491b6d8c$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $df90fc1a491b6d8c$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $df90fc1a491b6d8c$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $df90fc1a491b6d8c$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $df90fc1a491b6d8c$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $df90fc1a491b6d8c$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $df90fc1a491b6d8c$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $df90fc1a491b6d8c$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $df90fc1a491b6d8c$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $df90fc1a491b6d8c$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $df90fc1a491b6d8c$export$6ca726a2417e0f3f = [];
var $df90fc1a491b6d8c$export$4de80339753b012b = {};
var $df90fc1a491b6d8c$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $df90fc1a491b6d8c$export$7e77326b0f0e268c = function(as) {
    return $df90fc1a491b6d8c$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $df90fc1a491b6d8c$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $df90fc1a491b6d8c$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $df90fc1a491b6d8c$export$79ffe56a765070d2(o));
        };
    };
};
var $df90fc1a491b6d8c$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($df90fc1a491b6d8c$export$e56af863d5645d5f(o) ? $df90fc1a491b6d8c$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $df90fc1a491b6d8c$export$79ffe56a765070d2(o.value));
        };
    };
};
var $df90fc1a491b6d8c$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $6owmV.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, $df90fc1a491b6d8c$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $df90fc1a491b6d8c$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $6owmV.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, $df90fc1a491b6d8c$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $df90fc1a491b6d8c$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $6owmV.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $df90fc1a491b6d8c$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $6owmV.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $df90fc1a491b6d8c$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $6owmV.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $df90fc1a491b6d8c$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $6owmV.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};

});


parcelRegister("fl2uO", function(module, exports) {

$parcel$export(module.exports, "chainFirst", () => $b2aac0d871c3ca75$export$e3821ef4970c339c);
$parcel$export(module.exports, "tap", () => $b2aac0d871c3ca75$export$3f23594af5f37336);
$parcel$export(module.exports, "bind", () => $b2aac0d871c3ca75$export$2385a24977818dd0);
function $b2aac0d871c3ca75$export$e3821ef4970c339c(M) {
    var tapM = $b2aac0d871c3ca75$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $b2aac0d871c3ca75$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $b2aac0d871c3ca75$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

});

parcelRegister("5tUZ7", function(module, exports) {

$parcel$export(module.exports, "fromOption", () => $3fdbdd2ffd3a0541$export$172ec0a6ebfeb6fa);
$parcel$export(module.exports, "fromPredicate", () => $3fdbdd2ffd3a0541$export$23f31c55d7162b91);
$parcel$export(module.exports, "fromOptionK", () => $3fdbdd2ffd3a0541$export$a907462f448b49f8);
$parcel$export(module.exports, "chainOptionK", () => $3fdbdd2ffd3a0541$export$12d26179deb6a68a);
$parcel$export(module.exports, "fromEitherK", () => $3fdbdd2ffd3a0541$export$8138b0ae92c9b5d8);
$parcel$export(module.exports, "chainEitherK", () => $3fdbdd2ffd3a0541$export$a3eef2eba9908c3e);
$parcel$export(module.exports, "tapEither", () => $3fdbdd2ffd3a0541$export$be3ff275bb5a8ac9);
$parcel$export(module.exports, "filterOrElse", () => $3fdbdd2ffd3a0541$export$30af8ca9498ddf5b);
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 
var $fl2uO = parcelRequire("fl2uO");

var $6owmV = parcelRequire("6owmV");

var $jc2nG = parcelRequire("jc2nG");
function $3fdbdd2ffd3a0541$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($jc2nG.isNone(ma) ? $jc2nG.left(onNone()) : $jc2nG.right(ma.value));
        };
    };
}
function $3fdbdd2ffd3a0541$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $jc2nG.right(a) : $jc2nG.left(onFalse(a)));
        };
    };
}
function $3fdbdd2ffd3a0541$export$a907462f448b49f8(F) {
    var fromOptionF = $3fdbdd2ffd3a0541$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $6owmV.flow)(f, from);
        };
    };
}
function $3fdbdd2ffd3a0541$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $3fdbdd2ffd3a0541$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $3fdbdd2ffd3a0541$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $6owmV.flow)(f, F.fromEither);
    };
}
function $3fdbdd2ffd3a0541$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $3fdbdd2ffd3a0541$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $3fdbdd2ffd3a0541$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $3fdbdd2ffd3a0541$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $3fdbdd2ffd3a0541$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $jc2nG.right(a) : $jc2nG.left(onFalse(a)));
            });
        };
    };
}
function $3fdbdd2ffd3a0541$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $3fdbdd2ffd3a0541$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $fl2uO.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

});

parcelRegister("aFZgk", function(module, exports) {

$parcel$export(module.exports, "flap", () => $7c5d41234038769d$export$18c957606d8bdf09);
$parcel$export(module.exports, "bindTo", () => $7c5d41234038769d$export$7c052ae73f8acff0);
$parcel$export(module.exports, "let", () => $7c5d41234038769d$export$5d537b797c421217);
$parcel$export(module.exports, "getFunctorComposition", () => $7c5d41234038769d$export$7b0f6fce42e2b480);
$parcel$export(module.exports, "as", () => $7c5d41234038769d$export$6554612db691658e);
$parcel$export(module.exports, "asUnit", () => $7c5d41234038769d$export$9284b360ca18a0fd);
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
var $6owmV = parcelRequire("6owmV");
function $7c5d41234038769d$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $7c5d41234038769d$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $7c5d41234038769d$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $7c5d41234038769d$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $7c5d41234038769d$export$7b0f6fce42e2b480(F, G) {
    var _map = $7c5d41234038769d$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $6owmV.pipe)(fga, _map(f));
        }
    };
}
function $7c5d41234038769d$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $7c5d41234038769d$export$9284b360ca18a0fd(F) {
    var asM = $7c5d41234038769d$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}

});

parcelRegister("4mCaV", function(module, exports) {

$parcel$export(module.exports, "isNonEmpty", () => $32d6d44c7d1bd27c$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $32d6d44c7d1bd27c$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $32d6d44c7d1bd27c$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $32d6d44c7d1bd27c$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $32d6d44c7d1bd27c$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $32d6d44c7d1bd27c$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $32d6d44c7d1bd27c$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $32d6d44c7d1bd27c$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $32d6d44c7d1bd27c$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $32d6d44c7d1bd27c$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $32d6d44c7d1bd27c$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $32d6d44c7d1bd27c$export$b035e44d7bb4278f);
$parcel$export(module.exports, "union", () => $32d6d44c7d1bd27c$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $32d6d44c7d1bd27c$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $32d6d44c7d1bd27c$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $32d6d44c7d1bd27c$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $32d6d44c7d1bd27c$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $32d6d44c7d1bd27c$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $32d6d44c7d1bd27c$export$4c7897fafd92b108);
$parcel$export(module.exports, "of", () => $32d6d44c7d1bd27c$export$ba255e9e49e00608);
$parcel$export(module.exports, "prependAll", () => $32d6d44c7d1bd27c$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $32d6d44c7d1bd27c$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $32d6d44c7d1bd27c$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $32d6d44c7d1bd27c$export$2f0184d5df52135f);
$parcel$export(module.exports, "cons", () => $32d6d44c7d1bd27c$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $32d6d44c7d1bd27c$export$c40cf5aab899f397);

var $kf9cS = parcelRequire("kf9cS");

var $fl2uO = parcelRequire("fl2uO");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $6ZOPp = parcelRequire("6ZOPp");

var $6ANlS = parcelRequire("6ANlS");
var $32d6d44c7d1bd27c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $32d6d44c7d1bd27c$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $32d6d44c7d1bd27c$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $32d6d44c7d1bd27c$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $32d6d44c7d1bd27c$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $32d6d44c7d1bd27c$export$68159836694e22c1 = $32d6d44c7d1bd27c$export$c4c4d41eab625797;
var $32d6d44c7d1bd27c$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $32d6d44c7d1bd27c$var$__spreadArray($32d6d44c7d1bd27c$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $32d6d44c7d1bd27c$export$10d8903dec122b9d = $32d6d44c7d1bd27c$export$19903a1bf1942f6;
var $32d6d44c7d1bd27c$export$f4863e1822a1860c = function(i, a, as) {
    if ($32d6d44c7d1bd27c$export$a978c53b4062a525(as)) {
        var xs = $32d6d44c7d1bd27c$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $32d6d44c7d1bd27c$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $32d6d44c7d1bd27c$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $32d6d44c7d1bd27c$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $32d6d44c7d1bd27c$export$784d13d8ee351f07(as);
        var out = [
            $32d6d44c7d1bd27c$export$5fd5031fecdacec3(as)
        ];
        var rest = $32d6d44c7d1bd27c$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $32d6d44c7d1bd27c$export$b035e44d7bb4278f = function(ords) {
    if ($32d6d44c7d1bd27c$export$a978c53b4062a525(ords)) {
        var M = (0, $6ZOPp.getMonoid)();
        return $32d6d44c7d1bd27c$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $32d6d44c7d1bd27c$export$784d13d8ee351f07;
};
var $32d6d44c7d1bd27c$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $32d6d44c7d1bd27c$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $6owmV.pipe)(first, $32d6d44c7d1bd27c$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $32d6d44c7d1bd27c$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($32d6d44c7d1bd27c$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $32d6d44c7d1bd27c$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $32d6d44c7d1bd27c$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $6owmV.pipe)(s, $32d6d44c7d1bd27c$export$ee1b3e54f0441b22(f));
        } else return $32d6d44c7d1bd27c$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $32d6d44c7d1bd27c$export$7e77326b0f0e268c = $jc2nG.fromReadonlyNonEmptyArray;
var $32d6d44c7d1bd27c$export$571d59b505e6bb4e = function(as) {
    return $32d6d44c7d1bd27c$export$a978c53b4062a525(as) ? $jc2nG.some(as) : $jc2nG.none;
};
var $32d6d44c7d1bd27c$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $32d6d44c7d1bd27c$export$606959e7ccb797f0 = function(a) {
    return $32d6d44c7d1bd27c$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $32d6d44c7d1bd27c$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $32d6d44c7d1bd27c$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $32d6d44c7d1bd27c$export$c04edabe9c8d994f = function(as) {
    return [
        $32d6d44c7d1bd27c$export$5fd5031fecdacec3(as),
        $32d6d44c7d1bd27c$export$c01875f616615628(as)
    ];
};
var $32d6d44c7d1bd27c$export$89a97afc72a83708 = function(as) {
    return [
        $32d6d44c7d1bd27c$export$2cd8252107eb640b(as),
        $32d6d44c7d1bd27c$export$4c7897fafd92b108(as)
    ];
};
function $32d6d44c7d1bd27c$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $32d6d44c7d1bd27c$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $32d6d44c7d1bd27c$export$66c1ae025e96b4bc = function(as) {
    return $32d6d44c7d1bd27c$var$__spreadArray([
        $32d6d44c7d1bd27c$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $32d6d44c7d1bd27c$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $32d6d44c7d1bd27c$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($jc2nG.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $32d6d44c7d1bd27c$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $32d6d44c7d1bd27c$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $jc2nG.none : $jc2nG.some($32d6d44c7d1bd27c$export$f4863e1822a1860c(i, a, as));
    };
};
var $32d6d44c7d1bd27c$export$b6d8713d53419d4c = function(i, a) {
    return $32d6d44c7d1bd27c$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $32d6d44c7d1bd27c$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $32d6d44c7d1bd27c$export$2fde0b1c54fc39b9(i, as) ? $jc2nG.none : $jc2nG.some($32d6d44c7d1bd27c$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $32d6d44c7d1bd27c$export$784d13d8ee351f07 = $32d6d44c7d1bd27c$export$7e77326b0f0e268c;
var $32d6d44c7d1bd27c$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $32d6d44c7d1bd27c$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $32d6d44c7d1bd27c$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $32d6d44c7d1bd27c$export$8901015135f2fb22(bs, as);
    };
    return $32d6d44c7d1bd27c$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $32d6d44c7d1bd27c$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $32d6d44c7d1bd27c$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $32d6d44c7d1bd27c$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $32d6d44c7d1bd27c$export$c01875f616615628(as);
        return $32d6d44c7d1bd27c$export$a978c53b4062a525(rest) ? (0, $6owmV.pipe)(rest, $32d6d44c7d1bd27c$export$849c7567cbd62acc(middle), $32d6d44c7d1bd27c$export$68159836694e22c1($32d6d44c7d1bd27c$export$5fd5031fecdacec3(as))) : $32d6d44c7d1bd27c$export$784d13d8ee351f07(as);
    };
};
var $32d6d44c7d1bd27c$export$18153bb1181268e5 = $6ANlS.foldMapWithIndex;
var $32d6d44c7d1bd27c$export$b66cdc0497d8a99a = $6ANlS.foldMap;
var $32d6d44c7d1bd27c$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $32d6d44c7d1bd27c$export$7e77326b0f0e268c(f(0, $32d6d44c7d1bd27c$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $32d6d44c7d1bd27c$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($32d6d44c7d1bd27c$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $32d6d44c7d1bd27c$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $32d6d44c7d1bd27c$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $6owmV.pipe)(as.slice(1, m), $32d6d44c7d1bd27c$export$68159836694e22c1($32d6d44c7d1bd27c$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $32d6d44c7d1bd27c$export$2f0184d5df52135f = function(n) {
    return $32d6d44c7d1bd27c$export$433fe05b12ba833f($32d6d44c7d1bd27c$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $32d6d44c7d1bd27c$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_mapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $32d6d44c7d1bd27c$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_ap = function(fab, fa) {
    return (0, $6owmV.pipe)(fab, $32d6d44c7d1bd27c$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_extend = function(wa, f) {
    return (0, $6owmV.pipe)(wa, $32d6d44c7d1bd27c$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_reduce = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $32d6d44c7d1bd27c$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_foldMap = function(M) {
    var foldMapM = $32d6d44c7d1bd27c$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_reduceRight = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $32d6d44c7d1bd27c$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_traverse = function(F) {
    var traverseF = $32d6d44c7d1bd27c$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_alt = function(fa, that) {
    return (0, $6owmV.pipe)(fa, $32d6d44c7d1bd27c$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $32d6d44c7d1bd27c$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $32d6d44c7d1bd27c$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $32d6d44c7d1bd27c$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $32d6d44c7d1bd27c$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $32d6d44c7d1bd27c$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseWithIndexF(f));
    };
};
var $32d6d44c7d1bd27c$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $6owmV.pipe)(as, $32d6d44c7d1bd27c$export$c8c959650bbe80e2(that()));
    };
};
var $32d6d44c7d1bd27c$export$228be17d80722ab = $32d6d44c7d1bd27c$export$1517cca7889d6aaa;
var $32d6d44c7d1bd27c$export$2f6ca3d3b1f80bf5 = function(as) {
    return $32d6d44c7d1bd27c$export$5b8affa63fc6df16(function(f) {
        return (0, $6owmV.pipe)(as, $32d6d44c7d1bd27c$export$871de8747c9eaa88(f));
    });
};
var $32d6d44c7d1bd27c$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $6owmV.dual)(2, function(ma, f) {
    return (0, $6owmV.pipe)(ma, $32d6d44c7d1bd27c$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $32d6d44c7d1bd27c$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $32d6d44c7d1bd27c$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($32d6d44c7d1bd27c$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $32d6d44c7d1bd27c$export$c01875f616615628(next);
        }
        return out;
    };
};
var $32d6d44c7d1bd27c$export$ecd5e8ace626722c = /*#__PURE__*/ $32d6d44c7d1bd27c$export$8b58be045bf06082((0, $6owmV.identity));
var $32d6d44c7d1bd27c$export$bffa455ba8c619a6 = /*#__PURE__*/ $32d6d44c7d1bd27c$export$5b8affa63fc6df16((0, $6owmV.identity));
var $32d6d44c7d1bd27c$export$871de8747c9eaa88 = function(f) {
    return $32d6d44c7d1bd27c$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $32d6d44c7d1bd27c$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $32d6d44c7d1bd27c$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $32d6d44c7d1bd27c$export$533b26079ad0b4b = $6ANlS.reduce;
var $32d6d44c7d1bd27c$export$bbd3ef8720e22369 = $6ANlS.reduceWithIndex;
var $32d6d44c7d1bd27c$export$7fef8bcdbb34f435 = $6ANlS.reduceRight;
var $32d6d44c7d1bd27c$export$ce2b2fe0b88ccd0a = $6ANlS.reduceRightWithIndex;
var $32d6d44c7d1bd27c$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $32d6d44c7d1bd27c$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $32d6d44c7d1bd27c$export$49bb65c2ea163039 = function(F) {
    return $32d6d44c7d1bd27c$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $32d6d44c7d1bd27c$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $32d6d44c7d1bd27c$export$5fd5031fecdacec3(as)), $32d6d44c7d1bd27c$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $6owmV.pipe)(bs, $32d6d44c7d1bd27c$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $32d6d44c7d1bd27c$export$f9380c9a627682d3 = $6ANlS.head;
var $32d6d44c7d1bd27c$export$9156e739aa33e19f = 'NonEmptyArray';
var $32d6d44c7d1bd27c$export$3cb5cd7f7776c81 = $6ANlS.getShow;
var $32d6d44c7d1bd27c$export$e759a9a7f8d04692 = function() {
    return {
        concat: $32d6d44c7d1bd27c$export$ee1b3e54f0441b22
    };
};
var $32d6d44c7d1bd27c$export$804fed467fde44e4 = $6ANlS.getEq;
var $32d6d44c7d1bd27c$export$baca17b4aff42f82 = function(E) {
    var unionE = $32d6d44c7d1bd27c$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $32d6d44c7d1bd27c$export$bd5b6bfc5fa2ee61 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map
};
var $32d6d44c7d1bd27c$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($32d6d44c7d1bd27c$export$bd5b6bfc5fa2ee61);
var $32d6d44c7d1bd27c$export$59a71046037e6c20 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    of: $32d6d44c7d1bd27c$export$ba255e9e49e00608
};
var $32d6d44c7d1bd27c$export$9fdffe0fe1e91cad = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    mapWithIndex: $32d6d44c7d1bd27c$var$_mapWithIndex
};
var $32d6d44c7d1bd27c$export$efc21ddc6aeb363d = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    ap: $32d6d44c7d1bd27c$var$_ap
};
var $32d6d44c7d1bd27c$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $kf9cS.apFirst)($32d6d44c7d1bd27c$export$efc21ddc6aeb363d);
var $32d6d44c7d1bd27c$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $kf9cS.apSecond)($32d6d44c7d1bd27c$export$efc21ddc6aeb363d);
var $32d6d44c7d1bd27c$export$1279d2b7807629fd = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    ap: $32d6d44c7d1bd27c$var$_ap,
    of: $32d6d44c7d1bd27c$export$ba255e9e49e00608
};
var $32d6d44c7d1bd27c$export$f18d5acc27d70423 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    ap: $32d6d44c7d1bd27c$var$_ap,
    chain: $32d6d44c7d1bd27c$export$5b8affa63fc6df16
};
var $32d6d44c7d1bd27c$export$e3821ef4970c339c = /*#__PURE__*/ (0, $fl2uO.chainFirst)($32d6d44c7d1bd27c$export$f18d5acc27d70423);
var $32d6d44c7d1bd27c$export$fb641926d034ac7d = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    ap: $32d6d44c7d1bd27c$var$_ap,
    of: $32d6d44c7d1bd27c$export$ba255e9e49e00608,
    chain: $32d6d44c7d1bd27c$export$5b8affa63fc6df16
};
var $32d6d44c7d1bd27c$export$41404b31838667c9 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    reduce: $32d6d44c7d1bd27c$var$_reduce,
    foldMap: $32d6d44c7d1bd27c$var$_foldMap,
    reduceRight: $32d6d44c7d1bd27c$var$_reduceRight
};
var $32d6d44c7d1bd27c$export$e8f7d17aaff345cb = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    reduce: $32d6d44c7d1bd27c$var$_reduce,
    foldMap: $32d6d44c7d1bd27c$var$_foldMap,
    reduceRight: $32d6d44c7d1bd27c$var$_reduceRight,
    reduceWithIndex: $32d6d44c7d1bd27c$var$_reduceWithIndex,
    foldMapWithIndex: $32d6d44c7d1bd27c$var$_foldMapWithIndex,
    reduceRightWithIndex: $32d6d44c7d1bd27c$var$_reduceRightWithIndex
};
var $32d6d44c7d1bd27c$export$a0202666c3bda011 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    reduce: $32d6d44c7d1bd27c$var$_reduce,
    foldMap: $32d6d44c7d1bd27c$var$_foldMap,
    reduceRight: $32d6d44c7d1bd27c$var$_reduceRight,
    traverse: $32d6d44c7d1bd27c$var$_traverse,
    sequence: $32d6d44c7d1bd27c$export$49bb65c2ea163039
};
var $32d6d44c7d1bd27c$export$bd7b528d8c36ec41 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    mapWithIndex: $32d6d44c7d1bd27c$var$_mapWithIndex,
    reduce: $32d6d44c7d1bd27c$var$_reduce,
    foldMap: $32d6d44c7d1bd27c$var$_foldMap,
    reduceRight: $32d6d44c7d1bd27c$var$_reduceRight,
    traverse: $32d6d44c7d1bd27c$var$_traverse,
    sequence: $32d6d44c7d1bd27c$export$49bb65c2ea163039,
    reduceWithIndex: $32d6d44c7d1bd27c$var$_reduceWithIndex,
    foldMapWithIndex: $32d6d44c7d1bd27c$var$_foldMapWithIndex,
    reduceRightWithIndex: $32d6d44c7d1bd27c$var$_reduceRightWithIndex,
    traverseWithIndex: $32d6d44c7d1bd27c$var$_traverseWithIndex
};
var $32d6d44c7d1bd27c$export$25ba4469a069167 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    alt: $32d6d44c7d1bd27c$var$_alt
};
var $32d6d44c7d1bd27c$export$fdd73124b9f1de36 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    map: $32d6d44c7d1bd27c$var$_map,
    extend: $32d6d44c7d1bd27c$var$_extend,
    extract: $32d6d44c7d1bd27c$export$f9380c9a627682d3
};
var $32d6d44c7d1bd27c$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $32d6d44c7d1bd27c$export$ba255e9e49e00608($jc2nG.emptyRecord);
var $32d6d44c7d1bd27c$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $aFZgk.bindTo)($32d6d44c7d1bd27c$export$bd5b6bfc5fa2ee61);
var $32d6d44c7d1bd27c$export$5d537b797c421217 = /*#__PURE__*/ (0, $aFZgk.let)($32d6d44c7d1bd27c$export$bd5b6bfc5fa2ee61);
var $32d6d44c7d1bd27c$export$2385a24977818dd0 = /*#__PURE__*/ (0, $fl2uO.bind)($32d6d44c7d1bd27c$export$f18d5acc27d70423);
var $32d6d44c7d1bd27c$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $kf9cS.apS)($32d6d44c7d1bd27c$export$efc21ddc6aeb363d);
var $32d6d44c7d1bd27c$export$5fd5031fecdacec3 = $6ANlS.head;
var $32d6d44c7d1bd27c$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $32d6d44c7d1bd27c$export$4c7897fafd92b108 = $6ANlS.last;
var $32d6d44c7d1bd27c$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $32d6d44c7d1bd27c$export$96ec731ed4dcb222 = $6ANlS.min;
var $32d6d44c7d1bd27c$export$8960430cfd85939f = $6ANlS.max;
var $32d6d44c7d1bd27c$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $32d6d44c7d1bd27c$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($32d6d44c7d1bd27c$export$5fd5031fecdacec3(as), $32d6d44c7d1bd27c$export$c01875f616615628(as));
    };
};
var $32d6d44c7d1bd27c$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($32d6d44c7d1bd27c$export$2cd8252107eb640b(as), $32d6d44c7d1bd27c$export$4c7897fafd92b108(as));
    };
};
var $32d6d44c7d1bd27c$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $32d6d44c7d1bd27c$var$__spreadArray([
            f($32d6d44c7d1bd27c$export$5fd5031fecdacec3(as))
        ], $32d6d44c7d1bd27c$export$c01875f616615628(as), true);
    };
};
var $32d6d44c7d1bd27c$export$20ca6ad9f7762931 = function(a) {
    return $32d6d44c7d1bd27c$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $32d6d44c7d1bd27c$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $6owmV.pipe)($32d6d44c7d1bd27c$export$2cd8252107eb640b(as), $32d6d44c7d1bd27c$export$10d8903dec122b9d(f($32d6d44c7d1bd27c$export$4c7897fafd92b108(as))));
    };
};
var $32d6d44c7d1bd27c$export$d3affa0a0a83d946 = function(a) {
    return $32d6d44c7d1bd27c$export$302ad361c463800a(function() {
        return a;
    });
};
var $32d6d44c7d1bd27c$export$739ec22334c44788 = $6ANlS.intercalate;
var $32d6d44c7d1bd27c$export$e08e3b67e392101e = $32d6d44c7d1bd27c$export$5b8affa63fc6df16;
function $32d6d44c7d1bd27c$export$103ce2c0a67e4e61(O) {
    var sortO = $32d6d44c7d1bd27c$export$97db5808d8f88186(O);
    var groupO = $32d6d44c7d1bd27c$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $32d6d44c7d1bd27c$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $32d6d44c7d1bd27c$export$3dea766d36a8935f(predicate) {
    return $32d6d44c7d1bd27c$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $32d6d44c7d1bd27c$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $32d6d44c7d1bd27c$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $32d6d44c7d1bd27c$export$b446f6baa3bb1430 = $32d6d44c7d1bd27c$export$c04edabe9c8d994f;
var $32d6d44c7d1bd27c$export$712962e076096ed4 = $32d6d44c7d1bd27c$export$89a97afc72a83708;
function $32d6d44c7d1bd27c$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $32d6d44c7d1bd27c$export$68159836694e22c1(head) : (0, $6owmV.pipe)(tail, $32d6d44c7d1bd27c$export$68159836694e22c1(head));
}
var $32d6d44c7d1bd27c$export$c40cf5aab899f397 = function(init, end) {
    return (0, $6owmV.pipe)(init, $32d6d44c7d1bd27c$export$10d8903dec122b9d(end));
};
var $32d6d44c7d1bd27c$export$baeb00bf1e27e233 = $32d6d44c7d1bd27c$export$849c7567cbd62acc;
var $32d6d44c7d1bd27c$export$93e2b83da34ff82a = $6ANlS.concatAll;
var $32d6d44c7d1bd27c$export$a5383a53b408af94 = {
    URI: $32d6d44c7d1bd27c$export$9156e739aa33e19f,
    of: $32d6d44c7d1bd27c$export$ba255e9e49e00608,
    map: $32d6d44c7d1bd27c$var$_map,
    mapWithIndex: $32d6d44c7d1bd27c$var$_mapWithIndex,
    ap: $32d6d44c7d1bd27c$var$_ap,
    chain: $32d6d44c7d1bd27c$export$5b8affa63fc6df16,
    extend: $32d6d44c7d1bd27c$var$_extend,
    extract: $32d6d44c7d1bd27c$export$f9380c9a627682d3,
    reduce: $32d6d44c7d1bd27c$var$_reduce,
    foldMap: $32d6d44c7d1bd27c$var$_foldMap,
    reduceRight: $32d6d44c7d1bd27c$var$_reduceRight,
    traverse: $32d6d44c7d1bd27c$var$_traverse,
    sequence: $32d6d44c7d1bd27c$export$49bb65c2ea163039,
    reduceWithIndex: $32d6d44c7d1bd27c$var$_reduceWithIndex,
    foldMapWithIndex: $32d6d44c7d1bd27c$var$_foldMapWithIndex,
    reduceRightWithIndex: $32d6d44c7d1bd27c$var$_reduceRightWithIndex,
    traverseWithIndex: $32d6d44c7d1bd27c$var$_traverseWithIndex,
    alt: $32d6d44c7d1bd27c$var$_alt
};

});
parcelRegister("6ZOPp", function(module, exports) {

$parcel$export(module.exports, "fromCompare", () => $517fddffcf2cf02b$export$aa9e0de96ff2f1fd);
$parcel$export(module.exports, "getMonoid", () => $517fddffcf2cf02b$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "min", () => $517fddffcf2cf02b$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $517fddffcf2cf02b$export$8960430cfd85939f);

var $JrPqh = parcelRequire("JrPqh");

var $6owmV = parcelRequire("6owmV");
var $517fddffcf2cf02b$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $517fddffcf2cf02b$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $517fddffcf2cf02b$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $517fddffcf2cf02b$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $517fddffcf2cf02b$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $517fddffcf2cf02b$export$66c1ae025e96b4bc = function(O) {
    return $517fddffcf2cf02b$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $517fddffcf2cf02b$var$contramap_ = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $517fddffcf2cf02b$export$53b696d27ecb7ba7(f));
};
var $517fddffcf2cf02b$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $517fddffcf2cf02b$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $517fddffcf2cf02b$export$9156e739aa33e19f = 'Ord';
var $517fddffcf2cf02b$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $517fddffcf2cf02b$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $517fddffcf2cf02b$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $517fddffcf2cf02b$export$e759a9a7f8d04692().concat,
        empty: $517fddffcf2cf02b$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $517fddffcf2cf02b$export$def901a57d5539c3 = {
    URI: $517fddffcf2cf02b$export$9156e739aa33e19f,
    contramap: $517fddffcf2cf02b$var$contramap_
};
var $517fddffcf2cf02b$export$e5bb9f0f2dedbef6 = {
    equals: (0, $6owmV.constTrue),
    compare: /*#__PURE__*/ (0, $6owmV.constant)(0)
};
var $517fddffcf2cf02b$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $517fddffcf2cf02b$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $517fddffcf2cf02b$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $517fddffcf2cf02b$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $517fddffcf2cf02b$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $517fddffcf2cf02b$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $517fddffcf2cf02b$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $517fddffcf2cf02b$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $517fddffcf2cf02b$export$96ec731ed4dcb222(O);
    var maxO = $517fddffcf2cf02b$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $517fddffcf2cf02b$export$cf95c51b03f10bae = function(O) {
    var ltO = $517fddffcf2cf02b$export$b961576059b7aeb6(O);
    var gtO = $517fddffcf2cf02b$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $517fddffcf2cf02b$export$c41db498223b95e9 = $517fddffcf2cf02b$export$65e3907585753458;
var $517fddffcf2cf02b$export$35315ebcdff1b05c = $517fddffcf2cf02b$export$66c1ae025e96b4bc;
var $517fddffcf2cf02b$export$ad12338f1fefb50e = $517fddffcf2cf02b$export$def901a57d5539c3;
// default compare for primitive types
function $517fddffcf2cf02b$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $517fddffcf2cf02b$var$strictOrd = {
    equals: (0, $JrPqh.eqStrict).equals,
    compare: $517fddffcf2cf02b$var$compare
};
var $517fddffcf2cf02b$export$ef759d57a4e44836 = $517fddffcf2cf02b$var$strictOrd;
var $517fddffcf2cf02b$export$c5f2758e49b2b86a = $517fddffcf2cf02b$var$strictOrd;
var $517fddffcf2cf02b$export$5ed021ff2336715c = $517fddffcf2cf02b$var$strictOrd;
var $517fddffcf2cf02b$export$722593c82468f9f4 = /*#__PURE__*/ (0, $6owmV.pipe)($517fddffcf2cf02b$export$5ed021ff2336715c, /*#__PURE__*/ $517fddffcf2cf02b$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));

});
parcelRegister("JrPqh", function(module, exports) {

$parcel$export(module.exports, "fromEquals", () => $0889ca3987661a8e$export$fec6acd8d60e8568);
$parcel$export(module.exports, "eqStrict", () => $0889ca3987661a8e$export$37a88d8211c10fd3);

var $6owmV = parcelRequire("6owmV");
var $0889ca3987661a8e$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $0889ca3987661a8e$export$8cf3da7c1c9174ea = function(eqs) {
    return $0889ca3987661a8e$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $0889ca3987661a8e$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $0889ca3987661a8e$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $0889ca3987661a8e$var$contramap_ = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $0889ca3987661a8e$export$53b696d27ecb7ba7(f));
};
var $0889ca3987661a8e$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $0889ca3987661a8e$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $0889ca3987661a8e$export$9156e739aa33e19f = 'Eq';
var $0889ca3987661a8e$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $0889ca3987661a8e$var$empty = {
    equals: function() {
        return true;
    }
};
var $0889ca3987661a8e$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $0889ca3987661a8e$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $0889ca3987661a8e$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $0889ca3987661a8e$export$e759a9a7f8d04692().concat,
        empty: $0889ca3987661a8e$var$empty
    };
};
var $0889ca3987661a8e$export$def901a57d5539c3 = {
    URI: $0889ca3987661a8e$export$9156e739aa33e19f,
    contramap: $0889ca3987661a8e$var$contramap_
};
var $0889ca3987661a8e$export$1a50cb133a346493 = $0889ca3987661a8e$export$65e3907585753458;
var $0889ca3987661a8e$export$b35b2bde1875587a = $0889ca3987661a8e$export$8cf3da7c1c9174ea;
var $0889ca3987661a8e$export$24d177074f8dc6ef = $0889ca3987661a8e$export$37a88d8211c10fd3.equals;
var $0889ca3987661a8e$export$9663ddc1cf085b32 = $0889ca3987661a8e$export$def901a57d5539c3;
var $0889ca3987661a8e$export$d7927e8ffc1afb48 = $0889ca3987661a8e$export$37a88d8211c10fd3;
var $0889ca3987661a8e$export$fa624555ca2acbc8 = $0889ca3987661a8e$export$37a88d8211c10fd3;
var $0889ca3987661a8e$export$e24978670be1e4f3 = $0889ca3987661a8e$export$37a88d8211c10fd3;
var $0889ca3987661a8e$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};

});


parcelRegister("6ANlS", function(module, exports) {

$parcel$export(module.exports, "empty", () => $4ccc63221d3468eb$export$6e22c362a0406a2c);
$parcel$export(module.exports, "isNonEmpty", () => $4ccc63221d3468eb$export$a978c53b4062a525);
$parcel$export(module.exports, "isOutOfBound", () => $4ccc63221d3468eb$export$2fde0b1c54fc39b9);
$parcel$export(module.exports, "prependW", () => $4ccc63221d3468eb$export$c4c4d41eab625797);
$parcel$export(module.exports, "prepend", () => $4ccc63221d3468eb$export$68159836694e22c1);
$parcel$export(module.exports, "appendW", () => $4ccc63221d3468eb$export$19903a1bf1942f6);
$parcel$export(module.exports, "append", () => $4ccc63221d3468eb$export$10d8903dec122b9d);
$parcel$export(module.exports, "unsafeInsertAt", () => $4ccc63221d3468eb$export$f4863e1822a1860c);
$parcel$export(module.exports, "unsafeUpdateAt", () => $4ccc63221d3468eb$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "uniq", () => $4ccc63221d3468eb$export$f70730c3d1fc524e);
$parcel$export(module.exports, "head", () => $4ccc63221d3468eb$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tail", () => $4ccc63221d3468eb$export$c01875f616615628);
$parcel$export(module.exports, "sortBy", () => $4ccc63221d3468eb$export$b035e44d7bb4278f);
$parcel$export(module.exports, "union", () => $4ccc63221d3468eb$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "rotate", () => $4ccc63221d3468eb$export$bb628a54ab399bc9);
$parcel$export(module.exports, "splitAt", () => $4ccc63221d3468eb$export$b0d75975ac0be0e1);
$parcel$export(module.exports, "makeBy", () => $4ccc63221d3468eb$export$849fbdcc2211fcde);
$parcel$export(module.exports, "range", () => $4ccc63221d3468eb$export$d02631cccf789723);
$parcel$export(module.exports, "init", () => $4ccc63221d3468eb$export$2cd8252107eb640b);
$parcel$export(module.exports, "last", () => $4ccc63221d3468eb$export$4c7897fafd92b108);
$parcel$export(module.exports, "prependAll", () => $4ccc63221d3468eb$export$849c7567cbd62acc);
$parcel$export(module.exports, "intersperse", () => $4ccc63221d3468eb$export$af200dcf8b7cb5de);
$parcel$export(module.exports, "chop", () => $4ccc63221d3468eb$export$433fe05b12ba833f);
$parcel$export(module.exports, "chunksOf", () => $4ccc63221d3468eb$export$2f0184d5df52135f);
$parcel$export(module.exports, "reduce", () => $4ccc63221d3468eb$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $4ccc63221d3468eb$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $4ccc63221d3468eb$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $4ccc63221d3468eb$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $4ccc63221d3468eb$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $4ccc63221d3468eb$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "of", () => $4ccc63221d3468eb$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $4ccc63221d3468eb$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getEq", () => $4ccc63221d3468eb$export$804fed467fde44e4);
$parcel$export(module.exports, "min", () => $4ccc63221d3468eb$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $4ccc63221d3468eb$export$8960430cfd85939f);
$parcel$export(module.exports, "concatAll", () => $4ccc63221d3468eb$export$b314777ae20abca9);
$parcel$export(module.exports, "intercalate", () => $4ccc63221d3468eb$export$739ec22334c44788);
$parcel$export(module.exports, "cons", () => $4ccc63221d3468eb$export$8327ebbef2a0ba76);
$parcel$export(module.exports, "snoc", () => $4ccc63221d3468eb$export$c40cf5aab899f397);

var $kf9cS = parcelRequire("kf9cS");

var $fl2uO = parcelRequire("fl2uO");

var $JrPqh = parcelRequire("JrPqh");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $6ZOPp = parcelRequire("6ZOPp");

var $gKa7k = parcelRequire("gKa7k");
var $4ccc63221d3468eb$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4ccc63221d3468eb$export$6e22c362a0406a2c = $jc2nG.emptyReadonlyArray;
var $4ccc63221d3468eb$export$a978c53b4062a525 = $jc2nG.isNonEmpty;
var $4ccc63221d3468eb$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $4ccc63221d3468eb$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $4ccc63221d3468eb$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $4ccc63221d3468eb$export$68159836694e22c1 = $4ccc63221d3468eb$export$c4c4d41eab625797;
var $4ccc63221d3468eb$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $4ccc63221d3468eb$var$__spreadArray($4ccc63221d3468eb$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $4ccc63221d3468eb$export$10d8903dec122b9d = $4ccc63221d3468eb$export$19903a1bf1942f6;
var $4ccc63221d3468eb$export$f4863e1822a1860c = function(i, a, as) {
    if ($4ccc63221d3468eb$export$a978c53b4062a525(as)) {
        var xs = $jc2nG.fromReadonlyNonEmptyArray(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $4ccc63221d3468eb$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $jc2nG.fromReadonlyNonEmptyArray(as);
        xs[i] = a;
        return xs;
    }
};
var $4ccc63221d3468eb$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $4ccc63221d3468eb$export$5fd5031fecdacec3(as)
        ];
        var rest = $4ccc63221d3468eb$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $4ccc63221d3468eb$export$b035e44d7bb4278f = function(ords) {
    if ($4ccc63221d3468eb$export$a978c53b4062a525(ords)) {
        var M = (0, $6ZOPp.getMonoid)();
        return $4ccc63221d3468eb$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $6owmV.identity;
};
var $4ccc63221d3468eb$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $4ccc63221d3468eb$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $6owmV.pipe)(first, $4ccc63221d3468eb$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $4ccc63221d3468eb$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($4ccc63221d3468eb$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $4ccc63221d3468eb$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $6owmV.pipe)(s, $4ccc63221d3468eb$export$ee1b3e54f0441b22(f));
        } else return $4ccc63221d3468eb$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $4ccc63221d3468eb$export$9288e031f1846591 = function(as) {
    return $4ccc63221d3468eb$export$a978c53b4062a525(as) ? $jc2nG.some(as) : $jc2nG.none;
};
var $4ccc63221d3468eb$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $4ccc63221d3468eb$export$606959e7ccb797f0 = function(a) {
    return $4ccc63221d3468eb$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $4ccc63221d3468eb$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $4ccc63221d3468eb$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $4ccc63221d3468eb$export$c04edabe9c8d994f = function(as) {
    return [
        $4ccc63221d3468eb$export$5fd5031fecdacec3(as),
        $4ccc63221d3468eb$export$c01875f616615628(as)
    ];
};
var $4ccc63221d3468eb$export$89a97afc72a83708 = function(as) {
    return [
        $4ccc63221d3468eb$export$2cd8252107eb640b(as),
        $4ccc63221d3468eb$export$4c7897fafd92b108(as)
    ];
};
var $4ccc63221d3468eb$export$571d59b505e6bb4e = function(as) {
    return $4ccc63221d3468eb$export$9288e031f1846591(as.slice());
};
function $4ccc63221d3468eb$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $4ccc63221d3468eb$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $4ccc63221d3468eb$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $4ccc63221d3468eb$var$__spreadArray([
        $4ccc63221d3468eb$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $4ccc63221d3468eb$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $4ccc63221d3468eb$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $4ccc63221d3468eb$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($jc2nG.has.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $4ccc63221d3468eb$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $4ccc63221d3468eb$export$b6d8713d53419d4c = function(i, a) {
    return $4ccc63221d3468eb$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $4ccc63221d3468eb$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $4ccc63221d3468eb$export$2fde0b1c54fc39b9(i, as) ? $jc2nG.none : $jc2nG.some($4ccc63221d3468eb$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $4ccc63221d3468eb$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $4ccc63221d3468eb$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $4ccc63221d3468eb$export$8901015135f2fb22(bs, as);
    };
    return $4ccc63221d3468eb$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $4ccc63221d3468eb$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $4ccc63221d3468eb$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $4ccc63221d3468eb$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $4ccc63221d3468eb$export$c01875f616615628(as);
        return $4ccc63221d3468eb$export$a978c53b4062a525(rest) ? (0, $6owmV.pipe)(rest, $4ccc63221d3468eb$export$849c7567cbd62acc(middle), $4ccc63221d3468eb$export$68159836694e22c1($4ccc63221d3468eb$export$5fd5031fecdacec3(as))) : as;
    };
};
var $4ccc63221d3468eb$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $jc2nG.fromReadonlyNonEmptyArray(f(0, $4ccc63221d3468eb$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $4ccc63221d3468eb$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($4ccc63221d3468eb$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $4ccc63221d3468eb$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $4ccc63221d3468eb$export$6e22c362a0406a2c
        ] : [
            (0, $6owmV.pipe)(as.slice(1, m), $4ccc63221d3468eb$export$68159836694e22c1($4ccc63221d3468eb$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $4ccc63221d3468eb$export$2f0184d5df52135f = function(n) {
    return $4ccc63221d3468eb$export$433fe05b12ba833f($4ccc63221d3468eb$export$b0d75975ac0be0e1(n));
};
var $4ccc63221d3468eb$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $4ccc63221d3468eb$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_mapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $4ccc63221d3468eb$export$8f07ddce13659f50(f));
};
var $4ccc63221d3468eb$var$_ap = function(fab, fa) {
    return (0, $6owmV.pipe)(fab, $4ccc63221d3468eb$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_extend = function(wa, f) {
    return (0, $6owmV.pipe)(wa, $4ccc63221d3468eb$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_reduce = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $4ccc63221d3468eb$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_foldMap = function(M) {
    var foldMapM = $4ccc63221d3468eb$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_reduceRight = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $4ccc63221d3468eb$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_traverse = function(F) {
    var traverseF = $4ccc63221d3468eb$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_alt = function(fa, that) {
    return (0, $6owmV.pipe)(fa, $4ccc63221d3468eb$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $4ccc63221d3468eb$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $4ccc63221d3468eb$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $4ccc63221d3468eb$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $4ccc63221d3468eb$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $4ccc63221d3468eb$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseWithIndexF(f));
    };
};
var $4ccc63221d3468eb$export$ba255e9e49e00608 = $jc2nG.singleton;
var $4ccc63221d3468eb$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $6owmV.pipe)(as, $4ccc63221d3468eb$export$c8c959650bbe80e2(that()));
    };
};
var $4ccc63221d3468eb$export$228be17d80722ab = $4ccc63221d3468eb$export$1517cca7889d6aaa;
var $4ccc63221d3468eb$export$2f6ca3d3b1f80bf5 = function(as) {
    return $4ccc63221d3468eb$export$5b8affa63fc6df16(function(f) {
        return (0, $6owmV.pipe)(as, $4ccc63221d3468eb$export$871de8747c9eaa88(f));
    });
};
var $4ccc63221d3468eb$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $6owmV.dual)(2, function(ma, f) {
    return (0, $6owmV.pipe)(ma, $4ccc63221d3468eb$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $4ccc63221d3468eb$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $4ccc63221d3468eb$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($4ccc63221d3468eb$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $4ccc63221d3468eb$export$c01875f616615628(next);
        }
        return out;
    };
};
var $4ccc63221d3468eb$export$ecd5e8ace626722c = /*#__PURE__*/ $4ccc63221d3468eb$export$8b58be045bf06082((0, $6owmV.identity));
var $4ccc63221d3468eb$export$bffa455ba8c619a6 = /*#__PURE__*/ $4ccc63221d3468eb$export$5b8affa63fc6df16((0, $6owmV.identity));
var $4ccc63221d3468eb$export$871de8747c9eaa88 = function(f) {
    return $4ccc63221d3468eb$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $4ccc63221d3468eb$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $4ccc63221d3468eb$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $4ccc63221d3468eb$export$533b26079ad0b4b = function(b, f) {
    return $4ccc63221d3468eb$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $4ccc63221d3468eb$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $4ccc63221d3468eb$export$7fef8bcdbb34f435 = function(b, f) {
    return $4ccc63221d3468eb$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $4ccc63221d3468eb$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $4ccc63221d3468eb$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $4ccc63221d3468eb$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $4ccc63221d3468eb$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $4ccc63221d3468eb$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $4ccc63221d3468eb$export$49bb65c2ea163039 = function(F) {
    return $4ccc63221d3468eb$export$955fdc0d24efa249(F)((0, $6owmV.SK));
};
var $4ccc63221d3468eb$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $4ccc63221d3468eb$export$5fd5031fecdacec3(as)), $4ccc63221d3468eb$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $6owmV.pipe)(bs, $4ccc63221d3468eb$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $4ccc63221d3468eb$export$f9380c9a627682d3 = $jc2nG.head;
var $4ccc63221d3468eb$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $4ccc63221d3468eb$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $4ccc63221d3468eb$export$e759a9a7f8d04692 = function() {
    return {
        concat: $4ccc63221d3468eb$export$ee1b3e54f0441b22
    };
};
var $4ccc63221d3468eb$export$804fed467fde44e4 = function(E) {
    return (0, $JrPqh.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $4ccc63221d3468eb$export$baca17b4aff42f82 = function(E) {
    var unionE = $4ccc63221d3468eb$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $4ccc63221d3468eb$export$bd5b6bfc5fa2ee61 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map
};
var $4ccc63221d3468eb$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($4ccc63221d3468eb$export$bd5b6bfc5fa2ee61);
var $4ccc63221d3468eb$export$59a71046037e6c20 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    of: $4ccc63221d3468eb$export$ba255e9e49e00608
};
var $4ccc63221d3468eb$export$9fdffe0fe1e91cad = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    mapWithIndex: $4ccc63221d3468eb$var$_mapWithIndex
};
var $4ccc63221d3468eb$export$efc21ddc6aeb363d = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    ap: $4ccc63221d3468eb$var$_ap
};
var $4ccc63221d3468eb$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $kf9cS.apFirst)($4ccc63221d3468eb$export$efc21ddc6aeb363d);
var $4ccc63221d3468eb$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $kf9cS.apSecond)($4ccc63221d3468eb$export$efc21ddc6aeb363d);
var $4ccc63221d3468eb$export$1279d2b7807629fd = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    ap: $4ccc63221d3468eb$var$_ap,
    of: $4ccc63221d3468eb$export$ba255e9e49e00608
};
var $4ccc63221d3468eb$export$f18d5acc27d70423 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    ap: $4ccc63221d3468eb$var$_ap,
    chain: $4ccc63221d3468eb$export$5b8affa63fc6df16
};
var $4ccc63221d3468eb$export$e3821ef4970c339c = /*#__PURE__*/ (0, $fl2uO.chainFirst)($4ccc63221d3468eb$export$f18d5acc27d70423);
var $4ccc63221d3468eb$export$fb641926d034ac7d = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    ap: $4ccc63221d3468eb$var$_ap,
    of: $4ccc63221d3468eb$export$ba255e9e49e00608,
    chain: $4ccc63221d3468eb$export$5b8affa63fc6df16
};
var $4ccc63221d3468eb$export$41404b31838667c9 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    reduce: $4ccc63221d3468eb$var$_reduce,
    foldMap: $4ccc63221d3468eb$var$_foldMap,
    reduceRight: $4ccc63221d3468eb$var$_reduceRight
};
var $4ccc63221d3468eb$export$e8f7d17aaff345cb = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    reduce: $4ccc63221d3468eb$var$_reduce,
    foldMap: $4ccc63221d3468eb$var$_foldMap,
    reduceRight: $4ccc63221d3468eb$var$_reduceRight,
    reduceWithIndex: $4ccc63221d3468eb$var$_reduceWithIndex,
    foldMapWithIndex: $4ccc63221d3468eb$var$_foldMapWithIndex,
    reduceRightWithIndex: $4ccc63221d3468eb$var$_reduceRightWithIndex
};
var $4ccc63221d3468eb$export$a0202666c3bda011 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    reduce: $4ccc63221d3468eb$var$_reduce,
    foldMap: $4ccc63221d3468eb$var$_foldMap,
    reduceRight: $4ccc63221d3468eb$var$_reduceRight,
    traverse: $4ccc63221d3468eb$var$_traverse,
    sequence: $4ccc63221d3468eb$export$49bb65c2ea163039
};
var $4ccc63221d3468eb$export$bd7b528d8c36ec41 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    mapWithIndex: $4ccc63221d3468eb$var$_mapWithIndex,
    reduce: $4ccc63221d3468eb$var$_reduce,
    foldMap: $4ccc63221d3468eb$var$_foldMap,
    reduceRight: $4ccc63221d3468eb$var$_reduceRight,
    traverse: $4ccc63221d3468eb$var$_traverse,
    sequence: $4ccc63221d3468eb$export$49bb65c2ea163039,
    reduceWithIndex: $4ccc63221d3468eb$var$_reduceWithIndex,
    foldMapWithIndex: $4ccc63221d3468eb$var$_foldMapWithIndex,
    reduceRightWithIndex: $4ccc63221d3468eb$var$_reduceRightWithIndex,
    traverseWithIndex: $4ccc63221d3468eb$var$_traverseWithIndex
};
var $4ccc63221d3468eb$export$25ba4469a069167 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    alt: $4ccc63221d3468eb$var$_alt
};
var $4ccc63221d3468eb$export$fdd73124b9f1de36 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    map: $4ccc63221d3468eb$var$_map,
    extend: $4ccc63221d3468eb$var$_extend,
    extract: $4ccc63221d3468eb$export$f9380c9a627682d3
};
var $4ccc63221d3468eb$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $4ccc63221d3468eb$export$ba255e9e49e00608($jc2nG.emptyRecord);
var $4ccc63221d3468eb$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $aFZgk.bindTo)($4ccc63221d3468eb$export$bd5b6bfc5fa2ee61);
var $4ccc63221d3468eb$export$5d537b797c421217 = /*#__PURE__*/ (0, $aFZgk.let)($4ccc63221d3468eb$export$bd5b6bfc5fa2ee61);
var $4ccc63221d3468eb$export$2385a24977818dd0 = /*#__PURE__*/ (0, $fl2uO.bind)($4ccc63221d3468eb$export$f18d5acc27d70423);
var $4ccc63221d3468eb$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $kf9cS.apS)($4ccc63221d3468eb$export$efc21ddc6aeb363d);
var $4ccc63221d3468eb$export$5fd5031fecdacec3 = $4ccc63221d3468eb$export$f9380c9a627682d3;
var $4ccc63221d3468eb$export$c01875f616615628 = $jc2nG.tail;
var $4ccc63221d3468eb$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $4ccc63221d3468eb$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $4ccc63221d3468eb$export$96ec731ed4dcb222 = function(O) {
    var S = $gKa7k.min(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $4ccc63221d3468eb$export$8960430cfd85939f = function(O) {
    var S = $gKa7k.max(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $4ccc63221d3468eb$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $4ccc63221d3468eb$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($4ccc63221d3468eb$export$5fd5031fecdacec3(as), $4ccc63221d3468eb$export$c01875f616615628(as));
    };
};
var $4ccc63221d3468eb$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($4ccc63221d3468eb$export$2cd8252107eb640b(as), $4ccc63221d3468eb$export$4c7897fafd92b108(as));
    };
};
var $4ccc63221d3468eb$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $4ccc63221d3468eb$var$__spreadArray([
            f($4ccc63221d3468eb$export$5fd5031fecdacec3(as))
        ], $4ccc63221d3468eb$export$c01875f616615628(as), true);
    };
};
var $4ccc63221d3468eb$export$20ca6ad9f7762931 = function(a) {
    return $4ccc63221d3468eb$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $4ccc63221d3468eb$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $6owmV.pipe)($4ccc63221d3468eb$export$2cd8252107eb640b(as), $4ccc63221d3468eb$export$10d8903dec122b9d(f($4ccc63221d3468eb$export$4c7897fafd92b108(as))));
    };
};
var $4ccc63221d3468eb$export$d3affa0a0a83d946 = function(a) {
    return $4ccc63221d3468eb$export$302ad361c463800a(function() {
        return a;
    });
};
var $4ccc63221d3468eb$export$739ec22334c44788 = function(S) {
    var concatAllS = $4ccc63221d3468eb$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $6owmV.flow)($4ccc63221d3468eb$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $4ccc63221d3468eb$export$e08e3b67e392101e = $4ccc63221d3468eb$export$5b8affa63fc6df16;
function $4ccc63221d3468eb$export$103ce2c0a67e4e61(O) {
    var sortO = $4ccc63221d3468eb$export$97db5808d8f88186(O);
    var groupO = $4ccc63221d3468eb$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $4ccc63221d3468eb$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $4ccc63221d3468eb$export$6e22c362a0406a2c;
    };
}
function $4ccc63221d3468eb$export$3dea766d36a8935f(predicate) {
    return $4ccc63221d3468eb$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $4ccc63221d3468eb$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $4ccc63221d3468eb$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $4ccc63221d3468eb$export$b446f6baa3bb1430 = $4ccc63221d3468eb$export$c04edabe9c8d994f;
var $4ccc63221d3468eb$export$712962e076096ed4 = $4ccc63221d3468eb$export$89a97afc72a83708;
function $4ccc63221d3468eb$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $4ccc63221d3468eb$export$68159836694e22c1(head) : (0, $6owmV.pipe)(tail, $4ccc63221d3468eb$export$68159836694e22c1(head));
}
var $4ccc63221d3468eb$export$c40cf5aab899f397 = function(init, end) {
    return (0, $6owmV.pipe)(init, $4ccc63221d3468eb$export$ee1b3e54f0441b22([
        end
    ]));
};
var $4ccc63221d3468eb$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $jc2nG.none : $jc2nG.some($4ccc63221d3468eb$export$f4863e1822a1860c(i, a, as));
    };
};
var $4ccc63221d3468eb$export$baeb00bf1e27e233 = $4ccc63221d3468eb$export$849c7567cbd62acc;
var $4ccc63221d3468eb$export$93e2b83da34ff82a = $4ccc63221d3468eb$export$b314777ae20abca9;
var $4ccc63221d3468eb$export$3c6c57333e3dca24 = {
    URI: $4ccc63221d3468eb$export$9156e739aa33e19f,
    of: $4ccc63221d3468eb$export$ba255e9e49e00608,
    map: $4ccc63221d3468eb$var$_map,
    mapWithIndex: $4ccc63221d3468eb$var$_mapWithIndex,
    ap: $4ccc63221d3468eb$var$_ap,
    chain: $4ccc63221d3468eb$export$5b8affa63fc6df16,
    extend: $4ccc63221d3468eb$var$_extend,
    extract: $4ccc63221d3468eb$export$f9380c9a627682d3,
    reduce: $4ccc63221d3468eb$var$_reduce,
    foldMap: $4ccc63221d3468eb$var$_foldMap,
    reduceRight: $4ccc63221d3468eb$var$_reduceRight,
    traverse: $4ccc63221d3468eb$var$_traverse,
    sequence: $4ccc63221d3468eb$export$49bb65c2ea163039,
    reduceWithIndex: $4ccc63221d3468eb$var$_reduceWithIndex,
    foldMapWithIndex: $4ccc63221d3468eb$var$_foldMapWithIndex,
    reduceRightWithIndex: $4ccc63221d3468eb$var$_reduceRightWithIndex,
    traverseWithIndex: $4ccc63221d3468eb$var$_traverseWithIndex,
    alt: $4ccc63221d3468eb$var$_alt
};

});
parcelRegister("gKa7k", function(module, exports) {

$parcel$export(module.exports, "min", () => $c308ca4f21045854$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $c308ca4f21045854$export$8960430cfd85939f);
$parcel$export(module.exports, "constant", () => $c308ca4f21045854$export$c983f826f44ff86);
$parcel$export(module.exports, "reverse", () => $c308ca4f21045854$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "struct", () => $c308ca4f21045854$export$8cf3da7c1c9174ea);
$parcel$export(module.exports, "tuple", () => $c308ca4f21045854$export$65e3907585753458);
$parcel$export(module.exports, "intercalate", () => $c308ca4f21045854$export$739ec22334c44788);
$parcel$export(module.exports, "first", () => $c308ca4f21045854$export$43128fadae87b74a);
$parcel$export(module.exports, "last", () => $c308ca4f21045854$export$4c7897fafd92b108);
$parcel$export(module.exports, "concatAll", () => $c308ca4f21045854$export$b314777ae20abca9);
$parcel$export(module.exports, "semigroupVoid", () => $c308ca4f21045854$export$36aabcd6b6e45f3b);
$parcel$export(module.exports, "getObjectSemigroup", () => $c308ca4f21045854$export$2f965793fef2fb8a);
$parcel$export(module.exports, "getLastSemigroup", () => $c308ca4f21045854$export$edb0acd3f464ffc5);
$parcel$export(module.exports, "getFirstSemigroup", () => $c308ca4f21045854$export$84a57d7a8bf6c3ea);
$parcel$export(module.exports, "getTupleSemigroup", () => $c308ca4f21045854$export$bd94daf2735ef9c);
$parcel$export(module.exports, "getStructSemigroup", () => $c308ca4f21045854$export$98d1814f8ed74e13);
$parcel$export(module.exports, "getDualSemigroup", () => $c308ca4f21045854$export$e0cea6c43ec66a1);
$parcel$export(module.exports, "getJoinSemigroup", () => $c308ca4f21045854$export$4278e54cd9769e6d);
$parcel$export(module.exports, "getMeetSemigroup", () => $c308ca4f21045854$export$7baccd77d16d1a41);
$parcel$export(module.exports, "getIntercalateSemigroup", () => $c308ca4f21045854$export$fcc2cca196b2daf0);
$parcel$export(module.exports, "fold", () => $c308ca4f21045854$export$93e2b83da34ff82a);
$parcel$export(module.exports, "semigroupAll", () => $c308ca4f21045854$export$e8f9875ab703bdff);
$parcel$export(module.exports, "semigroupAny", () => $c308ca4f21045854$export$9511aba5be5ac81b);
$parcel$export(module.exports, "getFunctionSemigroup", () => $c308ca4f21045854$export$b2ecf5de014857c2);
$parcel$export(module.exports, "semigroupString", () => $c308ca4f21045854$export$d9b7100b101f2c5b);
$parcel$export(module.exports, "semigroupSum", () => $c308ca4f21045854$export$1481126044ad2de0);
$parcel$export(module.exports, "semigroupProduct", () => $c308ca4f21045854$export$a22a2283cc3aa839);
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 
var $6owmV = parcelRequire("6owmV");

var $jc2nG = parcelRequire("jc2nG");

var $batAm = parcelRequire("batAm");

var $6ZOPp = parcelRequire("6ZOPp");
var $c308ca4f21045854$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $6ZOPp.min(O)
    };
};
var $c308ca4f21045854$export$8960430cfd85939f = function(O) {
    return {
        concat: $6ZOPp.max(O)
    };
};
var $c308ca4f21045854$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $c308ca4f21045854$export$66c1ae025e96b4bc = $batAm.reverse;
var $c308ca4f21045854$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($jc2nG.has.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $c308ca4f21045854$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $c308ca4f21045854$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $c308ca4f21045854$export$43128fadae87b74a = function() {
    return {
        concat: (0, $6owmV.identity)
    };
};
var $c308ca4f21045854$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $c308ca4f21045854$export$b314777ae20abca9 = $batAm.concatAll;
var $c308ca4f21045854$export$36aabcd6b6e45f3b = $c308ca4f21045854$export$c983f826f44ff86(undefined);
var $c308ca4f21045854$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $c308ca4f21045854$export$edb0acd3f464ffc5 = $c308ca4f21045854$export$4c7897fafd92b108;
var $c308ca4f21045854$export$84a57d7a8bf6c3ea = $c308ca4f21045854$export$43128fadae87b74a;
var $c308ca4f21045854$export$bd94daf2735ef9c = $c308ca4f21045854$export$65e3907585753458;
var $c308ca4f21045854$export$98d1814f8ed74e13 = $c308ca4f21045854$export$8cf3da7c1c9174ea;
var $c308ca4f21045854$export$e0cea6c43ec66a1 = $c308ca4f21045854$export$66c1ae025e96b4bc;
var $c308ca4f21045854$export$4278e54cd9769e6d = $c308ca4f21045854$export$8960430cfd85939f;
var $c308ca4f21045854$export$7baccd77d16d1a41 = $c308ca4f21045854$export$96ec731ed4dcb222;
var $c308ca4f21045854$export$fcc2cca196b2daf0 = $c308ca4f21045854$export$739ec22334c44788;
function $c308ca4f21045854$export$93e2b83da34ff82a(S) {
    var concatAllS = $c308ca4f21045854$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $c308ca4f21045854$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $c308ca4f21045854$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $c308ca4f21045854$export$b2ecf5de014857c2 = (0, $6owmV.getSemigroup);
var $c308ca4f21045854$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $c308ca4f21045854$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $c308ca4f21045854$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};

});
parcelRegister("batAm", function(module, exports) {

$parcel$export(module.exports, "reverse", () => $821793f1534d58e9$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "concatAll", () => $821793f1534d58e9$export$b314777ae20abca9);
/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $821793f1534d58e9$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $821793f1534d58e9$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $821793f1534d58e9$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $821793f1534d58e9$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $821793f1534d58e9$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};

});




parcelRegister("8D8qW", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $648881fc62e7d708$export$dfc7155ac0343b8);
$parcel$export(module.exports, "head", () => $648881fc62e7d708$export$5fd5031fecdacec3);
$parcel$export(module.exports, "last", () => $648881fc62e7d708$export$4c7897fafd92b108);
$parcel$export(module.exports, "findIndex", () => $648881fc62e7d708$export$de3a4d4a0d731119);
$parcel$export(module.exports, "findFirst", () => $648881fc62e7d708$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstMap", () => $648881fc62e7d708$export$a86c11c94d794a95);
$parcel$export(module.exports, "findLast", () => $648881fc62e7d708$export$296de88ccac4bedb);
$parcel$export(module.exports, "findLastMap", () => $648881fc62e7d708$export$8b5e6d6ad82284fa);
$parcel$export(module.exports, "findLastIndex", () => $648881fc62e7d708$export$8855a8be7bd3e9f8);
$parcel$export(module.exports, "unsafeUpdateAt", () => $648881fc62e7d708$export$9c0c6889b1fa9bfc);
$parcel$export(module.exports, "elem", () => $648881fc62e7d708$export$5bf96401662340b7);
$parcel$export(module.exports, "reduce", () => $648881fc62e7d708$export$533b26079ad0b4b);
$parcel$export(module.exports, "foldMap", () => $648881fc62e7d708$export$b66cdc0497d8a99a);
$parcel$export(module.exports, "reduceRight", () => $648881fc62e7d708$export$7fef8bcdbb34f435);
$parcel$export(module.exports, "reduceWithIndex", () => $648881fc62e7d708$export$bbd3ef8720e22369);
$parcel$export(module.exports, "foldMapWithIndex", () => $648881fc62e7d708$export$18153bb1181268e5);
$parcel$export(module.exports, "reduceRightWithIndex", () => $648881fc62e7d708$export$ce2b2fe0b88ccd0a);
$parcel$export(module.exports, "_chainRecDepthFirst", () => $648881fc62e7d708$export$c5c44f872d8af73);
$parcel$export(module.exports, "chainRecDepthFirst", () => $648881fc62e7d708$export$f855115a79f70c1a);
$parcel$export(module.exports, "_chainRecBreadthFirst", () => $648881fc62e7d708$export$b9909b62ceeab991);
$parcel$export(module.exports, "chainRecBreadthFirst", () => $648881fc62e7d708$export$bffee57bb00a6859);
$parcel$export(module.exports, "of", () => $648881fc62e7d708$export$ba255e9e49e00608);
$parcel$export(module.exports, "getShow", () => $648881fc62e7d708$export$3cb5cd7f7776c81);
$parcel$export(module.exports, "getMonoid", () => $648881fc62e7d708$export$c2a7ef2cc9b32b31);
$parcel$export(module.exports, "getEq", () => $648881fc62e7d708$export$804fed467fde44e4);
$parcel$export(module.exports, "getOrd", () => $648881fc62e7d708$export$1af51209b1b91d07);
$parcel$export(module.exports, "every", () => $648881fc62e7d708$export$7ecc1a3b11b57dab);
$parcel$export(module.exports, "intercalate", () => $648881fc62e7d708$export$739ec22334c44788);

var $kf9cS = parcelRequire("kf9cS");

var $fl2uO = parcelRequire("fl2uO");

var $JrPqh = parcelRequire("JrPqh");

var $5tUZ7 = parcelRequire("5tUZ7");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $bTheZ = parcelRequire("bTheZ");

var $6ZOPp = parcelRequire("6ZOPp");

var $6ANlS = parcelRequire("6ANlS");

var $iCI6U = parcelRequire("iCI6U");

var $ciQV6 = parcelRequire("ciQV6");

var $bLjkL = parcelRequire("bLjkL");
var $648881fc62e7d708$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $648881fc62e7d708$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $648881fc62e7d708$export$a978c53b4062a525 = $6ANlS.isNonEmpty;
var $648881fc62e7d708$export$68159836694e22c1 = $6ANlS.prepend;
var $648881fc62e7d708$export$c4c4d41eab625797 = $6ANlS.prependW;
var $648881fc62e7d708$export$10d8903dec122b9d = $6ANlS.append;
var $648881fc62e7d708$export$19903a1bf1942f6 = $6ANlS.appendW;
var $648881fc62e7d708$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $648881fc62e7d708$export$6e22c362a0406a2c : $6ANlS.makeBy(f)(n);
};
var $648881fc62e7d708$export$606959e7ccb797f0 = function(n, a) {
    return $648881fc62e7d708$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $648881fc62e7d708$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $648881fc62e7d708$export$6e22c362a0406a2c;
    };
}
var $648881fc62e7d708$export$172ec0a6ebfeb6fa = function(ma) {
    return $jc2nG.isNone(ma) ? $648881fc62e7d708$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $648881fc62e7d708$export$80c878c9b1d77917 = function(e) {
    return $jc2nG.isLeft(e) ? $648881fc62e7d708$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $648881fc62e7d708$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $648881fc62e7d708$export$4659b591c19bdf3d = $648881fc62e7d708$export$2d55ea551c238330;
var $648881fc62e7d708$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? onNonEmpty($6ANlS.head(as), $6ANlS.tail(as)) : onEmpty();
    };
};
var $648881fc62e7d708$export$6280271dfaec4919 = $648881fc62e7d708$export$ebbe93aa91e3abdc;
var $648881fc62e7d708$export$f3163a37d0ef5927 = $648881fc62e7d708$export$6280271dfaec4919;
var $648881fc62e7d708$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? onNonEmpty($6ANlS.init(as), $6ANlS.last(as)) : onEmpty();
    };
};
var $648881fc62e7d708$export$b1cacb83a5c6bd02 = $648881fc62e7d708$export$364f7f2cc8473008;
var $648881fc62e7d708$export$77fa89c00b331c4c = $648881fc62e7d708$export$b1cacb83a5c6bd02;
var $648881fc62e7d708$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($648881fc62e7d708$export$dd1bc94b04021eeb(as)) return $648881fc62e7d708$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $648881fc62e7d708$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $648881fc62e7d708$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $648881fc62e7d708$export$346677f925de839c = function(as) {
    return as.length;
};
var $648881fc62e7d708$export$2fde0b1c54fc39b9 = $6ANlS.isOutOfBound;
function $648881fc62e7d708$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $648881fc62e7d708$export$dfc7155ac0343b8(i, as);
    } : $648881fc62e7d708$export$2fde0b1c54fc39b9(i, as) ? $jc2nG.none : $jc2nG.some(as[i]);
}
var $648881fc62e7d708$export$5fd5031fecdacec3 = function(as) {
    return $648881fc62e7d708$export$a978c53b4062a525(as) ? $jc2nG.some($6ANlS.head(as)) : $jc2nG.none;
};
var $648881fc62e7d708$export$4c7897fafd92b108 = function(as) {
    return $648881fc62e7d708$export$a978c53b4062a525(as) ? $jc2nG.some($6ANlS.last(as)) : $jc2nG.none;
};
var $648881fc62e7d708$export$c01875f616615628 = function(as) {
    return $648881fc62e7d708$export$a978c53b4062a525(as) ? $jc2nG.some($6ANlS.tail(as)) : $jc2nG.none;
};
var $648881fc62e7d708$export$2cd8252107eb640b = function(as) {
    return $648881fc62e7d708$export$a978c53b4062a525(as) ? $jc2nG.some($6ANlS.init(as)) : $jc2nG.none;
};
var $648881fc62e7d708$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $648881fc62e7d708$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $648881fc62e7d708$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $648881fc62e7d708$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $648881fc62e7d708$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $648881fc62e7d708$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $648881fc62e7d708$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $648881fc62e7d708$export$6e22c362a0406a2c : out;
    };
}
var $648881fc62e7d708$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $648881fc62e7d708$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $648881fc62e7d708$export$b0d75975ac0be0e1($648881fc62e7d708$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $648881fc62e7d708$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $648881fc62e7d708$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $648881fc62e7d708$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $648881fc62e7d708$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $648881fc62e7d708$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $648881fc62e7d708$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $648881fc62e7d708$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $648881fc62e7d708$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $648881fc62e7d708$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $648881fc62e7d708$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $jc2nG.some(i);
        }
        return $jc2nG.none;
    };
};
function $648881fc62e7d708$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $jc2nG.some(as[i]);
        }
        return $jc2nG.none;
    };
}
var $648881fc62e7d708$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($jc2nG.isSome(out)) return out;
        }
        return $jc2nG.none;
    };
};
function $648881fc62e7d708$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $jc2nG.some(as[i]);
        }
        return $jc2nG.none;
    };
}
var $648881fc62e7d708$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($jc2nG.isSome(out)) return out;
        }
        return $jc2nG.none;
    };
};
var $648881fc62e7d708$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $jc2nG.some(i);
        }
        return $jc2nG.none;
    };
};
var $648881fc62e7d708$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $jc2nG.none : $jc2nG.some($6ANlS.unsafeInsertAt(i, a, as));
    };
};
var $648881fc62e7d708$export$b6d8713d53419d4c = function(i, a) {
    return $648881fc62e7d708$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $648881fc62e7d708$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $648881fc62e7d708$export$2fde0b1c54fc39b9(i, as) ? $jc2nG.none : $jc2nG.some($648881fc62e7d708$export$4937fde8dfc38dbd(i, as));
    };
};
var $648881fc62e7d708$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $648881fc62e7d708$export$2fde0b1c54fc39b9(i, as) ? $jc2nG.none : $jc2nG.some($648881fc62e7d708$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $648881fc62e7d708$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $648881fc62e7d708$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $648881fc62e7d708$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $648881fc62e7d708$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $648881fc62e7d708$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $648881fc62e7d708$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $648881fc62e7d708$export$8901015135f2fb22(bs, as);
    };
    return $648881fc62e7d708$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $648881fc62e7d708$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $648881fc62e7d708$export$849c7567cbd62acc = function(middle) {
    var f = $6ANlS.prependAll(middle);
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $648881fc62e7d708$export$af200dcf8b7cb5de = function(middle) {
    var f = $6ANlS.intersperse(middle);
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $648881fc62e7d708$export$bb628a54ab399bc9 = function(n) {
    var f = $6ANlS.rotate(n);
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $648881fc62e7d708$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $648881fc62e7d708$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $648881fc62e7d708$export$f70730c3d1fc524e = function(E) {
    var f = $6ANlS.uniq(E);
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $648881fc62e7d708$export$b035e44d7bb4278f = function(ords) {
    var f = $6ANlS.sortBy(ords);
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $648881fc62e7d708$export$433fe05b12ba833f = function(f) {
    var g = $6ANlS.chop(f);
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? g(as) : $648881fc62e7d708$export$6e22c362a0406a2c;
    };
};
var $648881fc62e7d708$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $648881fc62e7d708$export$a978c53b4062a525(as) ? $6ANlS.splitAt(n)(as) : $648881fc62e7d708$export$dd1bc94b04021eeb(as) ? [
            as,
            $648881fc62e7d708$export$6e22c362a0406a2c
        ] : [
            $648881fc62e7d708$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $648881fc62e7d708$export$2f0184d5df52135f = function(n) {
    var f = $6ANlS.chunksOf(n);
    return function(as) {
        return $648881fc62e7d708$export$a978c53b4062a525(as) ? f(as) : $648881fc62e7d708$export$6e22c362a0406a2c;
    };
};
var $648881fc62e7d708$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $648881fc62e7d708$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $648881fc62e7d708$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $648881fc62e7d708$export$a978c53b4062a525(input) ? $648881fc62e7d708$export$5b8affa63fc6df16($6ANlS.head(input), function(a) {
            return go((0, $6owmV.pipe)(scope, $648881fc62e7d708$export$10d8903dec122b9d(a)), $6ANlS.tail(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $648881fc62e7d708$export$6e22c362a0406a2c;
    };
    return go($648881fc62e7d708$export$6e22c362a0406a2c, input);
}
var $648881fc62e7d708$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $648881fc62e7d708$export$dd1bc94b04021eeb(first) ? second : $648881fc62e7d708$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $648881fc62e7d708$export$ee1b3e54f0441b22 = $648881fc62e7d708$export$c8c959650bbe80e2;
function $648881fc62e7d708$export$971dd5b0dfd021b6(E) {
    var unionE = $6ANlS.union(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $648881fc62e7d708$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $648881fc62e7d708$export$a978c53b4062a525(first) && $648881fc62e7d708$export$a978c53b4062a525(second) ? unionE(second)(first) : $648881fc62e7d708$export$a978c53b4062a525(first) ? first : second;
    };
}
function $648881fc62e7d708$export$bc86dfbf7795668c(E) {
    var elemE = $648881fc62e7d708$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $648881fc62e7d708$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $648881fc62e7d708$export$acaf96a27438246b(E) {
    var elemE = $648881fc62e7d708$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $648881fc62e7d708$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $648881fc62e7d708$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$871de8747c9eaa88(f));
};
var $648881fc62e7d708$var$_mapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$8f07ddce13659f50(f));
};
var $648881fc62e7d708$var$_ap = function(fab, fa) {
    return (0, $6owmV.pipe)(fab, $648881fc62e7d708$export$2f6ca3d3b1f80bf5(fa));
};
var $648881fc62e7d708$var$_filter = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$3dea766d36a8935f(predicate));
};
var $648881fc62e7d708$var$_filterMap = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$a04c6c6965dd4709(f));
};
var $648881fc62e7d708$var$_partition = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$b29f828819edca8d(predicate));
};
var $648881fc62e7d708$var$_partitionMap = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$3117e3f9ececb6bc(f));
};
var $648881fc62e7d708$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $648881fc62e7d708$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$bc7c0794b9c6f3ba(f));
};
var $648881fc62e7d708$var$_alt = function(fa, that) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$228be17d80722ab(that));
};
var $648881fc62e7d708$var$_reduce = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$533b26079ad0b4b(b, f));
};
var $648881fc62e7d708$var$_foldMap = function(M) {
    var foldMapM = $648881fc62e7d708$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapM(f));
    };
};
var $648881fc62e7d708$var$_reduceRight = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$7fef8bcdbb34f435(b, f));
};
var $648881fc62e7d708$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$bbd3ef8720e22369(b, f));
};
var $648881fc62e7d708$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $648881fc62e7d708$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapWithIndexM(f));
    };
};
var $648881fc62e7d708$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$ce2b2fe0b88ccd0a(b, f));
};
var $648881fc62e7d708$var$_filterMapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$30c5cbe848021e97(f));
};
var $648881fc62e7d708$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$36e42aef19fc7171(predicateWithIndex));
};
var $648881fc62e7d708$var$_extend = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$8b58be045bf06082(f));
};
var $648881fc62e7d708$var$_traverse = function(F) {
    var traverseF = $648881fc62e7d708$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $648881fc62e7d708$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $648881fc62e7d708$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseWithIndexF(f));
    };
};
var $648881fc62e7d708$export$c5c44f872d8af73 = function(a, f) {
    return (0, $6owmV.pipe)(a, $648881fc62e7d708$export$f855115a79f70c1a(f));
};
var $648881fc62e7d708$export$b9909b62ceeab991 = function(a, f) {
    return (0, $6owmV.pipe)(a, $648881fc62e7d708$export$bffee57bb00a6859(f));
};
var $648881fc62e7d708$export$ba255e9e49e00608 = $6ANlS.of;
var $648881fc62e7d708$export$7f9972325ebfd559 = function() {
    return $648881fc62e7d708$export$6e22c362a0406a2c;
};
var $648881fc62e7d708$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $648881fc62e7d708$export$228be17d80722ab = $648881fc62e7d708$export$1517cca7889d6aaa;
var $648881fc62e7d708$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $648881fc62e7d708$export$5b8affa63fc6df16(function(f) {
        return (0, $6owmV.pipe)(fa, $648881fc62e7d708$export$871de8747c9eaa88(f));
    });
};
var $648881fc62e7d708$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $6owmV.dual)(2, function(ma, f) {
    return (0, $6owmV.pipe)(ma, $648881fc62e7d708$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $648881fc62e7d708$export$bffa455ba8c619a6 = /*#__PURE__*/ $648881fc62e7d708$export$5b8affa63fc6df16((0, $6owmV.identity));
var $648881fc62e7d708$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $648881fc62e7d708$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $648881fc62e7d708$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $iCI6U.separated)(left, right);
};
var $648881fc62e7d708$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $648881fc62e7d708$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($jc2nG.isSome(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $648881fc62e7d708$export$a04c6c6965dd4709 = function(f) {
    return $648881fc62e7d708$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $648881fc62e7d708$export$8e16b83750b44988 = /*#__PURE__*/ $648881fc62e7d708$export$a04c6c6965dd4709((0, $6owmV.identity));
var $648881fc62e7d708$export$b29f828819edca8d = function(predicate) {
    return $648881fc62e7d708$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $648881fc62e7d708$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $iCI6U.separated)(left, right);
    };
};
var $648881fc62e7d708$export$3117e3f9ececb6bc = function(f) {
    return $648881fc62e7d708$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $648881fc62e7d708$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $iCI6U.separated)(left, right);
    };
};
var $648881fc62e7d708$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $648881fc62e7d708$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $648881fc62e7d708$export$ecd5e8ace626722c = /*#__PURE__*/ $648881fc62e7d708$export$8b58be045bf06082((0, $6owmV.identity));
var $648881fc62e7d708$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $648881fc62e7d708$export$533b26079ad0b4b = function(b, f) {
    return $648881fc62e7d708$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $648881fc62e7d708$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $648881fc62e7d708$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $648881fc62e7d708$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $648881fc62e7d708$export$7fef8bcdbb34f435 = function(b, f) {
    return $648881fc62e7d708$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $648881fc62e7d708$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $648881fc62e7d708$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $648881fc62e7d708$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $648881fc62e7d708$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $648881fc62e7d708$var$_reduce(ta, F.of($648881fc62e7d708$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $6owmV.pipe)(as, $648881fc62e7d708$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $648881fc62e7d708$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $648881fc62e7d708$export$bbd3ef8720e22369(F.of($648881fc62e7d708$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $6owmV.pipe)(bs, $648881fc62e7d708$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $648881fc62e7d708$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $648881fc62e7d708$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $648881fc62e7d708$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $648881fc62e7d708$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $648881fc62e7d708$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($jc2nG.isSome(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $648881fc62e7d708$export$9156e739aa33e19f = 'ReadonlyArray';
var $648881fc62e7d708$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $648881fc62e7d708$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $648881fc62e7d708$export$dd1bc94b04021eeb(first) ? second : $648881fc62e7d708$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $648881fc62e7d708$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $648881fc62e7d708$export$e759a9a7f8d04692().concat,
        empty: $648881fc62e7d708$export$6e22c362a0406a2c
    };
};
var $648881fc62e7d708$export$804fed467fde44e4 = function(E) {
    return (0, $JrPqh.fromEquals)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $648881fc62e7d708$export$1af51209b1b91d07 = function(O) {
    return (0, $6ZOPp.fromCompare)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $bTheZ.Ord.compare(aLen, bLen);
    });
};
var $648881fc62e7d708$export$baca17b4aff42f82 = function(E) {
    var unionE = $648881fc62e7d708$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $648881fc62e7d708$export$c487aac9f4157837 = function(E) {
    return {
        concat: $648881fc62e7d708$export$baca17b4aff42f82(E).concat,
        empty: $648881fc62e7d708$export$6e22c362a0406a2c
    };
};
var $648881fc62e7d708$export$d379a869a72e4055 = function(E) {
    var intersectionE = $648881fc62e7d708$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $648881fc62e7d708$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $648881fc62e7d708$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $648881fc62e7d708$export$bd5b6bfc5fa2ee61 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map
};
var $648881fc62e7d708$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($648881fc62e7d708$export$bd5b6bfc5fa2ee61);
var $648881fc62e7d708$export$59a71046037e6c20 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    of: $648881fc62e7d708$export$ba255e9e49e00608
};
var $648881fc62e7d708$export$9fdffe0fe1e91cad = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    mapWithIndex: $648881fc62e7d708$var$_mapWithIndex
};
var $648881fc62e7d708$export$efc21ddc6aeb363d = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap
};
var $648881fc62e7d708$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $kf9cS.apFirst)($648881fc62e7d708$export$efc21ddc6aeb363d);
var $648881fc62e7d708$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $kf9cS.apSecond)($648881fc62e7d708$export$efc21ddc6aeb363d);
var $648881fc62e7d708$export$1279d2b7807629fd = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap,
    of: $648881fc62e7d708$export$ba255e9e49e00608
};
var $648881fc62e7d708$export$f18d5acc27d70423 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap,
    chain: $648881fc62e7d708$export$5b8affa63fc6df16
};
var $648881fc62e7d708$export$fb641926d034ac7d = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap,
    of: $648881fc62e7d708$export$ba255e9e49e00608,
    chain: $648881fc62e7d708$export$5b8affa63fc6df16
};
var $648881fc62e7d708$export$e3821ef4970c339c = /*#__PURE__*/ (0, $fl2uO.chainFirst)($648881fc62e7d708$export$f18d5acc27d70423);
var $648881fc62e7d708$export$8fa953f00d3b093 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    unfold: $648881fc62e7d708$export$c48e357c1a89b78d
};
var $648881fc62e7d708$export$25ba4469a069167 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    alt: $648881fc62e7d708$var$_alt
};
var $648881fc62e7d708$export$aaef8a3eae948f03 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    zero: $648881fc62e7d708$export$7f9972325ebfd559
};
var $648881fc62e7d708$export$864d727b48066337 = /*#__PURE__*/ (0, $bLjkL.guard)($648881fc62e7d708$export$aaef8a3eae948f03, $648881fc62e7d708$export$59a71046037e6c20);
var $648881fc62e7d708$export$4acb47accde578d2 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap,
    of: $648881fc62e7d708$export$ba255e9e49e00608,
    alt: $648881fc62e7d708$var$_alt,
    zero: $648881fc62e7d708$export$7f9972325ebfd559
};
var $648881fc62e7d708$export$5b5dd0e212d2a5bc = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    extend: $648881fc62e7d708$var$_extend
};
var $648881fc62e7d708$export$4a21ac48141ac3c9 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    compact: $648881fc62e7d708$export$8e16b83750b44988,
    separate: $648881fc62e7d708$export$709f6946f4e97408
};
var $648881fc62e7d708$export$d00e1c48fb621173 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    compact: $648881fc62e7d708$export$8e16b83750b44988,
    separate: $648881fc62e7d708$export$709f6946f4e97408,
    filter: $648881fc62e7d708$var$_filter,
    filterMap: $648881fc62e7d708$var$_filterMap,
    partition: $648881fc62e7d708$var$_partition,
    partitionMap: $648881fc62e7d708$var$_partitionMap
};
var $648881fc62e7d708$export$c29a647071e542ec = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    mapWithIndex: $648881fc62e7d708$var$_mapWithIndex,
    compact: $648881fc62e7d708$export$8e16b83750b44988,
    separate: $648881fc62e7d708$export$709f6946f4e97408,
    filter: $648881fc62e7d708$var$_filter,
    filterMap: $648881fc62e7d708$var$_filterMap,
    partition: $648881fc62e7d708$var$_partition,
    partitionMap: $648881fc62e7d708$var$_partitionMap,
    partitionMapWithIndex: $648881fc62e7d708$var$_partitionMapWithIndex,
    partitionWithIndex: $648881fc62e7d708$var$_partitionWithIndex,
    filterMapWithIndex: $648881fc62e7d708$var$_filterMapWithIndex,
    filterWithIndex: $648881fc62e7d708$var$_filterWithIndex
};
var $648881fc62e7d708$export$41404b31838667c9 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    reduce: $648881fc62e7d708$var$_reduce,
    foldMap: $648881fc62e7d708$var$_foldMap,
    reduceRight: $648881fc62e7d708$var$_reduceRight
};
var $648881fc62e7d708$export$e8f7d17aaff345cb = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    reduce: $648881fc62e7d708$var$_reduce,
    foldMap: $648881fc62e7d708$var$_foldMap,
    reduceRight: $648881fc62e7d708$var$_reduceRight,
    reduceWithIndex: $648881fc62e7d708$var$_reduceWithIndex,
    foldMapWithIndex: $648881fc62e7d708$var$_foldMapWithIndex,
    reduceRightWithIndex: $648881fc62e7d708$var$_reduceRightWithIndex
};
var $648881fc62e7d708$export$a0202666c3bda011 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    reduce: $648881fc62e7d708$var$_reduce,
    foldMap: $648881fc62e7d708$var$_foldMap,
    reduceRight: $648881fc62e7d708$var$_reduceRight,
    traverse: $648881fc62e7d708$var$_traverse,
    sequence: $648881fc62e7d708$export$49bb65c2ea163039
};
var $648881fc62e7d708$export$bd7b528d8c36ec41 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    mapWithIndex: $648881fc62e7d708$var$_mapWithIndex,
    reduce: $648881fc62e7d708$var$_reduce,
    foldMap: $648881fc62e7d708$var$_foldMap,
    reduceRight: $648881fc62e7d708$var$_reduceRight,
    reduceWithIndex: $648881fc62e7d708$var$_reduceWithIndex,
    foldMapWithIndex: $648881fc62e7d708$var$_foldMapWithIndex,
    reduceRightWithIndex: $648881fc62e7d708$var$_reduceRightWithIndex,
    traverse: $648881fc62e7d708$var$_traverse,
    sequence: $648881fc62e7d708$export$49bb65c2ea163039,
    traverseWithIndex: $648881fc62e7d708$var$_traverseWithIndex
};
var $648881fc62e7d708$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $648881fc62e7d708$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($jc2nG.isLeft(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $648881fc62e7d708$export$7d808dfaa6d54634 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap,
    chain: $648881fc62e7d708$export$5b8affa63fc6df16,
    chainRec: $648881fc62e7d708$export$c5c44f872d8af73
};
var $648881fc62e7d708$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($jc2nG.isLeft(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $648881fc62e7d708$export$57f3a385c7e59628 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap,
    chain: $648881fc62e7d708$export$5b8affa63fc6df16,
    chainRec: $648881fc62e7d708$export$b9909b62ceeab991
};
var $648881fc62e7d708$var$_wither = /*#__PURE__*/ (0, $ciQV6.witherDefault)($648881fc62e7d708$export$a0202666c3bda011, $648881fc62e7d708$export$4a21ac48141ac3c9);
var $648881fc62e7d708$var$_wilt = /*#__PURE__*/ (0, $ciQV6.wiltDefault)($648881fc62e7d708$export$a0202666c3bda011, $648881fc62e7d708$export$4a21ac48141ac3c9);
var $648881fc62e7d708$export$748d317b4c426f96 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    map: $648881fc62e7d708$var$_map,
    compact: $648881fc62e7d708$export$8e16b83750b44988,
    separate: $648881fc62e7d708$export$709f6946f4e97408,
    filter: $648881fc62e7d708$var$_filter,
    filterMap: $648881fc62e7d708$var$_filterMap,
    partition: $648881fc62e7d708$var$_partition,
    partitionMap: $648881fc62e7d708$var$_partitionMap,
    reduce: $648881fc62e7d708$var$_reduce,
    foldMap: $648881fc62e7d708$var$_foldMap,
    reduceRight: $648881fc62e7d708$var$_reduceRight,
    traverse: $648881fc62e7d708$var$_traverse,
    sequence: $648881fc62e7d708$export$49bb65c2ea163039,
    wither: $648881fc62e7d708$var$_wither,
    wilt: $648881fc62e7d708$var$_wilt
};
var $648881fc62e7d708$export$c40604f35db61519 = /*#__PURE__*/ (0, $ciQV6.filterE)($648881fc62e7d708$export$748d317b4c426f96);
var $648881fc62e7d708$export$825ea6cb6fc48d49 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    fromEither: $648881fc62e7d708$export$80c878c9b1d77917
};
var $648881fc62e7d708$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $5tUZ7.fromEitherK)($648881fc62e7d708$export$825ea6cb6fc48d49);
var $648881fc62e7d708$export$f4863e1822a1860c = $6ANlS.unsafeInsertAt;
var $648881fc62e7d708$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $648881fc62e7d708$export$a978c53b4062a525(as) ? $6ANlS.unsafeUpdateAt(i, a, as) : as;
};
var $648881fc62e7d708$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $648881fc62e7d708$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $648881fc62e7d708$export$571d59b505e6bb4e = function(as) {
    return $648881fc62e7d708$export$dd1bc94b04021eeb(as) ? $648881fc62e7d708$export$6e22c362a0406a2c : as.slice();
};
var $648881fc62e7d708$export$6e22c362a0406a2c = $6ANlS.empty;
function $648881fc62e7d708$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $648881fc62e7d708$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $648881fc62e7d708$export$f7e9f41ea797a17 = $648881fc62e7d708$export$ad14ef4001db2bcd;
var $648881fc62e7d708$export$739ec22334c44788 = function(M) {
    var intercalateM = $6ANlS.intercalate(M);
    return function(middle) {
        return $648881fc62e7d708$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $648881fc62e7d708$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $648881fc62e7d708$export$ba255e9e49e00608($jc2nG.emptyRecord);
var $648881fc62e7d708$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $aFZgk.bindTo)($648881fc62e7d708$export$bd5b6bfc5fa2ee61);
var $648881fc62e7d708$export$5d537b797c421217 = /*#__PURE__*/ (0, $aFZgk.let)($648881fc62e7d708$export$bd5b6bfc5fa2ee61);
var $648881fc62e7d708$export$2385a24977818dd0 = /*#__PURE__*/ (0, $fl2uO.bind)($648881fc62e7d708$export$f18d5acc27d70423);
var $648881fc62e7d708$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $kf9cS.apS)($648881fc62e7d708$export$efc21ddc6aeb363d);
var $648881fc62e7d708$export$e08e3b67e392101e = $648881fc62e7d708$export$5b8affa63fc6df16;
var $648881fc62e7d708$export$d02631cccf789723 = $6ANlS.range;
var $648881fc62e7d708$export$8327ebbef2a0ba76 = $6ANlS.cons;
var $648881fc62e7d708$export$c40cf5aab899f397 = $6ANlS.snoc;
var $648881fc62e7d708$export$baeb00bf1e27e233 = $648881fc62e7d708$export$849c7567cbd62acc;
var $648881fc62e7d708$export$95ca155af9fd5713 = {
    URI: $648881fc62e7d708$export$9156e739aa33e19f,
    compact: $648881fc62e7d708$export$8e16b83750b44988,
    separate: $648881fc62e7d708$export$709f6946f4e97408,
    map: $648881fc62e7d708$var$_map,
    ap: $648881fc62e7d708$var$_ap,
    of: $648881fc62e7d708$export$ba255e9e49e00608,
    chain: $648881fc62e7d708$export$5b8affa63fc6df16,
    filter: $648881fc62e7d708$var$_filter,
    filterMap: $648881fc62e7d708$var$_filterMap,
    partition: $648881fc62e7d708$var$_partition,
    partitionMap: $648881fc62e7d708$var$_partitionMap,
    mapWithIndex: $648881fc62e7d708$var$_mapWithIndex,
    partitionMapWithIndex: $648881fc62e7d708$var$_partitionMapWithIndex,
    partitionWithIndex: $648881fc62e7d708$var$_partitionWithIndex,
    filterMapWithIndex: $648881fc62e7d708$var$_filterMapWithIndex,
    filterWithIndex: $648881fc62e7d708$var$_filterWithIndex,
    alt: $648881fc62e7d708$var$_alt,
    zero: $648881fc62e7d708$export$7f9972325ebfd559,
    unfold: $648881fc62e7d708$export$c48e357c1a89b78d,
    reduce: $648881fc62e7d708$var$_reduce,
    foldMap: $648881fc62e7d708$var$_foldMap,
    reduceRight: $648881fc62e7d708$var$_reduceRight,
    traverse: $648881fc62e7d708$var$_traverse,
    sequence: $648881fc62e7d708$export$49bb65c2ea163039,
    reduceWithIndex: $648881fc62e7d708$var$_reduceWithIndex,
    foldMapWithIndex: $648881fc62e7d708$var$_foldMapWithIndex,
    reduceRightWithIndex: $648881fc62e7d708$var$_reduceRightWithIndex,
    traverseWithIndex: $648881fc62e7d708$var$_traverseWithIndex,
    extend: $648881fc62e7d708$var$_extend,
    wither: $648881fc62e7d708$var$_wither,
    wilt: $648881fc62e7d708$var$_wilt
};

});
parcelRegister("bTheZ", function(module, exports) {

$parcel$export(module.exports, "Ord", () => $8a823466b90cbc27$export$ee8aa95bfab51c5);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $8a823466b90cbc27$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $8a823466b90cbc27$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $8a823466b90cbc27$export$ee8aa95bfab51c5 = {
    equals: $8a823466b90cbc27$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $8a823466b90cbc27$export$88f31472ebc405c8 = {
    equals: $8a823466b90cbc27$export$a2050e5b0c4dcf10.equals,
    compare: $8a823466b90cbc27$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $8a823466b90cbc27$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $8a823466b90cbc27$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $8a823466b90cbc27$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $8a823466b90cbc27$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $8a823466b90cbc27$export$2517c0450e71e789 = {
    concat: $8a823466b90cbc27$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $8a823466b90cbc27$export$ee1a63590489b690 = {
    concat: $8a823466b90cbc27$export$5b0bccec79556292.concat,
    empty: 1
};
var $8a823466b90cbc27$export$a455218a85c89869 = {
    add: $8a823466b90cbc27$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $8a823466b90cbc27$export$5b0bccec79556292.concat,
    one: 1,
    sub: $8a823466b90cbc27$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};

});

parcelRegister("iCI6U", function(module, exports) {

$parcel$export(module.exports, "separated", () => $d8edfe04ab08711b$export$beaabdf62f4a639d);
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 
var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");
var $d8edfe04ab08711b$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $d8edfe04ab08711b$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $d8edfe04ab08711b$export$871de8747c9eaa88(f));
};
var $d8edfe04ab08711b$var$_mapLeft = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $d8edfe04ab08711b$export$472de43a55e4aa49(f));
};
var $d8edfe04ab08711b$var$_bimap = function(fa, g, f) {
    return (0, $6owmV.pipe)(fa, $d8edfe04ab08711b$export$eb54baf0b342cb1d(g, f));
};
var $d8edfe04ab08711b$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $d8edfe04ab08711b$export$beaabdf62f4a639d($d8edfe04ab08711b$export$eabcd2c8791e7bf4(fa), f($d8edfe04ab08711b$export$79ffe56a765070d2(fa)));
    };
};
var $d8edfe04ab08711b$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $d8edfe04ab08711b$export$beaabdf62f4a639d(f($d8edfe04ab08711b$export$eabcd2c8791e7bf4(fa)), $d8edfe04ab08711b$export$79ffe56a765070d2(fa));
    };
};
var $d8edfe04ab08711b$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $d8edfe04ab08711b$export$beaabdf62f4a639d(f($d8edfe04ab08711b$export$eabcd2c8791e7bf4(fa)), g($d8edfe04ab08711b$export$79ffe56a765070d2(fa)));
    };
};
var $d8edfe04ab08711b$export$9156e739aa33e19f = 'Separated';
var $d8edfe04ab08711b$export$fd0fe42029639505 = {
    URI: $d8edfe04ab08711b$export$9156e739aa33e19f,
    mapLeft: $d8edfe04ab08711b$var$_mapLeft,
    bimap: $d8edfe04ab08711b$var$_bimap
};
var $d8edfe04ab08711b$export$bd5b6bfc5fa2ee61 = {
    URI: $d8edfe04ab08711b$export$9156e739aa33e19f,
    map: $d8edfe04ab08711b$var$_map
};
var $d8edfe04ab08711b$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($d8edfe04ab08711b$export$bd5b6bfc5fa2ee61);
var $d8edfe04ab08711b$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $d8edfe04ab08711b$export$79ffe56a765070d2 = function(s) {
    return s.right;
};

});

parcelRegister("ciQV6", function(module, exports) {

$parcel$export(module.exports, "wiltDefault", () => $8f50374e90c1344d$export$f4cb42390e44d1d2);
$parcel$export(module.exports, "witherDefault", () => $8f50374e90c1344d$export$1f5c6f948d11a182);
$parcel$export(module.exports, "filterE", () => $8f50374e90c1344d$export$c40604f35db61519);

var $jc2nG = parcelRequire("jc2nG");
function $8f50374e90c1344d$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $8f50374e90c1344d$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $8f50374e90c1344d$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $jc2nG.some(a) : $jc2nG.none;
                    });
                });
            };
        };
    };
}

});

parcelRegister("bLjkL", function(module, exports) {

$parcel$export(module.exports, "guard", () => $890314cb377c0486$export$864d727b48066337);
function $890314cb377c0486$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}

});



parcelRegister("8oqh6", function(module, exports) {

$parcel$export(module.exports, "make", () => $61c4f23d127b8503$export$dd44f18ab656f3bb);
$parcel$export(module.exports, "getApplicative", () => $61c4f23d127b8503$export$1402880adb2295a7);

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");
var $61c4f23d127b8503$export$dd44f18ab656f3bb = (0, $6owmV.unsafeCoerce);
function $61c4f23d127b8503$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $61c4f23d127b8503$export$804fed467fde44e4 = (0, $6owmV.identity);
var $61c4f23d127b8503$export$1af51209b1b91d07 = (0, $6owmV.identity);
var $61c4f23d127b8503$export$c55397fc301c5a = (0, $6owmV.identity);
var $61c4f23d127b8503$export$e759a9a7f8d04692 = (0, $6owmV.identity);
var $61c4f23d127b8503$export$c2a7ef2cc9b32b31 = (0, $6owmV.identity);
var $61c4f23d127b8503$export$3d48c7fefc7b8ec2 = (0, $6owmV.identity);
var $61c4f23d127b8503$export$575097c1c561f76f = (0, $6owmV.identity);
var $61c4f23d127b8503$export$2e73cb3f0f25ed55 = (0, $6owmV.identity);
var $61c4f23d127b8503$export$f37f1abb2c955577 = (0, $6owmV.identity);
function $61c4f23d127b8503$export$81090df2aa47ff12(S) {
    return {
        URI: $61c4f23d127b8503$export$9156e739aa33e19f,
        _E: undefined,
        map: $61c4f23d127b8503$var$_map,
        ap: function(fab, fa) {
            return $61c4f23d127b8503$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $61c4f23d127b8503$export$1402880adb2295a7(M) {
    var A = $61c4f23d127b8503$export$81090df2aa47ff12(M);
    return {
        URI: $61c4f23d127b8503$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $61c4f23d127b8503$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $61c4f23d127b8503$var$_contramap = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $61c4f23d127b8503$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $61c4f23d127b8503$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $61c4f23d127b8503$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $61c4f23d127b8503$var$_bimap = function(fa, f, g) {
    return (0, $6owmV.pipe)(fa, $61c4f23d127b8503$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $61c4f23d127b8503$var$_mapLeft = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $61c4f23d127b8503$export$472de43a55e4aa49(f));
};
var $61c4f23d127b8503$export$53b696d27ecb7ba7 = function() {
    return 0, $6owmV.unsafeCoerce;
};
var $61c4f23d127b8503$export$871de8747c9eaa88 = function() {
    return 0, $6owmV.unsafeCoerce;
};
var $61c4f23d127b8503$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $61c4f23d127b8503$export$dd44f18ab656f3bb(f(fa));
    };
};
var $61c4f23d127b8503$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $61c4f23d127b8503$export$dd44f18ab656f3bb(f(fa));
    };
};
var $61c4f23d127b8503$export$9156e739aa33e19f = 'Const';
var $61c4f23d127b8503$export$bd5b6bfc5fa2ee61 = {
    URI: $61c4f23d127b8503$export$9156e739aa33e19f,
    map: $61c4f23d127b8503$var$_map
};
var $61c4f23d127b8503$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($61c4f23d127b8503$export$bd5b6bfc5fa2ee61);
var $61c4f23d127b8503$export$def901a57d5539c3 = {
    URI: $61c4f23d127b8503$export$9156e739aa33e19f,
    contramap: $61c4f23d127b8503$var$_contramap
};
var $61c4f23d127b8503$export$fd0fe42029639505 = {
    URI: $61c4f23d127b8503$export$9156e739aa33e19f,
    bimap: $61c4f23d127b8503$var$_bimap,
    mapLeft: $61c4f23d127b8503$var$_mapLeft
};
var $61c4f23d127b8503$export$dfdd8a9a12668b21 = {
    URI: $61c4f23d127b8503$export$9156e739aa33e19f,
    map: $61c4f23d127b8503$var$_map,
    contramap: $61c4f23d127b8503$var$_contramap,
    bimap: $61c4f23d127b8503$var$_bimap,
    mapLeft: $61c4f23d127b8503$var$_mapLeft
};

});

parcelRegister("c9yO0", function(module, exports) {

$parcel$export(module.exports, "monoidAll", () => $8d9152f4fa3210b3$export$ea84ccdc68daa647);
$parcel$export(module.exports, "monoidAny", () => $8d9152f4fa3210b3$export$c147905ca5134122);

var $lKr0T = parcelRequire("lKr0T");

var $6owmV = parcelRequire("6owmV");

var $jc2nG = parcelRequire("jc2nG");

var $gKa7k = parcelRequire("gKa7k");
var $8d9152f4fa3210b3$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $gKa7k.min(B).concat,
        empty: B.top
    };
};
var $8d9152f4fa3210b3$export$8960430cfd85939f = function(B) {
    return {
        concat: $gKa7k.max(B).concat,
        empty: B.bottom
    };
};
var $8d9152f4fa3210b3$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $gKa7k.reverse(M).concat,
        empty: M.empty
    };
};
var $8d9152f4fa3210b3$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($jc2nG.has.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $gKa7k.struct(monoids).concat,
        empty: empty
    };
};
var $8d9152f4fa3210b3$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $gKa7k.tuple.apply($gKa7k, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $8d9152f4fa3210b3$export$b314777ae20abca9 = function(M) {
    return $gKa7k.concatAll(M)(M.empty);
};
var $8d9152f4fa3210b3$export$50d82750fd26461d = {
    concat: $gKa7k.semigroupVoid.concat,
    empty: undefined
};
var $8d9152f4fa3210b3$export$4ab04e39033ac22a = $8d9152f4fa3210b3$export$65e3907585753458;
var $8d9152f4fa3210b3$export$dfc91d1e5b77420b = $8d9152f4fa3210b3$export$8cf3da7c1c9174ea;
var $8d9152f4fa3210b3$export$5ca84f9b29f1c1a2 = $8d9152f4fa3210b3$export$66c1ae025e96b4bc;
var $8d9152f4fa3210b3$export$9cc0388793460b00 = $8d9152f4fa3210b3$export$8960430cfd85939f;
var $8d9152f4fa3210b3$export$6d1c667712a51996 = $8d9152f4fa3210b3$export$96ec731ed4dcb222;
var $8d9152f4fa3210b3$export$93e2b83da34ff82a = $8d9152f4fa3210b3$export$b314777ae20abca9;
var $8d9152f4fa3210b3$export$ea84ccdc68daa647 = {
    concat: $gKa7k.semigroupAll.concat,
    empty: true
};
var $8d9152f4fa3210b3$export$c147905ca5134122 = {
    concat: $gKa7k.semigroupAny.concat,
    empty: false
};
var $8d9152f4fa3210b3$export$616ba591d6210ed8 = (0, $6owmV.getMonoid);
var $8d9152f4fa3210b3$export$5c6d2e402d334f37 = function() {
    return $8d9152f4fa3210b3$export$66c1ae025e96b4bc((0, $lKr0T.getMonoid)());
};
var $8d9152f4fa3210b3$export$fc39f3d77fa2e58a = {
    concat: $gKa7k.semigroupString.concat,
    empty: ''
};
var $8d9152f4fa3210b3$export$8f9c64d4a92a9eb6 = {
    concat: $gKa7k.semigroupSum.concat,
    empty: 0
};
var $8d9152f4fa3210b3$export$cb362f92c995f3b8 = {
    concat: $gKa7k.semigroupProduct.concat,
    empty: 1
};

});
parcelRegister("lKr0T", function(module, exports) {

$parcel$export(module.exports, "getMonoid", () => $fd52d92724b72e42$export$c2a7ef2cc9b32b31);
/**
 * @since 2.11.0
 */ 
var $6owmV = parcelRequire("6owmV");
var $fd52d92724b72e42$export$9156e739aa33e19f = 'Endomorphism';
var $fd52d92724b72e42$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $6owmV.flow)(first, second);
        }
    };
};
var $fd52d92724b72e42$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $fd52d92724b72e42$export$e759a9a7f8d04692().concat,
        empty: (0, $6owmV.identity)
    };
};

});


parcelRegister("1sIL7", function(module, exports) {

$parcel$export(module.exports, "none", () => $110b20304bac3bc7$export$f883a24d5edde77c);
$parcel$export(module.exports, "some", () => $110b20304bac3bc7$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "fromPredicate", () => $110b20304bac3bc7$export$23f31c55d7162b91);
$parcel$export(module.exports, "map", () => $110b20304bac3bc7$export$871de8747c9eaa88);
$parcel$export(module.exports, "isNone", () => $110b20304bac3bc7$export$e56af863d5645d5f);
$parcel$export(module.exports, "fromEither", () => $110b20304bac3bc7$export$80c878c9b1d77917);
$parcel$export(module.exports, "fold", () => $110b20304bac3bc7$export$93e2b83da34ff82a);
$parcel$export(module.exports, "getOrElse", () => $110b20304bac3bc7$export$8832081647a02ee7);
$parcel$export(module.exports, "fromNullable", () => $110b20304bac3bc7$export$b601f49376b4621a);
$parcel$export(module.exports, "chain", () => $110b20304bac3bc7$export$e08e3b67e392101e);
$parcel$export(module.exports, "option", () => $110b20304bac3bc7$export$a75d1723e6bda2ec);
$parcel$export(module.exports, "getFirstMonoid", () => $110b20304bac3bc7$export$56cd0d85e73e688f);

var $ffW6m = parcelRequire("ffW6m");

var $kf9cS = parcelRequire("kf9cS");

var $fl2uO = parcelRequire("fl2uO");

var $5tUZ7 = parcelRequire("5tUZ7");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $cJQb0 = parcelRequire("cJQb0");

var $gKa7k = parcelRequire("gKa7k");

var $iCI6U = parcelRequire("iCI6U");

var $ciQV6 = parcelRequire("ciQV6");

var $bLjkL = parcelRequire("bLjkL");
var $110b20304bac3bc7$export$f883a24d5edde77c = $jc2nG.none;
var $110b20304bac3bc7$export$ad14ef4001db2bcd = $jc2nG.some;
function $110b20304bac3bc7$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $110b20304bac3bc7$export$ad14ef4001db2bcd(a) : $110b20304bac3bc7$export$f883a24d5edde77c;
    };
}
var $110b20304bac3bc7$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$ad14ef4001db2bcd(ma.left);
};
var $110b20304bac3bc7$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$ad14ef4001db2bcd(ma.right);
};
var $110b20304bac3bc7$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$871de8747c9eaa88(f));
};
var $110b20304bac3bc7$var$_ap = function(fab, fa) {
    return (0, $6owmV.pipe)(fab, $110b20304bac3bc7$export$2f6ca3d3b1f80bf5(fa));
};
var $110b20304bac3bc7$var$_reduce = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$533b26079ad0b4b(b, f));
};
var $110b20304bac3bc7$var$_foldMap = function(M) {
    var foldMapM = $110b20304bac3bc7$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $6owmV.pipe)(fa, foldMapM(f));
    };
};
var $110b20304bac3bc7$var$_reduceRight = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$7fef8bcdbb34f435(b, f));
};
var $110b20304bac3bc7$var$_traverse = function(F) {
    var traverseF = $110b20304bac3bc7$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $110b20304bac3bc7$var$_alt = function(fa, that) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$228be17d80722ab(that));
};
var $110b20304bac3bc7$var$_filter = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $110b20304bac3bc7$var$_filterMap = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $110b20304bac3bc7$var$_extend = function(wa, f) {
    return (0, $6owmV.pipe)(wa, $110b20304bac3bc7$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $110b20304bac3bc7$var$_partition = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $110b20304bac3bc7$var$_partitionMap = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $110b20304bac3bc7$export$3117e3f9ececb6bc(f));
};
var $110b20304bac3bc7$export$9156e739aa33e19f = 'Option';
var $110b20304bac3bc7$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $110b20304bac3bc7$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($110b20304bac3bc7$export$e56af863d5645d5f(x) ? $110b20304bac3bc7$export$e56af863d5645d5f(y) : $110b20304bac3bc7$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $110b20304bac3bc7$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $110b20304bac3bc7$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $110b20304bac3bc7$export$5d7e502287836e58(x) ? $110b20304bac3bc7$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
var $110b20304bac3bc7$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $110b20304bac3bc7$export$e56af863d5645d5f(x) ? y : $110b20304bac3bc7$export$e56af863d5645d5f(y) ? x : $110b20304bac3bc7$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $110b20304bac3bc7$export$f883a24d5edde77c
    };
};
var $110b20304bac3bc7$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(fa) ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $110b20304bac3bc7$export$bd5b6bfc5fa2ee61 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map
};
var $110b20304bac3bc7$export$6554612db691658e = (0, $6owmV.dual)(2, (0, $aFZgk.as)($110b20304bac3bc7$export$bd5b6bfc5fa2ee61));
var $110b20304bac3bc7$export$9284b360ca18a0fd = (0, $aFZgk.asUnit)($110b20304bac3bc7$export$bd5b6bfc5fa2ee61);
var $110b20304bac3bc7$export$ba255e9e49e00608 = $110b20304bac3bc7$export$ad14ef4001db2bcd;
var $110b20304bac3bc7$export$59a71046037e6c20 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    of: $110b20304bac3bc7$export$ba255e9e49e00608
};
var $110b20304bac3bc7$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(fab) ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$e56af863d5645d5f(fa) ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $110b20304bac3bc7$export$efc21ddc6aeb363d = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    ap: $110b20304bac3bc7$var$_ap
};
var $110b20304bac3bc7$export$1279d2b7807629fd = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    ap: $110b20304bac3bc7$var$_ap,
    of: $110b20304bac3bc7$export$ba255e9e49e00608
};
var $110b20304bac3bc7$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $6owmV.dual)(2, function(ma, f) {
    return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? $110b20304bac3bc7$export$f883a24d5edde77c : f(ma.value);
});
var $110b20304bac3bc7$export$f18d5acc27d70423 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    ap: $110b20304bac3bc7$var$_ap,
    chain: $110b20304bac3bc7$export$5b8affa63fc6df16
};
var $110b20304bac3bc7$export$fb641926d034ac7d = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    ap: $110b20304bac3bc7$var$_ap,
    of: $110b20304bac3bc7$export$ba255e9e49e00608,
    chain: $110b20304bac3bc7$export$5b8affa63fc6df16
};
var $110b20304bac3bc7$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $110b20304bac3bc7$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $110b20304bac3bc7$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $110b20304bac3bc7$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $110b20304bac3bc7$export$41404b31838667c9 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    reduce: $110b20304bac3bc7$var$_reduce,
    foldMap: $110b20304bac3bc7$var$_foldMap,
    reduceRight: $110b20304bac3bc7$var$_reduceRight
};
var $110b20304bac3bc7$export$41d1a04d78e7b141 = (0, $6owmV.dual)(2, function(self, that) {
    return $110b20304bac3bc7$export$e56af863d5645d5f(self) ? that() : self;
});
var $110b20304bac3bc7$export$1517cca7889d6aaa = $110b20304bac3bc7$export$41d1a04d78e7b141;
var $110b20304bac3bc7$export$228be17d80722ab = $110b20304bac3bc7$export$41d1a04d78e7b141;
var $110b20304bac3bc7$export$25ba4469a069167 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    alt: $110b20304bac3bc7$var$_alt
};
var $110b20304bac3bc7$export$7f9972325ebfd559 = function() {
    return $110b20304bac3bc7$export$f883a24d5edde77c;
};
var $110b20304bac3bc7$export$aaef8a3eae948f03 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    zero: $110b20304bac3bc7$export$7f9972325ebfd559
};
var $110b20304bac3bc7$export$864d727b48066337 = /*#__PURE__*/ (0, $bLjkL.guard)($110b20304bac3bc7$export$aaef8a3eae948f03, $110b20304bac3bc7$export$59a71046037e6c20);
var $110b20304bac3bc7$export$4acb47accde578d2 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    ap: $110b20304bac3bc7$var$_ap,
    of: $110b20304bac3bc7$export$ba255e9e49e00608,
    alt: $110b20304bac3bc7$var$_alt,
    zero: $110b20304bac3bc7$export$7f9972325ebfd559
};
var $110b20304bac3bc7$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(wa) ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$ad14ef4001db2bcd(f(wa));
    };
};
var $110b20304bac3bc7$export$5b5dd0e212d2a5bc = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    extend: $110b20304bac3bc7$var$_extend
};
var $110b20304bac3bc7$export$8e16b83750b44988 = /*#__PURE__*/ $110b20304bac3bc7$export$5b8affa63fc6df16((0, $6owmV.identity));
var $110b20304bac3bc7$var$defaultSeparated = /*#__PURE__*/ (0, $iCI6U.separated)($110b20304bac3bc7$export$f883a24d5edde77c, $110b20304bac3bc7$export$f883a24d5edde77c);
var $110b20304bac3bc7$export$709f6946f4e97408 = function(ma) {
    return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? $110b20304bac3bc7$var$defaultSeparated : (0, $iCI6U.separated)($110b20304bac3bc7$export$da405662c16fca8e(ma.value), $110b20304bac3bc7$export$482f3615ecf01dc6(ma.value));
};
var $110b20304bac3bc7$export$4a21ac48141ac3c9 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    compact: $110b20304bac3bc7$export$8e16b83750b44988,
    separate: $110b20304bac3bc7$export$709f6946f4e97408
};
var $110b20304bac3bc7$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(fa) ? $110b20304bac3bc7$export$f883a24d5edde77c : predicate(fa.value) ? fa : $110b20304bac3bc7$export$f883a24d5edde77c;
    };
};
var $110b20304bac3bc7$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(fa) ? $110b20304bac3bc7$export$f883a24d5edde77c : f(fa.value);
    };
};
var $110b20304bac3bc7$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $iCI6U.separated)($110b20304bac3bc7$var$_filter(fa, (0, $cJQb0.not)(predicate)), $110b20304bac3bc7$var$_filter(fa, predicate));
    };
};
var $110b20304bac3bc7$export$3117e3f9ececb6bc = function(f) {
    return (0, $6owmV.flow)($110b20304bac3bc7$export$871de8747c9eaa88(f), $110b20304bac3bc7$export$709f6946f4e97408);
};
var $110b20304bac3bc7$export$d00e1c48fb621173 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    compact: $110b20304bac3bc7$export$8e16b83750b44988,
    separate: $110b20304bac3bc7$export$709f6946f4e97408,
    filter: $110b20304bac3bc7$var$_filter,
    filterMap: $110b20304bac3bc7$var$_filterMap,
    partition: $110b20304bac3bc7$var$_partition,
    partitionMap: $110b20304bac3bc7$var$_partitionMap
};
var $110b20304bac3bc7$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $110b20304bac3bc7$export$e56af863d5645d5f(ta) ? F.of($110b20304bac3bc7$export$f883a24d5edde77c) : F.map(f(ta.value), $110b20304bac3bc7$export$ad14ef4001db2bcd);
        };
    };
};
var $110b20304bac3bc7$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(ta) ? F.of($110b20304bac3bc7$export$f883a24d5edde77c) : F.map(ta.value, $110b20304bac3bc7$export$ad14ef4001db2bcd);
    };
};
var $110b20304bac3bc7$export$a0202666c3bda011 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    reduce: $110b20304bac3bc7$var$_reduce,
    foldMap: $110b20304bac3bc7$var$_foldMap,
    reduceRight: $110b20304bac3bc7$var$_reduceRight,
    traverse: $110b20304bac3bc7$var$_traverse,
    sequence: $110b20304bac3bc7$export$49bb65c2ea163039
};
var $110b20304bac3bc7$var$_wither = /*#__PURE__*/ (0, $ciQV6.witherDefault)($110b20304bac3bc7$export$a0202666c3bda011, $110b20304bac3bc7$export$4a21ac48141ac3c9);
var $110b20304bac3bc7$var$_wilt = /*#__PURE__*/ (0, $ciQV6.wiltDefault)($110b20304bac3bc7$export$a0202666c3bda011, $110b20304bac3bc7$export$4a21ac48141ac3c9);
var $110b20304bac3bc7$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $110b20304bac3bc7$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $110b20304bac3bc7$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $110b20304bac3bc7$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $110b20304bac3bc7$export$748d317b4c426f96 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    reduce: $110b20304bac3bc7$var$_reduce,
    foldMap: $110b20304bac3bc7$var$_foldMap,
    reduceRight: $110b20304bac3bc7$var$_reduceRight,
    traverse: $110b20304bac3bc7$var$_traverse,
    sequence: $110b20304bac3bc7$export$49bb65c2ea163039,
    compact: $110b20304bac3bc7$export$8e16b83750b44988,
    separate: $110b20304bac3bc7$export$709f6946f4e97408,
    filter: $110b20304bac3bc7$var$_filter,
    filterMap: $110b20304bac3bc7$var$_filterMap,
    partition: $110b20304bac3bc7$var$_partition,
    partitionMap: $110b20304bac3bc7$var$_partitionMap,
    wither: $110b20304bac3bc7$var$_wither,
    wilt: $110b20304bac3bc7$var$_wilt
};
var $110b20304bac3bc7$export$8bf7aba4a9e09055 = function() {
    return $110b20304bac3bc7$export$f883a24d5edde77c;
};
var $110b20304bac3bc7$export$5f956d47d0619c3a = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    ap: $110b20304bac3bc7$var$_ap,
    of: $110b20304bac3bc7$export$ba255e9e49e00608,
    chain: $110b20304bac3bc7$export$5b8affa63fc6df16,
    throwError: $110b20304bac3bc7$export$8bf7aba4a9e09055
};
var $110b20304bac3bc7$export$80c878c9b1d77917 = $110b20304bac3bc7$export$482f3615ecf01dc6;
var $110b20304bac3bc7$export$825ea6cb6fc48d49 = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    fromEither: $110b20304bac3bc7$export$80c878c9b1d77917
};
var $110b20304bac3bc7$export$5d7e502287836e58 = $jc2nG.isSome;
var $110b20304bac3bc7$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $110b20304bac3bc7$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $110b20304bac3bc7$export$ccb09033cefa61e8 = $110b20304bac3bc7$export$2d55ea551c238330;
var $110b20304bac3bc7$export$4659b591c19bdf3d = $110b20304bac3bc7$export$2d55ea551c238330;
var $110b20304bac3bc7$export$93e2b83da34ff82a = $110b20304bac3bc7$export$4659b591c19bdf3d;
var $110b20304bac3bc7$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $110b20304bac3bc7$export$8832081647a02ee7 = $110b20304bac3bc7$export$d8a997ff0e6436f3;
var $110b20304bac3bc7$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($110b20304bac3bc7$export$bd5b6bfc5fa2ee61);
var $110b20304bac3bc7$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $kf9cS.apFirst)($110b20304bac3bc7$export$efc21ddc6aeb363d);
var $110b20304bac3bc7$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $kf9cS.apSecond)($110b20304bac3bc7$export$efc21ddc6aeb363d);
var $110b20304bac3bc7$export$bffa455ba8c619a6 = $110b20304bac3bc7$export$8e16b83750b44988;
var $110b20304bac3bc7$export$3f23594af5f37336 = /*#__PURE__*/ (0, $6owmV.dual)(2, $fl2uO.tap($110b20304bac3bc7$export$f18d5acc27d70423));
var $110b20304bac3bc7$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $6owmV.dual)(2, (0, $5tUZ7.tapEither)($110b20304bac3bc7$export$825ea6cb6fc48d49, $110b20304bac3bc7$export$f18d5acc27d70423));
var $110b20304bac3bc7$export$ecd5e8ace626722c = /*#__PURE__*/ $110b20304bac3bc7$export$8b58be045bf06082((0, $6owmV.identity));
var $110b20304bac3bc7$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $5tUZ7.fromEitherK)($110b20304bac3bc7$export$825ea6cb6fc48d49);
var $110b20304bac3bc7$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $5tUZ7.chainEitherK)($110b20304bac3bc7$export$825ea6cb6fc48d49, $110b20304bac3bc7$export$f18d5acc27d70423);
var $110b20304bac3bc7$export$c5f2bdbf9b43f0c0 = $110b20304bac3bc7$export$be3ff275bb5a8ac9;
var $110b20304bac3bc7$export$b601f49376b4621a = function(a) {
    return a == null ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$ad14ef4001db2bcd(a);
};
var $110b20304bac3bc7$export$d234c058d1d4e435 = function(f) {
    try {
        return $110b20304bac3bc7$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $110b20304bac3bc7$export$f883a24d5edde77c;
    }
};
var $110b20304bac3bc7$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $110b20304bac3bc7$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $110b20304bac3bc7$export$c69ca7b73fad45e1 = function(f) {
    return (0, $6owmV.flow)(f, $110b20304bac3bc7$export$b601f49376b4621a);
};
var $110b20304bac3bc7$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? $110b20304bac3bc7$export$f883a24d5edde77c : $110b20304bac3bc7$export$b601f49376b4621a(f(ma.value));
    };
};
var $110b20304bac3bc7$export$b187f57ee1822bc5 = /*#__PURE__*/ $110b20304bac3bc7$export$4659b591c19bdf3d((0, $6owmV.constNull), (0, $6owmV.identity));
var $110b20304bac3bc7$export$cb585b8513fa8577 = /*#__PURE__*/ $110b20304bac3bc7$export$4659b591c19bdf3d((0, $6owmV.constUndefined), (0, $6owmV.identity));
function $110b20304bac3bc7$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $110b20304bac3bc7$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $110b20304bac3bc7$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $110b20304bac3bc7$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $110b20304bac3bc7$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $110b20304bac3bc7$export$ba255e9e49e00608($jc2nG.emptyRecord);
var $110b20304bac3bc7$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $aFZgk.bindTo)($110b20304bac3bc7$export$bd5b6bfc5fa2ee61);
var $110b20304bac3bc7$export$5d537b797c421217 = /*#__PURE__*/ (0, $aFZgk.let)($110b20304bac3bc7$export$bd5b6bfc5fa2ee61);
var $110b20304bac3bc7$export$2385a24977818dd0 = /*#__PURE__*/ $fl2uO.bind($110b20304bac3bc7$export$f18d5acc27d70423);
var $110b20304bac3bc7$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $kf9cS.apS)($110b20304bac3bc7$export$efc21ddc6aeb363d);
var $110b20304bac3bc7$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $110b20304bac3bc7$export$ba255e9e49e00608($jc2nG.emptyReadonlyArray);
var $110b20304bac3bc7$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $jc2nG.head(as));
        if ($110b20304bac3bc7$export$e56af863d5645d5f(o)) return $110b20304bac3bc7$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($110b20304bac3bc7$export$e56af863d5645d5f(o_1)) return $110b20304bac3bc7$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $110b20304bac3bc7$export$ad14ef4001db2bcd(out);
    };
};
var $110b20304bac3bc7$export$d4e79db5dc14cc1 = function(f) {
    var g = $110b20304bac3bc7$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $jc2nG.isNonEmpty(as) ? g(as) : $110b20304bac3bc7$export$c74b6e34b2b6efb0;
    };
};
var $110b20304bac3bc7$export$104a2841e9cbad06 = $110b20304bac3bc7$export$d4e79db5dc14cc1;
var $110b20304bac3bc7$export$64f39b2a2b79e1b1 = function(f) {
    return $110b20304bac3bc7$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $110b20304bac3bc7$export$d330b60315c14cd1 = /*#__PURE__*/ $110b20304bac3bc7$export$64f39b2a2b79e1b1((0, $6owmV.identity));
var $110b20304bac3bc7$export$e08e3b67e392101e = $110b20304bac3bc7$export$5b8affa63fc6df16;
var $110b20304bac3bc7$export$e3821ef4970c339c = $110b20304bac3bc7$export$3f23594af5f37336;
function $110b20304bac3bc7$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $110b20304bac3bc7$export$5d7e502287836e58(getOption(a));
    };
}
var $110b20304bac3bc7$export$c2a8dfc107523e74 = $110b20304bac3bc7$export$c81f992c08fd0bf3;
var $110b20304bac3bc7$export$a75d1723e6bda2ec = {
    URI: $110b20304bac3bc7$export$9156e739aa33e19f,
    map: $110b20304bac3bc7$var$_map,
    of: $110b20304bac3bc7$export$ba255e9e49e00608,
    ap: $110b20304bac3bc7$var$_ap,
    chain: $110b20304bac3bc7$export$5b8affa63fc6df16,
    reduce: $110b20304bac3bc7$var$_reduce,
    foldMap: $110b20304bac3bc7$var$_foldMap,
    reduceRight: $110b20304bac3bc7$var$_reduceRight,
    traverse: $110b20304bac3bc7$var$_traverse,
    sequence: $110b20304bac3bc7$export$49bb65c2ea163039,
    zero: $110b20304bac3bc7$export$7f9972325ebfd559,
    alt: $110b20304bac3bc7$var$_alt,
    extend: $110b20304bac3bc7$var$_extend,
    compact: $110b20304bac3bc7$export$8e16b83750b44988,
    separate: $110b20304bac3bc7$export$709f6946f4e97408,
    filter: $110b20304bac3bc7$var$_filter,
    filterMap: $110b20304bac3bc7$var$_filterMap,
    partition: $110b20304bac3bc7$var$_partition,
    partitionMap: $110b20304bac3bc7$var$_partitionMap,
    wither: $110b20304bac3bc7$var$_wither,
    wilt: $110b20304bac3bc7$var$_wilt,
    throwError: $110b20304bac3bc7$export$8bf7aba4a9e09055
};
var $110b20304bac3bc7$export$18979a515d2a828e = /*#__PURE__*/ (0, $kf9cS.getApplySemigroup)($110b20304bac3bc7$export$efc21ddc6aeb363d);
var $110b20304bac3bc7$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $ffW6m.getApplicativeMonoid)($110b20304bac3bc7$export$1279d2b7807629fd);
var $110b20304bac3bc7$export$56cd0d85e73e688f = function() {
    return $110b20304bac3bc7$export$c2a7ef2cc9b32b31((0, $gKa7k.first)());
};
var $110b20304bac3bc7$export$ca391a563a1f3001 = function() {
    return $110b20304bac3bc7$export$c2a7ef2cc9b32b31((0, $gKa7k.last)());
};

});
parcelRegister("ffW6m", function(module, exports) {

$parcel$export(module.exports, "getApplicativeMonoid", () => $b1b5537cc4f7029c$export$c8e1a8ea383fd0ff);
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 
var $kf9cS = parcelRequire("kf9cS");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");
function $b1b5537cc4f7029c$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $kf9cS.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $b1b5537cc4f7029c$export$9833a940afed18f3(F, G) {
    var map = (0, $aFZgk.getFunctorComposition)(F, G).map;
    var _ap = (0, $kf9cS.ap)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $6owmV.pipe)(fgab, _ap(fga));
        }
    };
}

});

parcelRegister("cJQb0", function(module, exports) {

$parcel$export(module.exports, "not", () => $946229317cf112ce$export$6003a5f097c73977);

var $6owmV = parcelRequire("6owmV");
var $946229317cf112ce$var$contramap_ = function(predicate, f) {
    return (0, $6owmV.pipe)(predicate, $946229317cf112ce$export$53b696d27ecb7ba7(f));
};
var $946229317cf112ce$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $6owmV.flow)(f, predicate);
    };
};
var $946229317cf112ce$export$9156e739aa33e19f = 'Predicate';
var $946229317cf112ce$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $6owmV.pipe)(first, $946229317cf112ce$export$252bb8b3bbdf6749(second));
        }
    };
};
var $946229317cf112ce$export$d795ff673668f564 = function() {
    return {
        concat: $946229317cf112ce$export$45c71cec3a7e90aa().concat,
        empty: (0, $6owmV.constFalse)
    };
};
var $946229317cf112ce$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $6owmV.pipe)(first, $946229317cf112ce$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $946229317cf112ce$export$4c43b04d78b174fa = function() {
    return {
        concat: $946229317cf112ce$export$d900a29579818780().concat,
        empty: (0, $6owmV.constTrue)
    };
};
var $946229317cf112ce$export$def901a57d5539c3 = {
    URI: $946229317cf112ce$export$9156e739aa33e19f,
    contramap: $946229317cf112ce$var$contramap_
};
var $946229317cf112ce$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $946229317cf112ce$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $946229317cf112ce$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};

});


parcelRegister("crypz", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $90f2b3076aa8c829$export$a4627e546088548d);

var $kf9cS = parcelRequire("kf9cS");

var $fl2uO = parcelRequire("fl2uO");

var $6owmV = parcelRequire("6owmV");
function $90f2b3076aa8c829$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $90f2b3076aa8c829$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $90f2b3076aa8c829$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $90f2b3076aa8c829$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $90f2b3076aa8c829$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $90f2b3076aa8c829$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $90f2b3076aa8c829$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $90f2b3076aa8c829$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $90f2b3076aa8c829$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $90f2b3076aa8c829$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $90f2b3076aa8c829$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $90f2b3076aa8c829$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $90f2b3076aa8c829$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $90f2b3076aa8c829$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $90f2b3076aa8c829$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $90f2b3076aa8c829$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $90f2b3076aa8c829$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $90f2b3076aa8c829$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $90f2b3076aa8c829$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $90f2b3076aa8c829$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $90f2b3076aa8c829$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $90f2b3076aa8c829$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $90f2b3076aa8c829$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $90f2b3076aa8c829$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $90f2b3076aa8c829$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $90f2b3076aa8c829$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $90f2b3076aa8c829$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $90f2b3076aa8c829$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $90f2b3076aa8c829$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $90f2b3076aa8c829$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $90f2b3076aa8c829$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $90f2b3076aa8c829$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $90f2b3076aa8c829$export$1124ffa357d27237(I) {
    var r = {};
    if ($90f2b3076aa8c829$var$isFunctor(I)) r.map = $90f2b3076aa8c829$export$871de8747c9eaa88(I);
    if ($90f2b3076aa8c829$var$isContravariant(I)) r.contramap = $90f2b3076aa8c829$export$53b696d27ecb7ba7(I);
    if ($90f2b3076aa8c829$var$isFunctorWithIndex(I)) r.mapWithIndex = $90f2b3076aa8c829$export$8f07ddce13659f50(I);
    if ($90f2b3076aa8c829$var$isApply(I)) {
        r.ap = $90f2b3076aa8c829$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $kf9cS.apFirst)(I);
        r.apSecond = (0, $kf9cS.apSecond)(I);
    }
    if ($90f2b3076aa8c829$var$isChain(I)) {
        r.chain = $90f2b3076aa8c829$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $fl2uO.chainFirst)(I);
        r.flatten = r.chain((0, $6owmV.identity));
    }
    if ($90f2b3076aa8c829$var$isBifunctor(I)) {
        r.bimap = $90f2b3076aa8c829$export$eb54baf0b342cb1d(I);
        r.mapLeft = $90f2b3076aa8c829$export$472de43a55e4aa49(I);
    }
    if ($90f2b3076aa8c829$var$isExtend(I)) {
        r.extend = $90f2b3076aa8c829$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $6owmV.identity));
    }
    if ($90f2b3076aa8c829$var$isFoldable(I)) {
        r.reduce = $90f2b3076aa8c829$export$533b26079ad0b4b(I);
        r.foldMap = $90f2b3076aa8c829$export$b66cdc0497d8a99a(I);
        r.reduceRight = $90f2b3076aa8c829$export$7fef8bcdbb34f435(I);
    }
    if ($90f2b3076aa8c829$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $90f2b3076aa8c829$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $90f2b3076aa8c829$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $90f2b3076aa8c829$export$ce2b2fe0b88ccd0a(I);
    }
    if ($90f2b3076aa8c829$var$isAlt(I)) r.alt = $90f2b3076aa8c829$export$228be17d80722ab(I);
    if ($90f2b3076aa8c829$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($90f2b3076aa8c829$var$isFilterable(I)) {
        r.filter = $90f2b3076aa8c829$export$3dea766d36a8935f(I);
        r.filterMap = $90f2b3076aa8c829$export$a04c6c6965dd4709(I);
        r.partition = $90f2b3076aa8c829$export$b29f828819edca8d(I);
        r.partitionMap = $90f2b3076aa8c829$export$3117e3f9ececb6bc(I);
    }
    if ($90f2b3076aa8c829$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $90f2b3076aa8c829$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $90f2b3076aa8c829$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $90f2b3076aa8c829$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $90f2b3076aa8c829$export$bc7c0794b9c6f3ba(I);
    }
    if ($90f2b3076aa8c829$var$isProfunctor(I)) r.promap = $90f2b3076aa8c829$export$6684e88861ab74ec(I);
    if ($90f2b3076aa8c829$var$isSemigroupoid(I)) r.compose = $90f2b3076aa8c829$export$f672e0b6f7222cd7(I);
    if ($90f2b3076aa8c829$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $90f2b3076aa8c829$export$a4627e546088548d = (0, $6owmV.pipe);

});

parcelRegister("Z9TCE", function(module, exports) {

$parcel$export(module.exports, "fromIso", () => $0b7d5fc9423f8fdc$export$3160d47a1ad63980);

var $1sIL7 = parcelRequire("1sIL7");

var $crypz = parcelRequire("crypz");

var $4zd51 = parcelRequire("4zd51");

var $gJDUm = parcelRequire("gJDUm");

var $kI1cH = parcelRequire("kI1cH");
var $0b7d5fc9423f8fdc$export$493d36ec626b6698 = $kI1cH.at;
var $0b7d5fc9423f8fdc$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $0b7d5fc9423f8fdc$export$493d36ec626b6698(function(i) {
            return (0, $crypz.pipe)(iso, $kI1cH.isoAsLens, $kI1cH.lensComposeLens(sia.at(i)));
        });
    };
};
var $0b7d5fc9423f8fdc$export$ba8573d258bae607 = $kI1cH.atReadonlyRecord;
var $0b7d5fc9423f8fdc$export$3d6583cb45ca961e = function(E) {
    var lookupE = $4zd51.lookup(E);
    var deleteAtE = $4zd51.deleteAt(E);
    var insertAtE = $4zd51.insertAt(E);
    return function() {
        return $0b7d5fc9423f8fdc$export$493d36ec626b6698(function(key) {
            return $kI1cH.lens(function(s) {
                return lookupE(key, s);
            }, $1sIL7.fold(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $0b7d5fc9423f8fdc$export$388a7d8e51ea972f = function(E) {
    var elemE = $gJDUm.elem(E);
    var insertE = $gJDUm.insert(E);
    var removeE = $gJDUm.remove(E);
    return $0b7d5fc9423f8fdc$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $kI1cH.lens(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $0b7d5fc9423f8fdc$export$1cfc761eca4929a9 = $kI1cH.atReadonlyRecord;

});
parcelRegister("4zd51", function(module, exports) {

$parcel$export(module.exports, "lookup", () => $353493b6a5455058$export$dfc7155ac0343b8);
$parcel$export(module.exports, "deleteAt", () => $353493b6a5455058$export$90f9093465da3136);
$parcel$export(module.exports, "insertAt", () => $353493b6a5455058$export$9f200c4466975173);

var $JrPqh = parcelRequire("JrPqh");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $1sIL7 = parcelRequire("1sIL7");

var $iCI6U = parcelRequire("iCI6U");

var $ciQV6 = parcelRequire("ciQV6");
var $353493b6a5455058$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $353493b6a5455058$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $353493b6a5455058$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $353493b6a5455058$export$346677f925de839c = function(m) {
    return m.size;
};
var $353493b6a5455058$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $353493b6a5455058$export$6a0d13241802fe80(E) {
    var lookupE = $353493b6a5455058$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $353493b6a5455058$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $jc2nG.isSome(lookupE(k, m));
    };
}
function $353493b6a5455058$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $353493b6a5455058$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $353493b6a5455058$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $353493b6a5455058$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $353493b6a5455058$export$bb44f104e3c54dae(O) {
    var keysO = $353493b6a5455058$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $353493b6a5455058$export$4aaa3912a3956cb7 = function(O) {
    return $353493b6a5455058$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $353493b6a5455058$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $353493b6a5455058$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $jc2nG.some([
                kas[b],
                b + 1
            ]) : $jc2nG.none;
        });
    };
}
var $353493b6a5455058$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $353493b6a5455058$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($jc2nG.isNone(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $353493b6a5455058$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $353493b6a5455058$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($jc2nG.isSome(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $353493b6a5455058$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $353493b6a5455058$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $353493b6a5455058$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $353493b6a5455058$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($jc2nG.isNone(found)) return $jc2nG.none;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $jc2nG.some(m);
            var r = new Map(m);
            r.set(fk, next);
            return $jc2nG.some(r);
        };
    };
};
function $353493b6a5455058$export$3e41007ebfff0e64(E) {
    var lookupE = $353493b6a5455058$export$dfc7155ac0343b8(E);
    var deleteAtE = $353493b6a5455058$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $6owmV.pipe)(lookupE(k, m), $1sIL7.map(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $353493b6a5455058$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $353493b6a5455058$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $jc2nG.some([
                ka,
                a
            ]);
        }
        return $jc2nG.none;
    };
}
function $353493b6a5455058$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $353493b6a5455058$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $353493b6a5455058$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $6owmV.pipe)(lookupWithKeyE(k, m), $1sIL7.map(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $353493b6a5455058$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $353493b6a5455058$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $353493b6a5455058$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($jc2nG.isNone(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $353493b6a5455058$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $353493b6a5455058$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $353493b6a5455058$export$35d0420a84c5d3ae(SK, SA);
    return (0, $JrPqh.fromEquals)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $353493b6a5455058$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $353493b6a5455058$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($353493b6a5455058$export$dd1bc94b04021eeb(mx)) return my;
            if ($353493b6a5455058$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($jc2nG.isSome(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $353493b6a5455058$export$6e22c362a0406a2c
    };
}
var $353493b6a5455058$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $353493b6a5455058$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $353493b6a5455058$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($jc2nG.isSome(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $353493b6a5455058$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $353493b6a5455058$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($jc2nG.isLeft(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $iCI6U.separated)(left, right);
    };
};
function $353493b6a5455058$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $iCI6U.separated)(left, right);
    };
}
var $353493b6a5455058$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($jc2nG.isSome(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $353493b6a5455058$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $353493b6a5455058$var$_map = function(fa, f) {
    return $353493b6a5455058$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $353493b6a5455058$var$_filter = function(fa, p) {
    return $353493b6a5455058$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $353493b6a5455058$var$_filterMap = function(fa, f) {
    return $353493b6a5455058$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $353493b6a5455058$var$_partition = function(fa, predicate) {
    return $353493b6a5455058$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $353493b6a5455058$var$_partitionMap = function(fa, f) {
    return $353493b6a5455058$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $353493b6a5455058$var$_filterWithIndex = function(fa, p) {
    return (0, $6owmV.pipe)(fa, $353493b6a5455058$export$36e42aef19fc7171(p));
};
var $353493b6a5455058$var$_filterMapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $353493b6a5455058$export$30c5cbe848021e97(f));
};
var $353493b6a5455058$var$_partitionWithIndex = function(fa, p) {
    return (0, $6owmV.pipe)(fa, $353493b6a5455058$export$dad5e500f2bab9bc(p));
};
var $353493b6a5455058$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $353493b6a5455058$export$bc7c0794b9c6f3ba(f));
};
var $353493b6a5455058$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($jc2nG.isSome(oa)) m.set(k, oa.value);
    }
    return m;
};
var $353493b6a5455058$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $353493b6a5455058$var$_filter(fa, predicate);
    };
};
var $353493b6a5455058$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $353493b6a5455058$var$_filterMap(fa, f);
    };
};
var $353493b6a5455058$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $353493b6a5455058$var$_map(fa, f);
    };
};
var $353493b6a5455058$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $353493b6a5455058$var$_mapWithIndex(fa, f);
    };
};
var $353493b6a5455058$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $353493b6a5455058$var$_partition(fa, predicate);
    };
};
var $353493b6a5455058$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $353493b6a5455058$var$_partitionMap(fa, f);
    };
};
var $353493b6a5455058$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($jc2nG.isLeft(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $iCI6U.separated)(left, right);
};
var $353493b6a5455058$export$9156e739aa33e19f = 'ReadonlyMap';
var $353493b6a5455058$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $353493b6a5455058$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $353493b6a5455058$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $353493b6a5455058$export$baca17b4aff42f82(E, S).concat,
        empty: $353493b6a5455058$export$6e22c362a0406a2c
    };
};
var $353493b6a5455058$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $353493b6a5455058$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $353493b6a5455058$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $353493b6a5455058$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $353493b6a5455058$export$d600270efcad85ac() {
    return {
        URI: $353493b6a5455058$export$9156e739aa33e19f,
        _E: undefined,
        map: $353493b6a5455058$var$_map,
        mapWithIndex: $353493b6a5455058$var$_mapWithIndex,
        compact: $353493b6a5455058$export$8e16b83750b44988,
        separate: $353493b6a5455058$export$709f6946f4e97408,
        filter: $353493b6a5455058$var$_filter,
        filterMap: $353493b6a5455058$var$_filterMap,
        partition: $353493b6a5455058$var$_partition,
        partitionMap: $353493b6a5455058$var$_partitionMap,
        partitionMapWithIndex: $353493b6a5455058$var$_partitionMapWithIndex,
        partitionWithIndex: $353493b6a5455058$var$_partitionWithIndex,
        filterMapWithIndex: $353493b6a5455058$var$_filterMapWithIndex,
        filterWithIndex: $353493b6a5455058$var$_filterWithIndex
    };
}
var $353493b6a5455058$export$bd5b6bfc5fa2ee61 = {
    URI: $353493b6a5455058$export$9156e739aa33e19f,
    map: $353493b6a5455058$var$_map
};
var $353493b6a5455058$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($353493b6a5455058$export$bd5b6bfc5fa2ee61);
var $353493b6a5455058$export$7c7748da5f3db60f = function() {
    return {
        URI: $353493b6a5455058$export$9156e739aa33e19f,
        _E: undefined,
        map: $353493b6a5455058$var$_map,
        mapWithIndex: $353493b6a5455058$var$_mapWithIndex
    };
};
var $353493b6a5455058$export$4a21ac48141ac3c9 = {
    URI: $353493b6a5455058$export$9156e739aa33e19f,
    compact: $353493b6a5455058$export$8e16b83750b44988,
    separate: $353493b6a5455058$export$709f6946f4e97408
};
var $353493b6a5455058$export$d00e1c48fb621173 = {
    URI: $353493b6a5455058$export$9156e739aa33e19f,
    map: $353493b6a5455058$var$_map,
    compact: $353493b6a5455058$export$8e16b83750b44988,
    separate: $353493b6a5455058$export$709f6946f4e97408,
    filter: $353493b6a5455058$var$_filter,
    filterMap: $353493b6a5455058$var$_filterMap,
    partition: $353493b6a5455058$var$_partition,
    partitionMap: $353493b6a5455058$var$_partitionMap
};
var $353493b6a5455058$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $353493b6a5455058$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $353493b6a5455058$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $353493b6a5455058$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $353493b6a5455058$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $353493b6a5455058$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $353493b6a5455058$export$d544f02c7cebdaed = function(O) {
    var reduceO = $353493b6a5455058$export$533b26079ad0b4b(O);
    var foldMapO = $353493b6a5455058$export$b66cdc0497d8a99a(O);
    var reduceRightO = $353493b6a5455058$export$7fef8bcdbb34f435(O);
    return {
        URI: $353493b6a5455058$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $6owmV.pipe)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $6owmV.pipe)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $6owmV.pipe)(fa, reduceRightO(b, f));
        }
    };
};
var $353493b6a5455058$export$bbd3ef8720e22369 = function(O) {
    var keysO = $353493b6a5455058$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $353493b6a5455058$export$18153bb1181268e5 = function(O) {
    var keysO = $353493b6a5455058$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $353493b6a5455058$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $353493b6a5455058$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $353493b6a5455058$export$6c59d75f118e7bc9 = function(O) {
    var F = $353493b6a5455058$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $353493b6a5455058$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $353493b6a5455058$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $353493b6a5455058$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $353493b6a5455058$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $6owmV.pipe)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $6owmV.pipe)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $6owmV.pipe)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $353493b6a5455058$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $353493b6a5455058$export$46b81797a3375b8c(O);
    var F = $353493b6a5455058$export$d544f02c7cebdaed(O);
    return {
        URI: $353493b6a5455058$export$9156e739aa33e19f,
        _E: undefined,
        map: $353493b6a5455058$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $353493b6a5455058$export$46b81797a3375b8c = function(O) {
    var FWI = $353493b6a5455058$export$6c59d75f118e7bc9(O);
    var keysO = $353493b6a5455058$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $6owmV.SK));
        };
    };
    return {
        URI: $353493b6a5455058$export$9156e739aa33e19f,
        _E: undefined,
        map: $353493b6a5455058$var$_map,
        mapWithIndex: $353493b6a5455058$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $353493b6a5455058$export$bb8ef26a634cac7b(O) {
    var TWI = $353493b6a5455058$export$46b81797a3375b8c(O);
    return {
        URI: $353493b6a5455058$export$9156e739aa33e19f,
        _E: undefined,
        map: $353493b6a5455058$var$_map,
        compact: $353493b6a5455058$export$8e16b83750b44988,
        separate: $353493b6a5455058$export$709f6946f4e97408,
        filter: $353493b6a5455058$var$_filter,
        filterMap: $353493b6a5455058$var$_filterMap,
        partition: $353493b6a5455058$var$_partition,
        partitionMap: $353493b6a5455058$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $353493b6a5455058$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $ciQV6.wiltDefault)(TWI, $353493b6a5455058$export$4a21ac48141ac3c9),
        wither: (0, $ciQV6.witherDefault)(TWI, $353493b6a5455058$export$4a21ac48141ac3c9)
    };
}
var $353493b6a5455058$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $353493b6a5455058$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($353493b6a5455058$export$dd1bc94b04021eeb(first)) return second;
            if ($353493b6a5455058$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($jc2nG.isSome(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($jc2nG.isNone(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $353493b6a5455058$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $353493b6a5455058$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($353493b6a5455058$export$dd1bc94b04021eeb(first) || $353493b6a5455058$export$dd1bc94b04021eeb(second)) return $353493b6a5455058$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($jc2nG.isSome(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $353493b6a5455058$export$acaf96a27438246b = function(E) {
    var memberE = $353493b6a5455058$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($353493b6a5455058$export$dd1bc94b04021eeb(first)) return second;
            if ($353493b6a5455058$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $353493b6a5455058$export$9f200c4466975173 = $353493b6a5455058$export$ff82449ce381c54a;
var $353493b6a5455058$export$28562fb56044e6b5 = {
    URI: $353493b6a5455058$export$9156e739aa33e19f,
    map: $353493b6a5455058$var$_map,
    compact: $353493b6a5455058$export$8e16b83750b44988,
    separate: $353493b6a5455058$export$709f6946f4e97408,
    filter: $353493b6a5455058$var$_filter,
    filterMap: $353493b6a5455058$var$_filterMap,
    partition: $353493b6a5455058$var$_partition,
    partitionMap: $353493b6a5455058$var$_partitionMap
};

});

parcelRegister("gJDUm", function(module, exports) {

$parcel$export(module.exports, "elem", () => $c2efce3ad56cd8ac$export$5bf96401662340b7);
$parcel$export(module.exports, "insert", () => $c2efce3ad56cd8ac$export$21a5ca8aa77d35ff);
$parcel$export(module.exports, "remove", () => $c2efce3ad56cd8ac$export$cd7f480d6b8286c3);

var $JrPqh = parcelRequire("JrPqh");

var $6owmV = parcelRequire("6owmV");

var $cJQb0 = parcelRequire("cJQb0");

var $iCI6U = parcelRequire("iCI6U");
var $c2efce3ad56cd8ac$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $c2efce3ad56cd8ac$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $c2efce3ad56cd8ac$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $c2efce3ad56cd8ac$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $c2efce3ad56cd8ac$export$871de8747c9eaa88(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $c2efce3ad56cd8ac$export$e08e3b67e392101e(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $c2efce3ad56cd8ac$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $c2efce3ad56cd8ac$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $iCI6U.separated)(left, right);
    };
}
function $c2efce3ad56cd8ac$export$971dd5b0dfd021b6(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $c2efce3ad56cd8ac$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($c2efce3ad56cd8ac$export$dd1bc94b04021eeb(me)) return that;
        if ($c2efce3ad56cd8ac$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $c2efce3ad56cd8ac$export$bc86dfbf7795668c(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $c2efce3ad56cd8ac$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($c2efce3ad56cd8ac$export$dd1bc94b04021eeb(me) || $c2efce3ad56cd8ac$export$dd1bc94b04021eeb(that)) return $c2efce3ad56cd8ac$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $c2efce3ad56cd8ac$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $c2efce3ad56cd8ac$export$5bf96401662340b7(EB);
            var hasC = $c2efce3ad56cd8ac$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $iCI6U.separated)(left, right);
        };
    };
}
function $c2efce3ad56cd8ac$export$acaf96a27438246b(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $c2efce3ad56cd8ac$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $c2efce3ad56cd8ac$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $c2efce3ad56cd8ac$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $c2efce3ad56cd8ac$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $c2efce3ad56cd8ac$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $c2efce3ad56cd8ac$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $c2efce3ad56cd8ac$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $c2efce3ad56cd8ac$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $c2efce3ad56cd8ac$export$21a5ca8aa77d35ff(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $c2efce3ad56cd8ac$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $c2efce3ad56cd8ac$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $c2efce3ad56cd8ac$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    var removeE = $c2efce3ad56cd8ac$export$cd7f480d6b8286c3(E);
    var insertE = $c2efce3ad56cd8ac$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $c2efce3ad56cd8ac$export$8e16b83750b44988 = function(E) {
    return $c2efce3ad56cd8ac$export$a04c6c6965dd4709(E)((0, $6owmV.identity));
};
function $c2efce3ad56cd8ac$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $c2efce3ad56cd8ac$export$5bf96401662340b7(EE);
        var elemEA = $c2efce3ad56cd8ac$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $iCI6U.separated)(left, right);
    };
}
function $c2efce3ad56cd8ac$export$a04c6c6965dd4709(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $c2efce3ad56cd8ac$export$6e22c362a0406a2c = new Set();
var $c2efce3ad56cd8ac$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $c2efce3ad56cd8ac$export$346677f925de839c = function(set) {
    return set.size;
};
var $c2efce3ad56cd8ac$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $c2efce3ad56cd8ac$export$7ecc1a3b11b57dab(predicate) {
    return (0, $cJQb0.not)($c2efce3ad56cd8ac$export$ad14ef4001db2bcd((0, $cJQb0.not)(predicate)));
}
function $c2efce3ad56cd8ac$export$af04532ec9ff13d2(E) {
    var elemE = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $c2efce3ad56cd8ac$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $c2efce3ad56cd8ac$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $c2efce3ad56cd8ac$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $c2efce3ad56cd8ac$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $c2efce3ad56cd8ac$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $c2efce3ad56cd8ac$export$9156e739aa33e19f = 'ReadonlySet';
function $c2efce3ad56cd8ac$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $c2efce3ad56cd8ac$export$804fed467fde44e4(E) {
    var subsetE = $c2efce3ad56cd8ac$export$af04532ec9ff13d2(E);
    return (0, $JrPqh.fromEquals)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $c2efce3ad56cd8ac$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $c2efce3ad56cd8ac$export$971dd5b0dfd021b6(E)
    };
};
var $c2efce3ad56cd8ac$export$c487aac9f4157837 = function(E) {
    return {
        concat: $c2efce3ad56cd8ac$export$baca17b4aff42f82(E).concat,
        empty: $c2efce3ad56cd8ac$export$6e22c362a0406a2c
    };
};
var $c2efce3ad56cd8ac$export$d379a869a72e4055 = function(E) {
    return {
        concat: $c2efce3ad56cd8ac$export$bc86dfbf7795668c(E)
    };
};
var $c2efce3ad56cd8ac$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $c2efce3ad56cd8ac$export$acaf96a27438246b(E)
    };
};
var $c2efce3ad56cd8ac$export$571d59b505e6bb4e = $c2efce3ad56cd8ac$export$9288e031f1846591;

});

parcelRegister("kI1cH", function(module, exports) {

$parcel$export(module.exports, "iso", () => $f138d9c72ca021d3$export$1aba8f741a0eae06);
$parcel$export(module.exports, "isoAsLens", () => $f138d9c72ca021d3$export$d001ee9513dee7c1);
$parcel$export(module.exports, "lens", () => $f138d9c72ca021d3$export$21cde5187c2605a3);
$parcel$export(module.exports, "isoAsPrism", () => $f138d9c72ca021d3$export$fde8c5b9dff57abc);
$parcel$export(module.exports, "prism", () => $f138d9c72ca021d3$export$e469dcfea9910464);
$parcel$export(module.exports, "isoAsOptional", () => $f138d9c72ca021d3$export$4d3db894cf45abd5);
$parcel$export(module.exports, "optional", () => $f138d9c72ca021d3$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "isoAsTraversal", () => $f138d9c72ca021d3$export$e55a826b3ba968d2);
$parcel$export(module.exports, "traversal", () => $f138d9c72ca021d3$export$8666ce7a134c2314);
$parcel$export(module.exports, "lensAsOptional", () => $f138d9c72ca021d3$export$bae94c671b4dc75d);
$parcel$export(module.exports, "lensAsTraversal", () => $f138d9c72ca021d3$export$e5de01c31c85830c);
$parcel$export(module.exports, "lensComposeLens", () => $f138d9c72ca021d3$export$62d1b5266563d2b6);
$parcel$export(module.exports, "prismComposePrism", () => $f138d9c72ca021d3$export$af9c087537c23eb1);
$parcel$export(module.exports, "lensComposePrism", () => $f138d9c72ca021d3$export$ffffe1ca21811d93);
$parcel$export(module.exports, "optionalComposeOptional", () => $f138d9c72ca021d3$export$8e08893559c32e38);
$parcel$export(module.exports, "prismAsOptional", () => $f138d9c72ca021d3$export$70f4d204f3bdc8bd);
$parcel$export(module.exports, "lensId", () => $f138d9c72ca021d3$export$a4b03755c6673298);
$parcel$export(module.exports, "lensProp", () => $f138d9c72ca021d3$export$a6ba95b157529836);
$parcel$export(module.exports, "lensProps", () => $f138d9c72ca021d3$export$c19575454e66bf5f);
$parcel$export(module.exports, "lensComponent", () => $f138d9c72ca021d3$export$103f2a6258fae742);
$parcel$export(module.exports, "lensAtKey", () => $f138d9c72ca021d3$export$fc68a3bfc89f0b98);
$parcel$export(module.exports, "atReadonlyRecord", () => $f138d9c72ca021d3$export$ba8573d258bae607);
$parcel$export(module.exports, "prismSet", () => $f138d9c72ca021d3$export$97725fa315d6412c);
$parcel$export(module.exports, "prismAsTraversal", () => $f138d9c72ca021d3$export$18564f4597667b6a);
$parcel$export(module.exports, "prismModifyOption", () => $f138d9c72ca021d3$export$ddb3ff54eaa1c530);
$parcel$export(module.exports, "prismModify", () => $f138d9c72ca021d3$export$f545e0bcbe4b5ea7);
$parcel$export(module.exports, "prismComposeLens", () => $f138d9c72ca021d3$export$dad01448ef670850);
$parcel$export(module.exports, "prismFromNullable", () => $f138d9c72ca021d3$export$258cc98aa6d7d21b);
$parcel$export(module.exports, "prismFromPredicate", () => $f138d9c72ca021d3$export$8f316a2f03469694);
$parcel$export(module.exports, "prismSome", () => $f138d9c72ca021d3$export$782e8b2fe031f968);
$parcel$export(module.exports, "prismRight", () => $f138d9c72ca021d3$export$929e170fdd93186c);
$parcel$export(module.exports, "prismLeft", () => $f138d9c72ca021d3$export$97ae81cf28b21f26);
$parcel$export(module.exports, "optionalAsTraversal", () => $f138d9c72ca021d3$export$a595a5197cc37264);
$parcel$export(module.exports, "optionalModifyOption", () => $f138d9c72ca021d3$export$48aae8aebe6d3ee9);
$parcel$export(module.exports, "optionalModify", () => $f138d9c72ca021d3$export$6d575f282c3c1d48);
$parcel$export(module.exports, "optionalIndex", () => $f138d9c72ca021d3$export$47ac94aa95300c6f);
$parcel$export(module.exports, "indexReadonlyArray", () => $f138d9c72ca021d3$export$bb0c054375ca4b0);
$parcel$export(module.exports, "optionalIndexNonEmpty", () => $f138d9c72ca021d3$export$83e62439a4d30c4c);
$parcel$export(module.exports, "indexReadonlyNonEmptyArray", () => $f138d9c72ca021d3$export$165af7b747e6b1f1);
$parcel$export(module.exports, "optionalKey", () => $f138d9c72ca021d3$export$a6c26e1663200bf4);
$parcel$export(module.exports, "indexReadonlyRecord", () => $f138d9c72ca021d3$export$3c3468aec3b83bbf);
$parcel$export(module.exports, "optionalFindFirst", () => $f138d9c72ca021d3$export$220673392b48821b);
$parcel$export(module.exports, "optionalFindFirstNonEmpty", () => $f138d9c72ca021d3$export$cf29cfc68de9a659);
$parcel$export(module.exports, "traversalComposeTraversal", () => $f138d9c72ca021d3$export$2c68ab81171b083f);
$parcel$export(module.exports, "ApplicativeIdentity", () => $f138d9c72ca021d3$export$7c4912ca011fa00e);
$parcel$export(module.exports, "fromTraversable", () => $f138d9c72ca021d3$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "traversalTraverse", () => $f138d9c72ca021d3$export$35db6fcbd934c57);
$parcel$export(module.exports, "index", () => $f138d9c72ca021d3$export$b610b8812bbcded9);
$parcel$export(module.exports, "at", () => $f138d9c72ca021d3$export$493d36ec626b6698);

var $8D8qW = parcelRequire("8D8qW");

var $ai8ct = parcelRequire("ai8ct");

var $6owmV = parcelRequire("6owmV");

var $1sIL7 = parcelRequire("1sIL7");

var $gmg2A = parcelRequire("gmg2A");

var $crypz = parcelRequire("crypz");
var $f138d9c72ca021d3$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f138d9c72ca021d3$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $f138d9c72ca021d3$export$d001ee9513dee7c1 = function(sa) {
    return $f138d9c72ca021d3$export$21cde5187c2605a3(sa.get, (0, $6owmV.flow)(sa.reverseGet, (0, $6owmV.constant)));
};
var $f138d9c72ca021d3$export$fde8c5b9dff57abc = function(sa) {
    return $f138d9c72ca021d3$export$e469dcfea9910464((0, $6owmV.flow)(sa.get, $1sIL7.some), sa.reverseGet);
};
var $f138d9c72ca021d3$export$4d3db894cf45abd5 = function(sa) {
    return $f138d9c72ca021d3$export$516e28dec6a4b6d4((0, $6owmV.flow)(sa.get, $1sIL7.some), (0, $6owmV.flow)(sa.reverseGet, (0, $6owmV.constant)));
};
var $f138d9c72ca021d3$export$e55a826b3ba968d2 = function(sa) {
    return $f138d9c72ca021d3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $f138d9c72ca021d3$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $f138d9c72ca021d3$export$bae94c671b4dc75d = function(sa) {
    return $f138d9c72ca021d3$export$516e28dec6a4b6d4((0, $6owmV.flow)(sa.get, $1sIL7.some), sa.set);
};
var $f138d9c72ca021d3$export$e5de01c31c85830c = function(sa) {
    return $f138d9c72ca021d3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $f138d9c72ca021d3$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $f138d9c72ca021d3$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $f138d9c72ca021d3$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $f138d9c72ca021d3$export$e469dcfea9910464((0, $6owmV.flow)(sa.getOption, $1sIL7.chain(ab.getOption)), (0, $6owmV.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $f138d9c72ca021d3$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $f138d9c72ca021d3$export$8e08893559c32e38($f138d9c72ca021d3$export$70f4d204f3bdc8bd(ab))($f138d9c72ca021d3$export$bae94c671b4dc75d(sa));
    };
};
var $f138d9c72ca021d3$export$a4b03755c6673298 = function() {
    return $f138d9c72ca021d3$export$21cde5187c2605a3((0, $6owmV.identity), (0, $6owmV.constant));
};
var $f138d9c72ca021d3$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $f138d9c72ca021d3$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $f138d9c72ca021d3$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $f138d9c72ca021d3$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $f138d9c72ca021d3$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $f138d9c72ca021d3$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $f138d9c72ca021d3$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $f138d9c72ca021d3$export$62d1b5266563d2b6($f138d9c72ca021d3$export$ba8573d258bae607().at(key)));
    };
};
var $f138d9c72ca021d3$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $f138d9c72ca021d3$export$70f4d204f3bdc8bd = function(sa) {
    return $f138d9c72ca021d3$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $f138d9c72ca021d3$export$97725fa315d6412c(a)(sa);
    });
};
var $f138d9c72ca021d3$export$18564f4597667b6a = function(sa) {
    return $f138d9c72ca021d3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $crypz.pipe)(sa.getOption(s), $1sIL7.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $f138d9c72ca021d3$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $f138d9c72ca021d3$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $crypz.pipe)(sa.getOption(s), $1sIL7.map(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $f138d9c72ca021d3$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $f138d9c72ca021d3$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $crypz.pipe)(g(s), $1sIL7.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $f138d9c72ca021d3$export$97725fa315d6412c = function(a) {
    return $f138d9c72ca021d3$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $f138d9c72ca021d3$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $f138d9c72ca021d3$export$8e08893559c32e38($f138d9c72ca021d3$export$bae94c671b4dc75d(ab))($f138d9c72ca021d3$export$70f4d204f3bdc8bd(sa));
    };
};
var $f138d9c72ca021d3$export$258cc98aa6d7d21b = function() {
    return $f138d9c72ca021d3$export$e469dcfea9910464($1sIL7.fromNullable, (0, $6owmV.identity));
};
var $f138d9c72ca021d3$export$8f316a2f03469694 = function(predicate) {
    return $f138d9c72ca021d3$export$e469dcfea9910464($1sIL7.fromPredicate(predicate), (0, $6owmV.identity));
};
var $f138d9c72ca021d3$export$782e8b2fe031f968 = function() {
    return $f138d9c72ca021d3$export$e469dcfea9910464((0, $6owmV.identity), $1sIL7.some);
};
var $f138d9c72ca021d3$export$929e170fdd93186c = function() {
    return $f138d9c72ca021d3$export$e469dcfea9910464($1sIL7.fromEither, $gmg2A.right);
};
var $f138d9c72ca021d3$export$97ae81cf28b21f26 = function() {
    return $f138d9c72ca021d3$export$e469dcfea9910464(function(s) {
        return $gmg2A.isLeft(s) ? $1sIL7.some(s.left) : $1sIL7.none;
    }, $gmg2A.left);
};
var $f138d9c72ca021d3$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $f138d9c72ca021d3$export$a595a5197cc37264 = function(sa) {
    return $f138d9c72ca021d3$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $crypz.pipe)(sa.getOption(s), $1sIL7.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $f138d9c72ca021d3$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $crypz.pipe)(optional.getOption(s), $1sIL7.map(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $f138d9c72ca021d3$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $f138d9c72ca021d3$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $crypz.pipe)(g(s), $1sIL7.getOrElse(function() {
                return s;
            }));
        };
    };
};
var $f138d9c72ca021d3$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $f138d9c72ca021d3$export$516e28dec6a4b6d4((0, $6owmV.flow)(sa.getOption, $1sIL7.chain(ab.getOption)), function(b) {
            return $f138d9c72ca021d3$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $f138d9c72ca021d3$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $f138d9c72ca021d3$export$8e08893559c32e38($f138d9c72ca021d3$export$bb0c054375ca4b0().index(i)));
    };
};
var $f138d9c72ca021d3$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $f138d9c72ca021d3$export$8e08893559c32e38($f138d9c72ca021d3$export$165af7b747e6b1f1().index(i)));
    };
};
var $f138d9c72ca021d3$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $f138d9c72ca021d3$export$8e08893559c32e38($f138d9c72ca021d3$export$3c3468aec3b83bbf().index(key)));
    };
};
var $f138d9c72ca021d3$export$220673392b48821b = function(predicate) {
    return $f138d9c72ca021d3$export$516e28dec6a4b6d4($8D8qW.findFirst(predicate), function(a) {
        return function(s) {
            return (0, $crypz.pipe)($8D8qW.findIndex(predicate)(s), $1sIL7.fold(function() {
                return s;
            }, function(i) {
                return $8D8qW.unsafeUpdateAt(i, a, s);
            }));
        };
    });
};
var $f138d9c72ca021d3$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $f138d9c72ca021d3$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $f138d9c72ca021d3$export$cf29cfc68de9a659 = function(predicate) {
    return $f138d9c72ca021d3$export$516e28dec6a4b6d4($8D8qW.findFirst(predicate), function(a) {
        return function(as) {
            return (0, $crypz.pipe)($8D8qW.findIndex(predicate)(as), $1sIL7.fold(function() {
                return as;
            }, function(i) {
                return $f138d9c72ca021d3$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $f138d9c72ca021d3$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $f138d9c72ca021d3$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $f138d9c72ca021d3$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $f138d9c72ca021d3$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $6owmV.identity),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $f138d9c72ca021d3$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $f138d9c72ca021d3$export$126b5a87c58d3f9c(T) {
    return function() {
        return $f138d9c72ca021d3$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $f138d9c72ca021d3$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $f138d9c72ca021d3$export$35db6fcbd934c57(T) {
    return $f138d9c72ca021d3$export$2c68ab81171b083f($f138d9c72ca021d3$export$126b5a87c58d3f9c(T)());
}
var $f138d9c72ca021d3$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $f138d9c72ca021d3$export$bb0c054375ca4b0 = function() {
    return $f138d9c72ca021d3$export$b610b8812bbcded9(function(i) {
        return $f138d9c72ca021d3$export$516e28dec6a4b6d4(function(as) {
            return $8D8qW.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $crypz.pipe)($8D8qW.lookup(i, as), $1sIL7.fold(function() {
                    return as;
                }, function() {
                    return $8D8qW.unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $f138d9c72ca021d3$export$165af7b747e6b1f1 = function() {
    return $f138d9c72ca021d3$export$b610b8812bbcded9(function(i) {
        return $f138d9c72ca021d3$export$516e28dec6a4b6d4(function(as) {
            return $8D8qW.lookup(i, as);
        }, function(a) {
            return function(as) {
                return (0, $crypz.pipe)($8D8qW.lookup(i, as), $1sIL7.fold(function() {
                    return as;
                }, function() {
                    return $f138d9c72ca021d3$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $f138d9c72ca021d3$export$3c3468aec3b83bbf = function() {
    return $f138d9c72ca021d3$export$b610b8812bbcded9(function(k) {
        return $f138d9c72ca021d3$export$516e28dec6a4b6d4(function(r) {
            return $ai8ct.lookup(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $1sIL7.isNone($ai8ct.lookup(k, r))) return r;
                return $ai8ct.insertAt(k, a)(r);
            };
        });
    });
};
var $f138d9c72ca021d3$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $f138d9c72ca021d3$export$ba8573d258bae607() {
    return $f138d9c72ca021d3$export$493d36ec626b6698(function(key) {
        return $f138d9c72ca021d3$export$21cde5187c2605a3(function(r) {
            return $ai8ct.lookup(key, r);
        }, $1sIL7.fold(function() {
            return $ai8ct.deleteAt(key);
        }, function(a) {
            return $ai8ct.insertAt(key, a);
        }));
    });
}

});
parcelRegister("ai8ct", function(module, exports) {

$parcel$export(module.exports, "deleteAt", () => $77e1f23488919643$export$90f9093465da3136);
$parcel$export(module.exports, "lookup", () => $77e1f23488919643$export$dfc7155ac0343b8);
$parcel$export(module.exports, "insertAt", () => $77e1f23488919643$export$9f200c4466975173);

var $JrPqh = parcelRequire("JrPqh");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $iCI6U = parcelRequire("iCI6U");

var $7bwGq = parcelRequire("7bwGq");

var $ciQV6 = parcelRequire("ciQV6");
var $77e1f23488919643$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $77e1f23488919643$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $77e1f23488919643$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $77e1f23488919643$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($jc2nG.has.call(r, k)) return false;
    }
    return true;
};
var $77e1f23488919643$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $77e1f23488919643$export$ed97f33186d4b816 = /*#__PURE__*/ $77e1f23488919643$var$keys_($7bwGq.Ord);
function $77e1f23488919643$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $77e1f23488919643$export$bb44f104e3c54dae($7bwGq.Ord)(O);
    var keysO = $77e1f23488919643$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $77e1f23488919643$export$4aaa3912a3956cb7 = /*#__PURE__*/ $77e1f23488919643$export$bb44f104e3c54dae($7bwGq.Ord)(function(k, a) {
    return [
        k,
        a
    ];
});
function $77e1f23488919643$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $77e1f23488919643$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $jc2nG.some([
                sas[b],
                b + 1
            ]) : $jc2nG.none;
        });
    };
}
var $77e1f23488919643$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($jc2nG.has.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $77e1f23488919643$export$a4f4bb6b1453fff5 = function(k, r) {
    return $jc2nG.has.call(r, k);
};
function $77e1f23488919643$export$90f9093465da3136(k) {
    return function(r) {
        if (!$jc2nG.has.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $77e1f23488919643$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$77e1f23488919643$export$a4f4bb6b1453fff5(k, r)) return $jc2nG.none;
        if (r[k] === a) return $jc2nG.some(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $jc2nG.some(out);
    };
};
var $77e1f23488919643$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$77e1f23488919643$export$a4f4bb6b1453fff5(k, r)) return $jc2nG.none;
        var next = f(r[k]);
        if (next === r[k]) return $jc2nG.some(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $jc2nG.some(out);
    };
};
function $77e1f23488919643$export$3e41007ebfff0e64(k) {
    var deleteAtk = $77e1f23488919643$export$90f9093465da3136(k);
    return function(r) {
        var oa = $77e1f23488919643$export$dfc7155ac0343b8(k, r);
        return $jc2nG.isNone(oa) ? $jc2nG.none : $jc2nG.some([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $77e1f23488919643$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $77e1f23488919643$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$jc2nG.has.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $77e1f23488919643$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $77e1f23488919643$export$dfc7155ac0343b8(k, r);
    };
    return $jc2nG.has.call(r, k) ? $jc2nG.some(r[k]) : $jc2nG.none;
}
var $77e1f23488919643$export$6e22c362a0406a2c = {};
function $77e1f23488919643$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($jc2nG.has.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $77e1f23488919643$export$871de8747c9eaa88(f) {
    return $77e1f23488919643$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $77e1f23488919643$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $77e1f23488919643$export$bbd3ef8720e22369($7bwGq.Ord).apply(void 0, args);
    var keysO = $77e1f23488919643$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $77e1f23488919643$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $77e1f23488919643$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $77e1f23488919643$export$18153bb1181268e5($7bwGq.Ord)(O);
}
function $77e1f23488919643$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $77e1f23488919643$export$ce2b2fe0b88ccd0a($7bwGq.Ord).apply(void 0, args);
    var keysO = $77e1f23488919643$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $77e1f23488919643$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $77e1f23488919643$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $77e1f23488919643$var$_traverseWithIndex($7bwGq.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $77e1f23488919643$export$df3f009e3d155b20(F) {
    var traverseOF = $77e1f23488919643$export$b3c6f3d9661cffba($7bwGq.Ord)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $77e1f23488919643$export$49bb65c2ea163039(F) {
    return $77e1f23488919643$export$5d141086b2c0bc6($7bwGq.Ord)(F);
}
var $77e1f23488919643$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $77e1f23488919643$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $6owmV.pipe)(fa, traverseF(f)), $77e1f23488919643$export$8e16b83750b44988);
        };
    };
};
var $77e1f23488919643$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $77e1f23488919643$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $6owmV.pipe)(fa, traverseF(f)), $77e1f23488919643$export$709f6946f4e97408);
        };
    };
};
function $77e1f23488919643$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($jc2nG.has.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $iCI6U.separated)(left, right);
    };
}
function $77e1f23488919643$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($jc2nG.has.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $iCI6U.separated)(left, right);
    };
}
function $77e1f23488919643$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($jc2nG.has.call(r, k)) {
            var ob = f(k, r[k]);
            if ($jc2nG.isSome(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $77e1f23488919643$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($jc2nG.has.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $77e1f23488919643$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $77e1f23488919643$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $6owmV.identity));
    };
}
function $77e1f23488919643$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $jc2nG.has.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $77e1f23488919643$export$9f69d28786a8399c = $77e1f23488919643$export$4aaa3912a3956cb7;
var $77e1f23488919643$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $77e1f23488919643$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $77e1f23488919643$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $77e1f23488919643$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $77e1f23488919643$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $77e1f23488919643$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($77e1f23488919643$export$dd1bc94b04021eeb(first)) return second;
            if ($77e1f23488919643$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($77e1f23488919643$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$77e1f23488919643$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $77e1f23488919643$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($77e1f23488919643$export$dd1bc94b04021eeb(first) || $77e1f23488919643$export$dd1bc94b04021eeb(second)) return $77e1f23488919643$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($77e1f23488919643$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $77e1f23488919643$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($77e1f23488919643$export$dd1bc94b04021eeb(first)) return second;
        if ($77e1f23488919643$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$77e1f23488919643$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$77e1f23488919643$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $77e1f23488919643$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$871de8747c9eaa88(f));
};
var $77e1f23488919643$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$8f07ddce13659f50(f));
};
var $77e1f23488919643$export$8eef5fdba9512999 = function(O) {
    var reduceO = $77e1f23488919643$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $6owmV.pipe)(fa, reduceO(b, f));
    };
};
var $77e1f23488919643$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $77e1f23488919643$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $6owmV.pipe)(fa, foldMapM(f));
        };
    };
};
var $77e1f23488919643$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $77e1f23488919643$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $6owmV.pipe)(fa, reduceRightO(b, f));
    };
};
var $77e1f23488919643$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$3dea766d36a8935f(predicate));
};
var $77e1f23488919643$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$a04c6c6965dd4709(f));
};
var $77e1f23488919643$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$b29f828819edca8d(predicate));
};
var $77e1f23488919643$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$3117e3f9ececb6bc(f));
};
var $77e1f23488919643$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $77e1f23488919643$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $6owmV.pipe)(fa, reduceWithIndexO(b, f));
    };
};
var $77e1f23488919643$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $77e1f23488919643$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $6owmV.pipe)(fa, foldMapWithIndexM(f));
        };
    };
};
var $77e1f23488919643$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $77e1f23488919643$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $6owmV.pipe)(fa, reduceRightWithIndexO(b, f));
    };
};
var $77e1f23488919643$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$bc7c0794b9c6f3ba(f));
};
var $77e1f23488919643$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $77e1f23488919643$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$30c5cbe848021e97(f));
};
var $77e1f23488919643$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $6owmV.pipe)(fa, $77e1f23488919643$export$36e42aef19fc7171(predicateWithIndex));
};
var $77e1f23488919643$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $77e1f23488919643$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $6owmV.flow)((0, $6owmV.SK), f));
        };
    };
};
var $77e1f23488919643$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $77e1f23488919643$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $6owmV.identity));
        };
    };
};
var $77e1f23488919643$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $77e1f23488919643$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($77e1f23488919643$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $77e1f23488919643$export$3dea766d36a8935f = function(predicate) {
    return $77e1f23488919643$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $77e1f23488919643$export$a04c6c6965dd4709 = function(f) {
    return $77e1f23488919643$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $77e1f23488919643$export$b29f828819edca8d = function(predicate) {
    return $77e1f23488919643$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $77e1f23488919643$export$3117e3f9ececb6bc = function(f) {
    return $77e1f23488919643$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $77e1f23488919643$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $77e1f23488919643$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $77e1f23488919643$export$533b26079ad0b4b($7bwGq.Ord).apply(void 0, args);
}
function $77e1f23488919643$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $77e1f23488919643$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $77e1f23488919643$export$b66cdc0497d8a99a($7bwGq.Ord)(O);
}
function $77e1f23488919643$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $77e1f23488919643$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $77e1f23488919643$export$7fef8bcdbb34f435($7bwGq.Ord).apply(void 0, args);
}
var $77e1f23488919643$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($jc2nG.has.call(r, k)) {
        var oa = r[k];
        if ($jc2nG.isSome(oa)) out[k] = oa.value;
    }
    return out;
};
var $77e1f23488919643$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($jc2nG.has.call(r, k)) {
        var e = r[k];
        if ($jc2nG.isLeft(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $iCI6U.separated)(left, right);
};
var $77e1f23488919643$export$9156e739aa33e19f = 'ReadonlyRecord';
function $77e1f23488919643$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $77e1f23488919643$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $77e1f23488919643$export$3cb5cd7f7776c81($7bwGq.Ord)(O);
}
function $77e1f23488919643$export$804fed467fde44e4(E) {
    var isSubrecordE = $77e1f23488919643$export$36e6f76a1d117b8a(E);
    return (0, $JrPqh.fromEquals)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $77e1f23488919643$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($77e1f23488919643$export$dd1bc94b04021eeb(first)) return second;
            if ($77e1f23488919643$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($jc2nG.has.call(second, k)) r[k] = $jc2nG.has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $77e1f23488919643$export$6e22c362a0406a2c
    };
}
var $77e1f23488919643$export$bd5b6bfc5fa2ee61 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab
};
var $77e1f23488919643$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($77e1f23488919643$export$bd5b6bfc5fa2ee61);
var $77e1f23488919643$export$9fdffe0fe1e91cad = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab,
    mapWithIndex: $77e1f23488919643$export$45e3e46323e6d66c
};
var $77e1f23488919643$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $77e1f23488919643$export$9156e739aa33e19f,
        reduce: $77e1f23488919643$export$8eef5fdba9512999(O),
        foldMap: $77e1f23488919643$export$11b0d0e0b70641d9(O),
        reduceRight: $77e1f23488919643$export$ec882fc9def9e5db(O)
    };
};
var $77e1f23488919643$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $77e1f23488919643$export$9156e739aa33e19f,
        reduce: $77e1f23488919643$export$8eef5fdba9512999(O),
        foldMap: $77e1f23488919643$export$11b0d0e0b70641d9(O),
        reduceRight: $77e1f23488919643$export$ec882fc9def9e5db(O),
        reduceWithIndex: $77e1f23488919643$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $77e1f23488919643$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $77e1f23488919643$export$3b7618311030b1af(O)
    };
};
var $77e1f23488919643$export$4a21ac48141ac3c9 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    compact: $77e1f23488919643$export$8e16b83750b44988,
    separate: $77e1f23488919643$export$709f6946f4e97408
};
var $77e1f23488919643$export$d00e1c48fb621173 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab,
    compact: $77e1f23488919643$export$8e16b83750b44988,
    separate: $77e1f23488919643$export$709f6946f4e97408,
    filter: $77e1f23488919643$export$ec7439dc64f73058,
    filterMap: $77e1f23488919643$export$e8609d6e184911e6,
    partition: $77e1f23488919643$export$8d112ad5a197e16a,
    partitionMap: $77e1f23488919643$export$f721fb25a1c72a8d
};
var $77e1f23488919643$export$c29a647071e542ec = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab,
    mapWithIndex: $77e1f23488919643$export$45e3e46323e6d66c,
    compact: $77e1f23488919643$export$8e16b83750b44988,
    separate: $77e1f23488919643$export$709f6946f4e97408,
    filter: $77e1f23488919643$export$ec7439dc64f73058,
    filterMap: $77e1f23488919643$export$e8609d6e184911e6,
    partition: $77e1f23488919643$export$8d112ad5a197e16a,
    partitionMap: $77e1f23488919643$export$f721fb25a1c72a8d,
    filterMapWithIndex: $77e1f23488919643$export$ac207938ecd8ddc4,
    filterWithIndex: $77e1f23488919643$export$560430393fed15de,
    partitionMapWithIndex: $77e1f23488919643$export$18034ec93490e9d2,
    partitionWithIndex: $77e1f23488919643$export$31601036bfbf1c76
};
var $77e1f23488919643$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $77e1f23488919643$export$9156e739aa33e19f,
        map: $77e1f23488919643$export$a0135aecf4a782ab,
        reduce: $77e1f23488919643$export$8eef5fdba9512999(O),
        foldMap: $77e1f23488919643$export$11b0d0e0b70641d9(O),
        reduceRight: $77e1f23488919643$export$ec882fc9def9e5db(O),
        traverse: $77e1f23488919643$export$b3c6f3d9661cffba(O),
        sequence: $77e1f23488919643$export$5d141086b2c0bc6(O)
    };
};
var $77e1f23488919643$export$46b81797a3375b8c = function(O) {
    return {
        URI: $77e1f23488919643$export$9156e739aa33e19f,
        map: $77e1f23488919643$export$a0135aecf4a782ab,
        mapWithIndex: $77e1f23488919643$export$45e3e46323e6d66c,
        reduce: $77e1f23488919643$export$8eef5fdba9512999(O),
        foldMap: $77e1f23488919643$export$11b0d0e0b70641d9(O),
        reduceRight: $77e1f23488919643$export$ec882fc9def9e5db(O),
        reduceWithIndex: $77e1f23488919643$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $77e1f23488919643$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $77e1f23488919643$export$3b7618311030b1af(O),
        traverse: $77e1f23488919643$export$b3c6f3d9661cffba(O),
        sequence: $77e1f23488919643$export$5d141086b2c0bc6(O),
        traverseWithIndex: $77e1f23488919643$var$_traverseWithIndex(O)
    };
};
var $77e1f23488919643$export$bb8ef26a634cac7b = function(O) {
    var T = $77e1f23488919643$export$4e0ffba11065d2c1(O);
    return {
        URI: $77e1f23488919643$export$9156e739aa33e19f,
        map: $77e1f23488919643$export$a0135aecf4a782ab,
        reduce: $77e1f23488919643$export$8eef5fdba9512999(O),
        foldMap: $77e1f23488919643$export$11b0d0e0b70641d9(O),
        reduceRight: $77e1f23488919643$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $77e1f23488919643$export$8e16b83750b44988,
        separate: $77e1f23488919643$export$709f6946f4e97408,
        filter: $77e1f23488919643$export$ec7439dc64f73058,
        filterMap: $77e1f23488919643$export$e8609d6e184911e6,
        partition: $77e1f23488919643$export$8d112ad5a197e16a,
        partitionMap: $77e1f23488919643$export$f721fb25a1c72a8d,
        wither: (0, $ciQV6.witherDefault)(T, $77e1f23488919643$export$4a21ac48141ac3c9),
        wilt: (0, $ciQV6.wiltDefault)(T, $77e1f23488919643$export$4a21ac48141ac3c9)
    };
};
var $77e1f23488919643$export$baca17b4aff42f82 = function(S) {
    var unionS = $77e1f23488919643$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $77e1f23488919643$export$c487aac9f4157837 = function(S) {
    return {
        concat: $77e1f23488919643$export$baca17b4aff42f82(S).concat,
        empty: $77e1f23488919643$export$6e22c362a0406a2c
    };
};
var $77e1f23488919643$export$d379a869a72e4055 = function(S) {
    var intersectionS = $77e1f23488919643$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $77e1f23488919643$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $77e1f23488919643$export$acaf96a27438246b(second)(first);
        }
    };
};
var $77e1f23488919643$export$41404b31838667c9 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $77e1f23488919643$export$8eef5fdba9512999($7bwGq.Ord),
    foldMap: /*#__PURE__*/ $77e1f23488919643$export$11b0d0e0b70641d9($7bwGq.Ord),
    reduceRight: /*#__PURE__*/ $77e1f23488919643$export$ec882fc9def9e5db($7bwGq.Ord)
};
var $77e1f23488919643$export$e8f7d17aaff345cb = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $77e1f23488919643$export$8eef5fdba9512999($7bwGq.Ord),
    foldMap: /*#__PURE__*/ $77e1f23488919643$export$11b0d0e0b70641d9($7bwGq.Ord),
    reduceRight: /*#__PURE__*/ $77e1f23488919643$export$ec882fc9def9e5db($7bwGq.Ord),
    reduceWithIndex: /*#__PURE__*/ $77e1f23488919643$export$dd5ca3bcbad0b6af($7bwGq.Ord),
    foldMapWithIndex: /*#__PURE__*/ $77e1f23488919643$export$e08bbf939bdc3250($7bwGq.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $77e1f23488919643$export$3b7618311030b1af($7bwGq.Ord)
};
var $77e1f23488919643$export$a0202666c3bda011 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $77e1f23488919643$export$8eef5fdba9512999($7bwGq.Ord),
    foldMap: /*#__PURE__*/ $77e1f23488919643$export$11b0d0e0b70641d9($7bwGq.Ord),
    reduceRight: /*#__PURE__*/ $77e1f23488919643$export$ec882fc9def9e5db($7bwGq.Ord),
    traverse: /*#__PURE__*/ $77e1f23488919643$export$b3c6f3d9661cffba($7bwGq.Ord),
    sequence: $77e1f23488919643$export$49bb65c2ea163039
};
var $77e1f23488919643$export$bd7b528d8c36ec41 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab,
    mapWithIndex: $77e1f23488919643$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $77e1f23488919643$export$8eef5fdba9512999($7bwGq.Ord),
    foldMap: /*#__PURE__*/ $77e1f23488919643$export$11b0d0e0b70641d9($7bwGq.Ord),
    reduceRight: /*#__PURE__*/ $77e1f23488919643$export$ec882fc9def9e5db($7bwGq.Ord),
    reduceWithIndex: /*#__PURE__*/ $77e1f23488919643$export$dd5ca3bcbad0b6af($7bwGq.Ord),
    foldMapWithIndex: /*#__PURE__*/ $77e1f23488919643$export$e08bbf939bdc3250($7bwGq.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $77e1f23488919643$export$3b7618311030b1af($7bwGq.Ord),
    traverse: /*#__PURE__*/ $77e1f23488919643$export$b3c6f3d9661cffba($7bwGq.Ord),
    sequence: $77e1f23488919643$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $77e1f23488919643$var$_traverseWithIndex($7bwGq.Ord)
};
var $77e1f23488919643$var$_wither = /*#__PURE__*/ (0, $ciQV6.witherDefault)($77e1f23488919643$export$a0202666c3bda011, $77e1f23488919643$export$4a21ac48141ac3c9);
var $77e1f23488919643$var$_wilt = /*#__PURE__*/ (0, $ciQV6.wiltDefault)($77e1f23488919643$export$a0202666c3bda011, $77e1f23488919643$export$4a21ac48141ac3c9);
var $77e1f23488919643$export$748d317b4c426f96 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $77e1f23488919643$export$8eef5fdba9512999($7bwGq.Ord),
    foldMap: /*#__PURE__*/ $77e1f23488919643$export$11b0d0e0b70641d9($7bwGq.Ord),
    reduceRight: /*#__PURE__*/ $77e1f23488919643$export$ec882fc9def9e5db($7bwGq.Ord),
    traverse: /*#__PURE__*/ $77e1f23488919643$export$b3c6f3d9661cffba($7bwGq.Ord),
    sequence: $77e1f23488919643$export$49bb65c2ea163039,
    compact: $77e1f23488919643$export$8e16b83750b44988,
    separate: $77e1f23488919643$export$709f6946f4e97408,
    filter: $77e1f23488919643$export$ec7439dc64f73058,
    filterMap: $77e1f23488919643$export$e8609d6e184911e6,
    partition: $77e1f23488919643$export$8d112ad5a197e16a,
    partitionMap: $77e1f23488919643$export$f721fb25a1c72a8d,
    wither: $77e1f23488919643$var$_wither,
    wilt: $77e1f23488919643$var$_wilt
};
var $77e1f23488919643$export$9f200c4466975173 = $77e1f23488919643$export$ff82449ce381c54a;
function $77e1f23488919643$export$5a15a386532a5ea4(k, r) {
    return $jc2nG.has.call(r === undefined ? this : r, k);
}
var $77e1f23488919643$export$74b9182b22de2bc1 = {
    URI: $77e1f23488919643$export$9156e739aa33e19f,
    map: $77e1f23488919643$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $77e1f23488919643$export$8eef5fdba9512999($7bwGq.Ord),
    foldMap: /*#__PURE__*/ $77e1f23488919643$export$11b0d0e0b70641d9($7bwGq.Ord),
    reduceRight: /*#__PURE__*/ $77e1f23488919643$export$ec882fc9def9e5db($7bwGq.Ord),
    traverse: /*#__PURE__*/ $77e1f23488919643$export$b3c6f3d9661cffba($7bwGq.Ord),
    sequence: $77e1f23488919643$export$49bb65c2ea163039,
    compact: $77e1f23488919643$export$8e16b83750b44988,
    separate: $77e1f23488919643$export$709f6946f4e97408,
    filter: $77e1f23488919643$export$ec7439dc64f73058,
    filterMap: $77e1f23488919643$export$e8609d6e184911e6,
    partition: $77e1f23488919643$export$8d112ad5a197e16a,
    partitionMap: $77e1f23488919643$export$f721fb25a1c72a8d,
    mapWithIndex: $77e1f23488919643$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $77e1f23488919643$export$dd5ca3bcbad0b6af($7bwGq.Ord),
    foldMapWithIndex: /*#__PURE__*/ $77e1f23488919643$export$e08bbf939bdc3250($7bwGq.Ord),
    reduceRightWithIndex: /*#__PURE__*/ $77e1f23488919643$export$3b7618311030b1af($7bwGq.Ord),
    filterMapWithIndex: $77e1f23488919643$export$ac207938ecd8ddc4,
    filterWithIndex: $77e1f23488919643$export$560430393fed15de,
    partitionMapWithIndex: $77e1f23488919643$export$18034ec93490e9d2,
    partitionWithIndex: $77e1f23488919643$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $77e1f23488919643$var$_traverseWithIndex($7bwGq.Ord),
    wither: $77e1f23488919643$var$_wither,
    wilt: $77e1f23488919643$var$_wilt
};

});
parcelRegister("7bwGq", function(module, exports) {

$parcel$export(module.exports, "Ord", () => $53b2e9b27164103a$export$ee8aa95bfab51c5);

var $6ANlS = parcelRequire("6ANlS");
var $53b2e9b27164103a$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $53b2e9b27164103a$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $53b2e9b27164103a$export$6e22c362a0406a2c = '';
var $53b2e9b27164103a$export$8f55868b713abdc3 = {
    concat: $53b2e9b27164103a$export$c16b1dbe8a4166b6.concat,
    empty: $53b2e9b27164103a$export$6e22c362a0406a2c
};
var $53b2e9b27164103a$export$ee8aa95bfab51c5 = {
    equals: $53b2e9b27164103a$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $53b2e9b27164103a$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $53b2e9b27164103a$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $53b2e9b27164103a$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $53b2e9b27164103a$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $53b2e9b27164103a$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $53b2e9b27164103a$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $53b2e9b27164103a$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $53b2e9b27164103a$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $53b2e9b27164103a$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $53b2e9b27164103a$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $53b2e9b27164103a$export$346677f925de839c = function(s) {
    return s.length;
};
var $53b2e9b27164103a$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $6ANlS.isNonEmpty)(out) ? out : [
            s
        ];
    };
};
var $53b2e9b27164103a$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $53b2e9b27164103a$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $53b2e9b27164103a$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};

});


parcelRegister("gmg2A", function(module, exports) {

$parcel$export(module.exports, "left", () => $be8b24c94b785637$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "right", () => $be8b24c94b785637$export$79ffe56a765070d2);
$parcel$export(module.exports, "isLeft", () => $be8b24c94b785637$export$d649b6842e09f2b);

var $ffW6m = parcelRequire("ffW6m");

var $kf9cS = parcelRequire("kf9cS");

var $fl2uO = parcelRequire("fl2uO");

var $4RRe4 = parcelRequire("4RRe4");

var $5tUZ7 = parcelRequire("5tUZ7");

var $6owmV = parcelRequire("6owmV");

var $aFZgk = parcelRequire("aFZgk");

var $jc2nG = parcelRequire("jc2nG");

var $iCI6U = parcelRequire("iCI6U");

var $ciQV6 = parcelRequire("ciQV6");
var $be8b24c94b785637$export$eabcd2c8791e7bf4 = $jc2nG.left;
var $be8b24c94b785637$export$79ffe56a765070d2 = $jc2nG.right;
var $be8b24c94b785637$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $6owmV.dual)(2, function(ma, f) {
    return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $be8b24c94b785637$var$_map = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $be8b24c94b785637$export$871de8747c9eaa88(f));
};
var $be8b24c94b785637$var$_ap = function(fab, fa) {
    return (0, $6owmV.pipe)(fab, $be8b24c94b785637$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $be8b24c94b785637$var$_reduce = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $be8b24c94b785637$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $be8b24c94b785637$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $be8b24c94b785637$export$b66cdc0497d8a99a(M);
        return (0, $6owmV.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $be8b24c94b785637$var$_reduceRight = function(fa, b, f) {
    return (0, $6owmV.pipe)(fa, $be8b24c94b785637$export$7fef8bcdbb34f435(b, f));
};
var $be8b24c94b785637$var$_traverse = function(F) {
    var traverseF = $be8b24c94b785637$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $6owmV.pipe)(ta, traverseF(f));
    };
};
var $be8b24c94b785637$var$_bimap = function(fa, f, g) {
    return (0, $6owmV.pipe)(fa, $be8b24c94b785637$export$eb54baf0b342cb1d(f, g));
};
var $be8b24c94b785637$var$_mapLeft = function(fa, f) {
    return (0, $6owmV.pipe)(fa, $be8b24c94b785637$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $be8b24c94b785637$var$_alt = function(fa, that) {
    return (0, $6owmV.pipe)(fa, $be8b24c94b785637$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $be8b24c94b785637$var$_extend = function(wa, f) {
    return (0, $6owmV.pipe)(wa, $be8b24c94b785637$export$8b58be045bf06082(f));
};
var $be8b24c94b785637$var$_chainRec = function(a, f) {
    return (0, $4RRe4.tailRec)(f(a), function(e) {
        return $be8b24c94b785637$export$d649b6842e09f2b(e) ? $be8b24c94b785637$export$79ffe56a765070d2($be8b24c94b785637$export$eabcd2c8791e7bf4(e.left)) : $be8b24c94b785637$export$d649b6842e09f2b(e.right) ? $be8b24c94b785637$export$eabcd2c8791e7bf4(f(e.right.left)) : $be8b24c94b785637$export$79ffe56a765070d2($be8b24c94b785637$export$79ffe56a765070d2(e.right.right));
    });
};
var $be8b24c94b785637$export$9156e739aa33e19f = 'Either';
var $be8b24c94b785637$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $be8b24c94b785637$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($be8b24c94b785637$export$d649b6842e09f2b(x) ? $be8b24c94b785637$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $be8b24c94b785637$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $be8b24c94b785637$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $be8b24c94b785637$export$d649b6842e09f2b(y) ? x : $be8b24c94b785637$export$d649b6842e09f2b(x) ? y : $be8b24c94b785637$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $be8b24c94b785637$export$cfae3069ac05ff4c = function(M) {
    var empty = $be8b24c94b785637$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $be8b24c94b785637$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $be8b24c94b785637$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? (0, $iCI6U.separated)(ma, ma) : $be8b24c94b785637$export$d649b6842e09f2b(ma.right) ? (0, $iCI6U.separated)($be8b24c94b785637$export$79ffe56a765070d2(ma.right.left), empty) : (0, $iCI6U.separated)(empty, $be8b24c94b785637$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $be8b24c94b785637$export$a4e870b0a57ec14e = function(M) {
    var empty = $be8b24c94b785637$export$eabcd2c8791e7bf4(M.empty);
    var _a = $be8b24c94b785637$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? (0, $iCI6U.separated)(ma, ma) : p(ma.right) ? (0, $iCI6U.separated)(empty, $be8b24c94b785637$export$79ffe56a765070d2(ma.right)) : (0, $iCI6U.separated)($be8b24c94b785637$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $be8b24c94b785637$export$9156e739aa33e19f,
        _E: undefined,
        map: $be8b24c94b785637$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($be8b24c94b785637$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $be8b24c94b785637$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($be8b24c94b785637$export$d649b6842e09f2b(ma)) return (0, $iCI6U.separated)(ma, ma);
            var e = f(ma.right);
            return $be8b24c94b785637$export$d649b6842e09f2b(e) ? (0, $iCI6U.separated)($be8b24c94b785637$export$79ffe56a765070d2(e.left), empty) : (0, $iCI6U.separated)(empty, $be8b24c94b785637$export$79ffe56a765070d2(e.right));
        }
    };
};
var $be8b24c94b785637$export$bb8ef26a634cac7b = function(M) {
    var F_ = $be8b24c94b785637$export$a4e870b0a57ec14e(M);
    var C = $be8b24c94b785637$export$cfae3069ac05ff4c(M);
    return {
        URI: $be8b24c94b785637$export$9156e739aa33e19f,
        _E: undefined,
        map: $be8b24c94b785637$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $be8b24c94b785637$var$_traverse,
        sequence: $be8b24c94b785637$export$49bb65c2ea163039,
        reduce: $be8b24c94b785637$var$_reduce,
        foldMap: $be8b24c94b785637$var$_foldMap,
        reduceRight: $be8b24c94b785637$var$_reduceRight,
        wither: (0, $ciQV6.witherDefault)($be8b24c94b785637$export$a0202666c3bda011, C),
        wilt: (0, $ciQV6.wiltDefault)($be8b24c94b785637$export$a0202666c3bda011, C)
    };
};
var $be8b24c94b785637$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $be8b24c94b785637$export$9156e739aa33e19f,
        _E: undefined,
        map: $be8b24c94b785637$var$_map,
        ap: function(fab, fa) {
            return $be8b24c94b785637$export$d649b6842e09f2b(fab) ? $be8b24c94b785637$export$d649b6842e09f2b(fa) ? $be8b24c94b785637$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $be8b24c94b785637$export$d649b6842e09f2b(fa) ? fa : $be8b24c94b785637$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $be8b24c94b785637$export$ba255e9e49e00608
    };
};
var $be8b24c94b785637$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $be8b24c94b785637$export$9156e739aa33e19f,
        _E: undefined,
        map: $be8b24c94b785637$var$_map,
        alt: function(me, that) {
            if ($be8b24c94b785637$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $be8b24c94b785637$export$d649b6842e09f2b(ea) ? $be8b24c94b785637$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $be8b24c94b785637$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $be8b24c94b785637$export$d649b6842e09f2b(fa) ? fa : $be8b24c94b785637$export$79ffe56a765070d2(f(fa.right));
    };
};
var $be8b24c94b785637$export$bd5b6bfc5fa2ee61 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map
};
var $be8b24c94b785637$export$6554612db691658e = (0, $6owmV.dual)(2, (0, $aFZgk.as)($be8b24c94b785637$export$bd5b6bfc5fa2ee61));
var $be8b24c94b785637$export$9284b360ca18a0fd = (0, $aFZgk.asUnit)($be8b24c94b785637$export$bd5b6bfc5fa2ee61);
var $be8b24c94b785637$export$ba255e9e49e00608 = $be8b24c94b785637$export$79ffe56a765070d2;
var $be8b24c94b785637$export$59a71046037e6c20 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    of: $be8b24c94b785637$export$ba255e9e49e00608
};
var $be8b24c94b785637$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $be8b24c94b785637$export$d649b6842e09f2b(fab) ? fab : $be8b24c94b785637$export$d649b6842e09f2b(fa) ? fa : $be8b24c94b785637$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $be8b24c94b785637$export$2f6ca3d3b1f80bf5 = $be8b24c94b785637$export$321be6e231de8eac;
var $be8b24c94b785637$export$efc21ddc6aeb363d = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    ap: $be8b24c94b785637$var$_ap
};
var $be8b24c94b785637$export$1279d2b7807629fd = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    ap: $be8b24c94b785637$var$_ap,
    of: $be8b24c94b785637$export$ba255e9e49e00608
};
var $be8b24c94b785637$export$f18d5acc27d70423 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    ap: $be8b24c94b785637$var$_ap,
    chain: $be8b24c94b785637$export$5b8affa63fc6df16
};
var $be8b24c94b785637$export$fb641926d034ac7d = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    ap: $be8b24c94b785637$var$_ap,
    of: $be8b24c94b785637$export$ba255e9e49e00608,
    chain: $be8b24c94b785637$export$5b8affa63fc6df16
};
var $be8b24c94b785637$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $be8b24c94b785637$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $be8b24c94b785637$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $be8b24c94b785637$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $be8b24c94b785637$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $be8b24c94b785637$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $be8b24c94b785637$export$41404b31838667c9 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    reduce: $be8b24c94b785637$var$_reduce,
    foldMap: $be8b24c94b785637$var$_foldMap,
    reduceRight: $be8b24c94b785637$var$_reduceRight
};
var $be8b24c94b785637$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $be8b24c94b785637$export$d649b6842e09f2b(ta) ? F.of($be8b24c94b785637$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $be8b24c94b785637$export$79ffe56a765070d2);
        };
    };
};
var $be8b24c94b785637$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? F.of($be8b24c94b785637$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $be8b24c94b785637$export$79ffe56a765070d2);
    };
};
var $be8b24c94b785637$export$a0202666c3bda011 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    reduce: $be8b24c94b785637$var$_reduce,
    foldMap: $be8b24c94b785637$var$_foldMap,
    reduceRight: $be8b24c94b785637$var$_reduceRight,
    traverse: $be8b24c94b785637$var$_traverse,
    sequence: $be8b24c94b785637$export$49bb65c2ea163039
};
var $be8b24c94b785637$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $be8b24c94b785637$export$d649b6842e09f2b(fa) ? $be8b24c94b785637$export$eabcd2c8791e7bf4(f(fa.left)) : $be8b24c94b785637$export$79ffe56a765070d2(g(fa.right));
    };
};
var $be8b24c94b785637$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $be8b24c94b785637$export$d649b6842e09f2b(fa) ? $be8b24c94b785637$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $be8b24c94b785637$export$fd0fe42029639505 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    bimap: $be8b24c94b785637$var$_bimap,
    mapLeft: $be8b24c94b785637$var$_mapLeft
};
var $be8b24c94b785637$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $be8b24c94b785637$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $be8b24c94b785637$export$228be17d80722ab = $be8b24c94b785637$export$1517cca7889d6aaa;
var $be8b24c94b785637$export$25ba4469a069167 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    alt: $be8b24c94b785637$var$_alt
};
var $be8b24c94b785637$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $be8b24c94b785637$export$d649b6842e09f2b(wa) ? wa : $be8b24c94b785637$export$79ffe56a765070d2(f(wa));
    };
};
var $be8b24c94b785637$export$5b5dd0e212d2a5bc = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    extend: $be8b24c94b785637$var$_extend
};
var $be8b24c94b785637$export$be58f7327716329d = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    ap: $be8b24c94b785637$var$_ap,
    chain: $be8b24c94b785637$export$5b8affa63fc6df16,
    chainRec: $be8b24c94b785637$var$_chainRec
};
var $be8b24c94b785637$export$8bf7aba4a9e09055 = $be8b24c94b785637$export$eabcd2c8791e7bf4;
var $be8b24c94b785637$export$5f956d47d0619c3a = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    ap: $be8b24c94b785637$var$_ap,
    of: $be8b24c94b785637$export$ba255e9e49e00608,
    chain: $be8b24c94b785637$export$5b8affa63fc6df16,
    throwError: $be8b24c94b785637$export$8bf7aba4a9e09055
};
var $be8b24c94b785637$export$825ea6cb6fc48d49 = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    fromEither: (0, $6owmV.identity)
};
var $be8b24c94b785637$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $5tUZ7.fromPredicate)($be8b24c94b785637$export$825ea6cb6fc48d49);
var $be8b24c94b785637$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $5tUZ7.fromOption)($be8b24c94b785637$export$825ea6cb6fc48d49);
var $be8b24c94b785637$export$d649b6842e09f2b = $jc2nG.isLeft;
var $be8b24c94b785637$export$a9d71693f0c1a85d = $jc2nG.isRight;
var $be8b24c94b785637$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $be8b24c94b785637$export$ccb09033cefa61e8 = $be8b24c94b785637$export$2d55ea551c238330;
var $be8b24c94b785637$export$4659b591c19bdf3d = $be8b24c94b785637$export$2d55ea551c238330;
var $be8b24c94b785637$export$93e2b83da34ff82a = $be8b24c94b785637$export$4659b591c19bdf3d;
var $be8b24c94b785637$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $be8b24c94b785637$export$8832081647a02ee7 = $be8b24c94b785637$export$d8a997ff0e6436f3;
var $be8b24c94b785637$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $aFZgk.flap)($be8b24c94b785637$export$bd5b6bfc5fa2ee61);
var $be8b24c94b785637$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $kf9cS.apFirst)($be8b24c94b785637$export$efc21ddc6aeb363d);
var $be8b24c94b785637$export$ac044f4aa9961a4f = $be8b24c94b785637$export$5f28d9feedcfd46e;
var $be8b24c94b785637$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $kf9cS.apSecond)($be8b24c94b785637$export$efc21ddc6aeb363d);
var $be8b24c94b785637$export$8a00020751233172 = $be8b24c94b785637$export$ed01bc59c3d06bf3;
var $be8b24c94b785637$export$3f23594af5f37336 = /*#__PURE__*/ (0, $6owmV.dual)(2, $fl2uO.tap($be8b24c94b785637$export$f18d5acc27d70423));
var $be8b24c94b785637$export$2409099f1fc434fb = /*#__PURE__*/ $be8b24c94b785637$export$5b8affa63fc6df16((0, $6owmV.identity));
var $be8b24c94b785637$export$bffa455ba8c619a6 = $be8b24c94b785637$export$2409099f1fc434fb;
var $be8b24c94b785637$export$ecd5e8ace626722c = /*#__PURE__*/ $be8b24c94b785637$export$8b58be045bf06082((0, $6owmV.identity));
var $be8b24c94b785637$export$a907462f448b49f8 = /*#__PURE__*/ (0, $5tUZ7.fromOptionK)($be8b24c94b785637$export$825ea6cb6fc48d49);
var $be8b24c94b785637$export$12d26179deb6a68a = /*#__PURE__*/ (0, $5tUZ7.chainOptionK)($be8b24c94b785637$export$825ea6cb6fc48d49, $be8b24c94b785637$export$f18d5acc27d70423);
var $be8b24c94b785637$export$377cc334277e5c3c = $be8b24c94b785637$export$12d26179deb6a68a;
/** @internal */ var $be8b24c94b785637$var$_FromEither = {
    fromEither: $be8b24c94b785637$export$825ea6cb6fc48d49.fromEither
};
var $be8b24c94b785637$export$cd139e14432f317b = /*#__PURE__*/ $jc2nG.liftNullable($be8b24c94b785637$var$_FromEither);
var $be8b24c94b785637$export$ea4a22f93200df79 = /*#__PURE__*/ $jc2nG.liftOption($be8b24c94b785637$var$_FromEither);
/** @internal */ var $be8b24c94b785637$var$_FlatMap = {
    flatMap: $be8b24c94b785637$export$5b8affa63fc6df16
};
var $be8b24c94b785637$export$1a0515933c5c84fe = /*#__PURE__*/ $jc2nG.flatMapNullable($be8b24c94b785637$var$_FromEither, $be8b24c94b785637$var$_FlatMap);
var $be8b24c94b785637$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $jc2nG.flatMapOption($be8b24c94b785637$var$_FromEither, $be8b24c94b785637$var$_FlatMap);
var $be8b24c94b785637$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $5tUZ7.filterOrElse)($be8b24c94b785637$export$825ea6cb6fc48d49, $be8b24c94b785637$export$f18d5acc27d70423);
var $be8b24c94b785637$export$84511cf4503ec9dd = $be8b24c94b785637$export$30af8ca9498ddf5b;
var $be8b24c94b785637$export$b0e76d9850c64156 = function(ma) {
    return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? $be8b24c94b785637$export$79ffe56a765070d2(ma.left) : $be8b24c94b785637$export$eabcd2c8791e7bf4(ma.right);
};
var $be8b24c94b785637$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $be8b24c94b785637$export$41d1a04d78e7b141 = $be8b24c94b785637$export$efd845e0c87089a6;
var $be8b24c94b785637$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $be8b24c94b785637$export$eabcd2c8791e7bf4(e) : $be8b24c94b785637$export$79ffe56a765070d2(a);
    };
};
var $be8b24c94b785637$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $be8b24c94b785637$export$79ffe56a765070d2(f());
    } catch (e) {
        return $be8b24c94b785637$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $be8b24c94b785637$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $be8b24c94b785637$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $be8b24c94b785637$export$c69ca7b73fad45e1 = function(e) {
    var from = $be8b24c94b785637$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $6owmV.flow)(f, from);
    };
};
var $be8b24c94b785637$export$c81f992c08fd0bf3 = function(e) {
    var from = $be8b24c94b785637$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $be8b24c94b785637$export$5b8affa63fc6df16(from(f));
    };
};
var $be8b24c94b785637$export$a0886ed3a572729f = /*#__PURE__*/ $be8b24c94b785637$export$ccb09033cefa61e8((0, $6owmV.identity), (0, $6owmV.identity));
function $be8b24c94b785637$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $be8b24c94b785637$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $be8b24c94b785637$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $be8b24c94b785637$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $be8b24c94b785637$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $be8b24c94b785637$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $be8b24c94b785637$export$ba255e9e49e00608($jc2nG.emptyRecord);
var $be8b24c94b785637$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $aFZgk.bindTo)($be8b24c94b785637$export$bd5b6bfc5fa2ee61);
var $be8b24c94b785637$export$5d537b797c421217 = /*#__PURE__*/ (0, $aFZgk.let)($be8b24c94b785637$export$bd5b6bfc5fa2ee61);
var $be8b24c94b785637$export$2385a24977818dd0 = /*#__PURE__*/ $fl2uO.bind($be8b24c94b785637$export$f18d5acc27d70423);
var $be8b24c94b785637$export$e0d5b1cbe98976d9 = $be8b24c94b785637$export$2385a24977818dd0;
var $be8b24c94b785637$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $kf9cS.apS)($be8b24c94b785637$export$efc21ddc6aeb363d);
var $be8b24c94b785637$export$5c01f27714264b3d = $be8b24c94b785637$export$8cbfc0239f42bb49;
var $be8b24c94b785637$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $be8b24c94b785637$export$ba255e9e49e00608($jc2nG.emptyReadonlyArray);
var $be8b24c94b785637$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $jc2nG.head(as));
        if ($be8b24c94b785637$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($be8b24c94b785637$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $be8b24c94b785637$export$79ffe56a765070d2(out);
    };
};
var $be8b24c94b785637$export$d4e79db5dc14cc1 = function(f) {
    var g = $be8b24c94b785637$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $jc2nG.isNonEmpty(as) ? g(as) : $be8b24c94b785637$export$c74b6e34b2b6efb0;
    };
};
var $be8b24c94b785637$export$104a2841e9cbad06 = $be8b24c94b785637$export$d4e79db5dc14cc1;
var $be8b24c94b785637$export$64f39b2a2b79e1b1 = function(f) {
    return $be8b24c94b785637$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $be8b24c94b785637$export$d330b60315c14cd1 = /*#__PURE__*/ $be8b24c94b785637$export$64f39b2a2b79e1b1((0, $6owmV.identity));
var $be8b24c94b785637$export$8e5885f0163d737a = $be8b24c94b785637$export$5b8affa63fc6df16;
var $be8b24c94b785637$export$e08e3b67e392101e = $be8b24c94b785637$export$5b8affa63fc6df16;
var $be8b24c94b785637$export$e3821ef4970c339c = $be8b24c94b785637$export$3f23594af5f37336;
var $be8b24c94b785637$export$5de78197fc44b933 = $be8b24c94b785637$export$3f23594af5f37336;
function $be8b24c94b785637$export$27924e57e9afff7f(s, onError) {
    return $be8b24c94b785637$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $be8b24c94b785637$export$702e019c6853c7a = function(u, onError) {
    return $be8b24c94b785637$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $be8b24c94b785637$export$5f5be1bb6cd1fded = {
    URI: $be8b24c94b785637$export$9156e739aa33e19f,
    map: $be8b24c94b785637$var$_map,
    of: $be8b24c94b785637$export$ba255e9e49e00608,
    ap: $be8b24c94b785637$var$_ap,
    chain: $be8b24c94b785637$export$5b8affa63fc6df16,
    reduce: $be8b24c94b785637$var$_reduce,
    foldMap: $be8b24c94b785637$var$_foldMap,
    reduceRight: $be8b24c94b785637$var$_reduceRight,
    traverse: $be8b24c94b785637$var$_traverse,
    sequence: $be8b24c94b785637$export$49bb65c2ea163039,
    bimap: $be8b24c94b785637$var$_bimap,
    mapLeft: $be8b24c94b785637$var$_mapLeft,
    alt: $be8b24c94b785637$var$_alt,
    extend: $be8b24c94b785637$var$_extend,
    chainRec: $be8b24c94b785637$var$_chainRec,
    throwError: $be8b24c94b785637$export$8bf7aba4a9e09055
};
var $be8b24c94b785637$export$18979a515d2a828e = /*#__PURE__*/ (0, $kf9cS.getApplySemigroup)($be8b24c94b785637$export$efc21ddc6aeb363d);
var $be8b24c94b785637$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $ffW6m.getApplicativeMonoid)($be8b24c94b785637$export$1279d2b7807629fd);
var $be8b24c94b785637$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $kf9cS.getApplySemigroup)($be8b24c94b785637$export$d9540e18497e6036(SE))(SA);
};
var $be8b24c94b785637$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $ffW6m.getApplicativeMonoid)($be8b24c94b785637$export$d9540e18497e6036(SE))(MA);
};
function $be8b24c94b785637$export$6843f928420ce3e4(SE) {
    var ap = $be8b24c94b785637$export$d9540e18497e6036(SE).ap;
    var alt = $be8b24c94b785637$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $be8b24c94b785637$export$9156e739aa33e19f,
        _E: undefined,
        map: $be8b24c94b785637$var$_map,
        of: $be8b24c94b785637$export$ba255e9e49e00608,
        chain: $be8b24c94b785637$export$5b8affa63fc6df16,
        bimap: $be8b24c94b785637$var$_bimap,
        mapLeft: $be8b24c94b785637$var$_mapLeft,
        reduce: $be8b24c94b785637$var$_reduce,
        foldMap: $be8b24c94b785637$var$_foldMap,
        reduceRight: $be8b24c94b785637$var$_reduceRight,
        extend: $be8b24c94b785637$var$_extend,
        traverse: $be8b24c94b785637$var$_traverse,
        sequence: $be8b24c94b785637$export$49bb65c2ea163039,
        chainRec: $be8b24c94b785637$var$_chainRec,
        throwError: $be8b24c94b785637$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}

});
parcelRegister("4RRe4", function(module, exports) {

$parcel$export(module.exports, "tailRec", () => $38b566364305963e$export$2e586eaa876dd2fd);
/**
 * @since 2.0.0
 */ var $38b566364305963e$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};

});




parcelRegister("kCQUZ", function(module, exports) {

$parcel$export(module.exports, "asLens", () => $f04067b2fc82b2a7$export$ba6dbfc52e933ec);
$parcel$export(module.exports, "asPrism", () => $f04067b2fc82b2a7$export$6963d4cf5712e556);
$parcel$export(module.exports, "asOptional", () => $f04067b2fc82b2a7$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $f04067b2fc82b2a7$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $f04067b2fc82b2a7$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "reverse", () => $f04067b2fc82b2a7$export$66c1ae025e96b4bc);
$parcel$export(module.exports, "modify", () => $f04067b2fc82b2a7$export$3ff57735a52b8713);

var $6owmV = parcelRequire("6owmV");

var $crypz = parcelRequire("crypz");

var $kI1cH = parcelRequire("kI1cH");
var $f04067b2fc82b2a7$export$1aba8f741a0eae06 = $kI1cH.iso;
var $f04067b2fc82b2a7$export$d560c7e4a29451c2 = function() {
    return $f04067b2fc82b2a7$export$1aba8f741a0eae06((0, $6owmV.identity), (0, $6owmV.identity));
};
var $f04067b2fc82b2a7$export$ba6dbfc52e933ec = $kI1cH.isoAsLens;
var $f04067b2fc82b2a7$export$6963d4cf5712e556 = $kI1cH.isoAsPrism;
var $f04067b2fc82b2a7$export$81a625dd455a09de = $kI1cH.isoAsOptional;
var $f04067b2fc82b2a7$export$ef38eac73d6f828f = $kI1cH.isoAsTraversal;
var $f04067b2fc82b2a7$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $f04067b2fc82b2a7$export$1aba8f741a0eae06((0, $6owmV.flow)(sa.get, ab.get), (0, $6owmV.flow)(ab.reverseGet, sa.reverseGet));
    };
};
var $f04067b2fc82b2a7$export$220ad92d18dabdd7 = $f04067b2fc82b2a7$export$f672e0b6f7222cd7;
var $f04067b2fc82b2a7$export$f5c3e419c6a355ce = function(ab) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$ba6dbfc52e933ec, $kI1cH.lensComposeLens(ab));
};
var $f04067b2fc82b2a7$export$c1dc05e399870f6 = function(ab) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$6963d4cf5712e556, $kI1cH.prismComposePrism(ab));
};
var $f04067b2fc82b2a7$export$323f76c400675c8b = function(ab) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$81a625dd455a09de, $kI1cH.optionalComposeOptional(ab));
};
var $f04067b2fc82b2a7$export$aa978f69e007229f = function(ab) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$ef38eac73d6f828f, $kI1cH.traversalComposeTraversal(ab));
};
var $f04067b2fc82b2a7$export$66c1ae025e96b4bc = function(sa) {
    return $f04067b2fc82b2a7$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $f04067b2fc82b2a7$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $f04067b2fc82b2a7$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $crypz.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $f04067b2fc82b2a7$export$b601f49376b4621a = function(sa) {
    return $f04067b2fc82b2a7$export$c1dc05e399870f6($kI1cH.prismFromNullable())(sa);
};
function $f04067b2fc82b2a7$export$3dea766d36a8935f(predicate) {
    return $f04067b2fc82b2a7$export$c1dc05e399870f6($kI1cH.prismFromPredicate(predicate));
}
var $f04067b2fc82b2a7$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$ba6dbfc52e933ec, $kI1cH.lensProp(prop));
};
var $f04067b2fc82b2a7$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$ba6dbfc52e933ec, $kI1cH.lensProps.apply($kI1cH, props));
};
var $f04067b2fc82b2a7$export$d8556a2a8f973135 = function(prop) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$ba6dbfc52e933ec, $kI1cH.lensComponent(prop));
};
var $f04067b2fc82b2a7$export$b610b8812bbcded9 = function(i) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$81a625dd455a09de, $kI1cH.optionalIndex(i));
};
var $f04067b2fc82b2a7$export$84162b00c25b711c = function(i) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$81a625dd455a09de, $kI1cH.optionalIndexNonEmpty(i));
};
var $f04067b2fc82b2a7$export$df61b30b684217c0 = function(key) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$81a625dd455a09de, $kI1cH.optionalKey(key));
};
var $f04067b2fc82b2a7$export$976574c443b9185b = function(key) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$ba6dbfc52e933ec, $kI1cH.lensAtKey(key));
};
var $f04067b2fc82b2a7$export$ad14ef4001db2bcd = /*#__PURE__*/ $f04067b2fc82b2a7$export$c1dc05e399870f6(/*#__PURE__*/ $kI1cH.prismSome());
var $f04067b2fc82b2a7$export$79ffe56a765070d2 = /*#__PURE__*/ $f04067b2fc82b2a7$export$c1dc05e399870f6(/*#__PURE__*/ $kI1cH.prismRight());
var $f04067b2fc82b2a7$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $f04067b2fc82b2a7$export$c1dc05e399870f6(/*#__PURE__*/ $kI1cH.prismLeft());
function $f04067b2fc82b2a7$export$df3f009e3d155b20(T) {
    return (0, $6owmV.flow)($f04067b2fc82b2a7$export$ef38eac73d6f828f, $kI1cH.traversalTraverse(T));
}
function $f04067b2fc82b2a7$export$9a2f228bed5035c2(predicate) {
    return $f04067b2fc82b2a7$export$323f76c400675c8b($kI1cH.optionalFindFirst(predicate));
}
function $f04067b2fc82b2a7$export$28e1f787311e0a21(predicate) {
    return $f04067b2fc82b2a7$export$323f76c400675c8b($kI1cH.optionalFindFirstNonEmpty(predicate));
}
var $f04067b2fc82b2a7$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $f04067b2fc82b2a7$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $f04067b2fc82b2a7$var$imap_ = function(ea, ab, ba) {
    return $f04067b2fc82b2a7$export$1aba8f741a0eae06((0, $6owmV.flow)(ea.get, ab), (0, $6owmV.flow)(ba, ea.reverseGet));
};
var $f04067b2fc82b2a7$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $f04067b2fc82b2a7$export$dbdf692cc5737cfd = {
    URI: $f04067b2fc82b2a7$export$9156e739aa33e19f,
    imap: $f04067b2fc82b2a7$var$imap_
};
var $f04067b2fc82b2a7$export$67666a3fb7d250d8 = {
    URI: $f04067b2fc82b2a7$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $f04067b2fc82b2a7$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $f04067b2fc82b2a7$export$3a8840c5b2ecf003 = {
    URI: $f04067b2fc82b2a7$export$9156e739aa33e19f,
    compose: $f04067b2fc82b2a7$export$67666a3fb7d250d8.compose,
    id: $f04067b2fc82b2a7$export$d560c7e4a29451c2
};

});

parcelRegister("4IHNc", function(module, exports) {

$parcel$export(module.exports, "fromAt", () => $36fd3dcbc36c78e2$export$c4dd3e639c7af330);
$parcel$export(module.exports, "fromIso", () => $36fd3dcbc36c78e2$export$3160d47a1ad63980);
/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 
var $1sIL7 = parcelRequire("1sIL7");

var $crypz = parcelRequire("crypz");

var $kI1cH = parcelRequire("kI1cH");

var $4zd51 = parcelRequire("4zd51");
var $36fd3dcbc36c78e2$export$b610b8812bbcded9 = $kI1cH.index;
var $36fd3dcbc36c78e2$export$c4dd3e639c7af330 = function(at) {
    return $36fd3dcbc36c78e2$export$b610b8812bbcded9(function(i) {
        return $kI1cH.lensComposePrism($kI1cH.prismSome())(at.at(i));
    });
};
var $36fd3dcbc36c78e2$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $36fd3dcbc36c78e2$export$b610b8812bbcded9(function(i) {
            return (0, $crypz.pipe)(iso, $kI1cH.isoAsOptional, $kI1cH.optionalComposeOptional(sia.index(i)));
        });
    };
};
var $36fd3dcbc36c78e2$export$bb0c054375ca4b0 = $kI1cH.indexReadonlyArray;
var $36fd3dcbc36c78e2$export$165af7b747e6b1f1 = $kI1cH.indexReadonlyNonEmptyArray;
var $36fd3dcbc36c78e2$export$3c3468aec3b83bbf = $kI1cH.indexReadonlyRecord;
var $36fd3dcbc36c78e2$export$92da200d6ddb6846 = function(E) {
    var lookupE = $4zd51.lookup(E);
    var insertAtE = $4zd51.insertAt(E);
    return function() {
        return $36fd3dcbc36c78e2$export$b610b8812bbcded9(function(key) {
            return $kI1cH.optional(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $crypz.pipe)(lookupE(key, s), $1sIL7.fold(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $36fd3dcbc36c78e2$export$2cd1c249765cd0a4 = $kI1cH.indexReadonlyArray;
var $36fd3dcbc36c78e2$export$720226bf1ef46cb2 = $kI1cH.indexReadonlyRecord;

});

parcelRegister("hW8VF", function(module, exports) {

$parcel$export(module.exports, "lens", () => $d0eec78f7288f50d$export$21cde5187c2605a3);
$parcel$export(module.exports, "id", () => $d0eec78f7288f50d$export$d560c7e4a29451c2);
$parcel$export(module.exports, "asOptional", () => $d0eec78f7288f50d$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $d0eec78f7288f50d$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $d0eec78f7288f50d$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $d0eec78f7288f50d$export$f5c3e419c6a355ce);
$parcel$export(module.exports, "composeIso", () => $d0eec78f7288f50d$export$220ad92d18dabdd7);
$parcel$export(module.exports, "composePrism", () => $d0eec78f7288f50d$export$c1dc05e399870f6);
$parcel$export(module.exports, "composeOptional", () => $d0eec78f7288f50d$export$323f76c400675c8b);
$parcel$export(module.exports, "composeTraversal", () => $d0eec78f7288f50d$export$aa978f69e007229f);
$parcel$export(module.exports, "modify", () => $d0eec78f7288f50d$export$3ff57735a52b8713);
$parcel$export(module.exports, "modifyF", () => $d0eec78f7288f50d$export$a28005d3e6beb9a6);
$parcel$export(module.exports, "fromNullable", () => $d0eec78f7288f50d$export$b601f49376b4621a);
$parcel$export(module.exports, "filter", () => $d0eec78f7288f50d$export$3dea766d36a8935f);
$parcel$export(module.exports, "prop", () => $d0eec78f7288f50d$export$977f3f6a9323c0f6);
$parcel$export(module.exports, "props", () => $d0eec78f7288f50d$export$8128bb6492cf3de7);
$parcel$export(module.exports, "component", () => $d0eec78f7288f50d$export$d8556a2a8f973135);
$parcel$export(module.exports, "index", () => $d0eec78f7288f50d$export$b610b8812bbcded9);
$parcel$export(module.exports, "indexNonEmpty", () => $d0eec78f7288f50d$export$84162b00c25b711c);
$parcel$export(module.exports, "key", () => $d0eec78f7288f50d$export$df61b30b684217c0);
$parcel$export(module.exports, "atKey", () => $d0eec78f7288f50d$export$976574c443b9185b);
$parcel$export(module.exports, "some", () => $d0eec78f7288f50d$export$ad14ef4001db2bcd);
$parcel$export(module.exports, "right", () => $d0eec78f7288f50d$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $d0eec78f7288f50d$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "traverse", () => $d0eec78f7288f50d$export$df3f009e3d155b20);
$parcel$export(module.exports, "findFirst", () => $d0eec78f7288f50d$export$9a2f228bed5035c2);
$parcel$export(module.exports, "findFirstNonEmpty", () => $d0eec78f7288f50d$export$28e1f787311e0a21);
$parcel$export(module.exports, "imap", () => $d0eec78f7288f50d$export$b2517b0ab3a58435);
$parcel$export(module.exports, "URI", () => $d0eec78f7288f50d$export$9156e739aa33e19f);
$parcel$export(module.exports, "Invariant", () => $d0eec78f7288f50d$export$dbdf692cc5737cfd);
$parcel$export(module.exports, "Semigroupoid", () => $d0eec78f7288f50d$export$67666a3fb7d250d8);
$parcel$export(module.exports, "Category", () => $d0eec78f7288f50d$export$3a8840c5b2ecf003);

var $6owmV = parcelRequire("6owmV");

var $crypz = parcelRequire("crypz");

var $kI1cH = parcelRequire("kI1cH");
var $d0eec78f7288f50d$export$21cde5187c2605a3 = $kI1cH.lens;
var $d0eec78f7288f50d$export$d560c7e4a29451c2 = $kI1cH.lensId;
var $d0eec78f7288f50d$export$81a625dd455a09de = $kI1cH.lensAsOptional;
var $d0eec78f7288f50d$export$ef38eac73d6f828f = $kI1cH.lensAsTraversal;
var $d0eec78f7288f50d$export$f672e0b6f7222cd7 = $kI1cH.lensComposeLens;
var $d0eec78f7288f50d$export$f5c3e419c6a355ce = $d0eec78f7288f50d$export$f672e0b6f7222cd7;
var $d0eec78f7288f50d$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.isoAsLens, $d0eec78f7288f50d$export$f672e0b6f7222cd7);
var $d0eec78f7288f50d$export$c1dc05e399870f6 = $kI1cH.lensComposePrism;
var $d0eec78f7288f50d$export$323f76c400675c8b = function(ab) {
    return (0, $6owmV.flow)($d0eec78f7288f50d$export$81a625dd455a09de, $kI1cH.optionalComposeOptional(ab));
};
var $d0eec78f7288f50d$export$aa978f69e007229f = function(ab) {
    return (0, $6owmV.flow)($d0eec78f7288f50d$export$ef38eac73d6f828f, $kI1cH.traversalComposeTraversal(ab));
};
var $d0eec78f7288f50d$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $d0eec78f7288f50d$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $crypz.pipe)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $d0eec78f7288f50d$export$b601f49376b4621a = function(sa) {
    return $d0eec78f7288f50d$export$c1dc05e399870f6($kI1cH.prismFromNullable())(sa);
};
function $d0eec78f7288f50d$export$3dea766d36a8935f(predicate) {
    return $d0eec78f7288f50d$export$c1dc05e399870f6($kI1cH.prismFromPredicate(predicate));
}
var $d0eec78f7288f50d$export$977f3f6a9323c0f6 = $kI1cH.lensProp;
var $d0eec78f7288f50d$export$8128bb6492cf3de7 = $kI1cH.lensProps;
var $d0eec78f7288f50d$export$d8556a2a8f973135 = $kI1cH.lensComponent;
var $d0eec78f7288f50d$export$b610b8812bbcded9 = function(i) {
    return (0, $6owmV.flow)($d0eec78f7288f50d$export$81a625dd455a09de, $kI1cH.optionalIndex(i));
};
var $d0eec78f7288f50d$export$84162b00c25b711c = function(i) {
    return (0, $6owmV.flow)($d0eec78f7288f50d$export$81a625dd455a09de, $kI1cH.optionalIndexNonEmpty(i));
};
var $d0eec78f7288f50d$export$df61b30b684217c0 = function(key) {
    return (0, $6owmV.flow)($d0eec78f7288f50d$export$81a625dd455a09de, $kI1cH.optionalKey(key));
};
var $d0eec78f7288f50d$export$976574c443b9185b = $kI1cH.lensAtKey;
var $d0eec78f7288f50d$export$ad14ef4001db2bcd = /*#__PURE__*/ $d0eec78f7288f50d$export$c1dc05e399870f6(/*#__PURE__*/ $kI1cH.prismSome());
var $d0eec78f7288f50d$export$79ffe56a765070d2 = /*#__PURE__*/ $d0eec78f7288f50d$export$c1dc05e399870f6(/*#__PURE__*/ $kI1cH.prismRight());
var $d0eec78f7288f50d$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $d0eec78f7288f50d$export$c1dc05e399870f6(/*#__PURE__*/ $kI1cH.prismLeft());
function $d0eec78f7288f50d$export$df3f009e3d155b20(T) {
    return (0, $6owmV.flow)($d0eec78f7288f50d$export$ef38eac73d6f828f, $kI1cH.traversalTraverse(T));
}
function $d0eec78f7288f50d$export$9a2f228bed5035c2(predicate) {
    return $d0eec78f7288f50d$export$323f76c400675c8b($kI1cH.optionalFindFirst(predicate));
}
function $d0eec78f7288f50d$export$28e1f787311e0a21(predicate) {
    return $d0eec78f7288f50d$export$323f76c400675c8b($kI1cH.optionalFindFirstNonEmpty(predicate));
}
var $d0eec78f7288f50d$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $d0eec78f7288f50d$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $d0eec78f7288f50d$var$imap_ = function(ea, ab, ba) {
    return $d0eec78f7288f50d$export$21cde5187c2605a3((0, $6owmV.flow)(ea.get, ab), (0, $6owmV.flow)(ba, ea.set));
};
var $d0eec78f7288f50d$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $d0eec78f7288f50d$export$dbdf692cc5737cfd = {
    URI: $d0eec78f7288f50d$export$9156e739aa33e19f,
    imap: $d0eec78f7288f50d$var$imap_
};
var $d0eec78f7288f50d$export$67666a3fb7d250d8 = {
    URI: $d0eec78f7288f50d$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $d0eec78f7288f50d$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $d0eec78f7288f50d$export$3a8840c5b2ecf003 = {
    URI: $d0eec78f7288f50d$export$9156e739aa33e19f,
    compose: $d0eec78f7288f50d$export$67666a3fb7d250d8.compose,
    id: $d0eec78f7288f50d$export$d560c7e4a29451c2
};

});

parcelRegister("lB86R", function(module, exports) {

$parcel$export(module.exports, "asTraversal", () => $fb93581b45a5953c$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $fb93581b45a5953c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modifyOption", () => $fb93581b45a5953c$export$a2ef9d652875bdfa);
$parcel$export(module.exports, "modify", () => $fb93581b45a5953c$export$3ff57735a52b8713);

var $6owmV = parcelRequire("6owmV");

var $1sIL7 = parcelRequire("1sIL7");

var $crypz = parcelRequire("crypz");

var $kI1cH = parcelRequire("kI1cH");
var $fb93581b45a5953c$export$516e28dec6a4b6d4 = $kI1cH.optional;
var $fb93581b45a5953c$export$d560c7e4a29451c2 = function() {
    return $fb93581b45a5953c$export$516e28dec6a4b6d4($1sIL7.some, (0, $6owmV.constant));
};
var $fb93581b45a5953c$export$ef38eac73d6f828f = $kI1cH.optionalAsTraversal;
var $fb93581b45a5953c$export$f672e0b6f7222cd7 = $kI1cH.optionalComposeOptional;
var $fb93581b45a5953c$export$323f76c400675c8b = $fb93581b45a5953c$export$f672e0b6f7222cd7;
var $fb93581b45a5953c$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.isoAsOptional, $fb93581b45a5953c$export$f672e0b6f7222cd7);
var $fb93581b45a5953c$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.lensAsOptional, $kI1cH.optionalComposeOptional);
var $fb93581b45a5953c$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.prismAsOptional, $kI1cH.optionalComposeOptional);
var $fb93581b45a5953c$export$aa978f69e007229f = function(ab) {
    return (0, $6owmV.flow)($fb93581b45a5953c$export$ef38eac73d6f828f, $kI1cH.traversalComposeTraversal(ab));
};
var $fb93581b45a5953c$export$a2ef9d652875bdfa = $kI1cH.optionalModifyOption;
var $fb93581b45a5953c$export$b2a7969df3fe0aa3 = function(a) {
    return $fb93581b45a5953c$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $fb93581b45a5953c$export$3ff57735a52b8713 = $kI1cH.optionalModify;
function $fb93581b45a5953c$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $crypz.pipe)(sa.getOption(s), $1sIL7.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $fb93581b45a5953c$export$b601f49376b4621a = /*#__PURE__*/ $fb93581b45a5953c$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismAsOptional(/*#__PURE__*/ $kI1cH.prismFromNullable()));
function $fb93581b45a5953c$export$3dea766d36a8935f(predicate) {
    return $fb93581b45a5953c$export$f672e0b6f7222cd7($kI1cH.prismAsOptional($kI1cH.prismFromPredicate(predicate)));
}
var $fb93581b45a5953c$export$977f3f6a9323c0f6 = function(prop) {
    return $fb93581b45a5953c$export$f672e0b6f7222cd7((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensProp(prop), $kI1cH.lensAsOptional));
};
var $fb93581b45a5953c$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $fb93581b45a5953c$export$f672e0b6f7222cd7((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensProps.apply($kI1cH, props), $kI1cH.lensAsOptional));
};
var $fb93581b45a5953c$export$d8556a2a8f973135 = function(prop) {
    return $fb93581b45a5953c$export$f672e0b6f7222cd7((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensComponent(prop), $kI1cH.lensAsOptional));
};
var $fb93581b45a5953c$export$b610b8812bbcded9 = $kI1cH.optionalIndex;
var $fb93581b45a5953c$export$84162b00c25b711c = $kI1cH.optionalIndexNonEmpty;
var $fb93581b45a5953c$export$df61b30b684217c0 = $kI1cH.optionalKey;
var $fb93581b45a5953c$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $fb93581b45a5953c$export$f672e0b6f7222cd7($kI1cH.lensAsOptional($kI1cH.atReadonlyRecord().at(key))));
    };
};
var $fb93581b45a5953c$export$ad14ef4001db2bcd = /*#__PURE__*/ $fb93581b45a5953c$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismAsOptional(/*#__PURE__*/ $kI1cH.prismSome()));
var $fb93581b45a5953c$export$79ffe56a765070d2 = /*#__PURE__*/ $fb93581b45a5953c$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismAsOptional(/*#__PURE__*/ $kI1cH.prismRight()));
var $fb93581b45a5953c$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $fb93581b45a5953c$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismAsOptional(/*#__PURE__*/ $kI1cH.prismLeft()));
function $fb93581b45a5953c$export$df3f009e3d155b20(T) {
    return (0, $6owmV.flow)($fb93581b45a5953c$export$ef38eac73d6f828f, $kI1cH.traversalTraverse(T));
}
function $fb93581b45a5953c$export$9a2f228bed5035c2(predicate) {
    return $fb93581b45a5953c$export$f672e0b6f7222cd7($kI1cH.optionalFindFirst(predicate));
}
function $fb93581b45a5953c$export$28e1f787311e0a21(predicate) {
    return $fb93581b45a5953c$export$f672e0b6f7222cd7($kI1cH.optionalFindFirstNonEmpty(predicate));
}
var $fb93581b45a5953c$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $fb93581b45a5953c$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $fb93581b45a5953c$var$imap_ = function(ea, ab, ba) {
    return $fb93581b45a5953c$export$516e28dec6a4b6d4((0, $6owmV.flow)(ea.getOption, $1sIL7.map(ab)), (0, $6owmV.flow)(ba, ea.set));
};
var $fb93581b45a5953c$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $fb93581b45a5953c$export$dbdf692cc5737cfd = {
    URI: $fb93581b45a5953c$export$9156e739aa33e19f,
    imap: $fb93581b45a5953c$var$imap_
};
var $fb93581b45a5953c$export$67666a3fb7d250d8 = {
    URI: $fb93581b45a5953c$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $fb93581b45a5953c$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $fb93581b45a5953c$export$3a8840c5b2ecf003 = {
    URI: $fb93581b45a5953c$export$9156e739aa33e19f,
    compose: $fb93581b45a5953c$export$67666a3fb7d250d8.compose,
    id: $fb93581b45a5953c$export$d560c7e4a29451c2
};

});

parcelRegister("ehgq4", function(module, exports) {

$parcel$export(module.exports, "fromPredicate", () => $a64f63cf93751104$export$23f31c55d7162b91);
$parcel$export(module.exports, "asOptional", () => $a64f63cf93751104$export$81a625dd455a09de);
$parcel$export(module.exports, "asTraversal", () => $a64f63cf93751104$export$ef38eac73d6f828f);
$parcel$export(module.exports, "compose", () => $a64f63cf93751104$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "composeLens", () => $a64f63cf93751104$export$f5c3e419c6a355ce);

var $6owmV = parcelRequire("6owmV");

var $1sIL7 = parcelRequire("1sIL7");

var $crypz = parcelRequire("crypz");

var $kI1cH = parcelRequire("kI1cH");
var $a64f63cf93751104$export$e469dcfea9910464 = $kI1cH.prism;
var $a64f63cf93751104$export$d560c7e4a29451c2 = function() {
    return $a64f63cf93751104$export$e469dcfea9910464($1sIL7.some, (0, $6owmV.identity));
};
var $a64f63cf93751104$export$23f31c55d7162b91 = $kI1cH.prismFromPredicate;
var $a64f63cf93751104$export$81a625dd455a09de = $kI1cH.prismAsOptional;
var $a64f63cf93751104$export$ef38eac73d6f828f = $kI1cH.prismAsTraversal;
var $a64f63cf93751104$export$f672e0b6f7222cd7 = $kI1cH.prismComposePrism;
var $a64f63cf93751104$export$c1dc05e399870f6 = $a64f63cf93751104$export$f672e0b6f7222cd7;
var $a64f63cf93751104$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.isoAsPrism, $a64f63cf93751104$export$f672e0b6f7222cd7);
var $a64f63cf93751104$export$f5c3e419c6a355ce = $kI1cH.prismComposeLens;
var $a64f63cf93751104$export$323f76c400675c8b = function(ab) {
    return (0, $6owmV.flow)($a64f63cf93751104$export$81a625dd455a09de, $kI1cH.optionalComposeOptional(ab));
};
var $a64f63cf93751104$export$aa978f69e007229f = function(ab) {
    return (0, $6owmV.flow)($a64f63cf93751104$export$ef38eac73d6f828f, $kI1cH.traversalComposeTraversal(ab));
};
var $a64f63cf93751104$export$adaa4cf7ef1b65be = $kI1cH.prismSet;
var $a64f63cf93751104$export$a2ef9d652875bdfa = $kI1cH.prismModifyOption;
var $a64f63cf93751104$export$3ff57735a52b8713 = $kI1cH.prismModify;
function $a64f63cf93751104$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $crypz.pipe)(sa.getOption(s), $1sIL7.fold(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $a64f63cf93751104$export$b601f49376b4621a = /*#__PURE__*/ $a64f63cf93751104$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismFromNullable());
function $a64f63cf93751104$export$3dea766d36a8935f(predicate) {
    return $a64f63cf93751104$export$f672e0b6f7222cd7($kI1cH.prismFromPredicate(predicate));
}
var $a64f63cf93751104$export$977f3f6a9323c0f6 = function(prop) {
    return $a64f63cf93751104$export$f5c3e419c6a355ce((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensProp(prop)));
}; // TODO: simplify?
var $a64f63cf93751104$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $a64f63cf93751104$export$f5c3e419c6a355ce((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensProps.apply($kI1cH, props)));
};
var $a64f63cf93751104$export$d8556a2a8f973135 = function(prop) {
    return $a64f63cf93751104$export$f5c3e419c6a355ce((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensComponent(prop)));
};
var $a64f63cf93751104$export$b610b8812bbcded9 = function(i) {
    return (0, $6owmV.flow)($a64f63cf93751104$export$81a625dd455a09de, $kI1cH.optionalIndex(i));
};
var $a64f63cf93751104$export$84162b00c25b711c = function(i) {
    return (0, $6owmV.flow)($a64f63cf93751104$export$81a625dd455a09de, $kI1cH.optionalIndexNonEmpty(i));
};
var $a64f63cf93751104$export$df61b30b684217c0 = function(key) {
    return (0, $6owmV.flow)($a64f63cf93751104$export$81a625dd455a09de, $kI1cH.optionalKey(key));
};
var $a64f63cf93751104$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $kI1cH.prismComposeLens($kI1cH.atReadonlyRecord().at(key))(sa);
    };
};
var $a64f63cf93751104$export$ad14ef4001db2bcd = /*#__PURE__*/ $a64f63cf93751104$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismSome());
var $a64f63cf93751104$export$79ffe56a765070d2 = /*#__PURE__*/ $a64f63cf93751104$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismRight());
var $a64f63cf93751104$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $a64f63cf93751104$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismLeft());
function $a64f63cf93751104$export$df3f009e3d155b20(T) {
    return (0, $6owmV.flow)($a64f63cf93751104$export$ef38eac73d6f828f, $kI1cH.traversalTraverse(T));
}
function $a64f63cf93751104$export$9a2f228bed5035c2(predicate) {
    return $a64f63cf93751104$export$323f76c400675c8b($kI1cH.optionalFindFirst(predicate));
}
function $a64f63cf93751104$export$28e1f787311e0a21(predicate) {
    return $a64f63cf93751104$export$323f76c400675c8b($kI1cH.optionalFindFirstNonEmpty(predicate));
}
var $a64f63cf93751104$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $a64f63cf93751104$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $a64f63cf93751104$var$imap_ = function(ea, ab, ba) {
    return $a64f63cf93751104$export$e469dcfea9910464((0, $6owmV.flow)(ea.getOption, $1sIL7.map(ab)), (0, $6owmV.flow)(ba, ea.reverseGet));
};
var $a64f63cf93751104$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $a64f63cf93751104$export$dbdf692cc5737cfd = {
    URI: $a64f63cf93751104$export$9156e739aa33e19f,
    imap: $a64f63cf93751104$var$imap_
};
var $a64f63cf93751104$export$67666a3fb7d250d8 = {
    URI: $a64f63cf93751104$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $a64f63cf93751104$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $a64f63cf93751104$export$3a8840c5b2ecf003 = {
    URI: $a64f63cf93751104$export$9156e739aa33e19f,
    compose: $a64f63cf93751104$export$67666a3fb7d250d8.compose,
    id: $a64f63cf93751104$export$d560c7e4a29451c2
};

});

parcelRegister("ccdkU", function(module, exports) {

$parcel$export(module.exports, "fromTraversable", () => $8e10f34ef49f3fb4$export$126b5a87c58d3f9c);
$parcel$export(module.exports, "compose", () => $8e10f34ef49f3fb4$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "modify", () => $8e10f34ef49f3fb4$export$3ff57735a52b8713);
$parcel$export(module.exports, "set", () => $8e10f34ef49f3fb4$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "filter", () => $8e10f34ef49f3fb4$export$3dea766d36a8935f);

var $8oqh6 = parcelRequire("8oqh6");

var $6owmV = parcelRequire("6owmV");

var $crypz = parcelRequire("crypz");

var $8D8qW = parcelRequire("8D8qW");

var $kI1cH = parcelRequire("kI1cH");
var $8e10f34ef49f3fb4$export$8666ce7a134c2314 = $kI1cH.traversal;
var $8e10f34ef49f3fb4$export$d560c7e4a29451c2 = function() {
    return $8e10f34ef49f3fb4$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $8e10f34ef49f3fb4$export$126b5a87c58d3f9c = $kI1cH.fromTraversable;
var $8e10f34ef49f3fb4$export$f672e0b6f7222cd7 = $kI1cH.traversalComposeTraversal;
var $8e10f34ef49f3fb4$export$aa978f69e007229f = $8e10f34ef49f3fb4$export$f672e0b6f7222cd7;
var $8e10f34ef49f3fb4$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.isoAsTraversal, $8e10f34ef49f3fb4$export$f672e0b6f7222cd7);
var $8e10f34ef49f3fb4$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.lensAsTraversal, $kI1cH.traversalComposeTraversal);
var $8e10f34ef49f3fb4$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.prismAsTraversal, $kI1cH.traversalComposeTraversal);
var $8e10f34ef49f3fb4$export$323f76c400675c8b = /*#__PURE__*/ (0, $6owmV.flow)($kI1cH.optionalAsTraversal, $kI1cH.traversalComposeTraversal);
var $8e10f34ef49f3fb4$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($kI1cH.ApplicativeIdentity)(f);
    };
};
var $8e10f34ef49f3fb4$export$adaa4cf7ef1b65be = function(a) {
    return $8e10f34ef49f3fb4$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $8e10f34ef49f3fb4$export$b601f49376b4621a = function(sa) {
    return $8e10f34ef49f3fb4$export$c1dc05e399870f6($kI1cH.prismFromNullable())(sa);
};
function $8e10f34ef49f3fb4$export$3dea766d36a8935f(predicate) {
    return $8e10f34ef49f3fb4$export$f672e0b6f7222cd7($kI1cH.prismAsTraversal($kI1cH.prismFromPredicate(predicate)));
}
var $8e10f34ef49f3fb4$export$977f3f6a9323c0f6 = function(prop) {
    return $8e10f34ef49f3fb4$export$f672e0b6f7222cd7((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensProp(prop), $kI1cH.lensAsTraversal));
};
var $8e10f34ef49f3fb4$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $8e10f34ef49f3fb4$export$f672e0b6f7222cd7((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensProps.apply($kI1cH, props), $kI1cH.lensAsTraversal));
};
var $8e10f34ef49f3fb4$export$d8556a2a8f973135 = function(prop) {
    return $8e10f34ef49f3fb4$export$f672e0b6f7222cd7((0, $crypz.pipe)($kI1cH.lensId(), $kI1cH.lensComponent(prop), $kI1cH.lensAsTraversal));
};
var $8e10f34ef49f3fb4$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $8e10f34ef49f3fb4$export$f672e0b6f7222cd7($kI1cH.optionalAsTraversal($kI1cH.indexReadonlyArray().index(i))));
    };
};
var $8e10f34ef49f3fb4$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $8e10f34ef49f3fb4$export$f672e0b6f7222cd7($kI1cH.optionalAsTraversal($kI1cH.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $8e10f34ef49f3fb4$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $8e10f34ef49f3fb4$export$f672e0b6f7222cd7($kI1cH.optionalAsTraversal($kI1cH.indexReadonlyRecord().index(key))));
    };
};
var $8e10f34ef49f3fb4$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $crypz.pipe)(sa, $8e10f34ef49f3fb4$export$f672e0b6f7222cd7($kI1cH.lensAsTraversal($kI1cH.atReadonlyRecord().at(key))));
    };
};
var $8e10f34ef49f3fb4$export$ad14ef4001db2bcd = /*#__PURE__*/ $8e10f34ef49f3fb4$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismAsTraversal(/*#__PURE__*/ $kI1cH.prismSome()));
var $8e10f34ef49f3fb4$export$79ffe56a765070d2 = /*#__PURE__*/ $8e10f34ef49f3fb4$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismAsTraversal(/*#__PURE__*/ $kI1cH.prismRight()));
var $8e10f34ef49f3fb4$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $8e10f34ef49f3fb4$export$f672e0b6f7222cd7(/*#__PURE__*/ $kI1cH.prismAsTraversal(/*#__PURE__*/ $kI1cH.prismLeft()));
var $8e10f34ef49f3fb4$export$df3f009e3d155b20 = $kI1cH.traversalTraverse;
function $8e10f34ef49f3fb4$export$9a2f228bed5035c2(predicate) {
    return $8e10f34ef49f3fb4$export$323f76c400675c8b($kI1cH.optionalFindFirst(predicate));
}
function $8e10f34ef49f3fb4$export$28e1f787311e0a21(predicate) {
    return $8e10f34ef49f3fb4$export$323f76c400675c8b($kI1cH.optionalFindFirstNonEmpty(predicate));
}
var $8e10f34ef49f3fb4$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($8oqh6.getApplicative(M))(function(a) {
                return $8oqh6.make(f(a));
            });
        };
    };
};
var $8e10f34ef49f3fb4$export$93e2b83da34ff82a = function(M) {
    return $8e10f34ef49f3fb4$export$b66cdc0497d8a99a(M)((0, $6owmV.identity));
};
var $8e10f34ef49f3fb4$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $8e10f34ef49f3fb4$export$b66cdc0497d8a99a($8D8qW.getMonoid())($8D8qW.of)(sa)(s);
    };
};
var $8e10f34ef49f3fb4$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $8e10f34ef49f3fb4$export$67666a3fb7d250d8 = {
    URI: $8e10f34ef49f3fb4$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $8e10f34ef49f3fb4$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $8e10f34ef49f3fb4$export$3a8840c5b2ecf003 = {
    URI: $8e10f34ef49f3fb4$export$9156e739aa33e19f,
    compose: $8e10f34ef49f3fb4$export$67666a3fb7d250d8.compose,
    id: $8e10f34ef49f3fb4$export$d560c7e4a29451c2
};

});


const $5bab64b7a676e01c$export$82796cc300bdfa9d = 'chat/v1/invoke_agent/stream';
const $5bab64b7a676e01c$export$7c03f5942efb8a41 = '/gateway/api/assist';


parcelRegister("jdpvf", function(module, exports) {

$parcel$export(module.exports, "makeAIAgentStreamRequest", () => $de28104d751ef460$export$f08c4fd1705b0192);

var $dOAU7 = parcelRequire("dOAU7");

var $fBaBT = parcelRequire("fBaBT");

var $iBQQK = parcelRequire("iBQQK");
function $de28104d751ef460$export$f08c4fd1705b0192(requestConfig) {
    const behaviorSubject = new (0, $dOAU7.BehaviorSubject)({
        content: null,
        responseState: (0, $fBaBT.AIAgentResponseState).Initialization
    });
    fetch(requestConfig.url, {
        credentials: 'include',
        ...requestConfig.requestInitParams
    }).then((response)=>(0, $iBQQK.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $fBaBT.AIAgentResponseState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.message.content;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $fBaBT.AIAgentResponseState).FinalResponse,
                        content: bufferContent,
                        metadata: {
                            tokenData: chunk.message.usage_data
                        }
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? [],
                        responseState: (0, $fBaBT.AIAgentResponseState).FollowUp
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $fBaBT.AIAgentResponseState).Error,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
}

});
parcelRegister("iBQQK", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $757365fe83e4b78a$export$e45226161c660403);

var $476Ri = parcelRequire("476Ri");

var $2Kk17 = parcelRequire("2Kk17");
async function* $757365fe83e4b78a$export$e45226161c660403(response) {
    // covered HTTP errors only from this doc
    // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
    const possibleHTTPError = await (0, $476Ri.match)(response).returnType().with({
        status: 201
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).NO_ANSWER,
                status_code: response.status
            }
        };
    }).with({
        status: 400
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).NO_AGENT,
                status_code: response.status
            }
        };
    }).with({
        status: 403
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).AI_DISABLED,
                status_code: response.status
            }
        };
    }).with({
        status: 429
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).RATE_LIMIT,
                status_code: response.status
            }
        };
    }).with({
        status: 500
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).with({
        status: (0, $476Ri.P).not(200)
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).otherwise(()=>Promise.resolve(null));
    if (possibleHTTPError) {
        yield possibleHTTPError;
        return;
    }
    if (!response.body) {
        const responseText = await response.text();
        yield {
            type: 'ERROR',
            message: {
                content: `[Error]: response.body is missing. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).NETWORK_ERROR,
                status_code: response.status
            }
        };
        return;
    }
    try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $2Kk17.ErrorMessage).UNEXPECTED
            }
        };
        return;
    }
}

});
parcelRegister("476Ri", function(module, exports) {

$parcel$export(module.exports, "P", () => $2fed22d83f7237ad$export$56c0d5a1e737357d);
$parcel$export(module.exports, "match", () => $2fed22d83f7237ad$export$4659b591c19bdf3d);
const $2fed22d83f7237ad$var$t = Symbol.for("@ts-pattern/matcher"), $2fed22d83f7237ad$var$e = Symbol.for("@ts-pattern/isVariadic"), $2fed22d83f7237ad$var$n = "@ts-pattern/anonymous-select-key", $2fed22d83f7237ad$var$r = (t)=>Boolean(t && "object" == typeof t), $2fed22d83f7237ad$var$i = (e)=>e && !!e[$2fed22d83f7237ad$var$t], $2fed22d83f7237ad$var$s = (n, o, c)=>{
    if ($2fed22d83f7237ad$var$i(n)) {
        const e = n[$2fed22d83f7237ad$var$t](), { matched: r, selections: i } = e.match(o);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2fed22d83f7237ad$var$r(n)) {
        if (!$2fed22d83f7237ad$var$r(o)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(o)) return !1;
            let t = [], r = [], a = [];
            for (const s of n.keys()){
                const o = n[s];
                $2fed22d83f7237ad$var$i(o) && o[$2fed22d83f7237ad$var$e] ? a.push(o) : a.length ? r.push(o) : t.push(o);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (o.length < t.length + r.length) return !1;
                const e = o.slice(0, t.length), n = 0 === r.length ? [] : o.slice(-r.length), i = o.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2fed22d83f7237ad$var$s(t, e[n], c)) && r.every((t, e)=>$2fed22d83f7237ad$var$s(t, n[e], c)) && (0 === a.length || $2fed22d83f7237ad$var$s(a[0], i, c));
            }
            return n.length === o.length && n.every((t, e)=>$2fed22d83f7237ad$var$s(t, o[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in o || $2fed22d83f7237ad$var$i(a = r) && "optional" === a[$2fed22d83f7237ad$var$t]().matcherType) && $2fed22d83f7237ad$var$s(r, o[e], c);
        });
    }
    return Object.is(o, n);
}, $2fed22d83f7237ad$var$o = (e)=>{
    var n, s, a;
    return $2fed22d83f7237ad$var$r(e) ? $2fed22d83f7237ad$var$i(e) ? null != (n = null == (s = (a = e[$2fed22d83f7237ad$var$t]()).getSelectionKeys) ? void 0 : s.call(a)) ? n : [] : Array.isArray(e) ? $2fed22d83f7237ad$var$c(e, $2fed22d83f7237ad$var$o) : $2fed22d83f7237ad$var$c(Object.values(e), $2fed22d83f7237ad$var$o) : [];
}, $2fed22d83f7237ad$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2fed22d83f7237ad$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2fed22d83f7237ad$var$s(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2fed22d83f7237ad$var$s(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2fed22d83f7237ad$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2fed22d83f7237ad$var$h(t),
        and: (e)=>$2fed22d83f7237ad$var$m(t, e),
        or: (e)=>$2fed22d83f7237ad$var$d(t, e),
        select: (e)=>void 0 === e ? $2fed22d83f7237ad$var$y(t) : $2fed22d83f7237ad$var$y(e, t)
    });
}
function $2fed22d83f7237ad$var$l(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2fed22d83f7237ad$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2fed22d83f7237ad$var$l($2fed22d83f7237ad$var$h(t)),
        select: (e)=>$2fed22d83f7237ad$var$l(void 0 === e ? $2fed22d83f7237ad$var$y(t) : $2fed22d83f7237ad$var$y(e, t))
    });
}
function $2fed22d83f7237ad$var$h(e) {
    return $2fed22d83f7237ad$var$u({
        [$2fed22d83f7237ad$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2fed22d83f7237ad$var$o(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2fed22d83f7237ad$var$s(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2fed22d83f7237ad$var$o(e),
                matcherType: "optional"
            })
    });
}
const $2fed22d83f7237ad$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2fed22d83f7237ad$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2fed22d83f7237ad$var$m(...e) {
    return $2fed22d83f7237ad$var$u({
        [$2fed22d83f7237ad$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2fed22d83f7237ad$var$s(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2fed22d83f7237ad$var$c(e, $2fed22d83f7237ad$var$o),
                matcherType: "and"
            })
    });
}
function $2fed22d83f7237ad$var$d(...e) {
    return $2fed22d83f7237ad$var$u({
        [$2fed22d83f7237ad$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2fed22d83f7237ad$var$c(e, $2fed22d83f7237ad$var$o).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2fed22d83f7237ad$var$s(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2fed22d83f7237ad$var$c(e, $2fed22d83f7237ad$var$o),
                matcherType: "or"
            })
    });
}
function $2fed22d83f7237ad$var$p(e) {
    return {
        [$2fed22d83f7237ad$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2fed22d83f7237ad$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2fed22d83f7237ad$var$u({
        [$2fed22d83f7237ad$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2fed22d83f7237ad$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2fed22d83f7237ad$var$s(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2fed22d83f7237ad$var$n
                    ].concat(void 0 === i ? [] : $2fed22d83f7237ad$var$o(i))
            })
    });
}
function $2fed22d83f7237ad$var$v(t) {
    return "number" == typeof t;
}
function $2fed22d83f7237ad$var$b(t) {
    return "string" == typeof t;
}
function $2fed22d83f7237ad$var$w(t) {
    return "bigint" == typeof t;
}
const $2fed22d83f7237ad$var$S = $2fed22d83f7237ad$var$u($2fed22d83f7237ad$var$p(function(t) {
    return !0;
})), $2fed22d83f7237ad$var$O = $2fed22d83f7237ad$var$S, $2fed22d83f7237ad$var$j = (t)=>Object.assign($2fed22d83f7237ad$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$m(t, (n = e, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$m(t, (n = e, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$m(t, (n = e, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$m(t, (n = e, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2fed22d83f7237ad$var$K = $2fed22d83f7237ad$var$j($2fed22d83f7237ad$var$p($2fed22d83f7237ad$var$b)), $2fed22d83f7237ad$var$x = (t)=>Object.assign($2fed22d83f7237ad$var$u(t), {
        between: (e, n)=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, ((t, e)=>$2fed22d83f7237ad$var$p((n)=>$2fed22d83f7237ad$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$v(e) && e < t))(e))),
        gt: (e)=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$v(e) && e > t))(e))),
        lte: (e)=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$v(e) && e <= t))(e))),
        gte: (e)=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$v(e) && e >= t))(e))),
        int: ()=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$v(t) && t > 0))),
        negative: ()=>$2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$m(t, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$v(t) && t < 0)))
    }), $2fed22d83f7237ad$var$E = $2fed22d83f7237ad$var$x($2fed22d83f7237ad$var$p($2fed22d83f7237ad$var$v)), $2fed22d83f7237ad$var$A = (t)=>Object.assign($2fed22d83f7237ad$var$u(t), {
        between: (e, n)=>$2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$m(t, ((t, e)=>$2fed22d83f7237ad$var$p((n)=>$2fed22d83f7237ad$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$w(e) && e < t))(e))),
        gt: (e)=>$2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$w(e) && e > t))(e))),
        lte: (e)=>$2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$w(e) && e <= t))(e))),
        gte: (e)=>$2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$m(t, ((t)=>$2fed22d83f7237ad$var$p((e)=>$2fed22d83f7237ad$var$w(e) && e >= t))(e))),
        positive: ()=>$2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$m(t, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$w(t) && t > 0))),
        negative: ()=>$2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$m(t, $2fed22d83f7237ad$var$p((t)=>$2fed22d83f7237ad$var$w(t) && t < 0)))
    }), $2fed22d83f7237ad$var$P = $2fed22d83f7237ad$var$A($2fed22d83f7237ad$var$p($2fed22d83f7237ad$var$w)), $2fed22d83f7237ad$var$T = $2fed22d83f7237ad$var$u($2fed22d83f7237ad$var$p(function(t) {
    return "boolean" == typeof t;
})), $2fed22d83f7237ad$var$B = $2fed22d83f7237ad$var$u($2fed22d83f7237ad$var$p(function(t) {
    return "symbol" == typeof t;
})), $2fed22d83f7237ad$var$_ = $2fed22d83f7237ad$var$u($2fed22d83f7237ad$var$p(function(t) {
    return null == t;
})), $2fed22d83f7237ad$var$k = $2fed22d83f7237ad$var$u($2fed22d83f7237ad$var$p(function(t) {
    return null != t;
}));
var $2fed22d83f7237ad$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2fed22d83f7237ad$var$t,
    optional: $2fed22d83f7237ad$var$h,
    array: function(...e) {
        return $2fed22d83f7237ad$var$l({
            [$2fed22d83f7237ad$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2fed22d83f7237ad$var$o(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2fed22d83f7237ad$var$s(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2fed22d83f7237ad$var$o(e[0])
                })
        });
    },
    set: function(...e) {
        return $2fed22d83f7237ad$var$u({
            [$2fed22d83f7237ad$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2fed22d83f7237ad$var$f(t, (t)=>$2fed22d83f7237ad$var$s(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2fed22d83f7237ad$var$o(e[0])
                })
        });
    },
    map: function(...e) {
        return $2fed22d83f7237ad$var$u({
            [$2fed22d83f7237ad$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [o, c] = e;
                        return {
                            matched: $2fed22d83f7237ad$var$g(t, (t, e)=>{
                                const n = $2fed22d83f7237ad$var$s(o, e, r), i = $2fed22d83f7237ad$var$s(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2fed22d83f7237ad$var$o(e[0]),
                            ...$2fed22d83f7237ad$var$o(e[1])
                        ]
                })
        });
    },
    intersection: $2fed22d83f7237ad$var$m,
    union: $2fed22d83f7237ad$var$d,
    not: function(e) {
        return $2fed22d83f7237ad$var$u({
            [$2fed22d83f7237ad$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2fed22d83f7237ad$var$s(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2fed22d83f7237ad$var$p,
    select: $2fed22d83f7237ad$var$y,
    any: $2fed22d83f7237ad$var$S,
    _: $2fed22d83f7237ad$var$O,
    string: $2fed22d83f7237ad$var$K,
    number: $2fed22d83f7237ad$var$E,
    bigint: $2fed22d83f7237ad$var$P,
    boolean: $2fed22d83f7237ad$var$T,
    symbol: $2fed22d83f7237ad$var$B,
    nullish: $2fed22d83f7237ad$var$_,
    nonNullable: $2fed22d83f7237ad$var$k,
    instanceOf: function(t) {
        return $2fed22d83f7237ad$var$u($2fed22d83f7237ad$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2fed22d83f7237ad$var$u($2fed22d83f7237ad$var$p($2fed22d83f7237ad$export$ce1e7a33533a73d9(t)));
    }
};
class $2fed22d83f7237ad$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2fed22d83f7237ad$var$$ = {
    matched: !1,
    value: void 0
};
function $2fed22d83f7237ad$export$4659b591c19bdf3d(t) {
    return new $2fed22d83f7237ad$var$I(t, $2fed22d83f7237ad$var$$);
}
class $2fed22d83f7237ad$var$I {
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let o = !1, c = {};
        const a = (t, e)=>{
            o = !0, c[t] = e;
        }, u = !r.some((t)=>$2fed22d83f7237ad$var$s(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2fed22d83f7237ad$var$$ : {
            matched: !0,
            value: e(o ? $2fed22d83f7237ad$var$n in c ? c[$2fed22d83f7237ad$var$n] : c : this.input, this.input)
        };
        return new $2fed22d83f7237ad$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2fed22d83f7237ad$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2fed22d83f7237ad$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive() {
        if (this.state.matched) return this.state.value;
        throw new $2fed22d83f7237ad$export$6c1467edb54d3773(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
}

});



parcelRegister("6uKUw", function(module, exports) {

$parcel$export(module.exports, "parsePartialJsonIfNeeded", () => $4e8d528e942166f6$export$1a589176614a95f1);

var $1KdUV = parcelRequire("1KdUV");

var $fBaBT = parcelRequire("fBaBT");
function $4e8d528e942166f6$export$1a589176614a95f1(state, config) {
    if (state.responseState !== (0, $fBaBT.AIAgentResponseState).Initialization && config.enablePartialJson && state.content) try {
        const parsedContent = (0, $1KdUV.parse)(state.content);
        return {
            ...state,
            content: parsedContent
        };
    } catch (error) {}
    return state;
}

});
parcelRegister("1KdUV", function(module, exports) {
"use strict";
var $1454e1fa5bb05fe4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1454e1fa5bb05fe4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1454e1fa5bb05fe4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.MalformedJSON = module.exports.PartialJSON = module.exports.parseJSON = module.exports.parse = void 0;

Object.defineProperty(module.exports, "Allow", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hJB1n")).Allow;
    }
});

$1454e1fa5bb05fe4$var$__exportStar((parcelRequire("hJB1n")), module.exports);
class $1454e1fa5bb05fe4$var$PartialJSON extends Error {
}
module.exports.PartialJSON = $1454e1fa5bb05fe4$var$PartialJSON;
class $1454e1fa5bb05fe4$var$MalformedJSON extends Error {
}
module.exports.MalformedJSON = $1454e1fa5bb05fe4$var$MalformedJSON;
/**
 * Parse incomplete JSON
 * @param {string} jsonString Partial JSON to be parsed
 * @param {number} allowPartial Specify what types are allowed to be partial, see {@link Allow} for details
 * @returns The parsed JSON
 * @throws {PartialJSON} If the JSON is incomplete (related to the `allow` parameter)
 * @throws {MalformedJSON} If the JSON is malformed
 */ function $1454e1fa5bb05fe4$var$parseJSON(jsonString, allowPartial = (parcelRequire("hJB1n")).Allow.ALL) {
    if (typeof jsonString !== "string") throw new TypeError(`expecting str, got ${typeof jsonString}`);
    if (!jsonString.trim()) throw new Error(`${jsonString} is empty`);
    return $1454e1fa5bb05fe4$var$_parseJSON(jsonString.trim(), allowPartial);
}
module.exports.parseJSON = $1454e1fa5bb05fe4$var$parseJSON;
const $1454e1fa5bb05fe4$var$_parseJSON = (jsonString, allow)=>{
    const length = jsonString.length;
    let index = 0;
    const markPartialJSON = (msg)=>{
        throw new $1454e1fa5bb05fe4$var$PartialJSON(`${msg} at position ${index}`);
    };
    const throwMalformedError = (msg)=>{
        throw new $1454e1fa5bb05fe4$var$MalformedJSON(`${msg} at position ${index}`);
    };
    const parseAny = ()=>{
        skipBlank();
        if (index >= length) markPartialJSON("Unexpected end of input");
        if (jsonString[index] === '"') return parseStr();
        if (jsonString[index] === "{") return parseObj();
        if (jsonString[index] === "[") return parseArr();
        if (jsonString.substring(index, index + 4) === "null" || (parcelRequire("hJB1n")).Allow.NULL & allow && length - index < 4 && "null".startsWith(jsonString.substring(index))) {
            index += 4;
            return null;
        }
        if (jsonString.substring(index, index + 4) === "true" || (parcelRequire("hJB1n")).Allow.BOOL & allow && length - index < 4 && "true".startsWith(jsonString.substring(index))) {
            index += 4;
            return true;
        }
        if (jsonString.substring(index, index + 5) === "false" || (parcelRequire("hJB1n")).Allow.BOOL & allow && length - index < 5 && "false".startsWith(jsonString.substring(index))) {
            index += 5;
            return false;
        }
        if (jsonString.substring(index, index + 8) === "Infinity" || (parcelRequire("hJB1n")).Allow.INFINITY & allow && length - index < 8 && "Infinity".startsWith(jsonString.substring(index))) {
            index += 8;
            return Infinity;
        }
        if (jsonString.substring(index, index + 9) === "-Infinity" || (parcelRequire("hJB1n")).Allow._INFINITY & allow && 1 < length - index && length - index < 9 && "-Infinity".startsWith(jsonString.substring(index))) {
            index += 9;
            return -Infinity;
        }
        if (jsonString.substring(index, index + 3) === "NaN" || (parcelRequire("hJB1n")).Allow.NAN & allow && length - index < 3 && "NaN".startsWith(jsonString.substring(index))) {
            index += 3;
            return NaN;
        }
        return parseNum();
    };
    const parseStr = ()=>{
        const start = index;
        let escape = false;
        index++; // skip initial quote
        while(index < length && (jsonString[index] !== '"' || escape && jsonString[index - 1] === "\\")){
            escape = jsonString[index] === "\\" ? !escape : false;
            index++;
        }
        if (jsonString.charAt(index) == '"') try {
            return JSON.parse(jsonString.substring(start, ++index - Number(escape)));
        } catch (e) {
            throwMalformedError(String(e));
        }
        else if ((parcelRequire("hJB1n")).Allow.STR & allow) try {
            return JSON.parse(jsonString.substring(start, index - Number(escape)) + '"');
        } catch (e) {
            // SyntaxError: Invalid escape sequence
            return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("\\")) + '"');
        }
        markPartialJSON("Unterminated string literal");
    };
    const parseObj = ()=>{
        index++; // skip initial brace
        skipBlank();
        const obj = {};
        try {
            while(jsonString[index] !== "}"){
                skipBlank();
                if (index >= length && (parcelRequire("hJB1n")).Allow.OBJ & allow) return obj;
                const key = parseStr();
                skipBlank();
                index++; // skip colon
                try {
                    const value = parseAny();
                    obj[key] = value;
                } catch (e) {
                    if ((parcelRequire("hJB1n")).Allow.OBJ & allow) return obj;
                    else throw e;
                }
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("hJB1n")).Allow.OBJ & allow) return obj;
            else markPartialJSON("Expected '}' at end of object");
        }
        index++; // skip final brace
        return obj;
    };
    const parseArr = ()=>{
        index++; // skip initial bracket
        const arr = [];
        try {
            while(jsonString[index] !== "]"){
                arr.push(parseAny());
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("hJB1n")).Allow.ARR & allow) return arr;
            markPartialJSON("Expected ']' at end of array");
        }
        index++; // skip final bracket
        return arr;
    };
    const parseNum = ()=>{
        if (index === 0) {
            if (jsonString === "-") throwMalformedError("Not sure what '-' is");
            try {
                return JSON.parse(jsonString);
            } catch (e) {
                if ((parcelRequire("hJB1n")).Allow.NUM & allow) try {
                    return JSON.parse(jsonString.substring(0, jsonString.lastIndexOf("e")));
                } catch (e) {}
                throwMalformedError(String(e));
            }
        }
        const start = index;
        if (jsonString[index] === "-") index++;
        while(jsonString[index] && ",]}".indexOf(jsonString[index]) === -1)index++;
        if (index == length && !((parcelRequire("hJB1n")).Allow.NUM & allow)) markPartialJSON("Unterminated number literal");
        try {
            return JSON.parse(jsonString.substring(start, index));
        } catch (e) {
            if (jsonString.substring(start, index) === "-") markPartialJSON("Not sure what '-' is");
            try {
                return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("e")));
            } catch (e) {
                throwMalformedError(String(e));
            }
        }
    };
    const skipBlank = ()=>{
        while(index < length && " \n\r\t".includes(jsonString[index]))index++;
    };
    return parseAny();
};
const $1454e1fa5bb05fe4$var$parse = $1454e1fa5bb05fe4$var$parseJSON;
module.exports.parse = $1454e1fa5bb05fe4$var$parse;

});
parcelRegister("hJB1n", function(module, exports) {
"use strict";
/**
 * Sometimes you don't allow every type to be partially parsed.
 * For example, you may not want a partial number because it may increase its size gradually before it's complete.
 * In this case, you can use the `Allow` object to control what types you allow to be partially parsed.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.ALL = module.exports.COLLECTION = module.exports.ATOM = module.exports.SPECIAL = module.exports.INF = module.exports._INFINITY = module.exports.INFINITY = module.exports.NAN = module.exports.BOOL = module.exports.NULL = module.exports.OBJ = module.exports.ARR = module.exports.NUM = module.exports.STR = void 0;
/**
 * allow partial strings like `"hello \u12` to be parsed as `"hello "`
 */ module.exports.STR = 1;
/**
 * allow partial numbers like `123.` to be parsed as `123`
 */ module.exports.NUM = 2;
/**
 * allow partial arrays like `[1, 2,` to be parsed as `[1, 2]`
 */ module.exports.ARR = 4;
/**
 * allow partial objects like `{"a": 1, "b":` to be parsed as `{"a": 1}`
 */ module.exports.OBJ = 8;
/**
 * allow `nu` to be parsed as `null`
 */ module.exports.NULL = 16;
/**
 * allow `tr` to be parsed as `true`, and `fa` to be parsed as `false`
 */ module.exports.BOOL = 32;
/**
 * allow `Na` to be parsed as `NaN`
 */ module.exports.NAN = 64;
/**
 * allow `Inf` to be parsed as `Infinity`
 */ module.exports.INFINITY = 128;
/**
 * allow `-Inf` to be parsed as `-Infinity`
 */ module.exports._INFINITY = 256;
module.exports.INF = module.exports.INFINITY | module.exports._INFINITY;
module.exports.SPECIAL = module.exports.NULL | module.exports.BOOL | module.exports.INF | module.exports.NAN;
module.exports.ATOM = module.exports.STR | module.exports.NUM | module.exports.SPECIAL;
module.exports.COLLECTION = module.exports.ARR | module.exports.OBJ;
module.exports.ALL = module.exports.ATOM | module.exports.COLLECTION;
/**
 * Control what types you allow to be partially parsed.
 * The default is to allow all types to be partially parsed, which in most casees is the best option.
 * @example
 * If you don't want to allow partial objects, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, Allow.ARR); // [ { a: 1, b: 2 } ]
 * ```
 * Or you can use `~` to disallow a type:
 * ```ts
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, ~Allow.OBJ); // [ { a: 1, b: 2 } ]
 * ```
 * @example
 * If you don't want to allow partial strings, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`["complete string", "incompl`, ~Allow.STR); // [ 'complete string' ]
 * ```
 */ module.exports.Allow = {
    STR: module.exports.STR,
    NUM: module.exports.NUM,
    ARR: module.exports.ARR,
    OBJ: module.exports.OBJ,
    NULL: module.exports.NULL,
    BOOL: module.exports.BOOL,
    NAN: module.exports.NAN,
    INFINITY: module.exports.INFINITY,
    _INFINITY: module.exports._INFINITY,
    INF: module.exports.INF,
    SPECIAL: module.exports.SPECIAL,
    ATOM: module.exports.ATOM,
    COLLECTION: module.exports.COLLECTION,
    ALL: module.exports.ALL
};
module.exports.default = module.exports.Allow;

});



parcelRegister("6iKPk", function(module, exports) {

$parcel$export(module.exports, "logInfo", () => $3286686b7d8a38df$export$89c0607256d35f0a);
const $3286686b7d8a38df$export$89c0607256d35f0a = (message, config, data)=>{
    if (config.enableLocalVerboseLogs) // eslint-disable-next-line no-console
    console.info(`[@atlassian/ai-agent-streaming] [${message}]:`, data);
};

});




parcelRegister("6a30R", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $97cd92cd81dfd9ff$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $97cd92cd81dfd9ff$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $97cd92cd81dfd9ff$export$3f864e37674c79e7);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $dn5wJ = parcelRequire("dn5wJ");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");
const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
    (0, $gKZoD.di)(window);
    try {
        const { hostname: hostname, pathname: pathname } = new URL(url);
        return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        hostname !== window.location.hostname || ![
            '/jira',
            '/browse'
        ].some((includedPath)=>pathname.startsWith(includedPath)));
    } catch (err) {
        // Defaults to external link for invalid URLs to avoid further processing
        return true;
    }
};
const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
    (0, $gKZoD.di)(window);
    if (!url) return;
    if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $dn5wJ.CardAction).ChangeStatusAction
        ]
    }
};
const $97cd92cd81dfd9ff$var$getProductForSmartLinksProvider = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const product = (0, $5uXOq.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $97cd92cd81dfd9ff$var$getProductForSmartLinksProvider(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};

});
parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});


parcelRegister("iixvy", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $545133d1825caa45$export$1bb5840a003dc643);
$parcel$export(module.exports, "useOptInStatus", () => $545133d1825caa45$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $545133d1825caa45$export$49e57b9044cda91c);

var $5uXOq = parcelRequire("5uXOq");

var $5euJh = parcelRequire("5euJh");
var $c04PQ = parcelRequire("c04PQ");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $5NH95 = parcelRequire("5NH95");

var $93Yeu = parcelRequire("93Yeu");

var $14XJw = parcelRequire("14XJw");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $ljlOe = parcelRequire("ljlOe");

var $44KLa = parcelRequire("44KLa");
const $545133d1825caa45$var$DISABLED = 'disabled';
const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $545133d1825caa45$var$ENABLED = 'enabled';
const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.PREMIUM_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return appEditions.core === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.STANDARD_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
    const isSupportedENV = !(0, $c04PQ.isFedRamp)();
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
    const isSupportedENV = !(0, $c04PQ.isFedRamp)();
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
    if ((0, $c04PQ.isFedRamp)()) return $545133d1825caa45$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    const { experimentValue: aiUpsellInEditorCohort } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: 'not-enrolled'
    };
    if (aiUpsellInEditorCohort === 'variation') return $545133d1825caa45$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
    return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
};
const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $5euJh.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljlOe.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $c04PQ.isFedRamp)()) return {
        optInStatus: $545133d1825caa45$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("5NH95", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $26b3b3762ac33b52$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $26b3b3762ac33b52$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c04PQ = parcelRequire("c04PQ");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $fmQtB = parcelRequire("fmQtB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $4SswE = parcelRequire("4SswE");

var $7xCut = parcelRequire("7xCut");
const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    switch(product){
        case 'JSW':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'JWM':
            // If tenant is configured with only JWM and JSW, we can provide an upgrade link for JSW
            return siteHasOnlyJira ? (0, $2vSU6.SOFTWARE_PROJECT) : undefined;
        case 'JPD':
        default:
            return undefined;
    }
};
const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const supportedEdition = $26b3b3762ac33b52$var$useGetSupportedEdition(product);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_free_ai_in_editor_v2_experiment');
    const statsigExperimentValue = config.get('cohort', 'not-enrolled');
    const siteMeetsRequirements = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') && supportedEdition === (0, $ldyPw.FREE_EDITION) && isOrgAdmin && !(0, $c04PQ.isFedRamp)();
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : 'not-enrolled';
    const fireExposure = (0, $5uXOq.useCallback)(()=>{
        fireExperimentExposure();
    }, [
        fireExperimentExposure
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : 'not-enrolled';
    // If the site is not FREE, or not on JSW/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = experimentValue !== 'not-enrolled';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue === 'variation';
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $7xCut.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmQtB.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isClicked = (0, $7xCut.getUpsellButtonWrapperClicked)();
    const hasFired = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFired.current) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {});
            hasFired.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $26b3b3762ac33b52$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $26b3b3762ac33b52$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fmQtB", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $2c23576aa5eb8dba$export$827041a383456a6a);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("3m7Tw")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("3m7Tw", function(module, exports) {

let $27198cdd03d57f89$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $27198cdd03d57f89$var$load("76n7a"),
    $27198cdd03d57f89$var$load("l253H"),
    $27198cdd03d57f89$var$load("ffQaD"),
    $27198cdd03d57f89$var$load("kvRbA"),
    $27198cdd03d57f89$var$load("1Gr9M")
]).then(()=>parcelRequire('b738i'));

});


parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("4SswE", function(module, exports) {

$parcel$export(module.exports, "useSiteHasOnlyJira", () => $b6d886096eb5e5b4$export$8ce0db5ac54a6136);

var $cVzoY = parcelRequire("cVzoY");


var $9OXo1 = parcelRequire("9OXo1");
function $b6d886096eb5e5b4$export$8ce0db5ac54a6136() {
    const tenantContext = (0, $9OXo1.useTenantContext)();
    try {
        const [firstExplicitlyLicensedProduct, ...rest] = (0, $cVzoY.default)(tenantContext);
        return rest.length === 0 && firstExplicitlyLicensedProduct === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});
parcelRegister("cVzoY", function(module, exports) {

$parcel$export(module.exports, "default", () => $386aacc800b616d8$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$386aacc800b616d8$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $c06e1abca7c13910$export$db515c8cec1e6f79] && result.push((0, $c06e1abca7c13910$export$db515c8cec1e6f79));
    licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && result.push((0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d] && result.push((0, $c06e1abca7c13910$export$1346c9aa3cbb477d));
    licensedProducts[0, $c06e1abca7c13910$export$202f50ee62667e32] && result.push((0, $c06e1abca7c13910$export$202f50ee62667e32));
    return result;
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';



parcelRegister("7xCut", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$b595420beb43f9ce);

var $bSSG7 = parcelRequire("bSSG7");
const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
    return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
    $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("ljlOe", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $82777381236a0306$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $82777381236a0306$export$dd0a751f23b19473);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $b3Gth = parcelRequire("b3Gth");
const $82777381236a0306$export$77aa5ca661b0742c = (0, $l37qh.createUseEntryPointContext)();
const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("b3Gth", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $a50fd4829307668f$export$7116d5b1a93db8d6);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3lj1i")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3lj1i", function(module, exports) {

let $26f2163bd2555fbe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $26f2163bd2555fbe$var$load("ffQaD"),
    $26f2163bd2555fbe$var$load("kvRbA"),
    $26f2163bd2555fbe$var$load("kNFvF"),
    $26f2163bd2555fbe$var$load("jU6DJ")
]).then(()=>parcelRequire('5s8iH'));

});



parcelRegister("44KLa", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $bf7c19a18c627984$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $bf7c19a18c627984$export$bbf8d259a508a485);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $7NYq5 = parcelRequire("7NYq5");

var $4UN9Z = parcelRequire("4UN9Z");

var $7XluA = parcelRequire("7XluA");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ljlOe = parcelRequire("ljlOe");

var $ejjdc = parcelRequire("ejjdc");
const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4UN9Z.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-premium-trial-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ejjdc.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("4UN9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $498daaeb8cd4c6ec$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");
var $1GGwS = parcelRequire("1GGwS");

var $e4yMr = parcelRequire("e4yMr");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1mySm = parcelRequire("1mySm");


var $ek69Y = parcelRequire("ek69Y");

var $lJhAv = parcelRequire("lJhAv");
const $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $498daaeb8cd4c6ec$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>(0, $VSDnB.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4yMr.default), {
                href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $ek69Y.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $5uXOq.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($1mySm)))
        ]);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1mySm))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                            xcss: $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $ek69Y.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJhAv.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lJhAv.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1GGwS.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $3490940fa7f2fa1c$export$bae9a077d7ed5dfe),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $ek69Y.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $498daaeb8cd4c6ec$export$2e2bcd8739ae039 = $498daaeb8cd4c6ec$var$AiOptIn;

});
parcelRegister("1mySm", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $3490940fa7f2fa1c$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $3490940fa7f2fa1c$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("ek69Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fe19a2c65ae0a6d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fe19a2c65ae0a6d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("lJhAv", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $1bcec8f5b168d85d$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $1bcec8f5b168d85d$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $1bcec8f5b168d85d$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $1bcec8f5b168d85d$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $1bcec8f5b168d85d$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $1bcec8f5b168d85d$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $1bcec8f5b168d85d$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $1bcec8f5b168d85d$export$24c280970213bb11 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$14966827497f4695 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $1bcec8f5b168d85d$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ejjdc", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $678322372bbc5cca$export$54e4ba490d2c6bb5);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $2jwCH = parcelRequire("2jwCH");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $gEusR = parcelRequire("gEusR");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2ogyS = parcelRequire("2ogyS");

var $iau6N = parcelRequire("iau6N");
const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $678322372bbc5cca$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignBlock: "stretch",
        xcss: $678322372bbc5cca$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $678322372bbc5cca$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $2ogyS.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2jwCH)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEusR.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $678322372bbc5cca$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $2ogyS.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $2ogyS.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iau6N.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $678322372bbc5cca$var$containerBorderStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${"var(--ds-background-accent-blue-subtle, #579DFF)"} 0%,
      ${"var(--ds-background-accent-purple-subtle, #9F8FEF)"} 100%
    )`
});
const $678322372bbc5cca$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $678322372bbc5cca$var$headerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $678322372bbc5cca$var$textContainerStyles = (0, $8CUq3.xcss)({
    padding: 'space.300'
});

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});
parcelRegister("2C7j9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $1e74cc92a54dd799$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $1e74cc92a54dd799$var$_close.default
    }));
$1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;

});


parcelRegister("c8oLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e401c8401021557f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");
function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e401c8401021557f$var$baseStyles = {
    name: "1khn195",
    styles: "box-sizing:border-box"
};
const $e401c8401021557f$var$blockBleedMap = {
    'space.025': {
        name: "9w2fxh",
        styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "1qhe0y6",
        styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "s0o2nz",
        styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "151e4o3",
        styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "16sn062",
        styles: "margin-block:var(--ds-space-negative-200, -1rem)"
    }
};
const $e401c8401021557f$var$inlineBleedMap = {
    'space.025': {
        name: "16oxh68",
        styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
    },
    'space.050': {
        name: "tdc6fz",
        styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
    },
    'space.100': {
        name: "crujrn",
        styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
    },
    'space.150': {
        name: "y28d58",
        styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
    },
    'space.200': {
        name: "1vfkteg",
        styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
    }
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $e401c8401021557f$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $e401c8401021557f$var$baseStyles,
            (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
            (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$e401c8401021557f$var$Bleed.displayName = 'Bleed';
var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;

});

parcelRegister("gEusR", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf0e2023e742d66$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $ghvaY = parcelRequire("ghvaY");

var $h2dcc = parcelRequire("h2dcc");
const $daf0e2023e742d66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($h2dcc)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ghvaY))
});
var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
// for advanced use only
const $daf0e2023e742d66$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("ghvaY", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("h2dcc", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("2ogyS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $703e8ca8733c69fc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $703e8ca8733c69fc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("iau6N", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $d916fa2fae12e75a$export$a2651a739f515dd4);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $3ZC89 = parcelRequire("3ZC89");

var $bOVbW = parcelRequire("bOVbW");

var $47gW9 = parcelRequire("47gW9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $ljlOe = parcelRequire("ljlOe");

var $2ogyS = parcelRequire("2ogyS");
const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: (0, $4R6GH.fg)('issue-view-sparkle-icon-replacement-fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bOVbW))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZC89))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $2ogyS.messages).tryItFreeButton));
};

});
parcelRegister("3ZC89", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b007f69ad81895a86b02f3ac63c0846>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e84a5872037db9e$var$_react = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2e84a5872037db9e$var$_premium = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("41hx5")));

var $2e84a5872037db9e$var$_premium2 = $2e84a5872037db9e$var$_interopRequireDefault((parcelRequire("8EYBJ")));
function $2e84a5872037db9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PremiumIcon.
 * This component is PremiumIcon, with `UNSAFE_fallbackIcon` set to "PremiumIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e84a5872037db9e$var$PremiumIcon = (props)=>/*#__PURE__*/ $2e84a5872037db9e$var$_react.default.createElement($2e84a5872037db9e$var$_premium.default, Object.assign({
        LEGACY_fallbackIcon: $2e84a5872037db9e$var$_premium2.default
    }, props));
$2e84a5872037db9e$var$PremiumIcon.Name = 'PremiumIconMigration';
var $2e84a5872037db9e$var$_default = module.exports.default = $2e84a5872037db9e$var$PremiumIcon;

});
parcelRegister("41hx5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ed4db10c38a4841$var$_react = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ed4db10c38a4841$var$_baseNew = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ed4db10c38a4841$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ed4db10c38a4841$var$PremiumIcon = (props)=>/*#__PURE__*/ $2ed4db10c38a4841$var$_react.default.createElement($2ed4db10c38a4841$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$2ed4db10c38a4841$var$PremiumIcon.displayName = 'PremiumIcon';
var $2ed4db10c38a4841$var$_default = module.exports.default = $2ed4db10c38a4841$var$PremiumIcon;

});

parcelRegister("8EYBJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64e11291068cd489$var$_react = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $64e11291068cd489$var$_premium = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("41hx5")));
function $64e11291068cd489$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64e11291068cd489$var$PremiumIcon = (props)=>/*#__PURE__*/ $64e11291068cd489$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $64e11291068cd489$var$_premium.default
    }));
$64e11291068cd489$var$PremiumIcon.displayName = 'PremiumIcon';
var $64e11291068cd489$var$_default = module.exports.default = $64e11291068cd489$var$PremiumIcon;

});






parcelRegister("147rB", function(module, exports) {

$parcel$export(module.exports, "useProfileCardProvider", () => $4cfb0fc564fb51d9$export$160c0313bd165356);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jcw0u = parcelRequire("jcw0u");


var $9l5Jv = parcelRequire("9l5Jv");

var $7I2zi = parcelRequire("7I2zi");

var $koeKL = parcelRequire("koeKL");

var $4oO9d = parcelRequire("4oO9d");

var $gLmUz = parcelRequire("gLmUz");

var $lVJAU = parcelRequire("lVJAU");

const $4cfb0fc564fb51d9$var$defaultActions = [
    (0, $e6a2e0952e4731b8$export$23cedd3261bd8015)
];
const $4cfb0fc564fb51d9$export$160c0313bd165356 = (props = {})=>{
    const { onLoadError: providedOnLoadError, actions: actions = $4cfb0fc564fb51d9$var$defaultActions } = props;
    const cloudId = (0, $koeKL.useCloudId)();
    const orgId = (0, $4oO9d.useOrgId)();
    const fabricPfDirUrl = (0, $gLmUz.useFabricProfileDirectoryUrl)();
    const intl = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onLoadError = (0, $5uXOq.useCallback)((error, analyticsEvent)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'loadProfileCardClient',
                packageName: 'jiraProfilecardProvider',
                teamName: 'bento'
            },
            error: error,
            // Skipping sentry since there is no follow-up action for these errors.
            skipSentry: true
        });
        providedOnLoadError && providedOnLoadError(error, analyticsEvent);
    }, [
        providedOnLoadError
    ]);
    const profileClient = (0, $5uXOq.useMemo)(()=>(0, $9l5Jv.createUserProfileCardClient)(fabricPfDirUrl || (0, $e81e3d4d8c6e2362$export$7c8e7812b81467ad), onLoadError, (0, $e81e3d4d8c6e2362$export$4b61157fa784d22e), cloudId, orgId), [
        fabricPfDirUrl,
        onLoadError,
        cloudId,
        orgId
    ]);
    const getActions = (0, $5uXOq.useCallback)((id)=>(0, $7I2zi.getSpaActions)(id, intl, push, actions), [
        actions,
        intl,
        push
    ]);
    const provider = (0, $5uXOq.useMemo)(()=>Promise.resolve({
            cloudId: cloudId,
            getActions: getActions,
            resourceClient: profileClient
        }), [
        cloudId,
        getActions,
        profileClient
    ]);
    return provider;
};

});
const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("9l5Jv", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $85b7b963f4e84597$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $85b7b963f4e84597$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $85b7b963f4e84597$export$d43dc22a8337ee9f);

var $blw2B = parcelRequire("blw2B");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $58UyI = parcelRequire("58UyI");
const $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $85b7b963f4e84597$export$c4393c51e6d104c3 = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $58UyI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $blw2B.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $85b7b963f4e84597$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            const finalProfileClient = profileClient || $85b7b963f4e84597$export$c4393c51e6d104c3(fabricPfDirUrl ?? '', onLoadError, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
            setState({
                profileClient: finalProfileClient
            });
        }
};
const $85b7b963f4e84597$export$d816ba2709570028 = (0, $gg7kZ.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $85b7b963f4e84597$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $85b7b963f4e84597$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'ProfileClientStore',
    initialState: $85b7b963f4e84597$export$d4c72bab9d6cc13a,
    actions: $85b7b963f4e84597$export$e324594224ef24da,
    containedBy: $85b7b963f4e84597$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($85b7b963f4e84597$export$e324594224ef24da.bootstrap())
    }
});
const $85b7b963f4e84597$export$d43dc22a8337ee9f = (0, $3sQ5x.createStateHook)($85b7b963f4e84597$export$6f57813fe9f31bf9);

});
parcelRegister("blw2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b628efa3a075dd4$export$2e2bcd8739ae039);


var $bp5g1 = parcelRequire("bp5g1");


var $dFLsP = parcelRequire("dFLsP");
var $2b628efa3a075dd4$export$2e2bcd8739ae039 = (0, $bp5g1.default);

});
parcelRegister("bp5g1", function(module, exports) {

$parcel$export(module.exports, "default", () => $35fb800f6bdcf84a$export$2e2bcd8739ae039);

var $5euJh = parcelRequire("5euJh");
var $c04PQ = parcelRequire("c04PQ");

var $4zh20 = parcelRequire("4zh20");

var $4mT2s = parcelRequire("4mT2s");

var $fjEAi = parcelRequire("fjEAi");

var $dFLsP = parcelRequire("dFLsP");
const $35fb800f6bdcf84a$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $35fb800f6bdcf84a$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$35fb800f6bdcf84a$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $35fb800f6bdcf84a$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $dFLsP.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $fjEAi.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $4zh20.default)(withDefaultConfig);
        this.tcClient = $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $5euJh.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $5euJh.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $c04PQ.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $4mT2s.default)({
        ...config
    }) : undefined;
}
var $35fb800f6bdcf84a$export$2e2bcd8739ae039 = $35fb800f6bdcf84a$var$ProfileCardClient;

});
parcelRegister("4zh20", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b1bd6752a000ab$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");
const $23b1bd6752a000ab$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $23b1bd6752a000ab$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    basePath() {
        return (0, $VSDnB.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("ivXTE", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $533bc31bb6af10e0$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $533bc31bb6af10e0$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $533bc31bb6af10e0$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $533bc31bb6af10e0$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $533bc31bb6af10e0$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $533bc31bb6af10e0$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $533bc31bb6af10e0$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $533bc31bb6af10e0$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $533bc31bb6af10e0$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $533bc31bb6af10e0$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $533bc31bb6af10e0$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $533bc31bb6af10e0$export$a9f8c9f412cf5664);

var $6TKEY = parcelRequire("6TKEY");
/** Below lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $533bc31bb6af10e0$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $533bc31bb6af10e0$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $6TKEY.getPageTime)())
        }
    });
const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $533bc31bb6af10e0$var$USER_SUBJECT;
        case 'team':
            return $533bc31bb6af10e0$var$TEAM_SUBJECT;
        case 'agent':
            return $533bc31bb6af10e0$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("6TKEY", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $83ec369559ddc36d$export$e9faea7c41053334);
const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
const $83ec369559ddc36d$var$initialPageTime = Date.now();
const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
    if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
    return Date.now() - $83ec369559ddc36d$var$initialPageTime;
};

});


parcelRegister("cZg4V", function(module, exports) {

$parcel$export(module.exports, "default", () => $e76084040147eae1$export$2e2bcd8739ae039);

var $iwKVT = parcelRequire("iwKVT");
class $e76084040147eae1$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("f3Zb8", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $b5fa858d1f1072ea$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $b5fa858d1f1072ea$export$d9ad65d422ee3f8c);

var $fcA5f = parcelRequire("fcA5f");
const $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $b5fa858d1f1072ea$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return !!error && $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $fcA5f.AGGError)) return !!error.errorType && $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $fcA5f.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $fcA5f.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $fcA5f.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $fcA5f.DirectoryGraphQLErrors) || causeError instanceof (0, $fcA5f.AGGErrors)) return $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $b5fa858d1f1072ea$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $fcA5f.DirectoryGraphQLErrors)(errors, traceId);
};
const $b5fa858d1f1072ea$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $fcA5f.AGGErrors)(errors, traceId);
};

});
parcelRegister("fcA5f", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $7db90b14dd6e48a6$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $7db90b14dd6e48a6$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $7db90b14dd6e48a6$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $7db90b14dd6e48a6$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $7db90b14dd6e48a6$export$60d8267243755b9c);
class $7db90b14dd6e48a6$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $7db90b14dd6e48a6$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $7db90b14dd6e48a6$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $7db90b14dd6e48a6$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("4mT2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d68ade6ab7f448$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cZg4V = parcelRequire("cZg4V");

var $a6hGK = parcelRequire("a6hGK");

var $hnIbm = parcelRequire("hnIbm");
const $b8d68ade6ab7f448$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b8d68ade6ab7f448$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b8d68ade6ab7f448$var$orgIdPromiseCache = new Map();
const $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache = new Map();
class $b8d68ade6ab7f448$var$TeamCentralCardClient extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b8d68ade6ab7f448$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
        const response = await (0, $hnIbm.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b8d68ade6ab7f448$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $VSDnB.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b8d68ade6ab7f448$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b8d68ade6ab7f448$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $a6hGK.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b8d68ade6ab7f448$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b8d68ade6ab7f448$export$2e2bcd8739ae039 = $b8d68ade6ab7f448$var$TeamCentralCardClient;

});
parcelRegister("a6hGK", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $9b806d5a2251e5d5$export$d38a536fd806c68f);

var $hnIbm = parcelRequire("hnIbm");
const $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $9b806d5a2251e5d5$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $9b806d5a2251e5d5$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $hnIbm.AGGQuery)(url, query, $9b806d5a2251e5d5$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("hnIbm", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $7fa677c30fceb004$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $7fa677c30fceb004$export$a14afb5f82fe705);

var $fcA5f = parcelRequire("fcA5f");

var $f3Zb8 = parcelRequire("f3Zb8");
const $7fa677c30fceb004$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $7fa677c30fceb004$var$id = (headers)=>headers;
async function $7fa677c30fceb004$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleDirectoryGraphQLErrors));
}
async function $7fa677c30fceb004$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
    return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleAGGErrors));
}
async function $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id, handleErrors) {
    const headers = processHeaders($7fa677c30fceb004$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $fcA5f.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("fjEAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2f761841b49fec$export$2e2bcd8739ae039);

var $ivXTE = parcelRequire("ivXTE");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $5Uw6l = parcelRequire("5Uw6l");
class $fb2f761841b49fec$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $5Uw6l.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("5Uw6l", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $c02eddc07333bc73$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $c02eddc07333bc73$export$26a8aad0c7182dd6);

var $hnIbm = parcelRequire("hnIbm");
const $c02eddc07333bc73$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $c02eddc07333bc73$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $c02eddc07333bc73$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $c02eddc07333bc73$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($c02eddc07333bc73$var$ARI_PREFIX) ? teamIdOrTeamAri : $c02eddc07333bc73$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $c02eddc07333bc73$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $c02eddc07333bc73$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $c02eddc07333bc73$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $c02eddc07333bc73$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$c02eddc07333bc73$var$TEAM_FRAGMENT}
    }
  }
}`;
const $c02eddc07333bc73$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $c02eddc07333bc73$export$4968f4e0119a5d9c,
        variables: {
            teamId: $c02eddc07333bc73$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $c02eddc07333bc73$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $c02eddc07333bc73$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $c02eddc07333bc73$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $hnIbm.AGGQuery)(url, query, $c02eddc07333bc73$export$1229c72526c01df2);
    return $c02eddc07333bc73$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("dFLsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafd789fd4bdf3ff$export$2e2bcd8739ae039);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");

var $VSDnB = parcelRequire("VSDnB");

var $ivXTE = parcelRequire("ivXTE");

var $2qnn4 = parcelRequire("2qnn4");

var $6TKEY = parcelRequire("6TKEY");

var $cZg4V = parcelRequire("cZg4V");

var $f3Zb8 = parcelRequire("f3Zb8");

var $hnIbm = parcelRequire("hnIbm");
const $eafd789fd4bdf3ff$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $eafd789fd4bdf3ff$var$aggUserQuery = (0, $5cllN.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $eafd789fd4bdf3ff$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $eafd789fd4bdf3ff$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $VSDnB.fg)('platform_agg_user_query_doc_change') ? (0, $1c8Um.print)($eafd789fd4bdf3ff$var$aggUserQuery) : $eafd789fd4bdf3ff$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $eafd789fd4bdf3ff$var$queryAGGUser = async (url, userId)=>{
    const query = $eafd789fd4bdf3ff$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $hnIbm.AGGQuery)(url, query);
    return user;
};
class $eafd789fd4bdf3ff$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $eafd789fd4bdf3ff$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = (0, $VSDnB.fg)('platform_profilecard-update-time-format') ? 'h:mmaaa' : 'h:mmbbb';
        if (user.zoneinfo) {
            if ((0, $2qnn4.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $2qnn4.localTime)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $2qnn4.localTime)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $6TKEY.getPageTime)();
            if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('succeeded', {
                    duration: (0, $6TKEY.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('failed', {
                    duration: (0, $6TKEY.getPageTime)() - startTime,
                    ...(0, $f3Zb8.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("1c8Um", function(module, exports) {

$parcel$export(module.exports, "print", () => $0dedd2672864572f$export$c2d084dc44961371);

var $12QNw = parcelRequire("12QNw");

var $541Mz = parcelRequire("541Mz");
function $0dedd2672864572f$export$c2d084dc44961371(ast) {
    return (0, $12QNw.visit)(ast, {
        leave: $0dedd2672864572f$var$printDocASTReducer
    });
}
var $0dedd2672864572f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $0dedd2672864572f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $0dedd2672864572f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $0dedd2672864572f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $0dedd2672864572f$var$join([
            op,
            $0dedd2672864572f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $0dedd2672864572f$var$wrap(' = ', defaultValue) + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $0dedd2672864572f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $0dedd2672864572f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
        if (argsLine.length > $0dedd2672864572f$var$MAX_LINE_LENGTH) argsLine = prefix + $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)');
        return $0dedd2672864572f$var$join([
            argsLine,
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $0dedd2672864572f$var$join([
            '...',
            $0dedd2672864572f$var$wrap('on ', typeCondition),
            $0dedd2672864572f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($0dedd2672864572f$var$wrap('', $0dedd2672864572f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $541Mz.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $0dedd2672864572f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $0dedd2672864572f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $0dedd2672864572f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $0dedd2672864572f$var$join([
            'schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $0dedd2672864572f$var$join([
            'scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $0dedd2672864572f$var$join([
            'type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $0dedd2672864572f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + ': ' + type + $0dedd2672864572f$var$wrap(' ', $0dedd2672864572f$var$join(directives, ' '));
    }),
    InputValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $0dedd2672864572f$var$join([
            name + ': ' + type,
            $0dedd2672864572f$var$wrap('= ', defaultValue),
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $0dedd2672864572f$var$join([
            'interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $0dedd2672864572f$var$join([
            'union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $0dedd2672864572f$var$join([
            'enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $0dedd2672864572f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $0dedd2672864572f$var$join([
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $0dedd2672864572f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $0dedd2672864572f$var$join([
            'input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $0dedd2672864572f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($0dedd2672864572f$var$hasMultilineItems(args) ? $0dedd2672864572f$var$wrap('(\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(args, '\n')), '\n)') : $0dedd2672864572f$var$wrap('(', $0dedd2672864572f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $0dedd2672864572f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $0dedd2672864572f$var$join([
            'extend schema',
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $0dedd2672864572f$var$join([
            'extend scalar',
            name,
            $0dedd2672864572f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $0dedd2672864572f$var$join([
            'extend type',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $0dedd2672864572f$var$join([
            'extend interface',
            name,
            $0dedd2672864572f$var$wrap('implements ', $0dedd2672864572f$var$join(interfaces, ' & ')),
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $0dedd2672864572f$var$join([
            'extend union',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $0dedd2672864572f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $0dedd2672864572f$var$join([
            'extend enum',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $0dedd2672864572f$var$join([
            'extend input',
            name,
            $0dedd2672864572f$var$join(directives, ' '),
            $0dedd2672864572f$var$block(fields)
        ], ' ');
    }
};
function $0dedd2672864572f$var$addDescription(cb) {
    return function(node) {
        return $0dedd2672864572f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $0dedd2672864572f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $0dedd2672864572f$var$block(array) {
    return $0dedd2672864572f$var$wrap('{\n', $0dedd2672864572f$var$indent($0dedd2672864572f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $0dedd2672864572f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $0dedd2672864572f$var$indent(str) {
    return $0dedd2672864572f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $0dedd2672864572f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $0dedd2672864572f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($0dedd2672864572f$var$isMultiline);
}

});
parcelRegister("12QNw", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $0c2eeee3dc68c900$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $0c2eeee3dc68c900$export$bf638b60ea8b89b7);

var $yEDl8 = parcelRequire("yEDl8");

var $98oUl = parcelRequire("98oUl");
var $0c2eeee3dc68c900$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $0c2eeee3dc68c900$export$a89c95c098ac2a58 = Object.freeze({});
function $0c2eeee3dc68c900$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $0c2eeee3dc68c900$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $98oUl.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $yEDl8.default)(node), "."));
            var visitFn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $98oUl.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $0c2eeee3dc68c900$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $0c2eeee3dc68c900$export$a89c95c098ac2a58) skipping[i] = $0c2eeee3dc68c900$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $0c2eeee3dc68c900$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("yEDl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0682b20f61c706c4$export$2e2bcd8739ae039);

var $7NbHY = parcelRequire("7NbHY");
function $0682b20f61c706c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0682b20f61c706c4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0682b20f61c706c4$var$_typeof(obj);
}
var $0682b20f61c706c4$var$MAX_ARRAY_LENGTH = 10;
var $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH = 2;
function $0682b20f61c706c4$export$2e2bcd8739ae039(value) {
    return $0682b20f61c706c4$var$formatValue(value, []);
}
function $0682b20f61c706c4$var$formatValue(value, seenValues) {
    switch($0682b20f61c706c4$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $0682b20f61c706c4$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0682b20f61c706c4$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $0682b20f61c706c4$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $0682b20f61c706c4$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $0682b20f61c706c4$var$formatArray(value, seenValues);
    return $0682b20f61c706c4$var$formatObject(value, seenValues);
}
function $0682b20f61c706c4$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[' + $0682b20f61c706c4$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $0682b20f61c706c4$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $0682b20f61c706c4$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0682b20f61c706c4$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($0682b20f61c706c4$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($0682b20f61c706c4$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $0682b20f61c706c4$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $7NbHY.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $0682b20f61c706c4$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("7NbHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac63109fd04dae2$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $5ac63109fd04dae2$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $5ac63109fd04dae2$export$2e2bcd8739ae039 = $5ac63109fd04dae2$var$nodejsCustomInspectSymbol;

});


parcelRegister("98oUl", function(module, exports) {

$parcel$export(module.exports, "Location", () => $6a682e985d2af3c5$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $6a682e985d2af3c5$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $6a682e985d2af3c5$export$8ee0fc9ee280b4ee);

var $520Pd = parcelRequire("520Pd");
var $6a682e985d2af3c5$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$18a2be9195644f38);
var $6a682e985d2af3c5$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($6a682e985d2af3c5$export$50792b0e93539fde);
function $6a682e985d2af3c5$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("520Pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9dc77a0e8a6949$export$2e2bcd8739ae039);

var $fM9AB = parcelRequire("fM9AB");

var $7NbHY = parcelRequire("7NbHY");
function $3a9dc77a0e8a6949$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $fM9AB.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $7NbHY.default) classObject.prototype[0, $7NbHY.default] = fn;
}

});
parcelRegister("fM9AB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c2c6f03066157d$export$2e2bcd8739ae039);
function $b7c2c6f03066157d$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("541Mz", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $3afeb56b3b6851c5$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $3afeb56b3b6851c5$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $3afeb56b3b6851c5$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $3afeb56b3b6851c5$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $3afeb56b3b6851c5$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $3afeb56b3b6851c5$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $3afeb56b3b6851c5$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $3afeb56b3b6851c5$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $3afeb56b3b6851c5$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("5cllN", function(module, exports) {

$parcel$export(module.exports, "gql", () => $3c8ea2810a9abcde$export$72e4926bf8358653);
$parcel$export(module.exports, "default", () => $3c8ea2810a9abcde$export$2e2bcd8739ae039);

var $3VFsf = parcelRequire("3VFsf");

var $8uUC9 = parcelRequire("8uUC9");
var $3c8ea2810a9abcde$var$docCache = new Map();
var $3c8ea2810a9abcde$var$fragmentSourceMap = new Map();
var $3c8ea2810a9abcde$var$printFragmentWarnings = true;
var $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
function $3c8ea2810a9abcde$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $3c8ea2810a9abcde$var$cacheKeyFromLoc(loc) {
    return $3c8ea2810a9abcde$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $3c8ea2810a9abcde$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $3c8ea2810a9abcde$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $3c8ea2810a9abcde$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($3c8ea2810a9abcde$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $3c8ea2810a9abcde$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, ast), {
        definitions: definitions
    });
}
function $3c8ea2810a9abcde$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $3c8ea2810a9abcde$var$parseDocument(source) {
    var cacheKey = $3c8ea2810a9abcde$var$normalize(source);
    if (!$3c8ea2810a9abcde$var$docCache.has(cacheKey)) {
        var parsed = (0, $8uUC9.parse)(source, {
            experimentalFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $3c8ea2810a9abcde$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $3c8ea2810a9abcde$var$docCache.set(cacheKey, $3c8ea2810a9abcde$var$stripLoc($3c8ea2810a9abcde$var$processFragments(parsed)));
    }
    return $3c8ea2810a9abcde$var$docCache.get(cacheKey);
}
function $3c8ea2810a9abcde$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $3c8ea2810a9abcde$var$parseDocument(result);
}
function $3c8ea2810a9abcde$export$657554ef4dc7ac2d() {
    $3c8ea2810a9abcde$var$docCache.clear();
    $3c8ea2810a9abcde$var$fragmentSourceMap.clear();
}
function $3c8ea2810a9abcde$export$e4294e638636c6ab() {
    $3c8ea2810a9abcde$var$printFragmentWarnings = false;
}
function $3c8ea2810a9abcde$export$78cf889af350c840() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = true;
}
function $3c8ea2810a9abcde$export$5290df9bbbd3cfa() {
    $3c8ea2810a9abcde$var$experimentalFragmentVariables = false;
}
var $3c8ea2810a9abcde$var$extras = {
    gql: $3c8ea2810a9abcde$export$72e4926bf8358653,
    resetCaches: $3c8ea2810a9abcde$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $3c8ea2810a9abcde$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $3c8ea2810a9abcde$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $3c8ea2810a9abcde$var$extras.gql, gql_1.resetCaches = $3c8ea2810a9abcde$var$extras.resetCaches, gql_1.disableFragmentWarnings = $3c8ea2810a9abcde$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $3c8ea2810a9abcde$var$extras.disableExperimentalFragmentVariables;
})($3c8ea2810a9abcde$export$72e4926bf8358653 || ($3c8ea2810a9abcde$export$72e4926bf8358653 = {}));
$3c8ea2810a9abcde$export$72e4926bf8358653["default"] = $3c8ea2810a9abcde$export$72e4926bf8358653;
var $3c8ea2810a9abcde$export$2e2bcd8739ae039 = $3c8ea2810a9abcde$export$72e4926bf8358653;

});
parcelRegister("8uUC9", function(module, exports) {

$parcel$export(module.exports, "parse", () => $62fd0a8327627af8$export$98e6a39c04603d36);

var $7ZXKi = parcelRequire("7ZXKi");

var $bzIlO = parcelRequire("bzIlO");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $6vk4Q = parcelRequire("6vk4Q");

var $jADQJ = parcelRequire("jADQJ");

var $jkcJk = parcelRequire("jkcJk");
function $62fd0a8327627af8$export$98e6a39c04603d36(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $62fd0a8327627af8$export$5303528d1070ff6f(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return value;
}
function $62fd0a8327627af8$export$28b8f402ccc88182(source, options) {
    var parser = new $62fd0a8327627af8$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $2z7TS.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $2z7TS.TokenKind).EOF);
    return type;
}
var $62fd0a8327627af8$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $6vk4Q.isSource)(source) ? source : new (0, $6vk4Q.Source)(source);
        this._lexer = new (0, $jkcJk.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $2z7TS.TokenKind).NAME);
        return {
            kind: (0, $bzIlO.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).DOCUMENT,
            definitions: this.many((0, $2z7TS.TokenKind).SOF, this.parseDefinition, (0, $2z7TS.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $2z7TS.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $2z7TS.TokenKind).BRACE_L)) return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $2z7TS.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $2z7TS.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).DOLLAR);
        return {
            kind: (0, $bzIlO.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).SELECTION_SET,
            selections: this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseSelection, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $2z7TS.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $bzIlO.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $2z7TS.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, item, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $2z7TS.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $2z7TS.TokenKind).NAME)) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $bzIlO.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $2z7TS.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $2z7TS.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $2z7TS.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $bzIlO.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $2z7TS.TokenKind).STRING:
            case (0, $2z7TS.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $2z7TS.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $bzIlO.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $bzIlO.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $bzIlO.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $2z7TS.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $bzIlO.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $2z7TS.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).LIST,
            values: this.any((0, $2z7TS.TokenKind).BRACKET_L, item, (0, $2z7TS.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $bzIlO.Kind).OBJECT,
            fields: this.any((0, $2z7TS.TokenKind).BRACE_L, item, (0, $2z7TS.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        return {
            kind: (0, $bzIlO.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $2z7TS.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $2z7TS.TokenKind).AT);
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $2z7TS.TokenKind).BRACKET_R);
            type = {
                kind: (0, $bzIlO.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).BANG)) return {
            kind: (0, $bzIlO.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $bzIlO.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $2z7TS.TokenKind).STRING) || this.peek((0, $2z7TS.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $bzIlO.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $2z7TS.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $2z7TS.TokenKind).AMP) || this.peek((0, $2z7TS.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $2z7TS.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $2z7TS.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $2z7TS.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $2z7TS.TokenKind).PAREN_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $2z7TS.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $2z7TS.TokenKind).EQUALS) ? this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $bzIlO.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseInputValueDef, (0, $2z7TS.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $2z7TS.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $2z7TS.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $2z7TS.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $2z7TS.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $bzIlO.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $2z7TS.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $jADQJ.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $98oUl.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected ".concat($62fd0a8327627af8$var$getTokenKindDesc(kind), ", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $2z7TS.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $7ZXKi.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($62fd0a8327627af8$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenDesc(token) {
    var value = token.value;
    return $62fd0a8327627af8$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $62fd0a8327627af8$var$getTokenKindDesc(kind) {
    return (0, $jkcJk.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("7ZXKi", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $5d2c9324f08528ec$export$bbee0c6176c019d4);

var $g5yZB = parcelRequire("g5yZB");
function $5d2c9324f08528ec$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $g5yZB.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("g5yZB", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $bb6841c873fb42f5$export$92d6ed0888e7cb7f);

var $a1qmV = parcelRequire("a1qmV");

var $cJPdE = parcelRequire("cJPdE");

var $6DBwa = parcelRequire("6DBwa");

var $3DTMg = parcelRequire("3DTMg");

var $4Zjco = parcelRequire("4Zjco");
function $bb6841c873fb42f5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bb6841c873fb42f5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bb6841c873fb42f5$var$_typeof(obj);
}
function $bb6841c873fb42f5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bb6841c873fb42f5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bb6841c873fb42f5$var$ownKeys(Object(source), true).forEach(function(key) {
            $bb6841c873fb42f5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bb6841c873fb42f5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bb6841c873fb42f5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bb6841c873fb42f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bb6841c873fb42f5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bb6841c873fb42f5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bb6841c873fb42f5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bb6841c873fb42f5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bb6841c873fb42f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bb6841c873fb42f5$var$_setPrototypeOf(subClass, superClass);
}
function $bb6841c873fb42f5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bb6841c873fb42f5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $bb6841c873fb42f5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bb6841c873fb42f5$var$_possibleConstructorReturn(this, result);
    };
}
function $bb6841c873fb42f5$var$_possibleConstructorReturn(self, call) {
    if (call && ($bb6841c873fb42f5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $bb6841c873fb42f5$var$_assertThisInitialized(self);
}
function $bb6841c873fb42f5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bb6841c873fb42f5$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $bb6841c873fb42f5$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$bb6841c873fb42f5$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $bb6841c873fb42f5$var$_construct(Class, arguments, $bb6841c873fb42f5$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $bb6841c873fb42f5$var$_setPrototypeOf(Wrapper, Class);
    };
    return $bb6841c873fb42f5$var$_wrapNativeSuper(Class);
}
function $bb6841c873fb42f5$var$_construct(Parent, args, Class) {
    if ($bb6841c873fb42f5$var$_isNativeReflectConstruct()) $bb6841c873fb42f5$var$_construct = Reflect.construct;
    else $bb6841c873fb42f5$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $bb6841c873fb42f5$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $bb6841c873fb42f5$var$_construct.apply(null, arguments);
}
function $bb6841c873fb42f5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bb6841c873fb42f5$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $bb6841c873fb42f5$var$_setPrototypeOf(o, p) {
    $bb6841c873fb42f5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bb6841c873fb42f5$var$_setPrototypeOf(o, p);
}
function $bb6841c873fb42f5$var$_getPrototypeOf(o) {
    $bb6841c873fb42f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bb6841c873fb42f5$var$_getPrototypeOf(o);
}
var $bb6841c873fb42f5$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $bb6841c873fb42f5$var$_inherits(GraphQLError, _Error);
    var _super = $bb6841c873fb42f5$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $bb6841c873fb42f5$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $bb6841c873fb42f5$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $bb6841c873fb42f5$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $3DTMg.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $3DTMg.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $cJPdE.default)(originalExtensions)) _this.extensions = $bb6841c873fb42f5$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($bb6841c873fb42f5$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $bb6841c873fb42f5$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($bb6841c873fb42f5$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($bb6841c873fb42f5$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $bb6841c873fb42f5$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $bb6841c873fb42f5$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $bb6841c873fb42f5$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $bb6841c873fb42f5$var$_wrapNativeSuper(Error));
function $bb6841c873fb42f5$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $bb6841c873fb42f5$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $4Zjco.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $4Zjco.printSourceLocation)(error.source, location);
    }
    return output;
}
function $bb6841c873fb42f5$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $a1qmV.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("a1qmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $74be73ae076c40a2$export$2e2bcd8739ae039);
function $74be73ae076c40a2$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cJPdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $94616b0c7295e50a$export$2e2bcd8739ae039);
function $94616b0c7295e50a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $94616b0c7295e50a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $94616b0c7295e50a$var$_typeof(obj);
}
function $94616b0c7295e50a$export$2e2bcd8739ae039(value) {
    return $94616b0c7295e50a$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("6DBwa", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $4d537cd703fb8e64$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $4d537cd703fb8e64$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $4d537cd703fb8e64$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("3DTMg", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $2a7047dfe88e1e3e$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("4Zjco", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $3a1bc06740b7fb42$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $3a1bc06740b7fb42$export$867940333fd9f869);

var $3DTMg = parcelRequire("3DTMg");
function $3a1bc06740b7fb42$export$96a9681e539deed(location) {
    return $3a1bc06740b7fb42$export$867940333fd9f869(location.source, (0, $3DTMg.getLocation)(location.source, location.start));
}
function $3a1bc06740b7fb42$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $3a1bc06740b7fb42$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $3a1bc06740b7fb42$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $3a1bc06740b7fb42$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $3a1bc06740b7fb42$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $3a1bc06740b7fb42$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $3a1bc06740b7fb42$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $3a1bc06740b7fb42$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $3a1bc06740b7fb42$var$leftPad(len, str) {
    return $3a1bc06740b7fb42$var$whitespace(len - str.length) + str;
}

});



parcelRegister("bzIlO", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $86d55dbd37d1d598$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $86d55dbd37d1d598$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("2z7TS", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $1de4fa7b8080613f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $1de4fa7b8080613f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6vk4Q", function(module, exports) {

$parcel$export(module.exports, "Source", () => $4bc536350d5671b9$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $4bc536350d5671b9$export$75135ee9ed6e435b);

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $a1qmV = parcelRequire("a1qmV");

var $6B4dU = parcelRequire("6B4dU");
function $4bc536350d5671b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4bc536350d5671b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4bc536350d5671b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4bc536350d5671b9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $4bc536350d5671b9$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $a1qmV.default)(0, "Body must be a string. Received: ".concat((0, $yEDl8.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $a1qmV.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $a1qmV.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $4bc536350d5671b9$var$_createClass(Source, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $4bc536350d5671b9$export$75135ee9ed6e435b(source) {
    return (0, $6B4dU.default)(source, $4bc536350d5671b9$export$1d2df86270c81ecb);
}

});
parcelRegister("6B4dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd9796d6ab57d14$export$2e2bcd8739ae039);

function $4cd9796d6ab57d14$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4cd9796d6ab57d14$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4cd9796d6ab57d14$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$4cd9796d6ab57d14$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("jADQJ", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $e4304a67ae3cac6f$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $e4304a67ae3cac6f$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("jkcJk", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $e119c27db9a87f5b$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $e119c27db9a87f5b$export$59ac0f4da287406a);

var $7ZXKi = parcelRequire("7ZXKi");

var $98oUl = parcelRequire("98oUl");

var $2z7TS = parcelRequire("2z7TS");

var $541Mz = parcelRequire("541Mz");
var $e119c27db9a87f5b$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $2z7TS.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $e119c27db9a87f5b$var$readToken(this, token);
        }while (token.kind === (0, $2z7TS.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $e119c27db9a87f5b$export$59ac0f4da287406a(kind) {
    return kind === (0, $2z7TS.TokenKind).BANG || kind === (0, $2z7TS.TokenKind).DOLLAR || kind === (0, $2z7TS.TokenKind).AMP || kind === (0, $2z7TS.TokenKind).PAREN_L || kind === (0, $2z7TS.TokenKind).PAREN_R || kind === (0, $2z7TS.TokenKind).SPREAD || kind === (0, $2z7TS.TokenKind).COLON || kind === (0, $2z7TS.TokenKind).EQUALS || kind === (0, $2z7TS.TokenKind).AT || kind === (0, $2z7TS.TokenKind).BRACKET_L || kind === (0, $2z7TS.TokenKind).BRACKET_R || kind === (0, $2z7TS.TokenKind).BRACE_L || kind === (0, $2z7TS.TokenKind).PIPE || kind === (0, $2z7TS.TokenKind).BRACE_R;
}
function $e119c27db9a87f5b$var$printCharCode(code) {
    return isNaN(code) ? (0, $2z7TS.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $e119c27db9a87f5b$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $e119c27db9a87f5b$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $e119c27db9a87f5b$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $e119c27db9a87f5b$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $e119c27db9a87f5b$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $e119c27db9a87f5b$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $7ZXKi.syntaxError)(source, pos, $e119c27db9a87f5b$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $e119c27db9a87f5b$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($e119c27db9a87f5b$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $e119c27db9a87f5b$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $e119c27db9a87f5b$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    } else {
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $e119c27db9a87f5b$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $e119c27db9a87f5b$var$isNameStart(code)) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
    return new (0, $98oUl.Token)(isFloat ? (0, $2z7TS.TokenKind).FLOAT : (0, $2z7TS.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $e119c27db9a87f5b$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $e119c27db9a87f5b$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $e119c27db9a87f5b$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $e119c27db9a87f5b$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $541Mz.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $7ZXKi.syntaxError)(source, position, "Invalid character within String: ".concat($e119c27db9a87f5b$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $7ZXKi.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $e119c27db9a87f5b$var$uniCharCode(a, b, c, d) {
    return $e119c27db9a87f5b$var$char2hex(a) << 12 | $e119c27db9a87f5b$var$char2hex(b) << 8 | $e119c27db9a87f5b$var$char2hex(c) << 4 | $e119c27db9a87f5b$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $e119c27db9a87f5b$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $e119c27db9a87f5b$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $98oUl.Token)((0, $2z7TS.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $e119c27db9a87f5b$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});



parcelRegister("2qnn4", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $de778707e3f7ab0e$export$f0dfd716e7b023cd);
parcelRequire("7UQ5i");
var $9uIbX = parcelRequire("9uIbX");
const $de778707e3f7ab0e$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $9uIbX.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7UQ5i", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("9uIbX")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $9uIbX = parcelRequire("9uIbX");





});
parcelRegister("9uIbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e9932008c468ee4$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $cmObS = parcelRequire("cmObS");

var $2b4cP = parcelRequire("2b4cP");
function $6e9932008c468ee4$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $cmObS.default)((0, $2b4cP.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("fwbX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4c31d9870379ac2$var$cloneObject;

var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
    return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
}
module.exports = module.exports.default;

});
parcelRegister("cpl5v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90882d6ff669df4d$var$assign;
function $90882d6ff669df4d$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}
module.exports = module.exports.default;

});


parcelRegister("cmObS", function(module, exports) {

$parcel$export(module.exports, "default", () => $900e78e49c474eed$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $920RE = parcelRequire("920RE");

var $2q3K8 = parcelRequire("2q3K8");
var $900e78e49c474eed$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $900e78e49c474eed$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($900e78e49c474eed$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $2q3K8.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $920RE.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("aR9Qf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e767cfeba790ebe$var$format;

var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));

var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));

var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));

var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));

var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));

var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));

var $5qguX = parcelRequire("5qguX");

var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));

var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
    if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
    var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
        var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $5qguX.isProtectedWeekYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $5qguX.isProtectedDayOfYearToken)(substring)) (0, $5qguX.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $7e767cfeba790ebe$var$cleanEscapedString(input) {
    return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});
parcelRegister("ck8JK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f8e2146dfa1d727$var$isValid;

var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
    (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
    var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
    return !isNaN(date);
}
module.exports = module.exports.default;

});
parcelRegister("2pWQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c2b912e6615b0b5$var$toDate;

var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $1c2b912e6615b0b5$var$toDate(argument) {
    (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});
parcelRegister("6eBfj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
function $48a0f126c2293ab3$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});



parcelRegister("kvNR5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));

var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));

var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));

var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));

var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
function $eeed6020e120f946$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $eeed6020e120f946$var$locale = {
    code: 'en-US',
    formatDistance: $eeed6020e120f946$var$_index.default,
    formatLong: $eeed6020e120f946$var$_index2.default,
    formatRelative: $eeed6020e120f946$var$_index3.default,
    localize: $eeed6020e120f946$var$_index4.default,
    match: $eeed6020e120f946$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
module.exports.default = $eeed6020e120f946$var$_default;
module.exports = module.exports.default;

});
parcelRegister("5u9TK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
    else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
    else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
}
module.exports = module.exports.default;

});

parcelRegister("e7AgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a47ddb0366100c31$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $a47ddb0366100c31$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a47ddb0366100c31$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a47ddb0366100c31$var$formatLong = {
    date: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $a47ddb0366100c31$var$_index.default)({
        formats: $a47ddb0366100c31$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
module.exports.default = $a47ddb0366100c31$var$_default;
module.exports = module.exports.default;

});
parcelRegister("4raqC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("8U2eY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
var $67b54aa1e07b4b42$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
    return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
}
module.exports = module.exports.default;

});

parcelRegister("b9d75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
function $81dab50370972ecd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $81dab50370972ecd$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $81dab50370972ecd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $81dab50370972ecd$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $81dab50370972ecd$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $81dab50370972ecd$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $81dab50370972ecd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
}
var $81dab50370972ecd$var$localize = {
    ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
    era: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
        values: $81dab50370972ecd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
module.exports.default = $81dab50370972ecd$var$_default;
module.exports = module.exports.default;

});
parcelRegister("llBmH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("hHwuU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));

var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
var $ce2fa922bf4a591b$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $ce2fa922bf4a591b$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ce2fa922bf4a591b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $ce2fa922bf4a591b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $ce2fa922bf4a591b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $ce2fa922bf4a591b$var$match = {
    ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
        matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
        parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
        matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
module.exports.default = $ce2fa922bf4a591b$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1IY7t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
function $141888fa04c95812$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("liduU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});



parcelRegister("bQkcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;

var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));

var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));

var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
    var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
    return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("aSksP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("7f9OM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;

var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));

var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
    var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});


parcelRegister("3ckvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));

var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));

var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));

var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));

var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2542672a600cd2b8$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $2542672a600cd2b8$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $2542672a600cd2b8$var$_index.default.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date); // Padding
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $2542672a600cd2b8$var$_index.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $2542672a600cd2b8$var$_index.default.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $2542672a600cd2b8$var$_index.default.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $2542672a600cd2b8$var$_index.default.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $2542672a600cd2b8$var$_index.default.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $2542672a600cd2b8$var$_index.default.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $2542672a600cd2b8$var$_index.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
    }
};
function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
}
function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
    }
    return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
}
function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
module.exports.default = $2542672a600cd2b8$var$_default;
module.exports = module.exports.default;

});
parcelRegister("kFGp1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
function $f0c88744bd108133$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $f0c88744bd108133$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
module.exports.default = $f0c88744bd108133$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bQ2eo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});


parcelRegister("3xdEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;

var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
    (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
    var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("6Falt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;

var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));

var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
    (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
    var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
    var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("6nDqw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;

var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $4a53796a96b58804$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
    (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("hI2kM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;

var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));

var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $ce485b424b643216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $ce485b424b643216$var$_index3.default)(1, arguments);
    var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("gUvh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;

var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));

var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
    (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
    var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("46m4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;

var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));

var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));

var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
    (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
    var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
    var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("clhRK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;

var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cbqvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;

var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));

var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));

var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));

var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
    var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("3ihh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;

var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));

var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));

var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));

var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
    var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});




parcelRegister("awKAW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
}
var $7aa109506ceedd4b$var$longFormatters = {
    p: $7aa109506ceedd4b$var$timeLongFormatter,
    P: $7aa109506ceedd4b$var$dateTimeLongFormatter
};
var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
module.exports.default = $7aa109506ceedd4b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("jGQTC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("5qguX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
    return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
    return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}

});


parcelRegister("920RE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6934f899b8aefb37$export$2e2bcd8739ae039);

var $927cR = parcelRequire("927cR");

var $6JaJ1 = parcelRequire("6JaJ1");
var $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE = 60000;
var $6934f899b8aefb37$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $6934f899b8aefb37$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $927cR.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $927cR.default)('long', date, options);
        }
    }
};
function $6934f899b8aefb37$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $6JaJ1.default)(timeZone, originalDate, true) / $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $6934f899b8aefb37$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $6934f899b8aefb37$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter);
}
function $6934f899b8aefb37$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $6934f899b8aefb37$var$addLeadingZeros(minutes, 2);
}
var $6934f899b8aefb37$export$2e2bcd8739ae039 = $6934f899b8aefb37$var$formatters;

});
parcelRegister("927cR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6939e400b4f30595$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $6939e400b4f30595$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $6939e400b4f30595$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $6939e400b4f30595$var$partsTimeZone(dtf, date) : $6939e400b4f30595$var$hackyTimeZone(dtf, date);
}
function $6939e400b4f30595$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $6939e400b4f30595$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $6939e400b4f30595$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("6JaJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e5f43d4fc19099f$export$2e2bcd8739ae039);

var $gTcao = parcelRequire("gTcao");

var $6Bk9v = parcelRequire("6Bk9v");
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR = 3600000;
var $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE = 60000;
var $4e5f43d4fc19099f$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $4e5f43d4fc19099f$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $4e5f43d4fc19099f$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $4e5f43d4fc19099f$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours)) return NaN;
        return -(hours * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $4e5f43d4fc19099f$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$4e5f43d4fc19099f$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR + minutes * $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($4e5f43d4fc19099f$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $4e5f43d4fc19099f$var$toUtcDate(date);
        var offset = $4e5f43d4fc19099f$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $4e5f43d4fc19099f$var$toUtcDate(date) {
    return (0, $6Bk9v.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $4e5f43d4fc19099f$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gTcao.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $6Bk9v.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $4e5f43d4fc19099f$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $4e5f43d4fc19099f$var$validIANATimezoneCache = {};
function $4e5f43d4fc19099f$var$isValidTimezoneIANAString(timeZoneString) {
    if ($4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("gTcao", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bb38695b1c145f$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $c4bb38695b1c145f$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $c4bb38695b1c145f$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $c4bb38695b1c145f$var$partsOffset(dtf, date) : $c4bb38695b1c145f$var$hackyOffset(dtf, date);
}
var $c4bb38695b1c145f$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $c4bb38695b1c145f$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $c4bb38695b1c145f$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $c4bb38695b1c145f$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $c4bb38695b1c145f$var$dtfCache = {};
function $c4bb38695b1c145f$var$getDateTimeFormat(timeZone) {
    if (!$c4bb38695b1c145f$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $c4bb38695b1c145f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $c4bb38695b1c145f$var$dtfCache[timeZone];
}

});

parcelRegister("6Bk9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce5d4976aa71227$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $4ce5d4976aa71227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("2q3K8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c30e9c4205eee83$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $6JaJ1 = parcelRequire("6JaJ1");

var $jxCgc = parcelRequire("jxCgc");
var $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR = 3600000;
var $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE = 60000;
var $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $1c30e9c4205eee83$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $jxCgc.default)
};
function $1c30e9c4205eee83$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1c30e9c4205eee83$var$splitDateString(argument);
    var parseYearResult = $1c30e9c4205eee83$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $1c30e9c4205eee83$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $1c30e9c4205eee83$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $6JaJ1.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $1c30e9c4205eee83$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $1c30e9c4205eee83$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $1c30e9c4205eee83$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $1c30e9c4205eee83$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1c30e9c4205eee83$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $1c30e9c4205eee83$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $1c30e9c4205eee83$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $1c30e9c4205eee83$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $1c30e9c4205eee83$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $1c30e9c4205eee83$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $1c30e9c4205eee83$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $1c30e9c4205eee83$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $1c30e9c4205eee83$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$1c30e9c4205eee83$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $1c30e9c4205eee83$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $1c30e9c4205eee83$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$1c30e9c4205eee83$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $1c30e9c4205eee83$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $1c30e9c4205eee83$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $1c30e9c4205eee83$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $1c30e9c4205eee83$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$1c30e9c4205eee83$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $1c30e9c4205eee83$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $1c30e9c4205eee83$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1c30e9c4205eee83$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1c30e9c4205eee83$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
        if (isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $1c30e9c4205eee83$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("jxCgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39ec715b89452b2$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $e39ec715b89452b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $e39ec715b89452b2$export$2e2bcd8739ae039 = $e39ec715b89452b2$var$tzPattern;

});



parcelRegister("2b4cP", function(module, exports) {

$parcel$export(module.exports, "default", () => $195fdf0d1f4870c0$export$2e2bcd8739ae039);

var $6JaJ1 = parcelRequire("6JaJ1");

var $2q3K8 = parcelRequire("2q3K8");
function $195fdf0d1f4870c0$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $2q3K8.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $6JaJ1.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("58UyI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $2fe94d89052b4b13$export$4b2a86afb64f42f1);

var $dFLsP = parcelRequire("dFLsP");

var $7f4tk = parcelRequire("7f4tk");

var $7I2zi = parcelRequire("7I2zi");
class $2fe94d89052b4b13$export$4b2a86afb64f42f1 extends (0, $dFLsP.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $7I2zi.isCustomerAccount)(userId)) {
                    const response = await (0, $7f4tk.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $7I2zi.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("7I2zi", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $9d3ef40360103f2e$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $9d3ef40360103f2e$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $9d3ef40360103f2e$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $9d3ef40360103f2e$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $9d3ef40360103f2e$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $9d3ef40360103f2e$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $9d3ef40360103f2e$export$518f47d656cb4e1a);

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $8vYX2 = parcelRequire("8vYX2");

const $9d3ef40360103f2e$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $9d3ef40360103f2e$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $9d3ef40360103f2e$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $9d3ef40360103f2e$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $9d3ef40360103f2e$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($9d3ef40360103f2e$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $8zOmE.fireScreenAnalytics)(analyticsEvent);
    }
};
const $9d3ef40360103f2e$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $9d3ef40360103f2e$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $9d3ef40360103f2e$var$getSpaViewProfileAction = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $9d3ef40360103f2e$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $8vYX2.profileCardMessages).assignedIssuesIssueTerminologyRefreshM4 : (0, $8vYX2.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $8vYX2.profileCardMessages).reportedIssuesIssueTerminologyRefreshM4 : (0, $8vYX2.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$export$518f47d656cb4e1a = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $e6a2e0952e4731b8$export$23cedd3261bd8015:
                return $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup);
            case 0, $e6a2e0952e4731b8$export$6bef782d14a92db8:
                return $9d3ef40360103f2e$var$getAssignedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$6b36f20db7a18a86:
                return $9d3ef40360103f2e$var$getReportedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$56da0dd0b0aa67b9:
                return $9d3ef40360103f2e$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("8vYX2", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $a3966562156ba1e4$export$49f2d2ccb123fddf);

var $7VHMR = parcelRequire("7VHMR");
const $a3966562156ba1e4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $a3966562156ba1e4$export$49f2d2ccb123fddf = (0, $7VHMR.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    },
    assignedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.assigned-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Assigned work items"
    },
    reportedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.reported-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Reported work items"
    }
});

});




parcelRegister("4oO9d", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $554c0ec604398cd6$export$52a03a3207af3687);

var $9OXo1 = parcelRequire("9OXo1");
const $554c0ec604398cd6$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("gLmUz", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $53e785fb2e37b84f$export$cb9379d435214a54);

var $9OXo1 = parcelRequire("9OXo1");
const $53e785fb2e37b84f$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

// Based on Confluence's usage of the AK ProfileClient
// See: https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend
const $e81e3d4d8c6e2362$export$7c8e7812b81467ad = '/gateway/api/directory/graphql';
const $e81e3d4d8c6e2362$export$4b61157fa784d22e = '/gateway/api/graphql';


parcelRegister("6Zc45", function(module, exports) {

$parcel$export(module.exports, "SummaryNonProactive", () => $8e51cffd66b7dbbb$export$63362b871a725b7e);

var $5uXOq = parcelRequire("5uXOq");

var $dGzaM = parcelRequire("dGzaM");

var $7i3ao = parcelRequire("7i3ao");

var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $f5oqj = parcelRequire("f5oqj");

var $fNobW = parcelRequire("fNobW");

var $dcX0o = parcelRequire("dcX0o");

var $37QwF = parcelRequire("37QwF");

var $94cfG = parcelRequire("94cfG");

var $2gCtH = parcelRequire("2gCtH");

var $eF8rD = parcelRequire("eF8rD");

var $lGvJS = parcelRequire("lGvJS");

var $9nEZP = parcelRequire("9nEZP");

var $6a30R = parcelRequire("6a30R");

var $iixvy = parcelRequire("iixvy");

var $5oFIy = parcelRequire("5oFIy");

var $147rB = parcelRequire("147rB");

var $6s1PB = parcelRequire("6s1PB");

var $jTFqj = parcelRequire("jTFqj");

var $kpCa9 = parcelRequire("kpCa9");

var $4Hax6 = parcelRequire("4Hax6");

var $eJfzL = parcelRequire("eJfzL");

var $a7K3Y = parcelRequire("a7K3Y");

var $5XrwN = parcelRequire("5XrwN");
const $8e51cffd66b7dbbb$export$63362b871a725b7e = ()=>{
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const isFeatureEnabled = isPremium && isAiOptInEnabled;
    const [isPanelShown] = (0, $lGvJS.useIsPanelShown)();
    const { closeSummaryPanel: closeSummaryPanel, stopLoading: stopLoading, setIsGenerating: setIsGenerating } = (0, $lGvJS.useActions)();
    const [isGenerating] = (0, $lGvJS.useIsGenerating)();
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const dataProviders = new (0, $dGzaM.default)();
    const profileCardProvider = (0, $147rB.useProfileCardProvider)();
    dataProviders.setProvider('profilecardProvider', profileCardProvider);
    const [{ content: content, responseState: responseState, error: error, followUpContent: followUpContent }] = (0, $9nEZP.useSmartSummaryStreaming)();
    const onContainerRef = (0, $5uXOq.useCallback)((element)=>{
        if (element && typeof element.scrollIntoView === 'function') element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, []);
    const onClosePanel = (0, $5uXOq.useCallback)(()=>{
        closeSummaryPanel();
        /** - isGenerating refers to when we call stream endpoint before any events come back *
		 *  - initialization refers to initial setup of streaming
		 *  - answer part means still streaming response
		 * */ const isStreaming = isGenerating || responseState === (0, $dcX0o.ConvoAIResponseState).AnswerPart || responseState === (0, $dcX0o.ConvoAIResponseState).Initialization;
        if (isStreaming) {
            stopLoading();
            fireTrack('aiInteraction dismissed', 'cancelJiraSmartSummarizeComments', {
                isGenerating: isStreaming
            });
        }
    }, [
        closeSummaryPanel,
        isGenerating,
        responseState,
        stopLoading,
        fireTrack
    ]);
    const resizingHeightProps = (0, $7i3ao.useResizingHeight)({
        duration: ()=>1500
    });
    const adfNode = (0, $5uXOq.useMemo)(()=>{
        if (!content) return null;
        return (0, $37QwF.encodeAdf)(content, true);
    }, [
        content
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * isGenerating refers to fetch stream call until we get some sort of content
		 * 	that is not initialisation (initialisation is basically no content). This means we actually have content of
		 * 	either streamed responses (answer part), final response (cached summaries)
		 * 	or error.
		 */ if (isGenerating && (responseState === (0, $dcX0o.ConvoAIResponseState).AnswerPart || responseState === (0, $dcX0o.ConvoAIResponseState).FinalResponse || responseState === (0, $dcX0o.ConvoAIResponseState).Error)) setIsGenerating(false);
    }, [
        isGenerating,
        responseState,
        setIsGenerating
    ]);
    if (!isFeatureEnabled || !isPanelShown) return null;
    const renderContent = ()=>{
        if (!adfNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
            eventHandlers: {
                link: {
                    onClick: (0, $6a30R.onLinkClick)
                }
            },
            document: adfNode,
            dataProviders: dataProviders,
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    };
    const renderFollowUps = ()=>{
        if (!followUpContent || !content) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XrwN.FollowUps), {
            followUpContent: followUpContent,
            summaryContent: content,
            onClose: closeSummaryPanel
        });
    };
    const renderSummaryAndFollowUps = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.250"
        }, renderContent(), renderFollowUps());
    };
    const renderError = (errorMessageTemplate)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
            eventHandlers: {
                link: {
                    onClick: (0, $6a30R.onLinkClick)
                }
            },
            document: (0, $a7K3Y.mapMessageTemplateErrorToAdfError)(errorMessageTemplate),
            dataProviders: dataProviders,
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    };
    const renderSummary = ()=>{
        switch(responseState){
            case (0, $dcX0o.ConvoAIResponseState).Error:
                return renderError(error?.message.message_template);
            case (0, $dcX0o.ConvoAIResponseState).AnswerPart:
            case (0, $dcX0o.ConvoAIResponseState).FinalResponse:
            case (0, $dcX0o.ConvoAIResponseState).FollowUp:
                return (0, $6s1PB.expVal)('jira_comment_summary_follow_ups_experiment', 'isEnabled', false) ? renderSummaryAndFollowUps() : renderContent();
            default:
                return null;
        }
    };
    const renderSummaryComponent = ()=>{
        if (isGenerating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "ai-smart-summaries.ui.first-stream-loading"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $8e51cffd66b7dbbb$var$containerStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kpCa9.GenerationSkeleton), null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJfzL.ContentWrapper), {
            ...resizingHeightProps,
            hasContent: true
        }, renderSummary()), responseState === (0, $dcX0o.ConvoAIResponseState).Error || responseState === (0, $dcX0o.ConvoAIResponseState).FinalResponse || responseState === (0, $dcX0o.ConvoAIResponseState).FollowUp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jTFqj.FooterStreaming), null) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJfzL.Container), {
        ref: onContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        isLoading: isGenerating,
        shouldFitContainer: true,
        spacing: "none",
        testId: "issue-smart-request-summary.ui.ai-container",
        hasNewBorderExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hax6.Header), {
        onClose: onClosePanel
    }), renderSummaryComponent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $8e51cffd66b7dbbb$var$containerStyle = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.150'
});

});
parcelRegister("dcX0o", function(module, exports) {

$parcel$export(module.exports, "ConvoAIResponseState", () => $61aa0bae1042bb24$export$5ad15ff4d6b74b3f);
$parcel$export(module.exports, "getDefaultConvoAIStreamingState", () => $61aa0bae1042bb24$export$c25f824513be9f8a);
var $61aa0bae1042bb24$export$5ad15ff4d6b74b3f = /*#__PURE__*/ function(ConvoAIResponseState) {
    ConvoAIResponseState["Initialization"] = "Initialization";
    ConvoAIResponseState["ChannelId"] = "ChannelId";
    ConvoAIResponseState["AnswerPart"] = "AnswerPart";
    ConvoAIResponseState["FinalResponse"] = "FinalResponse";
    ConvoAIResponseState["FollowUp"] = "FollowUp";
    ConvoAIResponseState["Error"] = "Error";
    return ConvoAIResponseState;
}({});
function $61aa0bae1042bb24$export$c25f824513be9f8a() {
    return {
        content: null,
        responseState: "Initialization"
    };
}

});

parcelRegister("9nEZP", function(module, exports) {

$parcel$export(module.exports, "useSmartSummaryStreaming", () => $f6d4059a58efb094$export$f23f371023d30e1b);

var $5uXOq = parcelRequire("5uXOq");

var $fFJT1 = parcelRequire("fFJT1");
var $dcX0o = parcelRequire("dcX0o");
var $kan5I = parcelRequire("kan5I");

var $6s1PB = parcelRequire("6s1PB");

var $gXz4p = parcelRequire("gXz4p");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $DVljb = parcelRequire("DVljb");

var $2gCtH = parcelRequire("2gCtH");

var $koeKL = parcelRequire("koeKL");

var $eF8rD = parcelRequire("eF8rD");
// The status code belongs to this list won't be sent as taskFail
const $f6d4059a58efb094$var$STATUS_CODE_RELIABILITY_WHITE_LIST = [
    400,
    401,
    403,
    429
];
const $f6d4059a58efb094$var$sendSloMetrics = (wasExperienceSuccesful, errorMessage, statusCode)=>{
    const experience = 'jiraSmartSummarizeComments';
    const analyticsSource = 'requestSummaryQuery';
    const additionalAttributes = {
        ...errorMessage && {
            error: errorMessage
        },
        ...statusCode && {
            statusCode: statusCode
        }
    };
    (0, $gXz4p.sendExperienceAnalytics)({
        experience: experience,
        wasExperienceSuccesful: wasExperienceSuccesful,
        analyticsSource: analyticsSource,
        application: (0, $efvDm.JIRA_SOFTWARE),
        edition: (0, $ldyPw.PREMIUM_EDITION),
        additionalAttributes: additionalAttributes
    });
};
const $f6d4059a58efb094$export$f23f371023d30e1b = ()=>{
    const issueKey = (0, $2gCtH.useIssueId)();
    const locale = (0, $DVljb.useNativeLocale)();
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const cloudId = (0, $koeKL.useCloudId)();
    const streamingRequest = {
        ai_feature_input: {
            content_ari: `ari:cloud:jira:${cloudId}:issue/${issueKey}`,
            locale: locale
        }
    };
    const streamingConfig = {
        apiPath: 'v2/ai-feature/jira/comment-summary/stream',
        timeoutDelay: 60000,
        headers: {
            'x-experience-id': 'jira-smart-summary',
            'x-product': 'jira'
        },
        ...(0, $6s1PB.expVal)('jira_comment_summary_follow_ups_experiment', 'isEnabled', false) ? {
            enableFollowUp: true
        } : {
            enableFollowUp: false
        }
    };
    const onStateChange = (0, $5uXOq.useCallback)((state)=>{
        // TODO: add potential analytics/peformance markers and potential state changes for ui?
        switch(state.responseState){
            case (0, $dcX0o.ConvoAIResponseState).Initialization:
                break;
            case (0, $dcX0o.ConvoAIResponseState).AnswerPart:
                break;
            case (0, $dcX0o.ConvoAIResponseState).FinalResponse:
                fireTrack('aiResult viewed', 'jiraSmartSummarizeComments');
                $f6d4059a58efb094$var$sendSloMetrics(true);
                break;
            case (0, $dcX0o.ConvoAIResponseState).Error:
                {
                    const errorMessage = state.error?.message.content;
                    const errorStatusCode = state.error?.message.status_code || 500;
                    const errorMessageTemplate = state.error?.message.message_template;
                    // this is user content, we do not classify this as an error for both SLO and unified error analytics
                    if (errorMessageTemplate === (0, $fFJT1.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS) break;
                    /**
					 * Do not trigger SLO failures if they are part of these status code white lists
					 */ if (!$f6d4059a58efb094$var$STATUS_CODE_RELIABILITY_WHITE_LIST.includes(errorStatusCode)) $f6d4059a58efb094$var$sendSloMetrics(false, errorMessage, errorStatusCode);
                    fireTrack('aiResult error', 'jiraSmartSummarizeCommentsError', {
                        error: errorMessage,
                        statusCode: errorStatusCode
                    });
                    break;
                }
            default:
                break;
        }
    }, [
        fireTrack
    ]);
    const [state, refetch] = (0, $kan5I.useConvoAIStreaming)(streamingRequest, streamingConfig, onStateChange);
    return [
        state,
        refetch
    ];
};

});
parcelRegister("fFJT1", function(module, exports) {

$parcel$export(module.exports, "ConvoAIErrorMessage", () => $2afc5edba1114c98$export$cb6667e6b65615);
$parcel$export(module.exports, "CONVOAI_DEFAULT_ERROR_CODE", () => $2afc5edba1114c98$export$26a36d98cab4996b);
var $2afc5edba1114c98$export$cb6667e6b65615 = /*#__PURE__*/ function(ConvoAIErrorMessage) {
    ConvoAIErrorMessage["RATE_LIMIT"] = "RATE_LIMIT";
    ConvoAIErrorMessage["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "ANSWER_UNAVAILABLE_FOR_CONTENT";
    ConvoAIErrorMessage["ACCEPTABLE_USE_VIOLATIONS"] = "ACCEPTABLE_USE_VIOLATIONS";
    ConvoAIErrorMessage["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    ConvoAIErrorMessage["NOT_FOUND"] = "NOT_FOUND";
    ConvoAIErrorMessage["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ConvoAIErrorMessage["BAD_REQUEST"] = "BAD_REQUEST";
    ConvoAIErrorMessage["UNEXPECTED"] = "UNEXPECTED";
    ConvoAIErrorMessage["TIMEOUT"] = "TIMEOUT";
    return ConvoAIErrorMessage;
}({});
const $2afc5edba1114c98$export$26a36d98cab4996b = 0;

});

parcelRegister("kan5I", function(module, exports) {

$parcel$export(module.exports, "useConvoAIStreaming", () => $251241c79c4d0537$export$d6e2ae1e990d7e71);

var $5uXOq = parcelRequire("5uXOq");

var $j7Dz8 = parcelRequire("j7Dz8");

var $6FRHB = parcelRequire("6FRHB");
var $6riHe = parcelRequire("6riHe");

var $fvQuq = parcelRequire("fvQuq");

var $dcX0o = parcelRequire("dcX0o");
function $251241c79c4d0537$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $5uXOq.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6riHe.useStatefulObservableEffect)((0, $fvQuq.convoAIStreamingEffect), (0, $dcX0o.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $6FRHB.useObservableEffect)((input$)=>input$.pipe((0, $j7Dz8.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $5uXOq.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $dcX0o.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}

});
parcelRegister("6FRHB", function(module, exports) {

$parcel$export(module.exports, "useObservableEffect", () => $5b26664b4f9f184a$export$42102e336cc49836);

var $5uXOq = parcelRequire("5uXOq");

var $cab1K = parcelRequire("cab1K");
function $5b26664b4f9f184a$export$42102e336cc49836(onObservableInit, inputs) {
    const [inputSubject$] = (0, $5uXOq.useState)(()=>new (0, $cab1K.Subject)());
    const [observable$] = (0, $5uXOq.useState)(()=>onObservableInit(inputSubject$));
    (0, $5uXOq.useEffect)(()=>{
        const subscription$ = observable$.subscribe();
        return ()=>{
            subscription$.unsubscribe();
        };
    }, [
        observable$
    ]);
    const callback = (0, $5uXOq.useCallback)((nextState)=>inputSubject$.next(nextState), [
        inputSubject$
    ]);
    (0, $5uXOq.useEffect)(()=>{
        inputSubject$.next(inputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        callback
    ];
}

});

parcelRegister("fvQuq", function(module, exports) {

$parcel$export(module.exports, "convoAIStreamingEffect", () => $8464f7068cabe299$export$a0d56a856e9914d2);

var $1SBaA = parcelRequire("1SBaA");

var $aq199 = parcelRequire("aq199");

var $e6C7w = parcelRequire("e6C7w");

var $ib0Rz = parcelRequire("ib0Rz");

var $8EnuM = parcelRequire("8EnuM");

var $gIcfQ = parcelRequire("gIcfQ");

var $4cJXk = parcelRequire("4cJXk");

var $cVFxd = parcelRequire("cVFxd");

var $bLNAF = parcelRequire("bLNAF");

var $jEfnV = parcelRequire("jEfnV");

var $cvLsC = parcelRequire("cvLsC");

var $imafm = parcelRequire("imafm");

var $fFJT1 = parcelRequire("fFJT1");

var $39syB = parcelRequire("39syB");

var $6DryU = parcelRequire("6DryU");

var $gfbVC = parcelRequire("gfbVC");

var $iU2sn = parcelRequire("iU2sn");

var $2s7xF = parcelRequire("2s7xF");

var $dcX0o = parcelRequire("dcX0o");
function $8464f7068cabe299$export$a0d56a856e9914d2(input$) {
    return input$.pipe((0, $bLNAF.skipWhile)(({ inputs: [_, { skip: skip }] })=>!!skip), (0, $gIcfQ.distinctUntilChanged)(({ inputs: [prevRequest, prevConfig, prevRefetchId] }, { inputs: [nextRequest, nextConfig, nextRefetchId] })=>(0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevRequest, nextRequest) && (0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevConfig, nextConfig) && prevRefetchId === nextRefetchId), (0, $cVFxd.map)(({ inputs: [request, config] })=>({
            config: (0, $6DryU.getDefaultConvoAIConfigWithUserSettings)(config),
            request: request
        })), (0, $cVFxd.map)(({ request: request, config: config })=>({
            requestConfig: (0, $39syB.createConvoAIRequestConfig)(request, config),
            config: config
        })), (0, $jEfnV.switchMap)(({ requestConfig: requestConfig, config: config })=>{
        (0, $2s7xF.logConvoAIInfo)('pre request data', config, requestConfig);
        let $request = (0, $gfbVC.makeConvoAIStreamRequest)(requestConfig);
        if (config.timeoutDelay) return $request.pipe((0, $imafm.timeout)(config.timeoutDelay), (0, $cVFxd.map)((state)=>({
                config: config,
                state: state
            })));
        return $request.pipe((0, $cVFxd.map)((state)=>({
                config: config,
                state: state
            })));
    }))// pipe() has an apparent limit of 9 operators
    // https://github.com/ReactiveX/rxjs/issues/4221#issuecomment-426774631
    .pipe((0, $4cJXk.filter)(({ config: config, state: state })=>!(!config.enableFollowUp && state.responseState === (0, $dcX0o.ConvoAIResponseState).FollowUp)), (0, $cVFxd.map)(({ config: config, state: state })=>{
        (0, $2s7xF.logConvoAIInfo)('response data', config, state);
        const nextState = (0, $iU2sn.parsePartialConvoAIJsonIfNeeded)(state, config);
        (0, $2s7xF.logConvoAIInfo)('post json parsing content', config, state);
        return {
            state: nextState,
            config: config
        };
    }), (0, $cvLsC.timeInterval)(), (0, $ib0Rz.concatMap)(({ value: { state: state, config: config }, interval: interval })=>{
        if (!config.delayChunkUpdate) return (0, $aq199.of)(state);
        const { time: time, gap: gap } = config.delayChunkUpdate;
        if (interval < gap) return (0, $aq199.of)(state).pipe((0, $8EnuM.delay)(time));
        return (0, $aq199.of)(state);
    }), (0, $e6C7w.catchError)((error)=>{
        if (error.name === 'TimeoutError') {
            const timeoutErrorState = {
                responseState: (0, $dcX0o.ConvoAIResponseState).Error,
                content: null,
                answerChunkIndex: undefined,
                error: {
                    type: 'ERROR',
                    message: {
                        content: error.message,
                        message_template: (0, $fFJT1.ConvoAIErrorMessage).TIMEOUT,
                        status_code: (0, $fFJT1.CONVOAI_DEFAULT_ERROR_CODE)
                    }
                }
            };
            return (0, $aq199.of)(timeoutErrorState);
        }
        const unexpectedErrorState = {
            responseState: (0, $dcX0o.ConvoAIResponseState).Error,
            content: null,
            error: {
                type: 'ERROR',
                message: {
                    content: error.message,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: (0, $fFJT1.CONVOAI_DEFAULT_ERROR_CODE)
                }
            }
        };
        return (0, $aq199.of)(unexpectedErrorState);
    }));
}

});
parcelRegister("imafm", function(module, exports) {
"use strict";
var $d5d23adf7cd1097c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hSQIY = parcelRequire("hSQIY");

var $3Oax8 = parcelRequire("3Oax8");

var $ggvKU = parcelRequire("ggvKU");

var $wboEv = parcelRequire("wboEv");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $d5d23adf7cd1097c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    var absoluteTimeout = $3Oax8.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $d5d23adf7cd1097c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $wboEv.TimeoutError()));
    };
}
module.exports.timeout = $d5d23adf7cd1097c$var$timeout;
var $d5d23adf7cd1097c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d5d23adf7cd1097c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d5d23adf7cd1097c$var$TimeoutSubscriber = function(_super) {
    $d5d23adf7cd1097c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($ggvKU.Subscriber);

});
parcelRegister("wboEv", function(module, exports) {
"use strict";
var $060bd46798dfd391$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $060bd46798dfd391$var$TimeoutError = function(_super) {
    $060bd46798dfd391$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $060bd46798dfd391$var$TimeoutError;

});


parcelRegister("39syB", function(module, exports) {

$parcel$export(module.exports, "createConvoAIRequestConfig", () => $758b105e9875a1ce$export$39a530c281991f7b);
const $758b105e9875a1ce$export$39a530c281991f7b = (request, config)=>{
    const requestInitParams = {
        method: 'POST',
        headers: new Headers({
            ...config.headers
        }),
        body: JSON.stringify(request)
    };
    return {
        requestInitParams: requestInitParams,
        url: `${config.baseUrl}/${config.apiPath}`
    };
};

});

parcelRegister("6DryU", function(module, exports) {

$parcel$export(module.exports, "getDefaultConvoAIConfigWithUserSettings", () => $d9be911427017a8a$export$98f0249d9632eade);

var $2Hqfz = parcelRequire("2Hqfz");

const $d9be911427017a8a$var$baseUrl = (0, $2Hqfz.Lens).fromNullableProp()('baseUrl', (0, $37cb68859af2804d$export$7c03f5942efb8a41));
const $d9be911427017a8a$var$enablePartialJson = (0, $2Hqfz.Lens).fromNullableProp()('enablePartialJson', false);
const $d9be911427017a8a$var$enableFollowUp = (0, $2Hqfz.Lens).fromNullableProp()('enableFollowUp', false);
const $d9be911427017a8a$var$enableLocalVerboseLogs = (0, $2Hqfz.Lens).fromNullableProp()('enableLocalVerboseLogs', false);
const $d9be911427017a8a$var$skip = (0, $2Hqfz.Lens).fromNullableProp()('skip', false);
const $d9be911427017a8a$var$contentType = (0, $2Hqfz.Lens).fromNullableProp()('content-type', 'application/json;charset=UTF-8');
const $d9be911427017a8a$var$xIssyntheticTraffic = (0, $2Hqfz.Lens).fromNullableProp()('x-issynthetic-traffic', 'false');
function $d9be911427017a8a$var$getHeaders(config) {
    const headers = {
        'content-type': $d9be911427017a8a$var$contentType.get(config.headers),
        'x-product': config.headers['x-product'],
        'x-experience-id': config.headers['x-experience-id'],
        'x-issynthetic-traffic': $d9be911427017a8a$var$xIssyntheticTraffic.get(config.headers)
    };
    if (config.headers['x-channel-id']) headers['x-channel-id'] = config.headers['x-channel-id'];
    return headers;
}
const $d9be911427017a8a$export$98f0249d9632eade = (config)=>({
        baseUrl: $d9be911427017a8a$var$baseUrl.get(config),
        apiPath: config.apiPath,
        enablePartialJson: $d9be911427017a8a$var$enablePartialJson.get(config),
        enableFollowUp: $d9be911427017a8a$var$enableFollowUp.get(config),
        enableLocalVerboseLogs: $d9be911427017a8a$var$enableLocalVerboseLogs.get(config),
        timeoutDelay: config.timeoutDelay,
        skip: $d9be911427017a8a$var$skip.get(config),
        headers: $d9be911427017a8a$var$getHeaders(config)
    });

});
const $37cb68859af2804d$export$7c03f5942efb8a41 = '/gateway/api/assist/api/ai';


parcelRegister("gfbVC", function(module, exports) {

$parcel$export(module.exports, "makeConvoAIStreamRequest", () => $73e1ae873e41e9d1$export$2f20a85d8fafe2d9);

var $dOAU7 = parcelRequire("dOAU7");

var $dcX0o = parcelRequire("dcX0o");

var $cUYPv = parcelRequire("cUYPv");
function $73e1ae873e41e9d1$export$2f20a85d8fafe2d9(requestConfig) {
    const behaviorSubject = new (0, $dOAU7.BehaviorSubject)((0, $dcX0o.getDefaultConvoAIStreamingState)());
    fetch(requestConfig.url, {
        credentials: 'include',
        ...requestConfig.requestInitParams
    }).then((response)=>(0, $cUYPv.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $dcX0o.ConvoAIResponseState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'CHANNEL_ID':
                    const channelId = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $dcX0o.ConvoAIResponseState).ChannelId,
                        content: channelId,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $dcX0o.ConvoAIResponseState).FinalResponse,
                        content: bufferContent
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? [],
                        responseState: (0, $dcX0o.ConvoAIResponseState).FollowUp
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        responseState: (0, $dcX0o.ConvoAIResponseState).Error,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
}

});
parcelRegister("cUYPv", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $cb2ad86fce3796f9$export$e45226161c660403);

var $476Ri = parcelRequire("476Ri");

var $fFJT1 = parcelRequire("fFJT1");
async function* $cb2ad86fce3796f9$export$e45226161c660403(response) {
    // Read the response body only if the status is 200 and the body is not null
    if (response.status === 200 && response.body) try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $fFJT1.ConvoAIErrorMessage).UNEXPECTED,
                status_code: (0, $fFJT1.CONVOAI_DEFAULT_ERROR_CODE)
            }
        };
        return;
    }
    // parse the response body as text which should be safe
    const responseText = await response.text();
    try {
        // try to parse the response body as json
        const responseJson = JSON.parse(responseText);
        // covered HTTP errors only from this doc
        // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
        // Kept for extra error handling security as we migrate to convo-ai from agent service
        yield (0, $476Ri.match)({
            status: response.status,
            body: response.body,
            text: responseText,
            json: responseJson
        }).returnType().with({
            status: 201
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 400
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 403
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 429
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).RATE_LIMIT,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 500
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            body: (0, $476Ri.P).nullish
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[Error]: response.body is missing. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).otherwise(({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $fFJT1.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            }));
    } catch (error) {
        yield {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: UNABLE_TO_PARSE_HTTP_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $fFJT1.ConvoAIErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }
}

});


parcelRegister("iU2sn", function(module, exports) {

$parcel$export(module.exports, "parsePartialConvoAIJsonIfNeeded", () => $729c3eb2c5671b48$export$d2c9dfa182282b6d);

var $1KdUV = parcelRequire("1KdUV");

var $dcX0o = parcelRequire("dcX0o");
function $729c3eb2c5671b48$export$d2c9dfa182282b6d(state, config) {
    if (state.responseState !== (0, $dcX0o.ConvoAIResponseState).Initialization && config.enablePartialJson && state.content) try {
        const parsedContent = (0, $1KdUV.parse)(state.content);
        return {
            ...state,
            content: parsedContent
        };
    } catch (error) {}
    return state;
}

});

parcelRegister("2s7xF", function(module, exports) {

$parcel$export(module.exports, "logConvoAIInfo", () => $bdd07af90a38fe15$export$7eba3e1ed428e5ae);
const $bdd07af90a38fe15$export$7eba3e1ed428e5ae = (message, config, data)=>{
    if (config.enableLocalVerboseLogs) // eslint-disable-next-line no-console
    console.info(`[@atlassian/convo-ai-streaming] [${message}]:`, data);
};

});




parcelRegister("jTFqj", function(module, exports) {

$parcel$export(module.exports, "FooterStreaming", () => $b700b4a3d549aa23$export$9b83f3efe4ac944a);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $2YBWI = parcelRequire("2YBWI");

var $lGvJS = parcelRequire("lGvJS");

var $4R6GH = parcelRequire("4R6GH");

var $cL9Y2 = parcelRequire("cL9Y2");

var $kpCa9 = parcelRequire("kpCa9");
const $b700b4a3d549aa23$export$a06f1c675e846f6f = ()=>{
    const [isGenerating] = (0, $lGvJS.useIsGenerating)();
    if (isGenerating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kpCa9.GenerationSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b700b4a3d549aa23$var$containerStyle
    }, !isGenerating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cL9Y2.SummaryFeedbackCollector), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2YBWI.AiFooter), {
        testId: "issue-smart-request-summary.ui.footer.flex",
        isBeta: false
    }));
};
const $b700b4a3d549aa23$export$9b83f3efe4ac944a = ({ shouldShowFeedback: shouldShowFeedback = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('proactive_comment_summary_targeting_gate') ? shouldShowFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cL9Y2.SummaryFeedbackCollector), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b700b4a3d549aa23$var$containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cL9Y2.SummaryFeedbackCollector), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2YBWI.AiFooter), {
        testId: "issue-smart-request-summary.ui.footer.flex",
        isBeta: false
    }));
};
const $b700b4a3d549aa23$var$containerStyle = (0, $8CUq3.xcss)({
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.150',
    paddingInline: 'space.150',
    gap: 'space.100'
});

});
parcelRegister("2YBWI", function(module, exports) {

$parcel$export(module.exports, "AiFooter", () => $3e82455ec7fd6882$export$915814a2dcce5cf0);

var $5uXOq = parcelRequire("5uXOq");

var $jps85 = parcelRequire("jps85");

var $1jWct = parcelRequire("1jWct");

var $aYAc3 = parcelRequire("aYAc3");

var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $jhmo0 = parcelRequire("jhmo0");

var $jldZL = parcelRequire("jldZL");

var $koVbs = parcelRequire("koVbs");

var $2m0b6 = parcelRequire("2m0b6");

var $l9x5I = parcelRequire("l9x5I");
const $3e82455ec7fd6882$var$ATLASSIAN_INTELLIGENCE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/';
const $3e82455ec7fd6882$var$AIFooterThreshold = {
    SMALL: 280,
    MEDIUM: 328,
    LARGE: 624
};
const $3e82455ec7fd6882$export$915814a2dcce5cf0 = ({ testId: testId, isBeta: isBeta = true, showDisclaimer: showDisclaimer = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footerContainer = (0, $5uXOq.useRef)(null);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        if (footerContainer.current) {
            const { offsetWidth: offsetWidth } = footerContainer.current;
            if (showDisclaimer) {
                if (offsetWidth > $3e82455ec7fd6882$var$AIFooterThreshold.LARGE) {
                    setDisplayedAttribution((0, $l9x5I.default).longAttributionText);
                    setDisplayedDisclaimer((0, $l9x5I.default).longDisclaimerText);
                } else if (offsetWidth > $3e82455ec7fd6882$var$AIFooterThreshold.MEDIUM) {
                    setDisplayedAttribution((0, $l9x5I.default).shortAttributionText);
                    setDisplayedDisclaimer((0, $l9x5I.default).disclaimerText);
                } else {
                    setDisplayedAttribution(null);
                    setDisplayedDisclaimer((0, $l9x5I.default).disclaimerText);
                }
            } else if (offsetWidth > $3e82455ec7fd6882$var$AIFooterThreshold.SMALL) setDisplayedAttribution((0, $l9x5I.default).longAttributionText);
            else setDisplayedAttribution((0, $l9x5I.default).shortAttributionText);
        }
    }, [
        showDisclaimer
    ]);
    const [displayedAttribution, setDisplayedAttribution] = (0, $5uXOq.useState)(null);
    const [displayedDisclaimer, setDisplayedDisclaimer] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        onResize();
    }, [
        onResize
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: footerContainer,
        onResize: onResize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        testId: testId,
        xcss: $3e82455ec7fd6882$var$footerStyle,
        spread: "space-between",
        alignBlock: "center",
        ref: footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.050"
    }, isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        testId: "atlassian-intelligence.common.ui.ai-footer.beta-lozenge",
        appearance: "default"
    }, formatMessage((0, $l9x5I.default).betaLozenge)), displayedDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        label: formatMessage((0, $l9x5I.default).infoIconLabel),
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, #626F86)",
        testId: "atlassian-intelligence.common.ui.ai-footer.info-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        xcss: $3e82455ec7fd6882$var$linkStyle,
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.disclaimer-text"
    }, formatMessage(displayedDisclaimer)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        xcss: $3e82455ec7fd6882$var$linkStyle,
        href: $3e82455ec7fd6882$var$ATLASSIAN_INTELLIGENCE_LINK,
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.attribution-link"
    }, displayedAttribution ? formatMessage(displayedAttribution) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, formatMessage((0, $l9x5I.default).longAttributionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
        label: formatMessage((0, $l9x5I.default).aiIconLabel),
        spacing: "spacious"
    })));
};
const $3e82455ec7fd6882$var$footerStyle = (0, $8CUq3.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingInline: 'space.150',
    paddingBlock: 'space.050'
});
const $3e82455ec7fd6882$var$linkStyle = (0, $8CUq3.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("l9x5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8aa0e93e9bc458$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7f8aa0e93e9bc458$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    betaLozenge: {
        "id": "atlassian-intelligence.common.ai-footer.beta-lozenge",
        "defaultMessage": "Beta"
    },
    disclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.disclaimer-text",
        "defaultMessage": "Content quality may vary"
    },
    longDisclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.long-disclaimer-text",
        "defaultMessage": "Content is based on your permissions, and its quality may vary"
    },
    shortAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.short-attribution-text",
        "defaultMessage": "Powered by AI"
    },
    longAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.long-attribution-text",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    infoIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.info-icon-label",
        "defaultMessage": "Info"
    },
    aiIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.ai-icon-label",
        "defaultMessage": "Atlassian Intelligence"
    }
});

});


parcelRegister("cL9Y2", function(module, exports) {

$parcel$export(module.exports, "SummaryFeedbackCollector", () => $aad716ad40f4968b$export$93d707488d8d04c1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $3xPiH = parcelRequire("3xPiH");

var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $eF8rD = parcelRequire("eF8rD");

var $93Yeu = parcelRequire("93Yeu");

var $lGvJS = parcelRequire("lGvJS");

var $eNNkf = parcelRequire("eNNkf");


var $cSD7y = parcelRequire("cSD7y");

var $6brYX = parcelRequire("6brYX");
const $aad716ad40f4968b$var$getFeedbackContext = (sentiment, projectType = '', isProactive)=>({
        entrypointId: 'a0b04376-5026-4a3a-92b3-d2ff97ae92c3',
        feedbackCollectorId: 'ddac4251-3a49-462d-8a6b-f602fe8ac06a',
        feedbackContext: [
            {
                id: 'sentiment',
                value: sentiment
            },
            {
                id: 'product',
                value: projectType
            },
            {
                id: 'isProactiveExperience',
                value: isProactive
            }
        ]
    });
const $aad716ad40f4968b$export$b9f795a310c99df5 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const [isProactivePanelShown] = (0, $lGvJS.useIsProactivePanelShown)();
    const [hasSubmittedFeedback, setHasSubmittedFeedback] = (0, $5uXOq.useState)(false);
    const onClickHelpful = (0, $5uXOq.useCallback)(()=>{
        fireTrack('aiFeedback submitted', 'feedbackSubmitted', {
            aiFeedbackResult: 'up'
        });
        openFeedbackCollector($aad716ad40f4968b$var$getFeedbackContext('good', projectType, isProactivePanelShown));
        setHasSubmittedFeedback(true);
    }, [
        openFeedbackCollector,
        projectType,
        fireTrack,
        isProactivePanelShown
    ]);
    const onClickUnhelpful = (0, $5uXOq.useCallback)(()=>{
        fireTrack('aiFeedback submitted', 'feedbackSubmitted', {
            aiFeedbackResult: 'down'
        });
        openFeedbackCollector($aad716ad40f4968b$var$getFeedbackContext('bad', projectType, isProactivePanelShown));
        setHasSubmittedFeedback(true);
    }, [
        openFeedbackCollector,
        projectType,
        fireTrack,
        isProactivePanelShown
    ]);
    if (hasSubmittedFeedback) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aad716ad40f4968b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, formatMessage((0, $6brYX.default).thanks)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aad716ad40f4968b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-smart-request-summary.ui.footer.feedback.button-like",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xPiH))), {
            LEGACY_size: "small",
            label: formatMessage((0, $6brYX.default).helpfulLabel),
            color: "var(--ds-text-subtlest, #626F86)"
        }),
        spacing: "compact",
        onClick: onClickHelpful,
        appearance: "subtle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-smart-request-summary.ui.footer.feedback.button-dislike",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aad716ad40f4968b$var$DislikeIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xPiH))), {
            LEGACY_size: "small",
            label: formatMessage((0, $6brYX.default).unhelpfulLabel),
            color: "var(--ds-text-subtlest, #626F86)"
        })),
        spacing: "compact",
        onClick: onClickUnhelpful,
        appearance: "subtle"
    }));
};
const $aad716ad40f4968b$export$9d2a3920b3ec35b9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const [isProactivePanelShown] = (0, $lGvJS.useIsProactivePanelShown)();
    const [hasSubmittedFeedback, setHasSubmittedFeedback] = (0, $5uXOq.useState)(false);
    const [hasToggledFeatureSetting, setHasToggledFeatureSetting] = (0, $5uXOq.useState)(false);
    const [hasEnabledProactiveFeature, { setValue: setValue }] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$25f5ee1223725a65));
    const setFeatureToggle = (0, $5uXOq.useCallback)((value)=>{
        setValue(value);
        setHasToggledFeatureSetting(true);
        fireTrack('button clicked', 'proactiveFeatureEnabled', {
            toggle: value
        });
    }, [
        fireTrack,
        setValue,
        setHasToggledFeatureSetting
    ]);
    const onClickHelpful = (0, $5uXOq.useCallback)(()=>{
        fireTrack('aiFeedback submitted', 'feedbackSubmitted', {
            aiFeedbackResult: 'up'
        });
        openFeedbackCollector($aad716ad40f4968b$var$getFeedbackContext('good', projectType, isProactivePanelShown));
        setHasSubmittedFeedback(true);
    }, [
        openFeedbackCollector,
        projectType,
        fireTrack,
        isProactivePanelShown
    ]);
    const onClickUnhelpful = (0, $5uXOq.useCallback)(()=>{
        fireTrack('aiFeedback submitted', 'feedbackSubmitted', {
            aiFeedbackResult: 'down'
        });
        openFeedbackCollector($aad716ad40f4968b$var$getFeedbackContext('bad', projectType, isProactivePanelShown));
        setHasSubmittedFeedback(true);
    }, [
        openFeedbackCollector,
        projectType,
        fireTrack,
        isProactivePanelShown
    ]);
    const renderFeedbackButton = ()=>{
        if (hasSubmittedFeedback) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xxsmall",
            as: "div"
        }, formatMessage((0, $6brYX.default).thanks)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            testId: "issue-smart-request-summary.ui.footer.feedback.button-like",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xPiH))), {
                LEGACY_size: "small",
                label: formatMessage((0, $6brYX.default).helpfulLabel),
                color: "var(--ds-text-subtlest, #626F86)"
            }),
            spacing: "compact",
            onClick: onClickHelpful,
            appearance: "subtle"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            testId: "issue-smart-request-summary.ui.footer.feedback.button-dislike",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aad716ad40f4968b$var$DislikeIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xPiH))), {
                LEGACY_size: "small",
                label: formatMessage((0, $6brYX.default).unhelpfulLabel),
                color: "var(--ds-text-subtlest, #626F86)"
            })),
            spacing: "compact",
            onClick: onClickUnhelpful,
            appearance: "subtle"
        }));
    };
    const renderProactiveFeatureToggle = ()=>{
        if (hasToggledFeatureSetting) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xxsmall",
            as: "div"
        }, hasEnabledProactiveFeature === 'true' ? formatMessage((0, $6brYX.default).autoSummarizeEnabledConfirmation) : formatMessage((0, $6brYX.default).autoSummarizeDisabledConfirmation)));
         // we have proactively shown the proactiveness to users
        // which means they haven't yet disabled the feature
        // so we show the option to disable if they have expanded the proactive comp
        if (isProactivePanelShown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            spacing: "none",
            onClick: ()=>setFeatureToggle('false')
        }, formatMessage((0, $6brYX.default).turnOffAutoSummarize)));
         // the user has toggled it off, so we give them ability to turn it back on
        // if they ever use the non-proactive feature again
        if (hasEnabledProactiveFeature === 'false') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            spacing: "none",
            onClick: ()=>setFeatureToggle('true')
        }, formatMessage((0, $6brYX.default).turnOnAutoSummarize)));
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $aad716ad40f4968b$var$containerStyle,
        spread: "space-between",
        alignBlock: "center"
    }, renderFeedbackButton(), renderProactiveFeatureToggle());
};
const $aad716ad40f4968b$export$93d707488d8d04c1 = (0, $cSD7y.componentWithFG)('proactive_comment_summary_targeting_gate', $aad716ad40f4968b$export$9d2a3920b3ec35b9, $aad716ad40f4968b$export$b9f795a310c99df5); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $aad716ad40f4968b$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $aad716ad40f4968b$var$containerStyle = (0, $8CUq3.xcss)({
    paddingInline: 'space.150',
    paddingBlock: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $aad716ad40f4968b$var$DislikeIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_t9ec1sub",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6brYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dd0dee854ac5175$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2dd0dee854ac5175$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    wasThisHelpful: {
        "id": "issue-smart-request-summary.footer.feedback.was-this-helpful",
        "defaultMessage": "Was this helpful?"
    },
    helpfulLabel: {
        "id": "issue-smart-request-summary.footer.feedback.helpful-label",
        "defaultMessage": "This summary was helpful"
    },
    unhelpfulLabel: {
        "id": "issue-smart-request-summary.footer.feedback.unhelpful-label",
        "defaultMessage": "This summary was unhelpful"
    },
    thanks: {
        "id": "issue-smart-request-summary.footer.feedback.thanks",
        "defaultMessage": "Thanks for your feedback!"
    },
    turnOffAutoSummarize: {
        "id": "issue-smart-request-summary.footer.feedback.turn-off-auto-summarize",
        "defaultMessage": "Turn automatic summaries off"
    },
    turnOnAutoSummarize: {
        "id": "issue-smart-request-summary.footer.feedback.turn-on-auto-summarize",
        "defaultMessage": "Turn automatic summaries on"
    },
    autoSummarizeDisabledConfirmation: {
        "id": "issue-smart-request-summary.footer.feedback.auto-summarize-enabled-confirmation",
        "defaultMessage": "Automatic summaries are turned off"
    },
    autoSummarizeEnabledConfirmation: {
        "id": "issue-smart-request-summary.footer.feedback.auto-summarize-disabled-confirmation",
        "defaultMessage": "Automatic summaries are turned on"
    }
});

});


parcelRegister("kpCa9", function(module, exports) {

$parcel$export(module.exports, "GenerationSkeleton", () => $be97a4ffbec21a22$export$6f1e3f6fd02dd25b);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $75Rey = parcelRequire("75Rey");

var $9Z2xT = parcelRequire("9Z2xT");
const $be97a4ffbec21a22$export$6f1e3f6fd02dd25b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $be97a4ffbec21a22$var$containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75Rey.GeneratingAnimation), {
        alt: formatMessage((0, $9Z2xT.default).generating)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "p",
        xcss: $be97a4ffbec21a22$var$textStyle
    }, formatMessage((0, $9Z2xT.default).generating)));
};
const $be97a4ffbec21a22$var$containerStyle = (0, $8CUq3.xcss)({
    alignItems: 'center',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.150',
    paddingInline: 'space.150',
    gap: 'space.100'
});
const $be97a4ffbec21a22$var$textStyle = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    margin: 'space.0',
    padding: 'space.0',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});

});
parcelRegister("75Rey", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $6f40b4a1f89010b5$export$483f53d5a0354a30);

var $5uXOq = parcelRequire("5uXOq");
const $6f40b4a1f89010b5$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("9Z2xT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b798cc6d3193f62a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b798cc6d3193f62a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    generating: {
        "id": "issue-smart-request-summary.footer.skeleton.generating",
        "defaultMessage": "Atlassian Intelligence is working"
    }
});

});



parcelRegister("4Hax6", function(module, exports) {

$parcel$export(module.exports, "Header", () => $bbbf109cce471eab$export$8b251419efc915eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $a8hd9 = parcelRequire("a8hd9");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $lGvJS = parcelRequire("lGvJS");

var $1REYA = parcelRequire("1REYA");
const $bbbf109cce471eab$export$8b251419efc915eb = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const closeButtonRef = (0, $5uXOq.useRef)(null);
    const [isPanelShown] = (0, $lGvJS.useIsPanelShown)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('jfp_a11y_issue_comments_summary_panel_focus')) return;
        if (isPanelShown) closeButtonRef.current?.focus();
    }, [
        isPanelShown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bbbf109cce471eab$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bbbf109cce471eab$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a8hd9))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $1REYA.default).onlyVisibleToYou))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            label: formatMessage((0, $1REYA.default).close),
            LEGACY_size: "small",
            color: "currentColor"
        }),
        onClick: (event, analyticsEvent)=>{
            onClose();
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'close');
        },
        testId: "issue-smart-request-summary.ui.header.close-button",
        ...(0, $4R6GH.fg)('jfp_a11y_issue_comments_summary_panel_focus') ? {
            ref: closeButtonRef
        } : {}
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $bbbf109cce471eab$var$TitleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $bbbf109cce471eab$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1rjc1b66 _18zrutpp _1e0c1txw _4cvr1h6o _1bah1yb4 _1doct94y _1il9nqa1 _1o3imuej",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1REYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1646673d4ada753$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d1646673d4ada753$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onlyVisibleToYou: {
        "id": "issue-smart-request-summary.header.only-visible-to-you",
        "defaultMessage": "Only visible to you"
    },
    close: {
        "id": "issue-smart-request-summary.header.close",
        "defaultMessage": "Close comment summary"
    }
});

});


parcelRegister("eJfzL", function(module, exports) {

$parcel$export(module.exports, "Container", () => $37be63696a73218d$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentWrapper", () => $37be63696a73218d$export$6ce170286acaa8d3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $37be63696a73218d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pfh1ejb",
            __cmplp.className
        ])
    });
});
const $37be63696a73218d$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasContent: hasContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18zru2gc _6rthutpp _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.hasContent && "_1pfhutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("a7K3Y", function(module, exports) {

$parcel$export(module.exports, "mapMessageTemplateErrorToAdfError", () => $61a41b3e21d205e1$export$9de98ae08bfa03a);

var $bPWvi = parcelRequire("bPWvi");
var $crgTC = parcelRequire("crgTC");
var $50sdg = parcelRequire("50sdg");

var $2Kk17 = parcelRequire("2Kk17");
const $61a41b3e21d205e1$export$8cb54193a7ec4694 = (0, $bPWvi.doc)((0, $50sdg.paragraph)("Atlassian Intelligence can't provide a response right now. Read more ", (0, $crgTC.link)({
    href: 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/'
})('in our support documentation.')));
const $61a41b3e21d205e1$export$a157ab00ffc4fc18 = (0, $bPWvi.doc)((0, $50sdg.paragraph)('Excessive use has been detected with Atlassian Intelligence. Try again later. Read more ', (0, $crgTC.link)({
    href: 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/'
})('in our support documentation.')));
const $61a41b3e21d205e1$export$d411e24c73fc02d9 = (0, $bPWvi.doc)((0, $50sdg.paragraph)('Text does not comply with Atlassian\'s "Acceptable use policy".'));
const $61a41b3e21d205e1$export$9de98ae08bfa03a = (messageTemplate)=>{
    switch(messageTemplate){
        case (0, $2Kk17.ErrorMessage).ACCEPTABLE_USE_VIOLATIONS:
            return $61a41b3e21d205e1$export$d411e24c73fc02d9;
        case (0, $2Kk17.ErrorMessage).RATE_LIMIT:
        case (0, $2Kk17.ErrorMessage).OPENAI_RATE_LIMIT_USER_ABUSE:
            return $61a41b3e21d205e1$export$a157ab00ffc4fc18;
        default:
            return $61a41b3e21d205e1$export$8cb54193a7ec4694;
    }
};

});
parcelRegister("crgTC", function(module, exports) {

$parcel$export(module.exports, "link", () => $209463d72e7e9bac$export$9c30223ca0a664fb);

var $73Fsb = parcelRequire("73Fsb");
const $209463d72e7e9bac$export$9c30223ca0a664fb = (attrs)=>(maybeNode)=>(0, $73Fsb.applyMark)({
            type: 'link',
            attrs: attrs
        }, maybeNode);

});
parcelRegister("73Fsb", function(module, exports) {

$parcel$export(module.exports, "applyMark", () => $04212c45ad539ef0$export$50d34f59d07755a2);

var $3Y6gl = parcelRequire("3Y6gl");

var $gBTcG = parcelRequire("gBTcG");
function $04212c45ad539ef0$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $gBTcG.text)(maybeNode) : maybeNode;
    if ((0, $3Y6gl.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $3Y6gl.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}

});
parcelRegister("3Y6gl", function(module, exports) {

$parcel$export(module.exports, "isDuplicateMark", () => $e5af87b14100d049$export$5ec47a80d7cc0dfa);
$parcel$export(module.exports, "duplicateMarkError", () => $e5af87b14100d049$export$db1000b9ac08ce57);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e5af87b14100d049$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}
function $e5af87b14100d049$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}

});




parcelRegister("5XrwN", function(module, exports) {

$parcel$export(module.exports, "FollowUps", () => $18586c671b38155e$export$f5e06c7941cb5ca7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $luBm6 = parcelRequire("luBm6");

var $hjiMw = parcelRequire("hjiMw");

var $koVbs = parcelRequire("koVbs");

var $cvptR = parcelRequire("cvptR");

var $2gCtH = parcelRequire("2gCtH");

var $eF8rD = parcelRequire("eF8rD");

var $lGvJS = parcelRequire("lGvJS");

var $8f1xg = parcelRequire("8f1xg");
const $18586c671b38155e$var$getContentIssueKeyUrl = (issueKey)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return `${window.location.origin}/browse/${issueKey}`;
};
const $18586c671b38155e$export$f5e06c7941cb5ca7 = ({ followUpContent: followUpContent, summaryContent: summaryContent, onClose: onClose })=>{
    const publish = (0, $hjiMw.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const [isProactivePanelShown] = (0, $lGvJS.useIsProactivePanelShown)();
    // allow us to distinguish whether proactive vs non-proactive in the rovo-chat analytics events
    const experienceName = isProactivePanelShown ? 'proactive-jira-smart-summary' : 'jira-smart-summary';
    const onFollowUpClick = (0, $5uXOq.useCallback)((followUp)=>{
        publish({
            type: 'chat-new',
            source: experienceName,
            data: {
                name: followUp.text.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: formatMessage((0, $8f1xg.default).followUpUserQuery, {
                                link: $18586c671b38155e$var$getContentIssueKeyUrl(issueKey)
                            })
                        },
                        agent_message: {
                            content: summaryContent
                        }
                    }
                ],
                prompt: followUp.text
            }
        });
        fireTrack('aiResult actioned', 'followUpQueryButton', {
            aiResultAction: 'followUpQuestionClick'
        });
        onClose();
    }, [
        publish,
        experienceName,
        formatMessage,
        issueKey,
        summaryContent,
        fireTrack,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        testId: "issue-smart-request-summary.ui.follow-ups.comment-summary-follow-ups"
    }, followUpContent.map((followUp, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18586c671b38155e$var$FollowUpButtonWrapper, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cvptR.FollowUpButton), {
            key: followUp.text,
            followUpIndex: index,
            followUpText: followUp.text,
            followUpType: followUp.type,
            experienceId: experienceName,
            onClick: ()=>onFollowUpClick(followUp)
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $18586c671b38155e$var$FollowUpButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_anlpuq6l _bepv12v5 _14hp1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cvptR", function(module, exports) {

$parcel$export(module.exports, "FollowUpButton", () => $542b164e6a542df8$export$668058776bea98f5);
$parcel$export(module.exports, "ChatPill", () => (parcelRequire("1NZUH")).ChatPill);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1NZUH = parcelRequire("1NZUH");

var $4eq41 = parcelRequire("4eq41");
var $jSnf2 = parcelRequire("jSnf2");
const $542b164e6a542df8$export$668058776bea98f5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $jSnf2.useAnalytics)();
    const analyticsPropertiesRef = (0, $5uXOq.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $4eq41.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $5uXOq.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NZUH.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref,
        children: followUpText
    });
});

});
parcelRegister("1NZUH", function(module, exports) {

$parcel$export(module.exports, "ChatPill", () => $0fd9c621f10bd238$export$e33faa86e0996d96);
$parcel$export(module.exports, "BrowseAgentsPill", () => $0fd9c621f10bd238$export$76b47032dcd9063b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $3JT92 = parcelRequire("3JT92");

var $4V6HW = parcelRequire("4V6HW");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $h88oy = parcelRequire("h88oy");

var $eCjlc = parcelRequire("eCjlc");
const $0fd9c621f10bd238$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $0fd9c621f10bd238$var$styles = {
    button: "_2rkoiti9 _11c82smr _189ee4h9 _1dqonqa1 _1h6dmuej _syaz1gjq _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhk1w7a _irr3166n _1di61dty",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $0fd9c621f10bd238$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ref: ref,
        ...props,
        xcss: $0fd9c621f10bd238$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $0fd9c621f10bd238$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h88oy.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: (0, $3JT92.cx)($0fd9c621f10bd238$var$styles.queryText, whiteSpacePreWrap && $0fd9c621f10bd238$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $0fd9c621f10bd238$export$76b47032dcd9063b = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        ref: ref,
        ...props,
        xcss: $0fd9c621f10bd238$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $0fd9c621f10bd238$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                space: "space.050",
                xcss: $0fd9c621f10bd238$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4V6HW))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $0fd9c621f10bd238$var$styles.queryText,
                        children: formatMessage((0, $eCjlc.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});

});
parcelRegister("4V6HW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec2830ef4a5653740a2b8f60e21924b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3951b0552a35072b$var$_react = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3951b0552a35072b$var$_baseNew = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3951b0552a35072b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3951b0552a35072b$var$AiAgentIcon = (props)=>/*#__PURE__*/ $3951b0552a35072b$var$_react.default.createElement($3951b0552a35072b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$3951b0552a35072b$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $3951b0552a35072b$var$_default = module.exports.default = $3951b0552a35072b$var$AiAgentIcon;

});

parcelRegister("h88oy", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $222c44ccbe7ec2a4$export$38f9b635c1c454e7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $82RQj = parcelRequire("82RQj");

var $jyBoJ = parcelRequire("jyBoJ");
const $222c44ccbe7ec2a4$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82RQj))), {
        ...props,
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $jyBoJ.default)
    });

});
parcelRegister("82RQj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7997b223b163fea361e6870d11885d8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5db846b1e6bcdc52$var$_react = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5db846b1e6bcdc52$var$_baseNew = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5db846b1e6bcdc52$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5db846b1e6bcdc52$var$AiChatIcon = (props)=>/*#__PURE__*/ $5db846b1e6bcdc52$var$_react.default.createElement($5db846b1e6bcdc52$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2z" clip-rule="evenodd"/><path fill="currentcolor" d="M6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$5db846b1e6bcdc52$var$AiChatIcon.displayName = 'AiChatIcon';
var $5db846b1e6bcdc52$var$_default = module.exports.default = $5db846b1e6bcdc52$var$AiChatIcon;

});

parcelRegister("jyBoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c3657b5b4eabc6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $c2c3657b5b4eabc6$var$ChatIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "6",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "9",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "12",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            })
        ]
    });
/**
 * __ChatIcon__
 */ const $c2c3657b5b4eabc6$var$ChatIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $c2c3657b5b4eabc6$var$ChatIconGlyph
    });
var $c2c3657b5b4eabc6$export$2e2bcd8739ae039 = $c2c3657b5b4eabc6$var$ChatIcon;

});


parcelRegister("eCjlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $34bad2d4003b85e8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $34bad2d4003b85e8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    browseAgentsPillLabel: {
        id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
        defaultMessage: 'Browse Agents',
        description: 'The label displayed on the browse agents pill'
    }
});

});



parcelRegister("8f1xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a54c6ee5677fa0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e0a54c6ee5677fa0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    followUpUserQuery: {
        "id": "issue-smart-request-summary.follow-ups.follow-up-user-query",
        "defaultMessage": "Summarize this {link}"
    }
});

});



parcelRegister("dzJaD", function(module, exports) {

$parcel$export(module.exports, "ProactiveSummary", () => $b0d5b702db1d8d27$export$a09ca3cbbe83122e);

var $5uXOq = parcelRequire("5uXOq");

var $f5oqj = parcelRequire("f5oqj");

var $dGzaM = parcelRequire("dGzaM");

var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $lGvJS = parcelRequire("lGvJS");

var $43uZ9 = parcelRequire("43uZ9");

var $37QwF = parcelRequire("37QwF");

var $6a30R = parcelRequire("6a30R");

var $147rB = parcelRequire("147rB");

var $94cfG = parcelRequire("94cfG");

var $kVVL1 = parcelRequire("kVVL1");

var $2QmDq = parcelRequire("2QmDq");

var $d4MOh = parcelRequire("d4MOh");

var $2gCtH = parcelRequire("2gCtH");

var $koeKL = parcelRequire("koeKL");

var $eF8rD = parcelRequire("eF8rD");

var $8K405 = parcelRequire("8K405");

var $6s1PB = parcelRequire("6s1PB");

var $jTFqj = parcelRequire("jTFqj");

var $4Hax6 = parcelRequire("4Hax6");

var $eJfzL = parcelRequire("eJfzL");

var $kpCa9 = parcelRequire("kpCa9");

var $5XrwN = parcelRequire("5XrwN");
const $b0d5b702db1d8d27$var$PROACTIVE_COMMENT_THRESHOLD = 5;
const $b0d5b702db1d8d27$var$LOADING_TICK = 500;
const $b0d5b702db1d8d27$export$8f407ec6cda42abf = ()=>(0, $5uXOq.useState)(false);
const $b0d5b702db1d8d27$export$a09ca3cbbe83122e = ()=>{
    const [content] = (0, $lGvJS.useContent)();
    const [isGenerating] = (0, $lGvJS.useIsGenerating)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [hasTriggeredProactive] = (0, $lGvJS.useHasTriggeredProactive)();
    const isActivityFeedInViewPort = (0, $kVVL1.useSelector)((0, $2QmDq.getActivityFeedInViewPort));
    const totalComments = (0, $kVVL1.useSelector)((0, $d4MOh.totalCommentsSelector));
    const [hasScrolled] = (0, $lGvJS.useHasScrolledLayoutContainer)();
    const issueId = (0, $2gCtH.useIssueId)();
    const [isMinimizedSummary, setIsMinimizedSummary] = (0, $5uXOq.useState)(true);
    const [hasFired, setHasFired] = (0, $5uXOq.useState)(false);
    const [isFakeLoading, setIsFakeLoading] = $b0d5b702db1d8d27$export$8f407ec6cda42abf();
    const [hasTriggeredInitialPanel, setHasTriggeredInitialPanel] = (0, $5uXOq.useState)(false);
    const [followUps, setFollowUps] = (0, $5uXOq.useState)([]);
    const dataProviders = new (0, $dGzaM.default)();
    const { fetchProactiveSummary: fetchProactiveSummary, setTriggeredProactive: setTriggeredProactive, setProactivePanelShown: setProactivePanelShown, updateProactiveSummaryCache: updateProactiveSummaryCache } = (0, $lGvJS.useActions)();
    const [isProactivePanelShown] = (0, $lGvJS.useIsProactivePanelShown)();
    const { fireTrack: fireTrack } = (0, $eF8rD.useSmartSummarizeCommentsAnalytics)();
    const profileCardProvider = (0, $147rB.useProfileCardProvider)();
    dataProviders.setProvider('profilecardProvider', profileCardProvider);
    const adfNode = (0, $5uXOq.useMemo)(()=>{
        if (!content) return null;
        return (0, $37QwF.encodeAdf)(content.summary, true);
    }, [
        content
    ]);
    const onShowMore = (0, $5uXOq.useCallback)(()=>{
        setIsMinimizedSummary(false);
        fireTrack('aiResult viewed', 'jiraSmartSummarizeComments', {
            doesNotMeetMAUCriteria: false
        });
        updateProactiveSummaryCache(issueId, cloudId);
    }, [
        fireTrack,
        updateProactiveSummaryCache,
        issueId,
        cloudId
    ]);
    const onShowMoreWithFollowUps = (0, $5uXOq.useCallback)(async ()=>{
        setIsMinimizedSummary(false);
        fireTrack('aiResult viewed', 'jiraSmartSummarizeComments', {
            doesNotMeetMAUCriteria: false
        });
        updateProactiveSummaryCache(issueId, cloudId);
        if (content?.summary) {
            const followUpsResponse = await (0, $43uZ9.fetchFollowUps)(content.summary, fireTrack);
            setFollowUps(followUpsResponse);
        }
    }, [
        fireTrack,
        updateProactiveSummaryCache,
        issueId,
        cloudId,
        content?.summary
    ]);
    const onComplete = (0, $5uXOq.useCallback)(()=>{
        if (!hasFired) {
            fireTrack('aiInteraction initiated', 'jiraSmartSummarizeComments');
            fireTrack('aiResult viewed', 'jiraSmartSummarizeComments', {
                doesNotMeetMAUCriteria: true
            });
            setHasFired(true);
        }
    }, [
        fireTrack,
        hasFired
    ]);
    const renderContent = ()=>{
        if (!adfNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
            onComplete: onComplete,
            eventHandlers: {
                link: {
                    onClick: (0, $6a30R.onLinkClick)
                }
            },
            document: adfNode,
            dataProviders: dataProviders,
            smartLinks: (0, $6a30R.smartLinksDefault)
        });
    };
    const renderFollowUps = ()=>{
        if (followUps.length === 0 || !content) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XrwN.FollowUps), {
            followUpContent: followUps,
            summaryContent: content.summary,
            onClose: onClosePanel
        });
    };
    const renderSummaryAndFollowUps = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.250"
        }, renderContent(), renderFollowUps());
    };
    const onClosePanel = (0, $5uXOq.useCallback)(()=>{
        setProactivePanelShown(false);
        updateProactiveSummaryCache(issueId, cloudId);
    }, [
        setProactivePanelShown,
        issueId,
        cloudId,
        updateProactiveSummaryCache
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // on mount the comment is below the threshold
        // never trigger proactive case ever, even if they
        // add more comments afterwards.
        if (totalComments < $b0d5b702db1d8d27$var$PROACTIVE_COMMENT_THRESHOLD) setTriggeredProactive(true);
        else if (!hasTriggeredProactive && content === null && issueId !== undefined) fetchProactiveSummary(issueId, cloudId, fireTrack);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * even though we fetch the endpoint on mount for quicker experience
		 * we do not render the component until the comment section is in the viewport
		 * and the user has scrolled. Also make sure that we have actual valid
		 * content and not errors or doesn't meet our pre-conditions
		 */ if (isActivityFeedInViewPort && hasScrolled && content !== null && !hasTriggeredInitialPanel) {
            setProactivePanelShown(true);
            setHasTriggeredInitialPanel(true);
            setIsFakeLoading(true);
        }
    }, [
        isActivityFeedInViewPort,
        hasScrolled,
        content,
        setProactivePanelShown,
        hasTriggeredInitialPanel,
        setIsFakeLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // we have fake loading to make the experience look smoother.
        // This is not real loading as we already have the full content available.
        if (isFakeLoading) {
            const timer = setTimeout(()=>{
                setIsFakeLoading(false);
            }, $b0d5b702db1d8d27$var$LOADING_TICK);
            return ()=>{
                clearTimeout(timer);
            };
        }
    }, [
        isFakeLoading,
        setIsFakeLoading
    ]);
    // generating content, or our proactive panel is not shown or
    // user has already pressed it themselves, we will enver show proactive
    if (isGenerating || !isProactivePanelShown) return null;
    const renderSummaryComponent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJfzL.ContentWrapper), {
            hasContent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8K405.AIContentBlur), {
            shouldOpenInCollapsedView: isMinimizedSummary,
            onShowMore: (0, $6s1PB.expVal)('jira_comment_summary_follow_ups_experiment', 'isEnabled', false) ? onShowMoreWithFollowUps : onShowMore,
            summaryLineHeight: 80
        }, (0, $6s1PB.expVal)('jira_comment_summary_follow_ups_experiment', 'isEnabled', false) ? renderSummaryAndFollowUps() : renderContent())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jTFqj.FooterStreaming), {
            shouldShowFeedback: !isMinimizedSummary
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJfzL.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        isLoading: isFakeLoading,
        shouldFitContainer: true,
        spacing: "none",
        testId: "issue-smart-request-summary.ui.ai-container",
        hasNewBorderExperience: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hax6.Header), {
        onClose: onClosePanel
    }), isFakeLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b0d5b702db1d8d27$var$containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kpCa9.GenerationSkeleton), null)) : renderSummaryComponent()));
};
const $b0d5b702db1d8d27$var$containerStyle = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.150'
});

});
parcelRegister("43uZ9", function(module, exports) {

$parcel$export(module.exports, "fetchFollowUps", () => $cecfcdc5a074bda8$export$a7f2949f0fb43860);

var $gKZoD = parcelRequire("gKZoD");
const $cecfcdc5a074bda8$var$headers = {
    'Content-Type': 'application/json',
    'X-Product': 'jira',
    'X-Experience-Id': 'jira-smart-summary'
};
const $cecfcdc5a074bda8$export$a7f2949f0fb43860 = async (summary, fireTrack)=>{
    (0, $gKZoD.di)(fetch);
    try {
        const response = await fetch('/gateway/api/assist/api/ai/v2/ai-feature/jira/comment-summary/followups', {
            method: 'POST',
            credentials: 'include',
            headers: $cecfcdc5a074bda8$var$headers,
            body: JSON.stringify({
                ai_feature_input: {
                    summary: summary
                }
            })
        });
        if (!response.ok) {
            const errorResponse = await response.json();
            throw new Error(errorResponse.errorMessage);
        }
        const data = await response.json();
        return data.ai_feature_output.follow_ups;
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Unidentified Error';
        fireTrack('aiResult error', 'jiraSmartSummarizeCommentsFollowUpError', {
            error: errorMessage,
            proactiveGeneratedAI: 1,
            userGeneratedAI: 0,
            isProactiveGenerated: true
        });
        // just return empty array,as we still have our main summary
        return [];
    }
};

});

parcelRegister("8K405", function(module, exports) {

$parcel$export(module.exports, "AIContentBlur", () => $96d1a6cbf4e4dca3$export$4a0c9e9f971c9d4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

const $96d1a6cbf4e4dca3$var$i18n = (0, $7VHMR.defineMessages)({
    showMore: {
        id: 'ai-content-blur.show-more',
        defaultMessage: 'Show more',
        description: 'Button used to expand the summary section when clicked'
    }
});
const $96d1a6cbf4e4dca3$var$BodyStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    position: 'relative'
});
const $96d1a6cbf4e4dca3$var$BlurStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    background: `linear-gradient( 0deg, ${`var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`} 0%, ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"} 100% )`,
    height: '20px',
    width: '100%'
});
const $96d1a6cbf4e4dca3$export$4a0c9e9f971c9d4 = ({ children: children, onShowMore: onShowMore, shouldOpenInCollapsedView: shouldOpenInCollapsedView, summaryLineHeight: summaryLineHeight, padding: padding })=>{
    const intl = (0, $koVbs.default)();
    const [isCollapsed, setIsCollapsed] = (0, $5uXOq.useState)(shouldOpenInCollapsedView);
    const handleShowMoreClick = ()=>{
        if (isCollapsed) {
            setIsCollapsed(false);
            onShowMore?.();
        }
    };
    if (!isCollapsed) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        testId: "summary-blur-container",
        onClick: handleShowMoreClick,
        style: {
            padding: padding
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kgoHi.default), {
            alignItems: "end",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f5TWP.default), {
                    grow: "fill",
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
                        xcss: $96d1a6cbf4e4dca3$var$BodyStyles,
                        style: {
                            maxHeight: summaryLineHeight ? `${summaryLineHeight}px` : '40px'
                        },
                        testId: "child-text-box-container",
                        children: [
                            children,
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                                xcss: $96d1a6cbf4e4dca3$var$BlurStyles,
                                style: {
                                    top: summaryLineHeight ? `${summaryLineHeight - 20}px` : '20px'
                                },
                                testId: "blur-styles-box-container"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
                    appearance: "link",
                    spacing: "none",
                    children: intl.formatMessage($96d1a6cbf4e4dca3$var$i18n.showMore)
                })
            ]
        })
    }));
};

});


const $e01a05af1d49e23d$export$2cb239d55dc89d35 = 5;




//# sourceMappingURL=async-issue-smart-request-summary.d16a8080.js.map
